webpackJsonp([1],{

/***/ "+LEf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'quikpoll',
  mixins: [_sidebar2.default]
}; //
//
//
//
//
//

/***/ }),

/***/ "+Xi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/blast-reviews-given.vue
var blast_reviews_given = __webpack_require__("aUzv");
var blast_reviews_given_default = /*#__PURE__*/__webpack_require__.n(blast_reviews_given);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da32654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/blast-reviews-given.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blast.reviewsGiven.length)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.blast.reviewsGiven.length)+" reviews you've given to others:")]),_vm._v(" "),_c('peer-reviews',{attrs:{"reviews":_vm.blast.reviewsGiven,"display":"given"}})],1):_c('div',[_vm._v("\n  You have not given any peer reviews yet.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_blast_reviews_given = (esExports);
// CONCATENATED MODULE: ./src/components/_global/blast-reviews-given.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  blast_reviews_given_default.a,
  _global_blast_reviews_given,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_blast_reviews_given = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+b26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/index.vue
var BlastStudent = __webpack_require__("pL8Z");
var BlastStudent_default = /*#__PURE__*/__webpack_require__.n(BlastStudent);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4537dcd1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blast-student"},[_c('layout',{attrs:{"expanded":_vm.layoutExpanded}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('masthead',{attrs:{"bg":_vm.blast.assignment.syncblastAsset.posterUrl,"video":_vm.backdropVideo}},[_c('h1',[_vm._v(_vm._s(_vm.blast.assignment.name))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.blast.assignment.syncblastAsset.prompt))]),_vm._v(" "),_c('blast-labels',{staticClass:"blast-labels",attrs:{"blast":_vm.blast}})],1),_vm._v(" "),_c('container',[_c('div',{staticClass:"background-text"},[(false)?_c('div',{staticClass:"blast-header"},[_c('h1',[_vm._v(_vm._s(_vm.blast.assignment.name))]),_vm._v(" "),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.prompt)}}),_vm._v(" "),_c('blast-labels',{staticClass:"blast-labels",attrs:{"blast":_vm.blast}})],1):_vm._e(),_vm._v(" "),(_vm.blast.assignment.instructions)?_c('div',{staticClass:"blast-note"},[_c('h2',[_vm._v("Note")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.blast.assignment.instructions)}})]):_vm._e(),_vm._v(" "),(_vm.blast.assignment.syncblastAsset.contentPartner)?_c('img',{staticClass:"partner-logo",attrs:{"src":_vm.blast.assignment.syncblastAsset.contentPartner.logoUrl,"alt":_vm.blast.assignment.syncblastAsset.contentPartner.name,"title":_vm.blast.assignment.syncblastAsset.contentPartner.name}}):_vm._e(),_vm._v(" "),_c('annotator',{attrs:{"config":{userAssignmentId: _vm.blast.id, syncblastAssetId: _vm.blast.assignment.syncblastAssetId},"inject":_vm.blast.annotations,"on":_vm.blast.isOpen}},_vm._m(0,false,true)),_vm._v(" "),(_vm.blast.assignment.features.blastResearch && _vm.blast.assignment.syncblastAsset.researchLinks.length)?_c('content-module',{attrs:{"type":"research","data":{links: _vm.blast.assignment.syncblastAsset.researchLinks}}}):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"controls",attrs:{"slot":"sidebarNav"},slot:"sidebarNav"},[_c('ul',{staticClass:"sidebar-nav"},[_c('li',{staticClass:"respond"},[_c('button',{on:{"click":function($event){_vm.layoutExpanded = !_vm.layoutExpanded}}},[_c('sprite',{attrs:{"name":"iconPullout"}})],1)]),_vm._v(" "),_vm._l((_vm.sidebarModules),function(sidebarModule){return _c('li',{class:{ active: _vm.activeTabKey == sidebarModule.key }},[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.setActiveTab(sidebarModule)}}},[_c('sprite',{attrs:{"name":sidebarModule.icon}}),_vm._v("\n            "+_vm._s(sidebarModule.title)+"\n          ")],1)])})],2)]),_vm._v(" "),_c('div',{attrs:{"slot":"questions"},slot:"questions"},[_c('div',{class:['question-layout']},[_c('transition-group',{attrs:{"name":"list","tag":"div"}},_vm._l((_vm.sidebarComponents),function(component){return (component.name == _vm.activeTabKey)?_c(component.name,{key:component.name,tag:"component",staticClass:"tab",attrs:{"blast":_vm.blast,"vm":_vm.vm}}):_vm._e()}))],1)]),_vm._v(" "),(_vm.blast.isOpen)?_c('div',{attrs:{"slot":"bottom"},slot:"bottom"},[(!_vm.blast.allResponsesComplete && _vm.showSubmitTooltip)?_c('div',{staticClass:"submit-tooltip"},[_c('p',[_c('span',[_vm._v("Progress:")]),_vm._v("\n          "+_vm._s(_vm.blast.completionProgress)+"%\n        ")]),_vm._v(" "),_c('p',[_vm._v("You must complete the assignment before you can submit.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"submit-assignment"},[_c('div',{staticClass:"progress"},[_c('progress',{attrs:{"max":"100"},domProps:{"value":_vm.blast.completionProgress}})]),_vm._v(" "),_c('div',{staticClass:"submission",on:{"mouseenter":function($event){_vm.showSubmitTooltip = true},"mouseleave":function($event){_vm.showSubmitTooltip = false}}},[_c('btn',{attrs:{"type":"submit","disabled":!_vm.blast.allResponsesComplete},on:{"click":function($event){$event.preventDefault();_vm.submitAssignment()}}},[_vm._v("Submit")])],1)])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._l((_vm.blast.assignment.blastBackground.contentModules),function(m){return _c('content-module',{key:m.id,attrs:{"type":m.type,"align":m.align,"data":m.data}})})}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_BlastStudent = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Cewq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4537dcd1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BlastStudent_default.a,
  components_BlastStudent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_BlastStudent = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+ebk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/rate.vue
var rate = __webpack_require__("OlF2");
var rate_default = /*#__PURE__*/__webpack_require__.n(rate);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddcda8f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/rate.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Rate Peers"}},[_c('section',[_c('transition-group',{attrs:{"name":"list","tag":"div"}},[_vm._l((_vm.blast.reviews),function(review){return (_vm.vm.activeReview && review.id == _vm.vm.activeReview.id)?_c('rate-peer',{key:review.id,staticClass:"peer-review",attrs:{"review":_vm.vm.activeReview},on:{"submit":_vm.vm.savePeerReview}}):_vm._e()}),_vm._v(" "),(!_vm.vm.activeReview)?_c('div',{key:"empty",staticClass:"peer-review"},[_c('p',[_vm._v(_vm._s(_vm.noReviewsAvailableMessage))])]):_vm._e()],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_rate = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/rate.vue
function injectStyle (ssrContext) {
  __webpack_require__("MGhq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ddcda8f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  rate_default.a,
  sidebar_rate,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_rate = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+whx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'Modal',
  props: ['title'],
  data: function data() {
    return {
      active: false
    };
  },
  created: function created() {}
};

/***/ }),

/***/ "/0Rk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ZcK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mahal.35f758d.jpg";

/***/ }),

/***/ "/gO/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/halfdome.6577350.jpg";

/***/ }),

/***/ "/i4I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _2 = __webpack_require__("IcnI");

var _3 = _interopRequireDefault(_2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _3.default.defineResource({
  name: "rubrics",
  computed: {
    maxScore: {
      get: function get() {
        var criteria = this.criteria || [];
        return this.score * criteria.length;
      }
    },
    scoreRange: {
      get: function get() {
        var start = this.zeroBased ? 0 : 1;
        return _.range(start, this.score + 1);
      }
    }
  }
});

exports.default = resource;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "/pYs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("uMhA");

__webpack_require__("oPmM");

__webpack_require__("A3OU");

__webpack_require__("qw2f");

__webpack_require__("bRJQ");

/***/ }),

/***/ "/qKa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("UIUo");

exports.default = {
  name: 'TextareaAutogrow',
  props: {
    value: {},
    max: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      innerValue: this.max >= 0 ? this.value.substring(0, this.max) : this.value
    };
  },
  mounted: function mounted() {
    $(this.$el).autogrow({
      vertical: true,
      horizontal: false
    });
  },
  destroyed: function destroyed() {
    // $(this.$el).trigger("remove.autogrow")
  },

  methods: {
    updateValue: function updateValue() {
      this.$emit("input", this.innerValue);
    },
    onKeyup: function onKeyup(event) {
      this.$emit('metaEnter');
    }
  }
}; //
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "/wwO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "channels",
  endpoint: "library/units"
});

exports.default = resource;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0/tJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vietnam.e4d5029.jpg";

/***/ }),

/***/ "02K0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'RubricCriteria',
  props: {
    value: {},
    rubric: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "087f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsDataHttp = __webpack_require__("R8ci");

var _jsDataHttp2 = _interopRequireDefault(_jsDataHttp);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var httpAdapter = new _jsDataHttp2.default({
  // basePath: process.env.API_HOST,
  // serialize (config, data) {
  //   console.log('serialize', config, data)
  // },
  httpConfig: {
    cache: false,
    headers: {
      common: {
        'Cache-Control': 'no-cache',
        'token': sessionStorage.getItem('token')
      },
      get: {
        'If-Modified-Since': 0
      }
    }
  }
});

exports.default = httpAdapter;

/***/ }),

/***/ "0AK1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'PeerReview',
  props: {
    review: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      default: "received"
    }
  },
  data: function data() {
    return {
      displayName: this.display == "given" ? this.review.reviewOf : this.review.reviewBy,
      showResponse: false
    };
  },

  methods: {
    toggleResponse: function toggleResponse() {
      this.showResponse = !this.showResponse;
    }
  }
};

/***/ }),

/***/ "0ovn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/varanasi.ee675bd.jpg";

/***/ }),

/***/ "0pZc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-close\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-close</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-close_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-close_icon-close\">\n            <path d=\"M16.63,14.05 C16.63,14.3433348 16.530001,14.5966656 16.33,14.81 L14.81,16.33 C14.5966656,16.530001 14.3433348,16.63 14.05,16.63 C13.7566652,16.63 13.5033344,16.530001 13.29,16.33 L10.01,13.03 L6.73,16.33 C6.5166656,16.530001 6.2633348,16.63 5.97,16.63 C5.6766652,16.63 5.4233344,16.530001 5.21,16.33 L3.69,14.81 C3.4766656,14.5966656 3.37,14.3433348 3.37,14.05 C3.37,13.7566652 3.4766656,13.5033344 3.69,13.29 L6.97,10.01 L3.69,6.73 C3.4766656,6.5166656 3.37,6.2633348 3.37,5.97 C3.37,5.6766652 3.4766656,5.4233344 3.69,5.21 L5.21,3.69 C5.4233344,3.4766656 5.6766652,3.37 5.97,3.37 C6.2633348,3.37 6.5166656,3.4766656 6.73,3.69 L10.01,6.97 L13.29,3.69 C13.5033344,3.4766656 13.7566652,3.37 14.05,3.37 C14.3433348,3.37 14.5966656,3.4766656 14.81,3.69 L16.33,5.21 C16.530001,5.410001 16.63,5.6633318 16.63,5.97 C16.63,6.2766682 16.530001,6.529999 16.33,6.73 L13.05,10.01 L16.33,13.29 C16.530001,13.490001 16.63,13.7433318 16.63,14.05 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "15Rg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/himalayas.e09948a.jpg";

/***/ }),

/***/ "17R7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1BCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/Masthead.vue
var Masthead = __webpack_require__("Gb9X");
var Masthead_default = /*#__PURE__*/__webpack_require__.n(Masthead);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9e61706","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/Masthead.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['masthead', {'has-video': !!_vm.video}],style:({'background-image': 'url('+_vm.bg+')'})},[(_vm.video)?_c('video-js',{staticClass:"banner-video",attrs:{"media":_vm.video,"autoplay":true,"muted":true,"chromeless":true,"banner":true},on:{"loadeddata":function($event){_vm.toggleBody(true)}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"banner-image",attrs:{"src":_vm.bg}}),_vm._v(" "),_c('transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBody),expression:"showBody"}],staticClass:"body"},[_c('container',[_vm._t("default")],2)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var BlastStudent_Masthead = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/Masthead.vue
function injectStyle (ssrContext) {
  __webpack_require__("dVC9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a9e61706"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Masthead_default.a,
  BlastStudent_Masthead,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_BlastStudent_Masthead = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1M2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/audio-button.vue
var audio_button = __webpack_require__("2SXq");
var audio_button_default = /*#__PURE__*/__webpack_require__.n(audio_button);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06dc28da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/audio-button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.toggle()}}},[(_vm.playing)?_c('sprite',{attrs:{"name":"iconPause","title":"Pause"}}):_c('sprite',{attrs:{"name":"iconPlay","title":"Play"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_audio_button = (esExports);
// CONCATENATED MODULE: ./src/components/_global/audio-button.vue
function injectStyle (ssrContext) {
  __webpack_require__("rotc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06dc28da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  audio_button_default.a,
  _global_audio_button,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_audio_button = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1t8i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'expander',
  data: function data() {
    return {
      isExpanded: false
    };
  }
};

/***/ }),

/***/ "1viU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/japan.e0d8cff.jpg";

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2And":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Kh8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2SXq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'AudioButton',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      playing: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.audio = new Audio(this.src);
    this.audio.onplaying = function () {
      _this.playing = true;
    };
    this.audio.onpause = function () {
      _this.playing = false;
    };
  },

  methods: {
    toggle: function toggle() {
      if (this.playing) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio.play();
      }
    }
  }
};

/***/ }),

/***/ "2Ti/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quikpoll",
  "use": "icon-quikpoll-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-quikpoll\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-quikpoll</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-quikpoll_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-quikpoll_icon-quikpoll\">\n            <path d=\"M8.96,1.6 L8.96,8.96 L1.6,8.96 C1.8400012,7.0133236 2.6466598,5.3533402 4.02,3.98 C5.3933402,2.6066598 7.0399904,1.8133344 8.96,1.6 Z M11.08,1.6 C13.1600104,1.866668 14.899993,2.7933254 16.3,4.38 C17.700007,5.9666746 18.4,7.826656 18.4,9.96 C18.4,12.2800116 17.5800082,14.2666584 15.94,15.92 C14.2999918,17.5733416 12.3066784,18.4 9.96,18.4 C7.826656,18.4 5.9733412,17.700007 4.4,16.3 C2.8266588,14.899993 1.8933348,13.1466772 1.6,11.04 L10.08,11.04 C10.346668,11.04 10.579999,10.9466676 10.78,10.76 C10.980001,10.5733324 11.08,10.3333348 11.08,10.04 L11.08,1.6 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "2Yv2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

var _ReviewDisplay = __webpack_require__("vrLr");

var _ReviewDisplay2 = _interopRequireDefault(_ReviewDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//


exports.default = {
  name: 'blast',
  mixins: [_sidebar2.default],
  components: { ReviewDisplay: _ReviewDisplay2.default }
};

/***/ }),

/***/ "2zug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueBus = {
  install: function install(Vue, options) {

    Vue.prototype.$bus = new Vue();
  }
};

_vue2.default.use(VueBus);

exports.default = VueBus;

/***/ }),

/***/ "30+m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "36kZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ej7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3h6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/expander.vue
var expander = __webpack_require__("1t8i");
var expander_default = /*#__PURE__*/__webpack_require__.n(expander);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013441aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/expander.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expander",class:{ 'expanded': _vm.isExpanded }},[_c('button',{staticClass:"expander-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.isExpanded = !_vm.isExpanded}}},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_vm._v(" "),_c('span',{staticClass:"decoration"})]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_expander = (esExports);
// CONCATENATED MODULE: ./src/components/_global/expander.vue
function injectStyle (ssrContext) {
  __webpack_require__("NFsx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-013441aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  expander_default.a,
  _global_expander,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_expander = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3klC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("L/b1");

__webpack_require__("NrOt");

//
//
//
//
//
//
//
//
//
//

var createRedactorSettings = function createRedactorSettings(defaults, cssClass, callbacks) {
  return _.defaults({}, defaults, {
    // plugins: ['ssAccessibility', 'counter', 'ssIndent'],
    linkify: false,
    toolbarFixed: false,
    toolbarOverflow: true,
    pasteInlineTags: ['strong', 'b', 'u', 'em', 'i'],
    tabKey: false,
    callbacks: function () {
      var _init = _.isFunction(callbacks.init) ? callbacks.init : _.noop;
      return _.assign({}, callbacks, {
        init: function init() {
          this.$editor.addClass(cssClass);
          // this.opts.videoContainerClass = 'flex-video'
          // this.opts.modal.link = linkModal
          return _init.call(this);
        },

        paste: function paste(html) {
          return html.replace(/&nbsp;/g, " ");
        }
      });
    }()
  });
};

exports.default = {
  name: 'redactor',
  props: {
    value: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    mode: String,
    autoFocus: Boolean
  },
  data: function data() {
    return {
      innerValue: this.value
    };
  },
  mounted: function mounted() {
    var self = this;
    var options = createRedactorSettings(this.config, $(this.$el).attr('class'), {
      change: function change(html) {
        self.$emit('input', html);
      }
    });
    this.instance = $(this.$refs['textarea']).redactor(options);
    this.innerValue = (this.value || "").replace(/li\svalue=\"\d*\"/g, "li");
    if (this.autoFocus) {
      this.instance.redactor('focus.end');
    }
  },
  beforeDestroy: function beforeDestroy() {
    try {
      this.instance.redactor("core.destroy");
    } catch (e) {}
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF"), __webpack_require__("7t+N")))

/***/ }),

/***/ "3qir":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lotus.ebe9951.jpg";

/***/ }),

/***/ "3vri":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueMeta = __webpack_require__("p3jY");

var _vueMeta2 = _interopRequireDefault(_vueMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueMeta2.default);

/***/ }),

/***/ "48cu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/Binder/index.vue
var Binder = __webpack_require__("zmwA");
var Binder_default = /*#__PURE__*/__webpack_require__.n(Binder);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55fa64c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Binder/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),(_vm.ready)?_c('section',[_c('assignment-list',{attrs:{"assignments":_vm.assignments}},[_c('h2',{attrs:{"slot":"headline"},slot:"headline"},[_vm._v(_vm._s(_vm.assignmentsCompleted)+":")]),_vm._v(" "),_c('div',{staticClass:"empty",attrs:{"slot":"empty"},slot:"empty"},[_c('h2',[_vm._v("You have not completed any assignments.")])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masthead"},[_c('div',{staticClass:"body"},[_c('h1',[_vm._v("BINDER")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var routes_Binder = (esExports);
// CONCATENATED MODULE: ./src/routes/Binder/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("QT3A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55fa64c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Binder_default.a,
  routes_Binder,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_routes_Binder = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4QZi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/faeroe.4271947.jpg";

/***/ }),

/***/ "4q07":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4xQm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "59tT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlastStudent = __webpack_require__("+b26");

var _BlastStudent2 = _interopRequireDefault(_BlastStudent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AssignmentsDetail',
  components: { BlastStudent: _BlastStudent2.default },
  routeConfig: {
    name: "assignmentDetail", path: "/assignments/:id", meta: { fullMainContainer: true }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.assignmentTitle
    };
  },
  data: function data() {
    return {
      assignment: null //this.$store.get('userAssignments', this.$route.params.id)
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id == 'preview') {
      var vm = this;
      $(window).on("message.blastDetail", function (event) {
        var origin = _.get(event, "originalEvent.origin");
        var source = _.get(event, "originalEvent.source");
        if (origin !== vm.$classicParams.origin || event.originalEvent.source !== window.parent) {
          return;
        }
        var ua = _.get(event, "originalEvent.data.userAssignment");
        if (ua) {
          _this.assignment = vm.$store.inject('userAssignments', ua);
        }
      });
      window.parent.postMessage("ready", vm.$classicParams.origin);
    } else {
      this.$store.find('userAssignments', this.$route.params.id).then(function (assignment) {
        _this.assignment = assignment;
      }).catch(function (err) {
        _this.$router.push({ name: "assignments" });
      });
    }
  },

  computed: {
    assignmentTitle: function assignmentTitle() {
      return _.get(this.assignment, "assignment.name") || "";
    }
  },
  beforeDestroy: function beforeDestroy() {
    $(window).off('.blastDetail');
  }
}; //
//
//
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("M4fF")))

/***/ }),

/***/ "5RMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-read-chrome",
  "use": "icon-read-chrome-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-read-chrome\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <title>reading</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-read-chrome_Svgsprites\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-read-chrome_reading\">\n            <path d=\"M8.01338704,15.9789225 C12.4122187,15.9789225 15.9789225,12.4122187 15.9789225,8.01338704 C15.9789225,3.61455541 12.4122187,0.0478515625 8.01338704,0.0478515625 C3.61455541,0.0478515625 0.0478515625,3.61455541 0.0478515625,8.01338704 C0.0478515625,12.4122187 3.61455541,15.9789225 8.01338704,15.9789225\" id=\"icon-read-chrome_Fill-1\" fill=\"#0361A8\" />\n            <path d=\"M11.760387,7.19888704 L4.26738704,7.19888704 C3.81738704,7.19888704 3.45238704,7.56388704 3.45238704,8.01288704 C3.45238704,8.46388704 3.81738704,8.82788704 4.26738704,8.82788704 L11.760387,8.82788704 C12.209387,8.82788704 12.574387,8.46388704 12.574387,8.01288704 C12.574387,7.56388704 12.209387,7.19888704 11.760387,7.19888704 M4.26738704,6.05888704 L11.760387,6.05888704 C12.209387,6.05888704 12.574387,5.69488704 12.574387,5.24488704 C12.574387,4.79488704 12.209387,4.42988704 11.760387,4.42988704 L4.26738704,4.42988704 C3.81738704,4.42988704 3.45238704,4.79488704 3.45238704,5.24488704 C3.45238704,5.69488704 3.81738704,6.05888704 4.26738704,6.05888704 M11.760387,9.96888704 L4.26738704,9.96888704 C3.81738704,9.96888704 3.45238704,10.333887 3.45238704,10.782887 C3.45238704,11.231887 3.81738704,11.596887 4.26738704,11.596887 L11.760387,11.596887 C12.209387,11.596887 12.574387,11.231887 12.574387,10.782887 C12.574387,10.333887 12.209387,9.96888704 11.760387,9.96888704\" id=\"icon-read-chrome_Fill-4\" fill=\"#FFFFFF\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "5Sp0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

var _ReviewDisplay = __webpack_require__("vrLr");

var _ReviewDisplay2 = _interopRequireDefault(_ReviewDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//


exports.default = {
  name: 'write',
  mixins: [_sidebar2.default],
  components: { ReviewDisplay: _ReviewDisplay2.default }
};

/***/ }),

/***/ "5Ue1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-check-outline",
  "use": "icon-check-outline-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-check-outline\">\n    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-check-outline</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-check-outline_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-check-outline_icon-check-outline\" fill-rule=\"nonzero\">\n            <path d=\"M18.16,5.91277344 C18.16,5.74249113 18.1091467,5.62171443 17.9864466,5.50632683 L16.4664466,3.98632683 C16.3461504,3.86603064 16.2196646,3.81277344 16.06,3.81277344 C15.9003354,3.81277344 15.7738496,3.86603064 15.6540354,3.98584416 L7.9794064,11.6814421 L7.62537362,11.3252506 L4.34644661,8.02632683 C4.22615042,7.90603064 4.09966457,7.85277344 3.94,7.85277344 C3.78033543,7.85277344 3.65384958,7.90603064 3.53355339,8.02632683 L2.0247686,9.534744 C1.91172388,9.65532504 1.86,9.78635886 1.86,9.95277344 C1.86,10.119188 1.91172388,10.2502218 2.01355339,10.35922 L7.56197056,15.9080048 C7.6825516,16.0210496 7.81358543,16.0727734 7.98,16.0727734 C8.14641457,16.0727734 8.2774484,16.0210496 8.38644661,15.91922 L17.9864466,6.31922005 C18.1067428,6.19892385 18.16,6.07243801 18.16,5.91277344 Z M14.9464466,3.27922005 C15.2528192,2.97284744 15.632995,2.81277344 16.06,2.81277344 C16.487005,2.81277344 16.8671808,2.97284744 17.1735534,3.27922005 L18.6819706,4.78800484 C18.9975221,5.08383445 19.16,5.46971934 19.16,5.91277344 C19.16,6.33977847 18.999926,6.71995422 18.6935534,7.02632683 L9.08197056,16.637542 C8.7758828,16.9244993 8.40025503,17.0727734 7.98,17.0727734 C7.55974497,17.0727734 7.1841172,16.9244993 6.86644661,16.6263268 L1.2952314,11.054744 C1.00827412,10.7486562 0.86,10.3730285 0.86,9.95277344 C0.86,9.53251841 1.00827412,9.15689063 1.30644661,8.83922005 L2.82644661,7.31922005 C3.13281922,7.01284744 3.51299497,6.85277344 3.94,6.85277344 C4.36700503,6.85277344 4.74718078,7.01284744 5.05462638,7.32029631 L7.98059361,10.2641048 L14.9464466,3.27922005 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "5YSM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueMoment = {
  install: function install(Vue, options) {

    Vue.prototype.$moment = _moment2.default;
  }
};

_vue2.default.use(VueMoment);

exports.default = VueMoment;

/***/ }),

/***/ "5dOw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-annotation",
  "use": "icon-annotation-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-annotation\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-annotation</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-annotation_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-annotation_icon-annotation\">\n            <path d=\"M19.8257145,2.72 C19.9457151,2.8400006 20.0057145,2.9833325 20.0057145,3.15 C20.0057145,3.3166675 19.9457151,3.4533328 19.8257145,3.56 L19.4057145,4 L18.5657145,4.84 L18.1257145,5.26 L14.7457145,1.88 L15.1657145,1.44 L16.0057145,0.6 L16.4457145,0.18 C16.5523817,0.0599994 16.689047,0 16.8557145,0 C17.022382,0 17.1657139,0.0599994 17.2857145,0.18 L19.8257145,2.72 Z M3.02571445,13.58 L13.7057145,2.9 L17.1057145,6.3 L6.42571445,16.98 L3.02571445,13.58 Z M0.0257144536,19.72 L2.00571445,14.6 L5.40571445,18 L0.285714454,19.98 C0.179047254,20.0200002 0.0990480536,20.0133336 0.0457144536,19.96 C-0.00761914636,19.9066664 -0.0142857464,19.8266672 0.0257144536,19.72 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "6JIv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueCountdown = __webpack_require__("+ikV");

var _vueCountdown2 = _interopRequireDefault(_vueCountdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('countdown', _vueCountdown2.default);

/***/ }),

/***/ "6MUw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vue2Filters = __webpack_require__("OjAt");

var _vue2Filters2 = _interopRequireDefault(_vue2Filters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vue2Filters2.default);

/***/ }),

/***/ "6S3C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6W09":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sidney.16097e0.jpg";

/***/ }),

/***/ "6WdU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tajmahal.b88e6c9.jpg";

/***/ }),

/***/ "6eYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/research-links.vue
var research_links = __webpack_require__("tNHr");
var research_links_default = /*#__PURE__*/__webpack_require__.n(research_links);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c911afb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/research-links.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.data.links),function(link){return _c('li',[_c('a',{attrs:{"href":link.url}},[_vm._v(_vm._s(link.linkTitle))]),_c('br'),_vm._v(_vm._s(link.description)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var content_module_research_links = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/research-links.vue
function injectStyle (ssrContext) {
  __webpack_require__("36kZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c911afb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  research_links_default.a,
  content_module_research_links,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _global_content_module_research_links = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7+rr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pyramids.b01cee8.jpg";

/***/ }),

/***/ "789/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__("hooP");

var _router2 = _interopRequireDefault(_router);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storageProp = "sbClassicParams";

var ClassicParams = {

  required: true,

  onReady: null,

  install: function install(Vue, options) {

    this.onReady = new _promise2.default(function (resolve, reject) {

      _router2.default.onReady(function (route) {
        var params = (0, _extends3.default)({
          embedMode: false
        }, route.query);
        var assignParamKeys = ['classicHost', 'env', 'embedMode', 'loginToken', 'origin'];
        var storedParamKeys = ['classicHost', 'env', 'embedMode'];
        // Assign variables we WANT to store in sessionStorage
        _lodash2.default.map(assignParamKeys, function (prop) {
          var value = params[prop];
          if (!_lodash2.default.isNil(value)) {
            Vue.prototype.$classicParams[prop] = value;
          }
        });
        // Store param keys in sessionStorage
        sessionStorage.setItem(storageProp, (0, _stringify2.default)(_lodash2.default.pick(Vue.prototype.$classicParams, storedParamKeys)));
        // If we have a token, let's set it (but not store it)
        if (params.token) {
          sessionStorage.setItem('token', params.token);
        }
        // Remove all the loading query strings
        _router2.default.replace(route.path);
        // Tell any listeners we now have params set
        resolve(Vue.prototype.$classicParams);
      });

      Vue.prototype.$classicParams = JSON.parse(sessionStorage.getItem(storageProp) || '{}');

      Vue.prototype.$classicParams.$destroy = function () {
        sessionStorage.removeItem(storageProp);
      };
    });
  }
};

_vue2.default.use(ClassicParams);

exports.default = ClassicParams;

/***/ }),

/***/ "7qbW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'assignmentSubmitted',
  mixins: [_sidebar2.default]
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "7ubM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8SLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/blast-response.vue
var blast_response = __webpack_require__("QVMN");
var blast_response_default = /*#__PURE__*/__webpack_require__.n(blast_response);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08694766","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/blast-response.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{staticClass:"question"},[_vm._v(_vm._s(_vm.model.question.promptHtml))]),_vm._v(" "),(_vm.respondable)?_c('div',[_c('textarea-autogrow',{attrs:{"placeholder":"Begin typing...","max":_vm.maxchars},on:{"input":_vm.updateValue},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}}),_vm._v(" "),_c('div',{staticClass:"chars"},[_vm._v("Characters Left: "+_vm._s(_vm.charsLeft))])],1):_c('div',{staticClass:"response"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.model.response)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_blast_response = (esExports);
// CONCATENATED MODULE: ./src/components/_global/blast-response.vue
function injectStyle (ssrContext) {
  __webpack_require__("7ubM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08694766"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  blast_response_default.a,
  _global_blast_response,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_blast_response = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8ndo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vue',
  props: {
    template: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var settings = _.assign(this.config, {
      el: this.$el,
      template: this.template,
      parent: this
    });
    new _vue2.default(settings);
  }
}; //
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "9/aY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AssignmentList/index.vue
var AssignmentList = __webpack_require__("TNX8");
var AssignmentList_default = /*#__PURE__*/__webpack_require__.n(AssignmentList);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a7193b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignmentList/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assignments.length)?_vm._t("headline"):_vm._e(),_vm._v(" "),(_vm.assignments.length)?_c('ul',{class:['assignment-items', { 'is-odd': ((_vm.assignments.length+1) % 2 === 0) }]},_vm._l((_vm.assignments),function(blast){return _c('assignment-item',{key:blast.id,attrs:{"blast":blast}})})):_c('div',[_vm._t("empty")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_AssignmentList = (esExports);
// CONCATENATED MODULE: ./src/components/AssignmentList/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("K4MD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45a7193b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AssignmentList_default.a,
  components_AssignmentList,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_AssignmentList = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9hrF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'Btn',
  props: {
    disabled: {
      type: Boolean,
      defaultTo: false
    }
  }
};

/***/ }),

/***/ "A3OU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ABrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-down-dir",
  "use": "icon-down-dir-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-down-dir\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-down-dir</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-down-dir_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-down-dir_icon-down-dir\">\n            <path d=\"M15.7091667,7.5 C15.7091667,7.6866676 15.6425007,7.8533326 15.5091667,8 L10.5091667,13 C10.3624993,13.1466674 10.1958343,13.22 10.0091667,13.22 C9.82249905,13.22 9.65583405,13.1466674 9.50916665,13 L4.50916665,8 C4.36249925,7.8533326 4.28916665,7.6866676 4.28916665,7.5 C4.28916665,7.3133324 4.36249925,7.1466674 4.50916665,7 C4.65583405,6.8533326 4.82249905,6.78 5.00916665,6.78 L15.0091667,6.78 C15.1958343,6.78 15.3624993,6.8533326 15.5091667,7 C15.6558341,7.1466674 15.7225001,7.3133324 15.7091667,7.5 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "AKuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Modal/index.vue
var Modal = __webpack_require__("+whx");
var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a1444c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default",[_vm._t("header",[_c('div',{staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_vm._t("body")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Modal = (esExports);
// CONCATENATED MODULE: ./src/components/Modal/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZwO8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a1444c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Modal_default.a,
  components_Modal,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AT2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AjKI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/monument.95f3d30.jpg";

/***/ }),

/***/ "AxAM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B0+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/sticky.vue
var sticky = __webpack_require__("KUtT");
var sticky_default = /*#__PURE__*/__webpack_require__.n(sticky);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-436a73eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/sticky.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component",staticClass:"sticky"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_sticky = (esExports);
// CONCATENATED MODULE: ./src/components/_global/sticky.vue
function injectStyle (ssrContext) {
  __webpack_require__("MDMS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  sticky_default.a,
  _global_sticky,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_sticky = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "B3WU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/rate-peer.vue
var rate_peer = __webpack_require__("H2B/");
var rate_peer_default = /*#__PURE__*/__webpack_require__.n(rate_peer);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e3f79b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/rate-peer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',{domProps:{"innerHTML":_vm._s(_vm.review.revieweeUserAssignment.reviewQuestion.response)}}),_vm._v(" "),_c('ul',_vm._l((_vm.review.rubrics.criteria),function(criteriaItem,criteriaIndex){return _c('li',[(_vm.review.rubrics.criteria.length > 1)?_c('p',[_vm._v(_vm._s(criteriaItem.name)+":")]):_vm._e(),_vm._v(" "),_c('ratings',{attrs:{"range":_vm.review.rubrics.scoreRange,"name":'rating-'+_vm.review.revieweeUserAssignmentId+'-'+criteriaIndex,"stars":_vm.review.rubrics.criteria.length == 1},on:{"input":function($event){_vm.updateRatings(_vm.ratings)}},model:{value:(_vm.review.ratings[criteriaIndex]),callback:function ($$v) {_vm.$set(_vm.review.ratings, criteriaIndex, $$v)},expression:"review.ratings[criteriaIndex]"}})],1)})),_vm._v(" "),_c('textarea-autogrow',{attrs:{"placeholder":"Begin typing..."},model:{value:(_vm.review.review),callback:function ($$v) {_vm.$set(_vm.review, "review", $$v)},expression:"review.review"}}),_vm._v(" "),_c('btn',{attrs:{"disabled":!_vm.reviewIsValid},on:{"click":function($event){$event.preventDefault();_vm.saveReview($event)}}},[_vm._v("Save Review")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_rate_peer = (esExports);
// CONCATENATED MODULE: ./src/components/_global/rate-peer.vue
function injectStyle (ssrContext) {
  __webpack_require__("yKHI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e3f79b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  rate_peer_default.a,
  _global_rate_peer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_rate_peer = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "B9Ve":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/basil.b22c630.jpg";

/***/ }),

/***/ "BmKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/blast-labels.vue
var blast_labels = __webpack_require__("DpJU");
var blast_labels_default = /*#__PURE__*/__webpack_require__.n(blast_labels);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7651280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/blast-labels.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('sprite',{attrs:{"name":"iconCalendar","title":"Due Date"}}),_vm._v("\n    Due "+_vm._s(_vm.$moment(_vm.blast.dueDate).fromNow())+"\n  ")],1),_vm._v(" "),_c('li',[_c('sprite',{attrs:{"name":"iconProfile","title":"Assigned By"}}),_vm._v("\n    "+_vm._s(_vm.$_.get(_vm.blast, 'assignment.assignedBy'))+"\n  ")],1),_vm._v(" "),_c('li',[_c('sprite',{attrs:{"name":"iconBlast","title":"Assignment Type"}}),_vm._v("\n    "+_vm._s(_vm.blast.assignmentType)+"\n  ")],1),_vm._v(" "),(_vm.blast.isReview)?_c('li',[_c('sprite',{attrs:{"name":"iconReview","title":"Review Mode"}}),_vm._v("\n    Review Mode\n  ")],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_blast_labels = (esExports);
// CONCATENATED MODULE: ./src/components/_global/blast-labels.vue
function injectStyle (ssrContext) {
  __webpack_require__("p9D3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7651280"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  blast_labels_default.a,
  _global_blast_labels,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_blast_labels = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BmRi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haydar.4896a69.jpg";

/***/ }),

/***/ "Bqf3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _definition = __webpack_require__("izHg");

var _definition2 = _interopRequireDefault(_definition);

var _selector = __webpack_require__("LeFr");

var _selector2 = _interopRequireDefault(_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'vocab',
  props: {
    model: Object,
    respondable: Boolean
  },
  components: { Definition: _definition2.default, Selector: _selector2.default },
  data: function data() {
    return {
      definitions: _.reduce(this.model.question.definitions, function (definitions, definition) {
        definitions[definition.id] = definition;
        return definitions;
      }, {})
    };
  },

  computed: {
    availableDefinitions: function availableDefinitions() {
      var used = _.map(this.model.response, function (response) {
        return +response.answerDefinitionId;
      });
      return this.model.question.definitions.filter(function (definition) {
        return !used.includes(definition.id);
      });
    }
  },
  methods: {
    doit: function doit(d) {
      this.model.DSSave();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "BuBz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C5MG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'assignmentList',
  props: {
    blast: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function title() {
      var words = this.blast.assignment.name.split(' ');
      var lastWords = words.splice(-2, 2).join('&nbsp;');
      words.push(lastWords);
      return words.join(' ');
    },
    dueDateStamp: function dueDateStamp() {
      return this.blast.pastDue ? "Past Due" : moment(this.blast.dueDate).fromNow(true);
    },
    status: function status() {
      if (this.blast.isOpen) {
        return { icon: "iconStar", label: "Assigned" };
      }
      if (this.blast.isClosed || this.blast.reviewsGivenCount >= this.blast.assignment.maxReview) {
        return { icon: "iconCheck", label: "Complete" };
      }
      if (this.blast.reviewsAvailableCount) {
        return { icon: "iconReview", label: "Review Available" };
      }
      return { icon: "iconHourglass", label: "Waiting for Review" };
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("PJh5")))

/***/ }),

/***/ "CBCv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

var _VisualVocab = __webpack_require__("yjho");

var _VisualVocab2 = _interopRequireDefault(_VisualVocab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//


exports.default = {
  name: 'vocab',
  mixins: [_sidebar2.default],
  components: { VisualVocab: _VisualVocab2.default }
};

/***/ }),

/***/ "CDdB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/404/index.vue
var _04 = __webpack_require__("M0Gz");
var _04_default = /*#__PURE__*/__webpack_require__.n(_04);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09245b0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/404/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('div',{staticClass:"container"},[_c('p',[_vm._v("It looks like you’ve reached a page that doesn’t exist. Redirecting you to the assignments page...")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var routes_404 = (esExports);
// CONCATENATED MODULE: ./src/routes/404/index.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  _04_default.a,
  routes_404,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_routes_404 = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CJs7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/halong.a43ed38.jpg";

/***/ }),

/***/ "Cewq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CmTk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/agua.1d19a10.jpg";

/***/ }),

/***/ "Cpn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-pullout",
  "use": "icon-pullout-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-pullout\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-pullout</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-pullout_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-pullout_icon-pullout\" fill-rule=\"nonzero\">\n            <path d=\"M5.35746231,10.4877633 C5.28018549,10.3391813 5.23651123,10.170327 5.23651123,9.99127197 C5.23651123,9.89326214 5.24959678,9.79830859 5.2741161,9.70806312 C5.29723304,9.60194682 5.33691459,9.4975502 5.3941226,9.398463 L7.39075799,5.94018907 C7.68830545,5.42482176 8.34730307,5.24824388 8.86267037,5.54579133 C9.37803768,5.84333879 9.55461556,6.50233641 9.25706811,7.01770372 L8.16238105,8.91375732 L18.7924481,8.91375732 C19.387543,8.91375732 19.8699627,9.39617706 19.8699627,9.99127197 C19.8699627,10.5863669 19.387543,11.0687866 18.7924481,11.0687866 L8.17810699,11.0687866 L9.25706811,12.9376021 C9.55461556,13.4529694 9.37803768,14.111967 8.86267037,14.4095145 C8.34730307,14.7070619 7.68830545,14.530484 7.39075799,14.0151167 L7.39075799,14.0151167 L5.3941226,10.5568428 C5.38098162,10.5340819 5.3687654,10.5110409 5.35746231,10.4877633 Z M1.64459229,0.331237793 L1.64459229,0.331237793 C2.43027667,0.331237793 3.06719971,0.968160831 3.06719971,1.75384521 L3.06719971,18.2286987 L3.06719971,18.2286987 C3.06719971,19.0143831 2.43027667,19.6513062 1.64459229,19.6513062 L1.64459229,19.6513062 C0.858907901,19.6513062 0.221984863,19.0143831 0.221984863,18.2286987 L0.221984863,1.75384521 L0.221984863,1.75384521 C0.221984863,0.968160831 0.858907901,0.331237793 1.64459229,0.331237793 L1.64459229,0.331237793 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Ct8I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var focusInput = function focusInput(element) {
  ($(element).is(":input") ? $(element) : $(element).find(":input")).focus();
};

exports.default = {
  name: "autoFocus",
  inserted: function inserted(el) {
    _.defer(function () {
      focusInput(el);
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("M4fF")))

/***/ }),

/***/ "D9hc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/ratings.vue
var ratings = __webpack_require__("mRjK");
var ratings_default = /*#__PURE__*/__webpack_require__.n(ratings);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b91beac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/ratings.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ratings', {'zero-based': _vm.zeroBased, stars: _vm.stars, numbers: !_vm.stars, hovering: !!_vm.hovered, 'not-hovering': !_vm.hovered}]},_vm._l((_vm.range),function(index){return _c('label',{class:{active: (_vm.hovered) ? index <= _vm.hovered : index <= _vm.innerValue, 'read-only': _vm.readOnly},on:{"mouseenter":function($event){_vm.hovered = index},"mouseleave":function($event){_vm.hovered = null}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.innerValue),expression:"innerValue"}],attrs:{"type":"radio","name":_vm.name,"disabled":_vm.readOnly},domProps:{"value":index,"checked":_vm._q(_vm.innerValue,index)},on:{"change":[function($event){_vm.innerValue=index},_vm.updateValues]}}),_vm._v(" "),(_vm.stars)?_c('sprite',{staticClass:"star-icon star-icon--outline",attrs:{"name":"iconStarOutline"}}):_vm._e(),_vm._v(" "),(_vm.stars)?_c('sprite',{staticClass:"star-icon star-icon--active",attrs:{"name":"iconStar"}}):_c('span',[_vm._v(_vm._s(index))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_ratings = (esExports);
// CONCATENATED MODULE: ./src/components/_global/ratings.vue
function injectStyle (ssrContext) {
  __webpack_require__("17R7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b91beac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ratings_default.a,
  _global_ratings,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_ratings = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DBiS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DRx7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brixby.d356760.jpg";

/***/ }),

/***/ "DXb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DkTw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "questions",
  relations: {
    belongsTo: {
      questionGroups: {
        localField: "questionGroup",
        localKey: "groupId"
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "DkuM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DlbQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/morainta.72bbba8.jpg";

/***/ }),

/***/ "DpJU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'blastLabels',
  props: {
    blast: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "DxDC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _2 = __webpack_require__("IcnI");

var _3 = _interopRequireDefault(_2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _3.default.defineResource({
  name: "userAssignments",
  endpoint: "user-assignments",
  relations: {
    hasMany: {
      responses: [{
        localField: "responses",
        localKeys: "responseIds"
      }, {
        localField: "compResponseIds",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.responses).filter({ question: { key: "sbcomp" } }).orderBy("displayOrder").map("id").value();
        }
      }, {
        localField: "compResponses",
        localKeys: "compResponseIds"
      }],
      reviews: [{
        localField: 'reviews',
        localKeys: 'reviewIds'
      }, {
        localField: 'reviewsGivenIds',
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.reviews).filter({ state: 'closed', reviewerUserAssignmentId: instance.id }).map("id").value();
        }
      }, {
        localField: 'peerReviewsReceivedIds',
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.reviews).filter(function (x) {
            return x.state === 'closed' && x.revieweeUserAssignmentId === instance.id && !!x.reviewerUserAssignmentId;
          }).map("id").value();
        }
      }, {
        localField: 'reviewsGiven',
        localKeys: 'reviewsGivenIds'
      }, {
        localField: 'peerReviewsReceived',
        localKeys: 'peerReviewsReceivedIds'
      }],
      annotations: [{
        localField: 'annotations',
        localKeys: 'annotationIds'
      }, {
        localField: 'teacherAnnotations',
        localKeys: 'teacherAnnotationIds'
      }],
      questionGroups: [{
        localField: "questionGroupIds",
        get: function get(Resource, relationDef, instance, origGetter) {
          var sortBy = {
            7: 1, // Comp
            10: 2, // Blast
            9: 2, // Write
            11: 3 // QuikPoll
          };
          return _.chain(instance.assignment.questions).map("groupId").uniq().sortBy(function (id) {
            return sortBy[id];
          }).value();
        }
      }, {
        localField: "questionGroups",
        localKeys: "questionGroupIds"
      }]
    },
    hasOne: {
      reviews: [{
        localField: 'teacherReviewId',
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.reviews).find(function (review) {
            return review.state == 'closed' && !review.reviewerUserAssignmentId;
          }).get("id").value();
        }
      }, {
        localField: "teacherReview",
        localKey: "teacherReviewId"
      }],
      responses: [{
        localField: "blastPromptId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.responses).find({ question: { key: "sbblast" } }).get("id").value();
        }
      }, {
        localField: "quikPollId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.responses).find({ question: { key: "sbpoll" } }).get("id").value();
        }
      }, {
        localField: "writeResponseId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.responses).find({ question: { key: "write" } }).get("id").value();
        }
      }, {
        localField: "reviewQuestionId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return instance.writeResponseId || instance.blastPromptId;
        }
      }, {
        localField: "vocabQuestionId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.responses).find({ question: { key: "sbvocab" } }).get("id").value();
        }
      }, {
        localField: "blastPrompt",
        localKey: "blastPromptId"
      }, {
        localField: "quikPoll",
        localKey: "quikPollId"
      }, {
        localField: "write",
        localKey: "writeResponseId"
      }, {
        localField: "reviewQuestion",
        localKey: "reviewQuestionId"
      }, {
        localField: "vocabQuestion",
        localKey: "vocabQuestionId"
      }]
    },
    belongsTo: {
      assignments: {
        localKey: "assignmentId",
        localField: "assignment"
      }
    }
  },
  computed: {
    dueDate: {
      get: function get() {
        var key = this.state == 'review' ? 'reviewEndDate' : 'endDate';
        if (this.assignment) {
          return moment(_.get(this, "assignment." + key));
        }
      }
    },
    isOpen: {
      get: function get() {
        return this.state === 'open';
      }
    },
    isClosed: {
      get: function get() {
        return this.state === 'closed';
      }
    },
    isReview: {
      get: function get() {
        return this.state === 'review';
      }
    },
    allResponsesComplete: {
      get: function get() {
        return _.every(this.responses, function (response) {
          return !!response.response;
        });
      }
    },
    assignmentType: function () {
      var typeLookup = {
        15: 'Read',
        16: 'Blast',
        17: 'Write'
      };
      return {
        get: function get() {
          return typeLookup[_.get(this, 'assignment.typeId')] || null;
        }
      };
    }(),
    completionProgress: {
      enumerable: true,
      get: function get() {
        var completed = _.filter(this.responses, function (response) {
          var key = _.get(response, "question.key");
          if (key == 'sbvocab') {
            return _.every(response.response, function (r) {
              return !!r.answerDefinitionId;
            });
          } else {
            return !!response.response;
          }
        }).length;
        return completed / this.responses.length * 100;
      }
    }
  },
  methods: {
    submitAssignment: function submitAssignment() {
      _.assign(this, {
        state: "pending",
        postDate: moment().toISOString()
      });
      return this.DSSave();
    },
    getNextOpenReview: function getNextOpenReview() {
      var review = _.find(this.reviews, { state: "open" });
      return review ? _.set(review, "review", "") : null;
    }
  }
});

exports.default = resource;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF"), __webpack_require__("PJh5")))

/***/ }),

/***/ "Dzvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Annotator/index.vue
var Annotator = __webpack_require__("fklI");
var Annotator_default = /*#__PURE__*/__webpack_require__.n(Annotator);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ffdae96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Annotator/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['annotation', { 'user-select-disabled': _vm.clearSelection || (_vm.on && _vm.selection.start) }]},[_c('div',{staticClass:"body"},[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade-up"}},[(_vm.showControls)?_c('annotation-controls',{ref:"controls",attrs:{"annotation":_vm.annotation,"on":_vm.on},on:{"save":function($event){_vm.save()},"close":function($event){_vm.resetSelection()},"controlsMounted":_vm.positionControls}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Annotator = (esExports);
// CONCATENATED MODULE: ./src/components/Annotator/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("m48A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ffdae96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Annotator_default.a,
  components_Annotator,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Annotator = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "E2F4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/horseshoefalls.e606b07.jpg";

/***/ }),

/***/ "EHqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-ribbon",
  "use": "icon-ribbon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-ribbon\">\n    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-ribbon</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-ribbon_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-ribbon_icon-ribbon\">\n            <path d=\"M8.49882903,13.12 L7.37882903,12.02 L5.79882903,11.82 L5.25882903,10.34 L3.93882903,9.48 L4.09882903,7.9 L3.27882903,6.56 L4.09882903,5.2 L3.93882903,3.64 L5.25882903,2.78 L5.79882903,1.3 L7.37882903,1.1 L8.49882903,0 L9.99882903,0.5 L11.498829,0 L12.618829,1.1 L14.198829,1.3 L14.738829,2.78 L16.058829,3.64 L15.898829,5.2 L16.718829,6.56 L15.898829,7.9 L16.058829,9.48 L14.738829,10.32 L14.198829,11.82 L12.618829,12 L11.498829,13.12 L9.99882903,12.6 L8.49882903,13.12 Z M10.238829,13.9 L11.798829,14.42 L13.158829,13.1 L15.018829,12.86 L15.358829,11.96 L17.758829,17.98 L14.738829,17.14 L14.278829,17.32 L12.678829,20 L12.358829,19.2 C11.4654912,16.9599888 10.7588316,15.1933398 10.238829,13.9 Z M4.63882903,11.96 L4.97882903,12.86 L6.85882903,13.1 L8.19882903,14.42 L9.75882903,13.9 C9.23882643,15.1933398 8.53216683,16.9599888 7.63882903,19.2 L7.31882903,20 L5.71882903,17.32 L5.25882903,17.14 L2.23882903,17.98 C3.17216703,15.646655 3.97215903,13.6400084 4.63882903,11.96 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "EJGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/poster-image.vue
var poster_image = __webpack_require__("yThj");
var poster_image_default = /*#__PURE__*/__webpack_require__.n(poster_image);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c701c920","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/poster-image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{on:{"error":function($event){_vm.useFallback()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_poster_image = (esExports);
// CONCATENATED MODULE: ./src/components/_global/poster-image.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  poster_image_default.a,
  _global_poster_image,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_poster_image = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Euco":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/quik-poll.vue
var quik_poll = __webpack_require__("QgTD");
var quik_poll_default = /*#__PURE__*/__webpack_require__.n(quik_poll);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567a012d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/quik-poll.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.respondable)?_c('div',[_c('p',{staticClass:"question"},[_vm._v(_vm._s(_vm.model.question.question))]),_vm._v(" "),_c('radio-group',{attrs:{"options":_vm.model.question.options,"name":"poll"},on:{"input":function($event){_vm.save()}},model:{value:(_vm.model.response),callback:function ($$v) {_vm.$set(_vm.model, "response", $$v)},expression:"model.response"}})],1):_c('div',[_c('p',{staticClass:"question"},[_vm._v(_vm._s(_vm.model.question.question))]),_vm._v(" "),_c('chart',{staticClass:"quikpoll",attrs:{"data":_vm.data,"labels":_vm.labels}}),_vm._v(" "),_c('ul',{staticClass:"legend"},_vm._l((_vm.options),function(option){return _c('li',{attrs:{"color":option.color}},[_c('span',{staticClass:"color",style:({backgroundColor: option.color})}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(option.value))]),_vm._v(" "),_c('span',{staticClass:"percent"},[_vm._v(_vm._s(option.percent)+"%")])])}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_quik_poll = (esExports);
// CONCATENATED MODULE: ./src/components/_global/quik-poll.vue
function injectStyle (ssrContext) {
  __webpack_require__("O0LQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-567a012d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  quik_poll_default.a,
  _global_quik_poll,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_quik_poll = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FHVA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/greatwall.af06253.jpg";

/***/ }),

/***/ "FKUz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "questionGroups",
  relations: {
    hasMany: {
      questions: {
        localField: "questions",
        foreignKey: "groupId"
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "FdUn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/sprite.vue
var sprite = __webpack_require__("x5YY");
var sprite_default = /*#__PURE__*/__webpack_require__.n(sprite);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02676e06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/sprite.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":_vm.sprites[_vm.name].viewBox}},[_c('use',{attrs:{"xlink:href":'#'+_vm.sprites[_vm.name].id}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_sprite = (esExports);
// CONCATENATED MODULE: ./src/components/_global/sprite.vue
function injectStyle (ssrContext) {
  __webpack_require__("WdoC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02676e06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  sprite_default.a,
  _global_sprite,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_sprite = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Fi2f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    blast: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      responses: this.blast.responses,
      reviews: this.blast.reviews
    };
  },

  computed: {
    noReviewsAvailableMessage: function noReviewsAvailableMessage() {
      return this.blast.reviewsGivenCount >= this.blast.assignment.maxReview ? "You have completed all assigned reviews!" : "There are currently no peer responses available to review. Please check back later!";
    },
    reviewCountMessage: function reviewCountMessage() {
      switch (this.blast.reviewsGivenCount) {
        case 0:
          return "not completed any reviews";
        case 1:
          return "completed one review";
        default:
          return "completed " + this.blast.reviewsGivenCount + " reviews";
      }
    }
  }
};

/***/ }),

/***/ "GX+T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'vocabDefinition',
  props: {
    value: Number,
    available: Array,
    all: Array
  },
  data: function data() {
    var _this = this;

    var selected = function () {
      if (_this.value) {
        var definition = _this.all.find(function (d) {
          return d.id == _this.value;
        });
        return {
          id: definition.id,
          label: definition.definition,
          enabled: false
        };
      } else {
        return null;
      }
    }();
    return {
      selected: selected,
      dropActive: false
    };
  },

  methods: {
    select: function select(option, event) {
      this.selected = option;
      this.$emit("input", option.id);
    },
    clear: function clear() {
      this.selected = null;
      this.$emit("input", null);
    },
    toggleDrop: function toggleDrop() {
      var _this2 = this;

      this.dropActive = !this.dropActive;
      if (this.dropActive) {
        this.$nextTick(function () {
          $(window).one("click", function () {
            _this2.dropActive = false;
          });
        });
      }
    }
  },
  computed: {
    options: function options() {
      var options = this.available.map(function (definition) {
        return {
          id: definition.id,
          label: definition.definition
        };
      });
      return _.shuffle(options);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("M4fF")))

/***/ }),

/***/ "GX5x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gb9X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'BlastStudentMasthead',
  props: {
    bg: {
      type: String
    },
    video: {
      type: Object
    }
  },
  data: function data() {
    return {
      showBody: !this.video
    };
  },

  methods: {
    toggleBody: function toggleBody(state) {
      this.showBody = state;
    }
  }
};

/***/ }),

/***/ "Gcho":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newyork.39df742.jpg";

/***/ }),

/***/ "GeeW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/montecarlo.a078364.jpg";

/***/ }),

/***/ "GoCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/write.vue
var write = __webpack_require__("5Sp0");
var write_default = /*#__PURE__*/__webpack_require__.n(write);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc81910e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/write.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Write"}},[_c('write-response',{attrs:{"model":_vm.blast.write,"respondable":_vm.blast.isOpen}}),_vm._v(" "),_c('review-display',{attrs:{"blast":_vm.blast}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_write = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/write.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  write_default.a,
  sidebar_write,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_write = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "H2B/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'RatePeer',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      ratings: this.review.ratings,
      inProgressInterval: null
    };
  },
  created: function created() {
    var _this = this;

    this.setInProgress();
    this.inProgressInterval = setInterval(function () {
      _this.setInProgress();
    }, 4 * 60 * 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.inProgressInterval);
  },

  computed: {
    reviewIsValid: function reviewIsValid() {
      return _.compact(this.ratings).length == this.review.rubrics.criteria.length;
    }
  },
  methods: {
    updateRatings: function updateRatings(ratings) {
      this.ratings = ratings;
    },
    saveReview: function saveReview() {
      this.review.state = 'completed';
      this.$emit('submit');
    },
    setInProgress: function setInProgress() {
      this.review.DSUpdate({ state: "in-progress" }, { cacheResponse: false });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "HHDd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HS0v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HTlV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-calendar\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-calendar</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-calendar_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-calendar_icon-calendar\">\n            <path d=\"M2.13,18.58 L5.35,18.58 L5.35,15.36 L2.13,15.36 L2.13,18.58 Z M6.07,18.58 L9.63,18.58 L9.63,15.36 L6.07,15.36 L6.07,18.58 Z M2.13,14.64 L5.35,14.64 L5.35,11.08 L2.13,11.08 L2.13,14.64 Z M6.07,14.64 L9.63,14.64 L9.63,11.08 L6.07,11.08 L6.07,14.64 Z M2.13,10.36 L5.35,10.36 L5.35,7.14 L2.13,7.14 L2.13,10.36 Z M10.35,18.58 L13.93,18.58 L13.93,15.36 L10.35,15.36 L10.35,18.58 Z M6.07,10.36 L9.63,10.36 L9.63,7.14 L6.07,7.14 L6.07,10.36 Z M14.63,18.58 L17.85,18.58 L17.85,15.36 L14.63,15.36 L14.63,18.58 Z M10.35,14.64 L13.93,14.64 L13.93,11.08 L10.35,11.08 L10.35,14.64 Z M6.43,5 L6.43,1.78 C6.43,1.6866662 6.3900004,1.606667 6.31,1.54 C6.2299996,1.473333 6.1500004,1.4333334 6.07,1.42 L5.35,1.42 C5.2566662,1.42 5.176667,1.4599996 5.11,1.54 C5.043333,1.6200004 5.0033334,1.6999996 4.99,1.78 L4.99,5 C4.99,5.0933338 5.0299996,5.1799996 5.11,5.26 C5.1900004,5.3400004 5.2699996,5.3733334 5.35,5.36 L6.07,5.36 C6.1633338,5.36 6.243333,5.326667 6.31,5.26 C6.376667,5.193333 6.4166666,5.1066672 6.43,5 Z M14.63,14.64 L17.85,14.64 L17.85,11.08 L14.63,11.08 L14.63,14.64 Z M10.35,10.36 L13.93,10.36 L13.93,7.14 L10.35,7.14 L10.35,10.36 Z M14.63,10.36 L17.85,10.36 L17.85,7.14 L14.63,7.14 L14.63,10.36 Z M14.99,5 L14.99,1.78 C14.99,1.6866662 14.956667,1.606667 14.89,1.54 C14.823333,1.473333 14.7366672,1.4333334 14.63,1.42 L13.93,1.42 C13.8366662,1.42 13.7500004,1.4599996 13.67,1.54 C13.5899996,1.6200004 13.5566666,1.6999996 13.57,1.78 L13.57,5 C13.57,5.0933338 13.603333,5.1799996 13.67,5.26 C13.736667,5.3400004 13.8233328,5.3733334 13.93,5.36 L14.63,5.36 C14.7366672,5.36 14.823333,5.326667 14.89,5.26 C14.956667,5.193333 14.99,5.1066672 14.99,5 Z M19.29,4.28 L19.29,18.58 C19.29,18.9666686 19.1433348,19.2999986 18.85,19.58 C18.5566652,19.8600014 18.2233352,20 17.85,20 L2.13,20 C1.7433314,20 1.4100014,19.8600014 1.13,19.58 C0.8499986,19.2999986 0.71,18.9666686 0.71,18.58 L0.71,4.28 C0.71,3.8933314 0.8499986,3.5600014 1.13,3.28 C1.4100014,2.9999986 1.7433314,2.86 2.13,2.86 L3.57,2.86 L3.57,1.78 C3.57,1.2866642 3.7433316,0.8666684 4.09,0.52 C4.4366684,0.1733316 4.8566642,0 5.35,0 L6.07,0 C6.5633358,0 6.9833316,0.1733316 7.33,0.52 C7.6766684,0.8666684 7.85,1.2866642 7.85,1.78 L7.85,2.86 L12.13,2.86 L12.13,1.78 C12.13,1.2866642 12.3099982,0.8666684 12.67,0.52 C13.0300018,0.1733316 13.4499976,0 13.93,0 L14.63,0 C15.1233358,0 15.5499982,0.1733316 15.91,0.52 C16.2700018,0.8666684 16.4433334,1.2866642 16.43,1.78 L16.43,2.86 L17.85,2.86 C18.2366686,2.86 18.5699986,2.9999986 18.85,3.28 C19.1300014,3.5600014 19.2766666,3.8933314 19.29,4.28 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "HckQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Annotator = __webpack_require__("Dzvx");

var _Annotator2 = _interopRequireDefault(_Annotator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'interactiveText',
  props: {
    annotationOn: { type: Boolean },
    annotationConfig: { type: Object }
  },
  components: { Annotator: _Annotator2.default },
  data: function data() {
    return {};
  }
}; //
//
//
//
//
//
//
//

/***/ }),

/***/ "HlYY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dorset.cd75baa.jpg";

/***/ }),

/***/ "HqjJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueLodash = {
  install: function install(Vue, options) {

    Vue.prototype.$_ = _lodash2.default;
  }
};

_vue2.default.use(VueLodash);

exports.default = VueLodash;

/***/ }),

/***/ "HulK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SecondaryNavigation',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      channels: []
    };
  },
  created: function created() {
    // TODO: Add channels after MVP
    // store.findAll('channels').then((channels) => {
    //   this.channels = channels
    // })
  },
  mounted: function mounted() {
    var _this = this;

    $(window).on("keyup.secNav", function (e) {
      if (e.which == 27) {
        _this.closeNav();
      }
    });
  },
  destroyed: function destroyed() {
    $(window).off(".secNav");
  },

  methods: {
    closeNav: function closeNav() {
      this.$emit('close');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "HvI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-clock\">\n    <!-- Generator: Sketch 49.3 (51167) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-clock</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-clock_icon-clock\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <path d=\"M11.6666667,5.41666667 L11.6666667,11.25 C11.6666667,11.3715284 11.6276046,11.4713538 11.5494792,11.5494792 C11.4713538,11.6276046 11.3715284,11.6666667 11.25,11.6666667 L7.08333333,11.6666667 C6.96180495,11.6666667 6.86197956,11.6276046 6.78385417,11.5494792 C6.70572878,11.4713538 6.66666667,11.3715284 6.66666667,11.25 L6.66666667,10.4166667 C6.66666667,10.2951383 6.70572878,10.1953129 6.78385417,10.1171875 C6.86197956,10.0390621 6.96180495,10 7.08333333,10 L10,10 L10,5.41666667 C10,5.29513828 10.0390621,5.19531289 10.1171875,5.1171875 C10.1953129,5.03906211 10.2951383,5 10.4166667,5 L11.25,5 C11.3715284,5 11.4713538,5.03906211 11.5494792,5.1171875 C11.6276046,5.19531289 11.6666667,5.29513828 11.6666667,5.41666667 Z M16.8431373,13.9285462 C17.5588271,12.7033381 17.9166667,11.365431 17.9166667,9.91478471 C17.9166667,8.4641384 17.5588271,7.1262313 16.8431373,5.90102327 C16.1274474,4.67581523 15.1568689,3.70546503 13.9313725,2.98994354 C12.7058762,2.27442205 11.3676543,1.91666667 9.91666667,1.91666667 C8.46567902,1.91666667 7.12745711,2.27442205 5.90196078,2.98994354 C4.67646446,3.70546503 3.70588593,4.67581523 2.99019608,5.90102327 C2.27450623,7.1262313 1.91666667,8.4641384 1.91666667,9.91478471 C1.91666667,11.365431 2.27450623,12.7033381 2.99019608,13.9285462 C3.70588593,15.1537542 4.67646446,16.1241044 5.90196078,16.8396259 C7.12745711,17.5551474 8.46567902,17.9129028 9.91666667,17.9129028 C11.3676543,17.9129028 12.7058762,17.5551474 13.9313725,16.8396259 C15.1568689,16.1241044 16.1274474,15.1537542 16.8431373,13.9285462 Z M18.6588542,4.98697917 C19.5529559,6.51476458 20,8.18575482 20,10 C20,11.8142452 19.5529559,13.4874055 18.6588542,15.0195313 C17.7647525,16.551657 16.551657,17.7647525 15.0195313,18.6588542 C13.4874055,19.5529559 11.8142452,20 10,20 C8.18575482,20 6.51259447,19.5529559 4.98046875,18.6588542 C3.44834303,17.7647525 2.23524753,16.551657 1.34114583,15.0195313 C0.447044141,13.4874055 1.77635684e-15,11.8142452 1.77635684e-15,10 C1.77635684e-15,8.18575482 0.447044141,6.51259447 1.34114583,4.98046875 C2.23524753,3.44834303 3.44834303,2.23524753 4.98046875,1.34114583 C6.51259447,0.447044141 8.18575482,1.77635684e-15 10,1.77635684e-15 C11.8142452,1.77635684e-15 13.4874055,0.447044141 15.0195313,1.34114583 C16.551657,2.23524753 17.7647525,3.45051315 18.6588542,4.98697917 Z\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Hyns":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/clipboard.vue
var clipboard = __webpack_require__("i+2D");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(clipboard);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d00a85","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/clipboard.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","data-clipboard-text":_vm.text}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_clipboard = (esExports);
// CONCATENATED MODULE: ./src/components/_global/clipboard.vue
function injectStyle (ssrContext) {
  __webpack_require__("DkuM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73d00a85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  clipboard_default.a,
  _global_clipboard,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_clipboard = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "I3gN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-pause\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-pause</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-pause_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-pause_icon-pause\">\n            <path d=\"M18.5714286,2.14285714 L18.5714286,17.8571429 C18.5714286,18.0505962 18.5007448,18.2180052 18.359375,18.359375 C18.2180052,18.5007448 18.0505962,18.5714286 17.8571429,18.5714286 L12.1428571,18.5714286 C11.9494038,18.5714286 11.7819948,18.5007448 11.640625,18.359375 C11.4992552,18.2180052 11.4285714,18.0505962 11.4285714,17.8571429 L11.4285714,2.14285714 C11.4285714,1.94940379 11.4992552,1.78199475 11.640625,1.640625 C11.7819948,1.49925525 11.9494038,1.42857143 12.1428571,1.42857143 L17.8571429,1.42857143 C18.0505962,1.42857143 18.2180052,1.49925525 18.359375,1.640625 C18.5007448,1.78199475 18.5714286,1.94940379 18.5714286,2.14285714 Z M8.57142857,2.14285714 L8.57142857,17.8571429 C8.57142857,18.0505962 8.50074475,18.2180052 8.359375,18.359375 C8.21800525,18.5007448 8.05059621,18.5714286 7.85714286,18.5714286 L2.14285714,18.5714286 C1.94940379,18.5714286 1.78199475,18.5007448 1.640625,18.359375 C1.49925525,18.2180052 1.42857143,18.0505962 1.42857143,17.8571429 L1.42857143,2.14285714 C1.42857143,1.94940379 1.49925525,1.78199475 1.640625,1.640625 C1.78199475,1.49925525 1.94940379,1.42857143 2.14285714,1.42857143 L7.85714286,1.42857143 C8.05059621,1.42857143 8.21800525,1.49925525 8.359375,1.640625 C8.50074475,1.78199475 8.57142857,1.94940379 8.57142857,2.14285714 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "I7Ud":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tahoe.62c2332.jpg";

/***/ }),

/***/ "IO2M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dolomite.d8fdd54.jpg";

/***/ }),

/***/ "IZGU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsData = __webpack_require__("nhAy");

var _jsData2 = _interopRequireDefault(_jsData);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _http = __webpack_require__("087f");

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import socketAdapter from './adapters/socket.js'

var store = new _jsData2.default.DS();
var findStrategy = function findStrategy(Resource, data, cb) {
  cb(null, data.data || data);
};

_lodash2.default.assign(store.defaults, {
  afterFind: findStrategy,
  afterFindAll: findStrategy,
  bypassCache: true
});

store.registerAdapter('http', _http2.default, { default: true });
// store.registerAdapter('socket', socketAdapter, {})

exports.default = store;

/***/ }),

/***/ "IlYA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stupa.f990914.jpg";

/***/ }),

/***/ "It2R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chocolatethills.a477cac.jpg";

/***/ }),

/***/ "JkCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tv",
  "use": "icon-tv-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-tv\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-tv</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-tv_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-tv_icon-tv\">\n            <path d=\"M18.5892334,13.6514566 L18.5892334,3.69293867 C18.5892334,3.60303493 18.5563844,3.52523479 18.4906856,3.45953591 C18.4249867,3.39383702 18.3471865,3.36098807 18.2572828,3.36098807 L1.65975298,3.36098807 C1.56984925,3.36098807 1.4920491,3.39383702 1.42635022,3.45953591 C1.36065133,3.52523479 1.32780239,3.60303493 1.32780239,3.69293867 L1.32780239,13.6514566 C1.32780239,13.7413603 1.36065133,13.8191604 1.42635022,13.8848593 C1.4920491,13.9505582 1.56984925,13.9834072 1.65975298,13.9834072 L18.2572828,13.9834072 C18.3471865,13.9834072 18.4249867,13.9505582 18.4906856,13.8848593 C18.5563844,13.8191604 18.5892334,13.7413603 18.5892334,13.6514566 Z M19.9170358,3.69293867 L19.9170358,13.6514566 C19.9170358,14.1078909 19.7545199,14.4986205 19.4294833,14.8236571 C19.1044468,15.1486937 18.7137172,15.3112095 18.2572828,15.3112095 L10.6224191,15.3112095 L10.6224191,16.6390119 L14.2738756,16.6390119 C14.3706951,16.6390119 14.4502241,16.670132 14.5124651,16.732373 C14.5747062,16.7946141 14.6058262,16.8741431 14.6058262,16.9709625 L14.6058262,17.6348637 C14.6058262,17.7316831 14.5747062,17.8112122 14.5124651,17.8734532 C14.4502241,17.9356943 14.3706951,17.9668143 14.2738756,17.9668143 L5.64316014,17.9668143 C5.54634073,17.9668143 5.4668117,17.9356943 5.40457065,17.8734532 C5.3423296,17.8112122 5.31120954,17.7316831 5.31120954,17.6348637 L5.31120954,16.9709625 C5.31120954,16.8741431 5.3423296,16.7946141 5.40457065,16.732373 C5.4668117,16.670132 5.54634073,16.6390119 5.64316014,16.6390119 L9.2946167,16.6390119 L9.2946167,15.3112095 L1.65975298,15.3112095 C1.20331863,15.3112095 0.812589023,15.1486937 0.487552438,14.8236571 C0.162515854,14.4986205 0,14.1078909 0,13.6514566 L0,3.69293867 C0,3.23650432 0.162515854,2.84577471 0.487552438,2.52073812 C0.812589023,2.19570154 1.20331863,2.03318569 1.65975298,2.03318569 L18.2572828,2.03318569 C18.7137172,2.03318569 19.1044468,2.19570154 19.4294833,2.52073812 C19.7545199,2.84577471 19.9170358,3.23650432 19.9170358,3.69293867 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "K4MD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUtT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noframeworkWaypoints = __webpack_require__("HIb3");

var _noframeworkWaypoints2 = _interopRequireDefault(_noframeworkWaypoints);

__webpack_require__("6zCy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//


exports.default = {
  name: 'sticky',
  props: {
    el: {
      type: String,
      default: "div"
    },
    offset: {
      type: Number
    }
  },
  data: function data() {
    return {
      sticky: null
    };
  },
  mounted: function mounted() {
    this.sticky = new Waypoint.Sticky({
      element: this.$el,
      offset: this.offset || 0
    });
  }
};

/***/ }),

/***/ "KWO8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "sessions",
  relations: {
    hasOne: {
      users: {
        localField: "user",
        localKey: "userId"
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "L/b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
// Make redactor work with webpack...



/*
	Redactor II
	Version 2.4
	Updated: March 7, 2017

	http://imperavi.com/redactor/

	Copyright (c) 2009-2017, Imperavi LLC.
	License: http://imperavi.com/redactor/license/

	Usage: $('#content').redactor();
*/

(function($)
{
	'use strict';

	if (!Function.prototype.bind)
	{
		Function.prototype.bind = function(scope)
		{
			var fn = this;
			return function()
			{
				return fn.apply(scope);
			};
		};
	}

	var uuid = 0;

	// Plugin
	$.fn.redactor = function(options)
	{
		var val = [];
		var args = Array.prototype.slice.call(arguments, 1);

		if (typeof options === 'string')
		{
			this.each(function()
			{
				var instance = $.data(this, 'redactor');
				var func;

				if (options.search(/\./) !== '-1')
				{
					func = options.split('.');
					if (typeof instance[func[0]] !== 'undefined')
					{
						func = instance[func[0]][func[1]];
					}
				}
				else
				{
					func = instance[options];
				}

				if (typeof instance !== 'undefined' && $.isFunction(func))
				{
					var methodVal = func.apply(instance, args);
					if (methodVal !== undefined && methodVal !== instance)
					{
						val.push(methodVal);
					}
				}
				else
				{
					$.error('No such method "' + options + '" for Redactor');
				}
			});
		}
		else
		{
			this.each(function()
			{
				$.data(this, 'redactor', {});
				$.data(this, 'redactor', Redactor(this, options));
			});
		}

		if (val.length === 0)
		{
			return this;
		}
		else if (val.length === 1)
		{
			return val[0];
		}
		else
		{
			return val;
		}

	};

	// Initialization
	function Redactor(el, options)
	{
		return new Redactor.prototype.init(el, options);
	}

	// Options
	$.Redactor = Redactor;
	$.Redactor.VERSION = '2.3';
	$.Redactor.modules = ['air', 'autosave', 'block', 'buffer', 'build', 'button', 'caret', 'clean', 'code', 'core', 'detect', 'dropdown',
						  'events', 'file', 'focus', 'image', 'indent', 'inline', 'insert', 'keydown', 'keyup',
						  'lang', 'line', 'link', 'linkify', 'list', 'marker', 'modal', 'observe', 'offset', 'paragraphize', 'paste', 'placeholder',
						  'progress', 'selection', 'shortcuts', 'storage', 'toolbar', 'upload', 'uploads3', 'utils',

						  'browser' // deprecated
						  ];

	$.Redactor.settings = {};
	$.Redactor.opts = {

		// settings
		animation: false,
		lang: 'en',
		direction: 'ltr',
		spellcheck: true,
		overrideStyles: true,
		scrollTarget: document,

		focus: false,
		focusEnd: false,

		clickToEdit: false,
		structure: false,

		tabindex: false,

		minHeight: false, // string
		maxHeight: false, // string

		maxWidth: false, // string

		plugins: false, // array
		callbacks: {},

		placeholder: false,

		linkify: true,
		enterKey: true,

		pastePlainText: false,
		pasteImages: true,
		pasteLinks: true,
		pasteBlockTags: ['pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'ul', 'ol', 'li', 'blockquote', 'p', 'figure', 'figcaption'],
		pasteInlineTags: ['br', 'strong', 'ins', 'code', 'del', 'span', 'samp', 'kbd', 'sup', 'sub', 'mark', 'var', 'cite', 'small', 'b', 'u', 'em', 'i'],

		preClass: false, // string
		preSpaces: 4, // or false
		tabAsSpaces: false, // true or number of spaces
		tabKey: true,

		autosave: false, // false or url
		autosaveName: false,
		autosaveFields: false,

		imageUpload: null,
		imageUploadParam: 'file',
		imageUploadFields: false,
		imageUploadForms: false,
        imageTag: 'figure',
        imageEditable: true,
		imageCaption: true,

		imagePosition: false,
		imageResizable: false,
		imageFloatMargin: '10px',

		dragImageUpload: true,
		multipleImageUpload: true,
		clipboardImageUpload: true,

		fileUpload: null,
		fileUploadParam: 'file',
		fileUploadFields: false,
		fileUploadForms: false,
		dragFileUpload: true,

		s3: false,

        linkNewTab: false,
		linkTooltip: true,
		linkNofollow: false,
		linkSize: 30,
		pasteLinkTarget: false,

		videoContainerClass: 'video-container',

		toolbar: true,
		toolbarFixed: true,
		toolbarFixedTarget: document,
		toolbarFixedTopOffset: 0, // pixels
		toolbarExternal: false, // ID selector

		air: false,
		airWidth: false,

		formatting: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
		formattingAdd: false,

		buttons: ['format', 'bold', 'italic', 'deleted', 'lists', 'image', 'file', 'link'], // + 'horizontalrule', 'underline', 'ol', 'ul', 'indent', 'outdent'

		buttonsHide: [],
		buttonsHideOnMobile: [],

		script: true,
		removeNewlines: false,
		removeComments: true,
		replaceTags: {
			'b': 'strong',
			'i': 'em',
			'strike': 'del'
		},

		// shortcuts
		shortcuts: {
			'ctrl+shift+m, meta+shift+m': { func: 'inline.removeFormat' },
			'ctrl+b, meta+b': { func: 'inline.format', params: ['bold'] },
			'ctrl+i, meta+i': { func: 'inline.format', params: ['italic'] },
			'ctrl+h, meta+h': { func: 'inline.format', params: ['superscript'] },
			'ctrl+l, meta+l': { func: 'inline.format', params: ['subscript'] },
			'ctrl+k, meta+k': { func: 'link.show' },
			'ctrl+shift+7':   { func: 'list.toggle', params: ['orderedlist'] },
			'ctrl+shift+8':   { func: 'list.toggle', params: ['unorderedlist'] }
		},
		shortcutsAdd: false,

		activeButtons: ['deleted', 'italic', 'bold'],
		activeButtonsStates: {
			b: 'bold',
			strong: 'bold',
			i: 'italic',
			em: 'italic',
			del: 'deleted',
			strike: 'deleted'
		},

		// private lang
		langs: {
			en: {

				"format": "Format",
				"image": "Image",
				"file": "File",
				"link": "Link",
				"bold": "Bold",
				"italic": "Italic",
				"deleted": "Strikethrough",
				"underline": "Underline",
				"bold-abbr": "B",
				"italic-abbr": "I",
				"deleted-abbr": "S",
				"underline-abbr": "U",
				"lists": "Lists",
				"link-insert": "Insert link",
				"link-edit": "Edit link",
				"link-in-new-tab": "Open link in new tab",
				"unlink": "Unlink",
				"cancel": "Cancel",
				"close": "Close",
				"insert": "Insert",
				"save": "Save",
				"delete": "Delete",
				"text": "Text",
				"edit": "Edit",
				"title": "Title",
				"paragraph": "Normal text",
				"quote": "Quote",
				"code": "Code",
				"heading1": "Heading 1",
				"heading2": "Heading 2",
				"heading3": "Heading 3",
				"heading4": "Heading 4",
				"heading5": "Heading 5",
				"heading6": "Heading 6",
				"filename": "Name",
				"optional": "optional",
				"unorderedlist": "Unordered List",
				"orderedlist": "Ordered List",
				"outdent": "Outdent",
				"indent": "Indent",
				"horizontalrule": "Line",
				"upload-label": "Drop file here or ",
				"caption": "Caption",

				"bulletslist": "Bullets",
				"numberslist": "Numbers",

				"image-position": "Position",
				"none": "None",
				"left": "Left",
				"right": "Right",
				"center": "Center",

				"accessibility-help-label": "Rich text editor"
			}
		},

		// private
		type: 'textarea', // textarea, div, inline, pre
		inline: false,
		buffer: [],
		rebuffer: [],
		inlineTags: ['a', 'span', 'strong', 'strike', 'b', 'u', 'em', 'i', 'code', 'del', 'ins', 'samp', 'kbd', 'sup', 'sub', 'mark', 'var', 'cite', 'small'],
		blockTags: ['pre', 'ul', 'ol', 'li', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',  'dl', 'dt', 'dd', 'div', 'td', 'blockquote', 'output', 'figcaption', 'figure', 'address', 'section', 'header', 'footer', 'aside', 'article', 'iframe'],
		paragraphize: true,
		paragraphizeBlocks: ['table', 'div', 'pre', 'form', 'ul', 'ol', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'dl', 'blockquote', 'figcaption',
							'address', 'section', 'header', 'footer', 'aside', 'article', 'object', 'style', 'script', 'iframe', 'select', 'input', 'textarea',
							'button', 'option', 'map', 'area', 'math', 'hr', 'fieldset', 'legend', 'hgroup', 'nav', 'figure', 'details', 'menu', 'summary', 'p'],
		emptyHtml: '<p>&#x200b;</p>',
		invisibleSpace: '&#x200b;',
		imageTypes: ['image/png', 'image/jpeg', 'image/gif'],
		userAgent: navigator.userAgent.toLowerCase(),
		observe: {
			dropdowns: []
		},
		regexps: {
			linkyoutube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.\-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig,
			linkvimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/,
			linkimage: /((https?|www)[^\s]+\.)(jpe?g|png|gif)(\?[^\s-]+)?/ig,
			url: /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/ig
		}

	};

	// Functionality
	Redactor.fn = $.Redactor.prototype = {

		keyCode: {
			BACKSPACE: 8,
			DELETE: 46,
			UP: 38,
			DOWN: 40,
			ENTER: 13,
			SPACE: 32,
			ESC: 27,
			TAB: 9,
			CTRL: 17,
			META: 91,
			SHIFT: 16,
			ALT: 18,
			RIGHT: 39,
			LEFT: 37,
			LEFT_WIN: 91
		},

		// =init
		init: function(el, options)
		{
			this.$element = $(el);
			this.uuid = uuid++;

			this.loadOptions(options);
			this.loadModules();

			// click to edit
			if (this.opts.clickToEdit && !this.$element.hasClass('redactor-click-to-edit'))
			{
				return this.loadToEdit(options);
			}
			else if (this.$element.hasClass('redactor-click-to-edit'))
			{
				this.$element.removeClass('redactor-click-to-edit');
			}

			// block & inline test tag regexp
			this.reIsBlock = new RegExp('^(' + this.opts.blockTags.join('|' ).toUpperCase() + ')$', 'i');
			this.reIsInline = new RegExp('^(' + this.opts.inlineTags.join('|' ).toUpperCase() + ')$', 'i');

			// set up drag upload
			this.opts.dragImageUpload = (this.opts.imageUpload === null) ? false : this.opts.dragImageUpload;
			this.opts.dragFileUpload = (this.opts.fileUpload === null) ? false : this.opts.dragFileUpload;

			// formatting storage
			this.formatting = {};

			// load lang
			this.lang.load();

			// extend shortcuts
			$.extend(this.opts.shortcuts, this.opts.shortcutsAdd);

			// set editor
			this.$editor = this.$element;

			// detect type of editor
			this.detectType();

			// start callback
			this.core.callback('start');
			this.core.callback('startToEdit');

			// build
			this.start = true;
			this.build.start();

		},
		detectType: function()
		{
			if (this.build.isInline() || this.opts.inline)
			{
				this.opts.type = 'inline';
			}
			else if (this.build.isTag('DIV'))
			{
				this.opts.type = 'div';
			}
			else if (this.build.isTag('PRE'))
			{
				this.opts.type = 'pre';
			}
		},
		loadToEdit: function(options)
		{

			this.$element.on('click.redactor-click-to-edit', $.proxy(function()
			{
				this.initToEdit(options);

			}, this));

			this.$element.addClass('redactor-click-to-edit');

			return;
		},
		initToEdit: function(options)
		{
			$.extend(options.callbacks,  {
				startToEdit: function()
				{
					this.insert.node(this.marker.get(), false);
				},
				initToEdit: function()
				{
					this.selection.restore();
					this.clickToCancelStorage = this.code.get();

					// cancel
					$(this.opts.clickToCancel).off('.redactor-click-to-edit');
					$(this.opts.clickToCancel).show().on('click.redactor-click-to-edit', $.proxy(function(e)
					{
						e.preventDefault();

						this.core.destroy();
						this.events.syncFire = false;
						this.$element.html(this.clickToCancelStorage);
						this.core.callback('cancel', this.clickToCancelStorage);
						this.events.syncFire = true;
						this.clickToCancelStorage = '';
						$(this.opts.clickToCancel).hide();
						$(this.opts.clickToSave).hide();

						this.$element.on('click.redactor-click-to-edit', $.proxy(function()
						{
							this.initToEdit(options);
						}, this));

						this.$element.addClass('redactor-click-to-edit');

					}, this));

					// save
					$(this.opts.clickToSave).off('.redactor-click-to-edit');
					$(this.opts.clickToSave).show().on('click.redactor-click-to-edit', $.proxy(function(e)
					{
						e.preventDefault();

						this.core.destroy();
						this.core.callback('save', this.code.get());
						$(this.opts.clickToCancel).hide();
						$(this.opts.clickToSave).hide();
						this.$element.on('click.redactor-click-to-edit', $.proxy(function()
						{
							this.initToEdit(options);
						}, this));
						this.$element.addClass('redactor-click-to-edit');

					}, this));
				}

			});

			this.$element.redactor(options);
			this.$element.off('.redactor-click-to-edit');

		},
		loadOptions: function(options)
		{
			var settings = {};

			// check namespace
			if (typeof $.Redactor.settings.namespace !== 'undefined')
			{
				 if (this.$element.hasClass($.Redactor.settings.namespace))
				 {
					 settings = $.Redactor.settings;
				 }
			}
			else
			{
				settings = $.Redactor.settings;
			}

			this.opts = $.extend(
				{},
				$.Redactor.opts,
				this.$element.data(),
				options
			);

			this.opts = $.extend(true, this.opts, settings);

		},
		getModuleMethods: function(object)
		{
			return Object.getOwnPropertyNames(object).filter(function(property)
			{
				return typeof object[property] === 'function';
			});
		},
		loadModules: function()
		{
			var len = $.Redactor.modules.length;
			for (var i = 0; i < len; i++)
			{
				this.bindModuleMethods($.Redactor.modules[i]);
			}
		},
		bindModuleMethods: function(module)
		{
			if (typeof this[module] === 'undefined')
			{
				return;
			}

			// init module
			this[module] = this[module]();

			var methods = this.getModuleMethods(this[module]);
			var len = methods.length;

			// bind methods
			for (var z = 0; z < len; z++)
			{
				this[module][methods[z]] = this[module][methods[z]].bind(this);
			}
		},

		// =air
		air: function()
		{
			return {
				enabled: false,
				collapsed: function()
				{
					if (this.opts.air)
					{
						this.selection.get().collapseToStart();
					}
				},
				collapsedEnd: function()
				{
					if (this.opts.air)
					{
						this.selection.get().collapseToEnd();
					}
				},
				build: function()
				{
					if (this.detect.isMobile())
					{
						return;
					}

					this.button.hideButtons();
					this.button.hideButtonsOnMobile();

					if (this.opts.buttons.length === 0)
					{
						return;
					}

					this.$air = this.air.createContainer();

					if (this.opts.airWidth !== false)
					{
						this.$air.css('width', this.opts.airWidth);
					}

					this.air.append();
					this.button.$toolbar = this.$air;
					this.button.setFormatting();
					this.button.load(this.$air);

					this.core.editor().on('mouseup.redactor', this, $.proxy(function(e)
					{
						if (this.selection.text() !== '')
						{
							this.air.show(e);
						}
					}, this));

				},
				append: function()
				{
					this.$air.appendTo('body');
				},
				createContainer: function()
				{
					return $('<ul>').addClass('redactor-air').attr({ 'id': 'redactor-air-' + this.uuid, 'role': 'toolbar' }).hide();
				},
				show: function (e)
				{
					//this.marker.remove();
					this.selection.saveInstant();
					//this.selection.restore(false);

					$('.redactor-air').hide();

					var leftFix = 0;
					var width = this.$air.innerWidth();

					if ($(window).width() < (e.clientX + width))
					{
						leftFix = 200;
					}

					this.$air.css({
						left: (e.clientX - leftFix) + 'px',
						top: (e.clientY + 10 + $(document).scrollTop()) + 'px'
					}).show();

					this.air.enabled = true;
					this.air.bindHide();
				},
				bindHide: function()
				{
					$(document).on('mousedown.redactor-air.' + this.uuid, $.proxy(function(e)
					{
						var dropdown = $(e.target).closest('.redactor-dropdown').length;

						if ($(e.target).closest(this.$air).length === 0 && dropdown === 0)
						{
							var hide = this.air.hide(e);
							if (hide !== false)
							{
								this.marker.remove();
							}
						}

					}, this)).on('keydown.redactor-air.' + this.uuid, $.proxy(function(e)
					{
						var key = e.which;
						if ((!this.utils.isRedactorParent(e.target) && !$(e.target).hasClass('redactor-in')) || $(e.target).closest('#redactor-modal').length !== 0)
						{
							return;
						}

						if (key === this.keyCode.ESC)
						{
							this.selection.get().collapseToStart();
							//this.marker.remove();
						}
						else if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
						{
							var sel = this.selection.get();
							var range = this.selection.range(sel);
							range.deleteContents();
							//this.marker.remove();
						}
						else if (key === this.keyCode.ENTER)
						{
							this.selection.get().collapseToEnd();
							//this.marker.remove();
						}

						if (this.air.enabled)
						{
							this.air.hide(e);
						}
						else
						{
							this.selection.get().collapseToStart();
							//this.marker.remove();
						}


					}, this));
				},
				hide: function(e)
				{
					var ctrl = e.ctrlKey || e.metaKey || (e.shiftKey && e.altKey);
					if (ctrl)
					{
						return false;
					}

					this.button.setInactiveAll();
					this.$air.fadeOut(100);
					this.air.enabled = false;
					$(document).off('mousedown.redactor-air.' + this.uuid);
					$(document).off('keydown.redactor-air.' + this.uuid);

				}
			};
		},

		// =autosave
		autosave: function()
		{
			return {
				enabled: false,
				html: false,
				init: function()
				{
					if (!this.opts.autosave)
					{
						return;
					}

					this.autosave.enabled = true;
					this.autosave.name = (this.opts.autosaveName) ? this.opts.autosaveName : this.$textarea.attr('name');

				},
				is: function()
				{
					return this.autosave.enabled;
				},
				send: function()
				{
					if (!this.opts.autosave)
					{
						return;
					}

					this.autosave.source = this.code.get();

					if (this.autosave.html === this.autosave.source)
					{
						return;
					}

					// data
					var data = {};
					data.name = this.autosave.name;
					data[this.autosave.name] = this.autosave.source;
					data = this.autosave.getHiddenFields(data);

					// ajax
					var jsxhr = $.ajax({
						url: this.opts.autosave,
						type: 'post',
						data: data
					});

					jsxhr.done(this.autosave.success);
				},
				getHiddenFields: function(data)
				{
					if (this.opts.autosaveFields === false || typeof this.opts.autosaveFields !== 'object')
					{
						return data;
					}

					$.each(this.opts.autosaveFields, $.proxy(function(k, v)
					{
						if (v !== null && v.toString().indexOf('#') === 0)
						{
							v = $(v).val();
						}

						data[k] = v;

					}, this));

					return data;

				},
				success: function(data)
				{
					var json;
					try
					{
						json = JSON.parse(data);
					}
					catch(e)
					{
						//data has already been parsed
						json = data;
					}

					var callbackName = (typeof json.error === 'undefined') ? 'autosave' :  'autosaveError';

					this.core.callback(callbackName, this.autosave.name, json);
					this.autosave.html = this.autosave.source;
				},
				disable: function()
				{
					this.autosave.enabled = false;

					clearInterval(this.autosaveTimeout);
				}
			};
		},

		// =block
		block: function()
		{
			return {
				format: function(tag, attr, value, type)
				{
					tag = (tag === 'quote') ? 'blockquote' : tag;

					this.block.tags = ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'figure'];
					if ($.inArray(tag, this.block.tags) === -1)
					{
						return;
					}

					if (tag === 'p' && typeof attr === 'undefined')
					{
						// remove all
						attr = 'class';
					}

					this.placeholder.hide();
					this.buffer.set();

					return (this.utils.isCollapsed()) ? this.block.formatCollapsed(tag, attr, value, type) : this.block.formatUncollapsed(tag, attr, value, type);
				},
				formatCollapsed: function(tag, attr, value, type)
				{
					this.selection.save();

					var block = this.selection.block();
					var currentTag = block.tagName.toLowerCase();
					if ($.inArray(currentTag, this.block.tags) === -1)
					{
						this.selection.restore();
						return;
					}

					if (currentTag === tag)
					{
						tag = 'p';
					}

                    var replaced;
                    if (currentTag === 'blockquote' && this.utils.isEndOfElement(block))
                    {
                        this.marker.remove();

                        replaced = document.createElement('p');
                        replaced.innerHTML = this.opts.invisibleSpace;

                        $(block).after(replaced);
                        this.caret.start(replaced);
                        var $last = $(block).children().last();

                        if ($last.length !== 0 && $last[0].tagName === 'BR')
                        {
                            $last.remove();
                        }
                    }
                    else
                    {
					    replaced = this.utils.replaceToTag(block, tag);
                    }

					if (typeof attr === 'object')
					{
						type = value;
						for (var key in attr)
						{
							replaced = this.block.setAttr(replaced, key, attr[key], type);
						}
					}
					else
					{
						replaced = this.block.setAttr(replaced, attr, value, type);
					}


					// trim pre
					if (tag === 'pre' && replaced.length === 1)
					{
						$(replaced).html($.trim($(replaced).html()));
					}

					this.selection.restore();
					this.block.removeInlineTags(replaced);

					return replaced;
				},
				formatUncollapsed: function(tag, attr, value, type)
				{
					this.selection.save();

					var replaced = [];
					var blocks = this.selection.blocks();

                    if (blocks[0] && $(blocks[0]).hasClass('redactor-in'))
                    {
                        blocks = $(blocks[0]).find(this.opts.blockTags.join(', '));
					}

					var len = blocks.length;
					for (var i = 0; i < len; i++)
					{
						var currentTag = blocks[i].tagName.toLowerCase();
						if ($.inArray(currentTag, this.block.tags) !== -1 && currentTag !== 'figure')
						{
							var block = this.utils.replaceToTag(blocks[i], tag);

							if (typeof attr === 'object')
							{
								type = value;
								for (var key in attr)
								{
									block = this.block.setAttr(block, key, attr[key], type);
								}
							}
							else
							{
								block = this.block.setAttr(block, attr, value, type);
							}

							replaced.push(block);
							this.block.removeInlineTags(block);
						}
					}

					this.selection.restore();

					// combine pre
					if (tag === 'pre' && replaced.length !== 0)
					{
						var first = replaced[0];
						$.each(replaced, function(i,s)
						{
							if (i !== 0)
							{
								$(first).append("\n" + $.trim(s.html()));
								$(s).remove();
							}
						});

						replaced = [];
						replaced.push(first);
					}

					return replaced;
				},
				removeInlineTags: function(node)
				{
					node = node[0] || node;

					var tags = this.opts.inlineTags;
					var blocks = ['PRE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

					if ($.inArray(node.tagName, blocks) === - 1)
					{
						return;
					}

					if (node.tagName !== 'PRE')
					{
						var index = tags.indexOf('a');
						tags.splice(index, 1);
					}

					$(node).find(tags.join(',')).not('.redactor-selection-marker').contents().unwrap();
				},
				setAttr: function(block, attr, value, type)
				{
					if (typeof attr === 'undefined')
					{
						return block;
					}

					var func = (typeof type === 'undefined') ? 'replace' : type;

					if (attr === 'class')
					{
						block = this.block[func + 'Class'](value, block);
					}
					else
					{
						if (func === 'remove')
						{
							block = this.block[func + 'Attr'](attr, block);
						}
						else if (func === 'removeAll')
						{
							block = this.block[func + 'Attr'](attr, block);
						}
						else
						{
							block = this.block[func + 'Attr'](attr, value, block);
						}
					}

					return block;

				},
				getBlocks: function(block)
				{
					return (typeof block === 'undefined') ? this.selection.blocks() : block;
				},
				replaceClass: function(value, block)
				{
					return $(this.block.getBlocks(block)).removeAttr('class').addClass(value)[0];
				},
				toggleClass: function(value, block)
				{
					return $(this.block.getBlocks(block)).toggleClass(value)[0];
				},
				addClass: function(value, block)
				{
					return $(this.block.getBlocks(block)).addClass(value)[0];
				},
				removeClass: function(value, block)
				{
					return $(this.block.getBlocks(block)).removeClass(value)[0];
				},
				removeAllClass: function(block)
				{
					return $(this.block.getBlocks(block)).removeAttr('class')[0];
				},
				replaceAttr: function(attr, value, block)
				{
					block = this.block.removeAttr(attr, block);

					return $(block).attr(attr, value)[0];
				},
				toggleAttr: function(attr, value, block)
				{
					block = this.block.getBlocks(block);

					var self = this;
					var returned = [];
					$.each(block, function(i,s)
					{
						var $el = $(s);
						if ($el.attr(attr))
						{
							returned.push(self.block.removeAttr(attr, s));
						}
						else
						{
							returned.push(self.block.addAttr(attr, value, s));
						}
					});

					return returned;

				},
				addAttr: function(attr, value, block)
				{
					return $(this.block.getBlocks(block)).attr(attr, value)[0];
				},
				removeAttr: function(attr, block)
				{
					return $(this.block.getBlocks(block)).removeAttr(attr)[0];
				},
				removeAllAttr: function(block)
				{
					block = this.block.getBlocks(block);

					var returned = [];
					$.each(block, function(i,s)
					{
						if (typeof s.attributes === 'undefined')
						{
							returned.push(s);
						}

						var $el = $(s);
						var len = s.attributes.length;
						for (var z = 0; z < len; z++)
						{
							$el.removeAttr(s.attributes[z].name);
						}

						returned.push($el[0]);
					});

					return returned;
				}
			};
		},

		// buffer
		buffer: function()
		{
			return {
				set: function(type)
				{
    				if (typeof type === 'undefined')
                    {
                        this.buffer.clear();
                    }

					if (typeof type === 'undefined' || type === 'undo')
					{
						this.buffer.setUndo();
					}
					else
					{
						this.buffer.setRedo();
					}
				},
				setUndo: function()
				{
                    var saved = this.selection.saveInstant();

					var last = this.opts.buffer[this.opts.buffer.length-1];
					var current = this.core.editor().html();

					var save = (typeof last !== 'undefined' && (last[0] === current)) ? false : true;
    				if (save)
    				{
						this.opts.buffer.push([current, saved]);
					}

					//this.selection.restoreInstant();
				},
				setRedo: function()
				{
					var saved = this.selection.saveInstant();
					this.opts.rebuffer.push([this.core.editor().html(), saved]);
					//this.selection.restoreInstant();
				},
				add: function()
				{
					this.opts.buffer.push([this.core.editor().html(), 0]);
				},
				undo: function()
				{
					if (this.opts.buffer.length === 0)
					{
						return;
					}

					var buffer = this.opts.buffer.pop();

					this.buffer.set('redo');
					this.core.editor().html(buffer[0]);

					this.selection.restoreInstant(buffer[1]);
					this.observe.load();
				},
				redo: function()
				{
					if (this.opts.rebuffer.length === 0)
					{
						return;
					}

					var buffer = this.opts.rebuffer.pop();

					this.buffer.set('undo');
					this.core.editor().html(buffer[0]);

					this.selection.restoreInstant(buffer[1]);
					this.observe.load();
				},
				clear: function()
				{
    				this.opts.rebuffer = [];
				}
			};
		},

		// =build
		build: function()
		{
			return {
				start: function()
				{
					if (this.opts.type === 'inline')
					{
						this.opts.type = 'inline';
					}
					else if (this.opts.type === 'div')
					{
						// empty
						var html = $.trim(this.$editor.html());
						if (html === '')
						{
							this.$editor.html(this.opts.emptyHtml);
						}
					}
					else if (this.opts.type === 'textarea')
					{
						this.build.startTextarea();
					}

					// set in
					this.build.setIn();

					// set id
					this.build.setId();

					// enable
					this.build.enableEditor();

					// options
					this.build.setOptions();

					// call
					this.build.callEditor();


				},
				createContainerBox: function()
				{
					this.$box = $('<div class="redactor-box" role="application" />');
				},
				setIn: function()
				{
					this.core.editor().addClass('redactor-in');
				},
				setId: function()
				{
					var id = (this.opts.type === 'textarea') ? 'redactor-uuid-' + this.uuid : this.$element.attr('id');

					this.core.editor().attr('id', (typeof id === 'undefined') ? 'redactor-uuid-' + this.uuid : id);
				},
				getName: function()
				{
					var name = this.$element.attr('name');

					return (typeof name === 'undefined') ? 'content-' + this.uuid : name;
				},
				loadFromTextarea: function()
				{
					this.$editor = $('<div />');

					// textarea
					this.$textarea = this.$element;
					this.$element.attr('name', this.build.getName());

					// place
					this.$box.insertAfter(this.$element).append(this.$editor).append(this.$element);
                    this.$editor.addClass('redactor-layer');

					if (this.opts.overrideStyles)
					{
					    this.$editor.addClass('redactor-styles');
					}

					this.$element.hide();

					this.$box.prepend('<span class="redactor-voice-label" id="redactor-voice-' + this.uuid +'" aria-hidden="false">' + this.lang.get('accessibility-help-label') + '</span>');
					this.$editor.attr({ 'aria-labelledby': 'redactor-voice-' + this.uuid, 'role': 'presentation' });
				},
				startTextarea: function()
				{
					this.build.createContainerBox();

					// load
					this.build.loadFromTextarea();

					// set code
					this.code.start(this.core.textarea().val());

					// set value
					this.core.textarea().val(this.clean.onSync(this.$editor.html()));
				},
				isTag: function(tag)
				{
					return (this.$element[0].tagName === tag);
				},
				isInline: function()
				{
					return (!this.build.isTag('TEXTAREA') && !this.build.isTag('DIV') && !this.build.isTag('PRE'));
				},
				enableEditor: function()
				{
					this.core.editor().attr({ 'contenteditable': true });
				},
				setOptions: function()
				{
					// inline
					if (this.opts.type === 'inline')
					{
						this.opts.enterKey = false;
					}

					// inline & pre
					if (this.opts.type === 'inline' || this.opts.type === 'pre')
					{
						this.opts.toolbarMobile = false;
						this.opts.toolbar = false;
						this.opts.air = false;
						this.opts.linkify = false;

					}

					// spellcheck
					this.core.editor().attr('spellcheck', this.opts.spellcheck);

					// structure
					if (this.opts.structure)
					{
						this.core.editor().addClass('redactor-structure');
					}

					// options sets only in textarea mode
					if (this.opts.type !== 'textarea')
					{
						return;
					}

					// direction
					this.core.box().attr('dir', this.opts.direction);
					this.core.editor().attr('dir', this.opts.direction);

					// tabindex
					if (this.opts.tabindex)
					{
						this.core.editor().attr('tabindex', this.opts.tabindex);
					}

					// min height
					if (this.opts.minHeight)
					{
						this.core.editor().css('min-height', this.opts.minHeight);
					}
					else
					{
						this.core.editor().css('min-height', '40px');
					}

					// max height
					if (this.opts.maxHeight)
					{
						this.core.editor().css('max-height', this.opts.maxHeight);
					}

					// max width
					if (this.opts.maxWidth)
					{
						this.core.editor().css({ 'max-width': this.opts.maxWidth, 'margin': 'auto' });
					}

				},
				callEditor: function()
				{
					this.build.disableBrowsersEditing();

					this.events.init();
					this.build.setHelpers();

					// init buttons
					if (this.opts.toolbar || this.opts.air)
					{
						this.toolbarsButtons = this.button.init();
					}

					// load toolbar
					if (this.opts.air)
					{
						this.air.build();
					}
					else if (this.opts.toolbar)
					{
						this.toolbar.build();
					}

					if (this.detect.isMobile() && this.opts.toolbarMobile && this.opts.air)
					{
						this.opts.toolbar = true;
						this.toolbar.build();
					}

					// observe dropdowns
					if (this.opts.air || this.opts.toolbar)
					{
						this.core.editor().on('mouseup.redactor-observe.' + this.uuid + ' keyup.redactor-observe.' + this.uuid + ' focus.redactor-observe.' + this.uuid + ' touchstart.redactor-observe.' + this.uuid, $.proxy(this.observe.toolbar, this));
						this.core.element().on('blur.callback.redactor', $.proxy(function()
						{
							this.button.setInactiveAll();

						}, this));
					}

					// modal templates init
					this.modal.templates();

					// plugins
					this.build.plugins();

					// autosave
					this.autosave.init();

					// sync code
					this.code.html = this.code.cleaned(this.core.editor().html());

					// init callback
					this.core.callback('init');
					this.core.callback('initToEdit');

					// get images & files list
					this.storage.observe();

					// started
					this.start = false;

				},
				setHelpers: function()
				{
					// linkify
					if (this.opts.linkify)
					{
						this.linkify.format();
					}

					// placeholder
					this.placeholder.init();

					// focus
					if (this.opts.focus)
					{
						setTimeout(this.focus.start, 100);
					}
					else if (this.opts.focusEnd)
					{
						setTimeout(this.focus.end, 100);
					}

				},
				disableBrowsersEditing: function()
				{
					try {
						// FF fix
						document.execCommand('enableObjectResizing', false, false);
						document.execCommand('enableInlineTableEditing', false, false);
						// IE prevent converting links
						document.execCommand("AutoUrlDetect", false, false);
					} catch (e) {}
				},
				plugins: function()
				{
					if (!this.opts.plugins)
					{
						return;
					}

					$.each(this.opts.plugins, $.proxy(function(i, s)
					{
						var func = (typeof RedactorPlugins !== 'undefined' && typeof RedactorPlugins[s] !== 'undefined') ? RedactorPlugins : Redactor.fn;

						if (!$.isFunction(func[s]))
						{
							return;
						}

						this[s] = func[s]();

						// get methods
						var methods = this.getModuleMethods(this[s]);
						var len = methods.length;

						// bind methods
						for (var z = 0; z < len; z++)
						{
							this[s][methods[z]] = this[s][methods[z]].bind(this);
						}

						// append lang
						if (typeof this[s].langs !== 'undefined')
						{
							var lang = {};
							if (typeof this[s].langs[this.opts.lang] !== 'undefined')
							{
								lang = this[s].langs[this.opts.lang];
							}
							else if (typeof this[s].langs[this.opts.lang] === 'undefined' && typeof this[s].langs.en !== 'undefined')
							{
								lang = this[s].langs.en;
							}

							// extend
							var self = this;
							$.each(lang, function(i,s)
							{
								if (typeof self.opts.curLang[i] === 'undefined')
								{
									self.opts.curLang[i] = s;
								}
							});
						}

						// init
						if ($.isFunction(this[s].init))
						{
							this[s].init();
						}


					}, this));

				}
			};
		},

		// =button
		button: function()
		{
			return {
				toolbar: function()
				{
					return (typeof this.button.$toolbar === 'undefined' || !this.button.$toolbar) ? this.$toolbar : this.button.$toolbar;
				},
				init: function()
				{
					return {
						format:
						{
							title: this.lang.get('format'),
							icon: true,
							dropdown:
							{
								p:
								{
									title: this.lang.get('paragraph'),
									func: 'block.format'
								},
								blockquote:
								{
									title: this.lang.get('quote'),
									func: 'block.format'
								},
								pre:
								{
									title: this.lang.get('code'),
									func: 'block.format'
								},
								h1:
								{
									title: this.lang.get('heading1'),
									func: 'block.format'
								},
								h2:
								{
									title: this.lang.get('heading2'),
									func: 'block.format'
								},
								h3:
								{
									title: this.lang.get('heading3'),
									func: 'block.format'
								},
								h4:
								{
									title: this.lang.get('heading4'),
									func: 'block.format'
								},
								h5:
								{
									title: this.lang.get('heading5'),
									func: 'block.format'
								},
								h6:
								{
									title: this.lang.get('heading6'),
									func: 'block.format'
								}
							}
						},
						bold:
						{
							title: this.lang.get('bold-abbr'),
							icon: true,
							label: this.lang.get('bold'),
							func: 'inline.format'
						},
						italic:
						{
							title: this.lang.get('italic-abbr'),
							icon: true,
							label: this.lang.get('italic'),
							func: 'inline.format'
						},
						deleted:
						{
							title: this.lang.get('deleted-abbr'),
							icon: true,
							label: this.lang.get('deleted'),
							func: 'inline.format'
						},
						underline:
						{
							title: this.lang.get('underline-abbr'),
							icon: true,
							label: this.lang.get('underline'),
							func: 'inline.format'
						},
						lists:
						{
							title: this.lang.get('lists'),
							icon: true,
							dropdown:
							{
								unorderedlist:
								{
									title: '&bull; ' + this.lang.get('unorderedlist'),
									func: 'list.toggle'
								},
								orderedlist:
								{
									title: '1. ' + this.lang.get('orderedlist'),
									func: 'list.toggle'
								},
								outdent:
								{
									title: '< ' + this.lang.get('outdent'),
									func: 'indent.decrease',
									observe: {
										element: 'li',
										out: {
											attr: {
												'class': 'redactor-dropdown-link-inactive',
												'aria-disabled': true
											}
										}
									}
								},
								indent:
								{
									title: '> ' + this.lang.get('indent'),
									func: 'indent.increase',
									observe: {
										element: 'li',
										out: {
											attr: {
												'class': 'redactor-dropdown-link-inactive',
												'aria-disabled': true
											}
										}
									}
								}
							}
						},
						ul:
						{
							title: '&bull; ' + this.lang.get('bulletslist'),
							icon: true,
							func: 'list.toggle'
						},
						ol:
						{
							title: '1. ' + this.lang.get('numberslist'),
							icon: true,
							func: 'list.toggle'
						},
						outdent:
						{
							title: this.lang.get('outdent'),
							icon: true,
							func: 'indent.decrease'
						},
						indent:
						{
							title: this.lang.get('indent'),
							icon: true,
							func: 'indent.increase'
						},
						image:
						{
							title: this.lang.get('image'),
							icon: true,
							func: 'image.show'
						},
						file:
						{
							title: this.lang.get('file'),
							icon: true,
							func: 'file.show'
						},
						link:
						{
							title: this.lang.get('link'),
							icon: true,
							dropdown:
							{
								link:
								{
									title: this.lang.get('link-insert'),
									func: 'link.show',
									observe: {
										element: 'a',
										'in': {
											title: this.lang.get('link-edit'),
										},
										out: {
											title: this.lang.get('link-insert')
										}
									}
								},
								unlink:
								{
									title: this.lang.get('unlink'),
									func: 'link.unlink',
									observe: {
										element: 'a',
										out: {
											attr: {
												'class': 'redactor-dropdown-link-inactive',
												'aria-disabled': true
											}
										}
									}
								}
							}
						},
						horizontalrule:
						{
							title: this.lang.get('horizontalrule'),
							icon: true,
							func: 'line.insert'
						}
					};
				},
				setFormatting: function()
				{
					$.each(this.toolbarsButtons.format.dropdown, $.proxy(function (i, s)
					{
						if ($.inArray(i, this.opts.formatting) === -1)
						{
							delete this.toolbarsButtons.format.dropdown[i];
						}

					}, this));

				},
				hideButtons: function()
				{
					if (this.opts.buttonsHide.length !== 0)
					{
						this.button.hideButtonsSlicer(this.opts.buttonsHide);
					}
				},
				hideButtonsOnMobile: function()
				{
					if (this.detect.isMobile() && this.opts.buttonsHideOnMobile.length !== 0)
					{
						this.button.hideButtonsSlicer(this.opts.buttonsHideOnMobile);
					}
				},
				hideButtonsSlicer: function(buttons)
				{
					$.each(buttons, $.proxy(function(i, s)
					{
						var index = this.opts.buttons.indexOf(s);
						if (index !== -1)
						{
						    this.opts.buttons.splice(index, 1);
						}

					}, this));
				},
				load: function($toolbar)
				{
					this.button.buttons = [];

					$.each(this.opts.buttons, $.proxy(function(i, btnName)
					{
						if (!this.toolbarsButtons[btnName]
							|| (btnName === 'file' && !this.file.is())
							|| (btnName === 'image' && !this.image.is()))
						{
							return;
						}

						$toolbar.append($('<li>').append(this.button.build(btnName, this.toolbarsButtons[btnName])));

					}, this));
				},
				buildButtonTooltip: function($btn, title)
				{
    				if (this.opts.air || this.detect.isMobile())
    				{
        				return;
    				}

                    var $tooltip = $('<span>');
				    $tooltip.addClass('re-button-tooltip');
				    $tooltip.html(title);

                    $btn.append($tooltip);
                    $btn.on('mouseover', function()
                    {
                        if ($(this).hasClass('redactor-button-disabled'))
                        {
                            return;
                        }

                        $tooltip.show();
                        $tooltip.css('margin-left', -($tooltip.innerWidth()/2));

                    }).on('mouseout', function()
                    {
                        $tooltip.hide();
                    });
				},
				build: function(btnName, btnObject)
				{
					if (this.opts.toolbar === false)
					{
						return;
					}

                    var title = (typeof btnObject.label !== 'undefined') ? btnObject.label : btnObject.title;
					var $button = $('<a href="javascript:void(null);" alt="' + title + '" rel="' + btnName + '" />')

                    $button.addClass('re-button re-' + btnName);
					$button.attr({ 'role': 'button', 'aria-label': title, 'tabindex': '-1' });

                    if (typeof btnObject.icon !== 'undefined')
                    {
    					var $icon = $('<i>');
					    $icon.addClass('re-icon-' + btnName);

					    $button.append($icon);
					    $button.addClass('re-button-icon');

                        this.button.buildButtonTooltip($button, title);
					}
					else
					{
    					$button.html(btnObject.title);
					}

					// click
					if (btnObject.func || btnObject.command || btnObject.dropdown)
					{
						this.button.setEvent($button, btnName, btnObject);
					}

					// dropdown
					if (btnObject.dropdown)
					{
						$button.addClass('redactor-toolbar-link-dropdown').attr('aria-haspopup', true);

						var $dropdown = $('<ul class="redactor-dropdown redactor-dropdown-' + this.uuid + ' redactor-dropdown-box-' + btnName + '" style="display: none;">');
						$button.data('dropdown', $dropdown);
						this.dropdown.build(btnName, $dropdown, btnObject.dropdown);
					}

					this.button.buttons.push($button);

					return $button;
				},
				getButtons: function()
				{
					return this.button.toolbar().find('a.re-button');
				},
				getButtonsKeys: function()
				{
					return this.button.buttons;
				},
				setEvent: function($button, btnName, btnObject)
				{
					$button.on('mousedown', $.proxy(function(e)
					{
						e.preventDefault();

						if ($button.hasClass('redactor-button-disabled'))
						{
							return false;
						}

						var type = 'func';
						var callback = btnObject.func;

						if (btnObject.command)
						{
							type = 'command';
							callback = btnObject.command;
						}
						else if (btnObject.dropdown)
						{
							type = 'dropdown';
							callback = false;
						}

						this.button.toggle(e, btnName, type, callback);

						return false;

					}, this));
				},
				toggle: function(e, btnName, type, callback, args)
				{

					if (this.detect.isIe() || !this.detect.isDesktop())
					{
						this.utils.freezeScroll();
						e.returnValue = false;
					}

					if (type === 'command')
					{
						this.inline.format(callback);
					}
					else if (type === 'dropdown')
					{
						this.dropdown.show(e, btnName);
					}
					else
					{
						this.button.clickCallback(e, callback, btnName, args);
					}

					if (type !== 'dropdown')
					{
						this.dropdown.hideAll(false);
					}

					if (this.opts.air && type !== 'dropdown')
					{
						this.air.hide(e);
					}

					if (this.detect.isIe() || !this.detect.isDesktop())
					{
						this.utils.unfreezeScroll();
					}
				},
				clickCallback: function(e, callback, btnName, args)
				{
					var func;

					args = (typeof args === 'undefined') ? btnName : args;

					if ($.isFunction(callback))
					{
						callback.call(this, btnName);
					}
					else if (callback.search(/\./) !== '-1')
					{
						func = callback.split('.');
						if (typeof this[func[0]] === 'undefined')
						{
							return;
						}

						if (typeof args === 'object')
						{
							this[func[0]][func[1]].apply(this, args);
						}
						else
						{
							this[func[0]][func[1]].call(this, args);
						}
					}
					else
					{

						if (typeof args === 'object')
						{
							this[callback].apply(this, args);
						}
						else
						{
							this[callback].call(this, args);
						}
					}

					this.observe.buttons(e, btnName);

				},
				all: function()
				{
					return this.button.buttons;
				},
				get: function(key)
				{
					if (this.opts.toolbar === false)
					{
						return;
					}

					return this.button.toolbar().find('a.re-' + key);
				},
				set: function(key, title)
				{
					if (this.opts.toolbar === false)
					{
						return;
					}

					var $btn = this.button.toolbar().find('a.re-' + key);

					$btn.html(title).attr('aria-label', title);

					return $btn;
				},
				add: function(key, title)
				{
					if (this.button.isAdded(key) !== true)
					{
						return $();
					}

					var btn = this.button.build(key, { title: title });

					this.button.toolbar().append($('<li>').append(btn));

					return btn;
				},
				addFirst: function(key, title)
				{
					if (this.button.isAdded(key) !== true)
					{
						return $();
					}

					var btn = this.button.build(key, { title: title });

					this.button.toolbar().prepend($('<li>').append(btn));

					return btn;
				},
				addAfter: function(afterkey, key, title)
				{
					if (this.button.isAdded(key) !== true)
					{
						return $();
					}

					var btn = this.button.build(key, { title: title });
					var $btn = this.button.get(afterkey);

					if ($btn.length !== 0)
					{
						$btn.parent().after($('<li>').append(btn));
					}
					else
					{
						this.button.toolbar().append($('<li>').append(btn));
					}

					return btn;
				},
				addBefore: function(beforekey, key, title)
				{
					if (this.button.isAdded(key) !== true)
					{
						return $();
					}

					var btn = this.button.build(key, { title: title });
					var $btn = this.button.get(beforekey);

					if ($btn.length !== 0)
					{
						$btn.parent().before($('<li>').append(btn));
					}
					else
					{
						this.button.toolbar().append($('<li>').append(btn));
					}

					return btn;
				},
				isAdded: function(key)
				{
	                var index = this.opts.buttonsHideOnMobile.indexOf(key);
                    if (this.opts.toolbar === false || (index !== -1 && this.detect.isMobile()))
                    {
					    return false;
					}

					return true;
				},
				setIcon: function($btn, icon)
				{
					$btn.html(icon).addClass('re-button-icon');
					this.button.buildButtonTooltip($btn, $btn.attr('alt'));
				},
				changeIcon: function(key, newIconClass)
				{
                    var $btn = this.button.get(key);
                    if ($btn.length !== 0)
					{
    					$btn.find('i').removeAttr('class').addClass('re-icon-' + newIconClass);
    				}
				},
				addCallback: function($btn, callback)
				{
					if (typeof $btn === 'undefined' || this.opts.toolbar === false)
					{
						return;
					}

					var type = (callback === 'dropdown') ? 'dropdown' : 'func';
					var key = $btn.attr('rel');
					$btn.on('mousedown', $.proxy(function(e)
					{
						if ($btn.hasClass('redactor-button-disabled'))
						{
							return false;
						}

						this.button.toggle(e, key, type, callback);

					}, this));
				},
				addDropdown: function($btn, dropdown)
				{
					if (this.opts.toolbar === false)
					{
						return;
					}

					$btn.addClass('redactor-toolbar-link-dropdown').attr('aria-haspopup', true);

					var key = $btn.attr('rel');
					this.button.addCallback($btn, 'dropdown');

					var $dropdown = $('<div class="redactor-dropdown redactor-dropdown-' + this.uuid + ' redactor-dropdown-box-' + key + '" style="display: none;">');
					$btn.data('dropdown', $dropdown);

					// build dropdown
					if (dropdown)
					{
						this.dropdown.build(key, $dropdown, dropdown);
					}

					return $dropdown;
				},
				setActive: function(key)
				{
					this.button.get(key).addClass('redactor-act');
				},
				setInactive: function(key)
				{
					this.button.get(key).removeClass('redactor-act');
				},
				setInactiveAll: function(key)
				{
					var $btns = this.button.toolbar().find('a.re-button');

					if (typeof key !== 'undefined')
					{
						$btns = $btns.not('.re-' + key);
					}

					$btns.removeClass('redactor-act');
				},
				disable: function(key)
				{
					this.button.get(key).addClass('redactor-button-disabled');
				},
				enable: function(key)
				{
					this.button.get(key).removeClass('redactor-button-disabled');
				},
				disableAll: function(key)
				{
					var $btns = this.button.toolbar().find('a.re-button');
					if (typeof key !== 'undefined')
					{
						$btns = $btns.not('.re-' + key);
					}

					$btns.addClass('redactor-button-disabled');
				},
				enableAll: function()
				{
					this.button.toolbar().find('a.re-button').removeClass('redactor-button-disabled');
				},
				remove: function(key)
				{
					this.button.get(key).remove();
				}
			};
		},

		// =caret
		caret: function()
		{
			return {
				set: function(node1, node2, end)
				{
					this.core.editor().focus();

					end = (typeof end === 'undefined') ? 0 : 1;

					node1 = node1[0] || node1;
					node2 = node2[0] || node2;

					var sel = this.selection.get();
					var range = this.selection.range(sel);

					try
					{
						range.setStart(node1, 0);
						range.setEnd(node2, end);
					}
					catch (e) {}

					this.selection.update(sel, range);
				},
				prepare: function(node)
				{
					// firefox focus
					if (this.detect.isFirefox() && typeof this.start !== 'undefined')
					{
						this.core.editor().focus();
					}

					return node[0] || node;
				},
				start: function(node)
				{
					var sel, range;
					node = this.caret.prepare(node);

					if (!node)
					{
						return;
					}

					if (node.tagName === 'BR')
					{
						return this.caret.before(node);
					}

					var $first = $(node).children().first();

					// empty or inline tag
					var inline = this.utils.isInlineTag(node.tagName);
					if (node.innerHTML === '' || inline)
					{
                        this.caret.setStartEmptyOrInline(node, inline);
					}
					// empty inline inside
                    else if ($first && $first.length !== 0 && this.utils.isInlineTag($first[0].tagName) && $first.text() === '')
                    {
                       this.caret.setStartEmptyOrInline($first[0], true);
                    }
                    // block tag
					else
					{
                        sel = window.getSelection();
                        sel.removeAllRanges();

                        range = document.createRange();
                        range.selectNodeContents(node);
                        range.collapse(true);
                        sel.addRange(range);
					}


				},
				setStartEmptyOrInline: function(node, inline)
				{
                    var sel = window.getSelection();
				    var range = document.createRange();
					var textNode = document.createTextNode('\u200B');

					range.setStart(node, 0);
					range.insertNode(textNode);
					range.setStartAfter(textNode);
					range.collapse(true);

					sel.removeAllRanges();
					sel.addRange(range);

					// remove invisible text node
					if (!inline)
					{
						this.core.editor().on('keydown.redactor-remove-textnode', function()
						{
							$(textNode).remove();
							$(this).off('keydown.redactor-remove-textnode');
						});
					}
				},
				end: function(node)
				{
					var sel, range;
					node = this.caret.prepare(node);

					if (!node)
					{
						return;
					}

					// empty node
					if (node.tagName !== 'BR' && node.innerHTML === '')
					{
						return this.caret.start(node);
					}

					// br
					if (node.tagName === 'BR')
					{
						var space = document.createElement('span');
						space.className = 'redactor-invisible-space';
						space.innerHTML = '&#x200b;';

						$(node).after(space);

						sel = window.getSelection();
						sel.removeAllRanges();

						range = document.createRange();

						range.setStartBefore(space);
						range.setEndBefore(space);
						sel.addRange(range);

						$(space).replaceWith(function()
						{
							return $(this).contents();
						});

						return;
					}

					if (node.lastChild && node.lastChild.nodeType === 1)
					{
						return this.caret.after(node.lastChild);
					}

					sel = window.getSelection();
					sel.removeAllRanges();

					range = document.createRange();
					range.selectNodeContents(node);
					range.collapse(false);
					sel.addRange(range);
				},
				after: function(node)
				{
					var sel, range;
					node = this.caret.prepare(node);


					if (!node)
					{
						return;
					}

					if (node.tagName === 'BR')
					{
						return this.caret.end(node);
					}

					// block tag
					if (this.utils.isBlockTag(node.tagName))
					{
						var next = this.caret.next(node);

						if (typeof next === 'undefined')
						{
							this.caret.end(node);
						}
						else
						{
							// table
							if (next.tagName === 'TABLE')
							{
								next = $(next).find('th, td').first()[0];
							}
							// list
							else if (next.tagName === 'UL' || next.tagName === 'OL')
							{
								next = $(next).find('li').first()[0];
							}

							this.caret.start(next);
						}

						return;
					}

					// inline tag
					var textNode = document.createTextNode('\u200B');

					sel = window.getSelection();
					sel.removeAllRanges();

					range = document.createRange();
					range.setStartAfter(node);
					range.insertNode(textNode);
					range.setStartAfter(textNode);
					range.collapse(true);

					sel.addRange(range);

				},
				before: function(node)
				{
					var sel, range;
					node = this.caret.prepare(node);


					if (!node)
					{
						return;
					}

					// block tag
					if (this.utils.isBlockTag(node.tagName))
					{
						var prev = this.caret.prev(node);

						if (typeof prev === 'undefined')
						{
							this.caret.start(node);
						}
						else
						{
							// table
							if (prev.tagName === 'TABLE')
							{
								prev = $(prev).find('th, td').last()[0];
							}
							// list
							else if (prev.tagName === 'UL' || prev.tagName === 'OL')
							{
								prev = $(prev).find('li').last()[0];
							}

							this.caret.end(prev);
						}

						return;
					}

					// inline tag
					sel = window.getSelection();
					sel.removeAllRanges();

					range = document.createRange();

			        range.setStartBefore(node);
			        range.collapse(true);

			        sel.addRange(range);
				},
				next: function(node)
				{
					var $next = $(node).next();
					if ($next.hasClass('redactor-script-tag, redactor-selection-marker'))
					{
						return $next.next()[0];
					}
					else
					{
						return $next[0];
					}
				},
				prev: function(node)
				{
					var $prev = $(node).prev();
					if ($prev.hasClass('redactor-script-tag, redactor-selection-marker'))
					{
						return $prev.prev()[0];
					}
					else
					{
						return $prev[0];
					}
				},

				// #backward
				offset: function(node)
				{
					return this.offset.get(node);
				}

			};
		},

		// =clean
		clean: function()
		{
			return {
				onSet: function(html)
				{
					html = this.clean.savePreCode(html);
					html = this.clean.saveFormTags(html);

					// convert script tag
					if (this.opts.script)
					{
						html = html.replace(/<script(.*?[^>]?)>([\w\W]*?)<\/script>/gi, '<pre class="redactor-script-tag" $1>$2</pre>');
					}

					// converting entity
					html = html.replace(/\$/g, '&#36;');
					html = html.replace(/&amp;/g, '&');

					// replace special characters in links
					html = html.replace(/<a href="(.*?[^>]?)®(.*?[^>]?)">/gi, '<a href="$1&reg$2">');

					// save markers
					html = html.replace(/<span id="selection-marker-1"(.*?[^>]?)>​<\/span>/gi, '###marker1###');
					html = html.replace(/<span id="selection-marker-2"(.*?[^>]?)>​<\/span>/gi, '###marker2###');

					// replace tags
					var self = this;
					var $div = $("<div/>").html($.parseHTML(html, document, true));

					var replacement = this.opts.replaceTags;
					if (replacement)
					{
                        var keys = Object.keys(this.opts.replaceTags);
    					$div.find(keys.join(',')).each(function(i,s)
    					{
    						self.utils.replaceToTag(s, replacement[s.tagName.toLowerCase()]);
    					});
					}

					// add span marker
					$div.find('span, a').attr('data-redactor-span', true).each(function()
					{
    					// add style cache
    					var $el = $(this);

    					if ($el.attr('style'))
    					{
        					$el.attr('data-redactor-style-cache', $el.attr('style'));
    					}
					});

					html = $div.html();

					// remove tags
					var tags = ['font', 'html', 'head', 'link', 'body', 'meta', 'applet'];
					if (!this.opts.script)
					{
						tags.push('script');
					}

					html = this.clean.stripTags(html, tags);

					// remove html comments
					if (this.opts.removeComments)
					{
					    html = html.replace(/<!--[\s\S]*?-->/gi, '');
					}

					// paragraphize
					html = this.paragraphize.load(html);

					// restore markers
					html = html.replace('###marker1###', '<span id="selection-marker-1" class="redactor-selection-marker">​</span>');
					html = html.replace('###marker2###', '<span id="selection-marker-2" class="redactor-selection-marker">​</span>');

					// empty
					if (html.search(/^(||\s||<br\s?\/?>||&nbsp;)$/i) !== -1)
					{
						return this.opts.emptyHtml;
					}

					return html;
				},
				onGet: function(html)
				{
					return this.clean.onSync(html);
				},
				onSync: function(html)
				{
					// remove invisible spaces
					html = html.replace(/\u200B/g, '');
					html = html.replace(/&#x200b;/gi, '');
					//html = html.replace(/&nbsp;&nbsp;/gi, '&nbsp;');

					if (html.search(/^<p>(||\s||<br\s?\/?>||&nbsp;)<\/p>$/i) !== -1)
					{
						return '';
					}

					// remove image resize
					html = html.replace(/<span(.*?)id="redactor-image-box"(.*?[^>])>([\w\W]*?)<img(.*?)><\/span>/gi, '$3<img$4>');
					html = html.replace(/<span(.*?)id="redactor-image-resizer"(.*?[^>])>(.*?)<\/span>/gi, '');
					html = html.replace(/<span(.*?)id="redactor-image-editter"(.*?[^>])>(.*?)<\/span>/gi, '');
					html = html.replace(/<img(.*?)style="(.*?)opacity: 0\.5;(.*?)"(.*?)>/gi, '<img$1style="$2$3"$4>');

					var $div = $("<div/>").html($.parseHTML(html, document, true));

					// remove empty atributes
					$div.find('*[style=""]').removeAttr('style');
					$div.find('*[class=""]').removeAttr('class');
					$div.find('*[rel=""]').removeAttr('rel');

					// remove markers
					$div.find('.redactor-invisible-space, .redactor-unlink').each(function()
					{
						$(this).contents().unwrap();
					});

					// remove span without attributes & span marker
				    $div.find('span, a').removeAttr('data-redactor-span data-redactor-style-cache').each(function()
					{
    					if (this.attributes.length === 0)
    					{
						    $(this).contents().unwrap();
						}
					});

					// remove rel attribute from img
					$div.find('img').removeAttr('rel');

					$div.find('.redactor-selection-marker, #redactor-insert-marker').remove();

					html = $div.html();

					// reconvert script tag
					if (this.opts.script)
					{
						html = html.replace(/<pre class="redactor-script-tag"(.*?[^>]?)>([\w\W]*?)<\/pre>/gi, '<script$1>$2</script>');
					}

					// restore form tag
					html = this.clean.restoreFormTags(html);

					// remove br in|of li/header tags
					html = html.replace(new RegExp('<br\\s?/?></h', 'gi'), '</h');
					html = html.replace(new RegExp('<br\\s?/?></li>', 'gi'), '</li>');
					html = html.replace(new RegExp('</li><br\\s?/?>', 'gi'), '</li>');

					// pre class
					html = html.replace(/<pre>/gi, "<pre>\n");
					if (this.opts.preClass)
					{
						html = html.replace(/<pre>/gi, '<pre class="' + this.opts.preClass + '">');
					}

					// link nofollow
					if (this.opts.linkNofollow)
					{
						html = html.replace(/<a(.*?)rel="nofollow"(.*?[^>])>/gi, '<a$1$2>');
						html = html.replace(/<a(.*?[^>])>/gi, '<a$1 rel="nofollow">');
					}

					// replace special characters
					var chars = {
						'\u2122': '&trade;',
						'\u00a9': '&copy;',
						'\u2026': '&hellip;',
						'\u2014': '&mdash;',
						'\u2010': '&dash;'
					};

					$.each(chars, function(i,s)
					{
						html = html.replace(new RegExp(i, 'g'), s);
					});

					html = html.replace(/&amp;/g, '&');

					// remove empty paragpraphs
					html = html.replace(/<p><\/p>/gi, "");

					// remove new lines
                    html = html.replace(/\n{2,}/g, "\n");

                    // remove all newlines
                    if (this.opts.removeNewlines)
                    {
                        html = html.replace(/\r?\n/g, "");
                    }

					return html;
				},
				onPaste: function(html, data, insert)
				{
					// if paste event
					if (insert !== true)
					{
    					// remove google docs markers
                        html = html.replace(/<b\sid="internal-source-marker(.*?)">([\w\W]*?)<\/b>/gi, "$2");
    					html = html.replace(/<b(.*?)id="docs-internal-guid(.*?)">([\w\W]*?)<\/b>/gi, "$3");

                        // google docs styles
                        html = html.replace(/<span[^>]*(font-style: italic; font-weight: bold|font-weight: bold; font-style: italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
                        html = html.replace(/<span[^>]*(font-style: italic; font-weight: 700|font-weight: 700; font-style: italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
                        html = html.replace(/<span[^>]*font-style: italic[^>]*>([\w\W]*?)<\/span>/gi, '<i>$1</i>');
                        html = html.replace(/<span[^>]*font-weight: bold[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');
                        html = html.replace(/<span[^>]*font-weight: 700[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');

						var msword = this.clean.isHtmlMsWord(html);
						if (msword)
						{
							html = this.clean.cleanMsWord(html);
						}
					}

					html = $.trim(html);

					if (data.pre)
					{
						if (this.opts.preSpaces)
						{
							html = html.replace(/\t/g, new Array(this.opts.preSpaces + 1).join(' '));
						}
					}
					else
					{
						html = this.clean.replaceBrToNl(html);
						html = this.clean.removeTagsInsidePre(html);
					}

					// if paste event
					if (insert !== true)
					{
						html = this.clean.removeEmptyInlineTags(html);

						if (data.encode === false)
						{
							html = html.replace(/&/g, '&amp;');
							html = this.clean.convertTags(html, data);
							html = this.clean.getPlainText(html);
							html = this.clean.reconvertTags(html, data);
						}

					}

					if (data.text)
					{
						html = this.clean.replaceNbspToSpaces(html);
						html = this.clean.getPlainText(html);
					}

					if (data.lists)
					{
    					html = html.replace("\n", '<br>');
    				}

					if (data.encode)
					{
						html = this.clean.encodeHtml(html);
					}

					if (data.paragraphize)
					{

						html = this.paragraphize.load(html);
					}

					return html;

				},
				getCurrentType: function(html, insert)
				{
					var blocks = this.selection.blocks();

					var data = {
						text: false,
						encode: false,
						paragraphize: true,
						line: this.clean.isHtmlLine(html),
						blocks: this.clean.isHtmlBlocked(html),
						pre: false,
						lists: false,
						block: true,
						inline: true,
						links: true,
						images: true
					};

					if (blocks.length === 1 && this.utils.isCurrentOrParent(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'figcaption']))
					{
						data.text = true;
						data.paragraphize = false;
						data.inline = false;
						data.images = false;
						data.links = false;
						data.line = true;
					}
					else if (this.opts.type === 'inline' || this.opts.enterKey === false)
					{
						data.paragraphize = false;
						data.block = false;
						data.line = true;
					}
					else if (blocks.length === 1 && this.utils.isCurrentOrParent(['li']))
					{
						data.lists = true;
						data.block = false;
						data.paragraphize = false;
						data.images = false;
					}
					else if (blocks.length === 1 && this.utils.isCurrentOrParent(['th', 'td', 'blockquote']))
					{
						data.block = false;
						data.paragraphize = false;

					}
					else if (this.opts.type === 'pre' || (blocks.length === 1 && this.utils.isCurrentOrParent('pre')))
					{
						data.inline = false;
						data.block = false;
						data.encode = true;
						data.pre = true;
						data.paragraphize = false;
						data.images = false;
						data.links = false;
					}

					if (data.line === true)
					{
						data.paragraphize = false;
					}

					if (insert === true)
					{
						data.text = false;
					}

					return data;

				},
				isHtmlBlocked: function(html)
				{
					var match1 = html.match(new RegExp('</(' + this.opts.blockTags.join('|' ).toUpperCase() + ')>', 'gi'));
					var match2 = html.match(new RegExp('<hr(.*?[^>])>', 'gi'));

					return (match1 === null && match2 === null) ? false : true;
				},
				isHtmlLine: function(html)
				{
					if (this.clean.isHtmlBlocked(html))
					{
						return false;
					}

					var matchBR = html.match(/<br\s?\/?>/gi);
					var matchNL = html.match(/\n/gi);

					return (!matchBR && !matchNL) ? true : false;
				},
				isHtmlMsWord: function(html)
				{
					return html.match(/class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i);
				},
				removeEmptyInlineTags: function(html)
				{
					var tags = this.opts.inlineTags;
    				var $div = $("<div/>").html($.parseHTML(html, document, true));
                    var self = this;

					var $spans = $div.find('span');
					var $tags = $div.find(tags.join(','));

					$tags.removeAttr('style');

					$tags.each(function()
					{
    					var tagHtml = $(this).html();
    					if (this.attributes.length === 0 && self.utils.isEmpty(tagHtml))
    					{
        					$(this).replaceWith(function()
        					{
        						return $(this).contents();
        					});
    					}
					});

                    $spans.each(function()
					{
    					var tagHtml = $(this).html();
    					if (this.attributes.length === 0)
    					{
        					$(this).replaceWith(function()
        					{
        						return $(this).contents();
        					});
    					}
					});

					html = $div.html();

					$div.remove();

					return html;
				},
				cleanMsWord: function(html)
				{
    				html = html.replace(/<!--[\s\S]*?-->/g, "");
    				html = html.replace(/<o:p>[\s\S]*?<\/o:p>/gi, '');
					html = html.replace(/\n/g, " ");
					html = html.replace(/<br\s?\/?>|<\/p>|<\/div>|<\/li>|<\/td>/gi, '\n\n');

					// lists
					var $div = $("<div/>").html(html);

					var lastList = false;
					var lastLevel = 1;
					var listsIds = [];

					$div.find("p[style]").each(function()
					{
						var matches = $(this).attr('style').match(/mso\-list\:l([0-9]+)\slevel([0-9]+)/);

						if (matches)
						{
							var currentList = parseInt(matches[1]);
							var currentLevel = parseInt(matches[2]);
							var listType = $(this).html().match(/^[\w]+\./) ? "ol" : "ul";

							var $li = $("<li/>").html($(this).html());

							$li.html($li.html().replace(/^([\w\.]+)</, '<'));
							$li.find("span:first").remove();

							if (currentLevel == 1 && $.inArray(currentList, listsIds) == -1)
							{
								var $list = $("<" + listType + "/>").attr({"data-level": currentLevel, "data-list": currentList}).html($li);
								$(this).replaceWith($list);

								lastList = currentList;
								listsIds.push(currentList);
							}
							else
							{
								if (currentLevel > lastLevel)
								{
									var $prevList = $div.find('[data-level="' + lastLevel + '"][data-list="' + lastList + '"]');
									var $lastList = $prevList;

									for(var i = lastLevel; i < currentLevel; i++)
									{
										$list = $("<" + listType + "/>");
										$list.appendTo($lastList.find("li").last());

										$lastList = $list;
									}

									$lastList.attr({"data-level": currentLevel, "data-list": currentList}).html($li);

								}
								else
								{
									var $prevList = $div.find('[data-level="' + currentLevel + '"][data-list="' + currentList + '"]').last();

									$prevList.append($li);
								}

								lastLevel = currentLevel;
								lastList = currentList;

								$(this).remove();
							}
						}
					});

					$div.find('[data-level][data-list]').removeAttr('data-level data-list');
					html = $div.html();

					return html;
				},
				replaceNbspToSpaces: function(html)
				{
					return html.replace('&nbsp;', ' ');
				},
				replaceBrToNl: function(html)
				{
					return html.replace(/<br\s?\/?>/gi, '\n');
				},
				replaceNlToBr: function(html)
				{
					return html.replace(/\n/g, '<br />');
				},
				convertTags: function(html, data)
				{
                    var $div = $('<div>').html(html);

                    // remove iframe
					$div.find('iframe').remove();

					// link target & attrs
					var $links = $div.find('a');
					$links.removeAttr('style');
					if (this.opts.pasteLinkTarget !== false)
					{
    					$links.attr('target', this.opts.pasteLinkTarget);
					}

                    // links
                    if (data.links && this.opts.pasteLinks)
                    {
                    	$div.find('a').each(function(i, link)
                    	{
                    		if (link.href)
                    		{
                    			var tmp = '##%a href="' + link.href + '"';
                    			var attr;
                    			for (var j = 0, length = link.attributes.length; j < length; j++)
                    			{
                    				attr = link.attributes.item(j);
                    				if (attr.name !== 'href')
                    				{
                    					tmp += ' ' + attr.name + '="' + attr.value + '"';
                    				}
                    			}

                    			link.outerHTML = tmp + '%##' + link.innerHTML + '##%/a%##';
                    		}
                    	});
                    }

                    html = $div.html();

                    // images
					if (data.images && this.opts.pasteImages)
					{
						html = html.replace(/<img(.*?)src="(.*?)"(.*?[^>])>/gi, '##%img$1src="$2"$3%##');
					}

					// plain text
					if (this.opts.pastePlainText)
					{
						return html;
					}

					// all tags
					var blockTags = (data.lists) ? ['ul', 'ol', 'li'] : this.opts.pasteBlockTags;

					var tags;
					if (data.block || data.lists)
					{
						tags = (data.inline) ? blockTags.concat(this.opts.pasteInlineTags) : blockTags;
					}
					else
					{
						tags = (data.inline) ? this.opts.pasteInlineTags : [];
					}

					var len = tags.length;
					for (var i = 0; i < len; i++)
					{
						html = html.replace(new RegExp('<\/' + tags[i] + '>', 'gi'), '###/' + tags[i] + '###');

						if (tags[i] === 'td' || tags[i] === 'th')
						{
							html = html.replace(new RegExp('<' + tags[i] + '(.*?[^>])((colspan|rowspan)="(.*?[^>])")?(.*?[^>])>', 'gi'), '###' + tags[i] + ' $2###');
						}
						else if (tags[i] === 'span')
						{
    						html = html.replace(new RegExp('<' + tags[i] + '([^>]*)class="([^>]*)"[^>]*>', 'gi'), '###' + tags[i] + ' class="$2"###');
                            html = html.replace(new RegExp('<' + tags[i] + '([^>]*)data-redactor-style-cache="([^>]*)"[^>]*>', 'gi'), '###' + tags[i] + ' cache="$2"###');
						}
						else
						{
							html = html.replace(new RegExp('<' + tags[i] + '[^>]*>', 'gi'), '###' + tags[i] + '###');
						}
					}

					return html;

				},
				reconvertTags: function(html, data)
				{
					// links & images
					if ((data.links && this.opts.pasteLinks) || (data.images && this.opts.pasteImages))
					{
						html = html.replace(new RegExp('##%', 'gi'), '<');
						html = html.replace(new RegExp('%##', 'gi'), '>');
                    }

					// plain text
					if (this.opts.pastePlainText)
					{
						return html;
					}

					var blockTags = (data.lists) ? ['ul', 'ol', 'li'] : this.opts.pasteBlockTags;

					var tags;
					if (data.block || data.lists)
					{
						tags = (data.inline) ? blockTags.concat(this.opts.pasteInlineTags) : blockTags;
					}
					else
					{
						tags = (data.inline) ? this.opts.pasteInlineTags : [];
					}

					var len = tags.length;
					for (var i = 0; i < len; i++)
					{
						html = html.replace(new RegExp('###\/' + tags[i] + '###', 'gi'), '</' + tags[i] + '>');
                    }

                    for (var i = 0; i < len; i++)
					{
    					html = html.replace(new RegExp('###' + tags[i] + '###', 'gi'), '<' + tags[i] + '>');
    				}

					for (var i = 0; i < len; i++)
					{
                        if (tags[i] === 'td' || tags[i] === 'th')
                        {
						    html = html.replace(new RegExp('###' + tags[i] + '\s?(.*?[^#])###', 'gi'), '<' + tags[i] + '$1>');
                        }
                        else if (tags[i] === 'span')
                        {
                            html = html.replace(new RegExp('###' + tags[i] + ' cache="(.*?[^#])"###', 'gi'), '<' + tags[i] + ' style="$1" data-redactor-span="true" data-redactor-style-cache="$1">');
                            html = html.replace(new RegExp('###' + tags[i] + '\s?(.*?[^#])###', 'gi'), '<' + tags[i] + '$1>');
                        }
                    }

					return html;

				},
				cleanPre: function(block)
				{
					block = (typeof block === 'undefined') ? $(this.selection.block()).closest('pre', this.core.editor()[0]) : block;

					$(block).find('br').replaceWith(function()
					{
						return document.createTextNode('\n');
					});

					$(block).find('p').replaceWith(function()
					{
						return $(this).contents();
					});

				},
				removeTagsInsidePre: function(html)
				{
					var $div = $('<div />').append(html);
					$div.find('pre').replaceWith(function()
					{
						var str = $(this).html();
						str = str.replace(/<br\s?\/?>|<\/p>|<\/div>|<\/li>|<\/td>/gi, '\n');
						str = str.replace(/(<([^>]+)>)/gi, '');

						return $('<pre />').append(str);
					});

					html = $div.html();
					$div.remove();

					return html;

				},
				getPlainText: function(html)
				{
					html = html.replace(/<!--[\s\S]*?-->/gi, '');
					html = html.replace(/<style[\s\S]*?style>/gi, '');
					html = html.replace(/<\/p>|<\/div>|<\/li>|<\/td>/gi, '\n');
					html = html.replace(/<\/H[1-6]>/gi, '\n\n');

					var tmp = document.createElement('div');
					tmp.innerHTML = html;
					html = tmp.textContent || tmp.innerText;

					return $.trim(html);
				},
				savePreCode: function(html)
				{
					html = this.clean.savePreFormatting(html);
					html = this.clean.saveCodeFormatting(html);
					html = this.clean.restoreSelectionMarkers(html);

					return html;
				},
				savePreFormatting: function(html)
				{
					var pre = html.match(/<pre(.*?)>([\w\W]*?)<\/pre>/gi);
					if (pre === null)
					{
						return html;
					}

					$.each(pre, $.proxy(function(i,s)
					{
    					var arr = [];
    					var codeTag = false;
    					var contents, attr1, attr2;

    					if (s.match(/<pre(.*?)>(([\n\r\s]+)?)<code(.*?)>/i))
    					{

        					arr = s.match(/<pre(.*?)>(([\n\r\s]+)?)<code(.*?)>([\w\W]*?)<\/code><\/pre>/i);
        					codeTag = true;

                            contents = arr[5];
                            attr1 = arr[1];
                            attr2 = arr[4];
    					}
                        else
						{
    						arr = s.match(/<pre(.*?)>([\w\W]*?)<\/pre>/i);

                            contents = arr[2];
                            attr1 = arr[1];
                        }

						contents = contents.replace(/<br\s?\/?>/g, '\n');
						contents = contents.replace(/&nbsp;/g, ' ');

						if (this.opts.preSpaces)
						{
							contents = contents.replace(/\t/g, new Array(this.opts.preSpaces + 1).join(' '));
						}

                        contents = this.clean.encodeEntities(contents);

						// $ fix
						contents = contents.replace(/\$/g, '&#36;');

                        if (codeTag)
                        {
                            html = html.replace(s, '<pre' + attr1 + '><code' + attr2 + '>' + contents + '</code></pre>');
                        }
                        else
                        {
                            html = html.replace(s, '<pre' + attr1 + '>' + contents + '</pre>');
                        }


					}, this));

					return html;
				},
				saveCodeFormatting: function(html)
				{
					var code = html.match(/<code(.*?)>([\w\W]*?)<\/code>/gi);
					if (code === null)
					{
						return html;
					}

					$.each(code, $.proxy(function(i,s)
					{
						var arr = s.match(/<code(.*?)>([\w\W]*?)<\/code>/i);

						arr[2] = arr[2].replace(/&nbsp;/g, ' ');
						arr[2] = this.clean.encodeEntities(arr[2]);
						arr[2] = arr[2].replace(/\$/g, '&#36;');

						html = html.replace(s, '<code' + arr[1] + '>' + arr[2] + '</code>');

					}, this));

					return html;
				},
				restoreSelectionMarkers: function(html)
				{
					html = html.replace(/&lt;span id=&quot;selection-marker-([0-9])&quot; class=&quot;redactor-selection-marker&quot;&gt;​&lt;\/span&gt;/g, '<span id="selection-marker-$1" class="redactor-selection-marker">​</span>');

					return html;
				},
				saveFormTags: function(html)
				{
					return html.replace(/<form(.*?)>([\w\W]*?)<\/form>/gi, '<section$1 rel="redactor-form-tag">$2</section>');
				},
				restoreFormTags: function(html)
				{
					return html.replace(/<section(.*?) rel="redactor-form-tag"(.*?)>([\w\W]*?)<\/section>/gi, '<form$1$2>$3</form>');
				},
				encodeHtml: function(html)
				{
					html = html.replace(/”/g, '"');
					html = html.replace(/“/g, '"');
					html = html.replace(/‘/g, '\'');
					html = html.replace(/’/g, '\'');
					html = this.clean.encodeEntities(html);

					return html;
				},
				encodeEntities: function(str)
				{
					str = String(str).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
					str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

					return str;
				},
				stripTags: function(input, denied)
				{
					if (typeof denied === 'undefined')
					{
						return input.replace(/(<([^>]+)>)/gi, '');
					}

				    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

				    return input.replace(tags, function ($0, $1)
				    {
				        return denied.indexOf($1.toLowerCase()) === -1 ? $0 : '';
				    });
				},
				removeMarkers: function(html)
				{
					return html.replace(/<span(.*?[^>]?)class="redactor-selection-marker"(.*?[^>]?)>([\w\W]*?)<\/span>/gi, '');
				},
				removeSpaces: function(html)
				{
					html = $.trim(html);
					html = html.replace(/\n/g, '');
					html = html.replace(/[\t]*/g, '');
					html = html.replace(/\n\s*\n/g, "\n");
					html = html.replace(/^[\s\n]*/g, ' ');
					html = html.replace(/[\s\n]*$/g, ' ');
					html = html.replace( />\s{2,}</g, '> <'); // between inline tags can be only one space
					html = html.replace(/\n\n/g, "\n");
					html = html.replace(/\u200B/g, '');

					return html;
				},
				removeSpacesHard: function(html)
				{
					html = $.trim(html);
					html = html.replace(/\n/g, '');
					html = html.replace(/[\t]*/g, '');
					html = html.replace(/\n\s*\n/g, "\n");
					html = html.replace(/^[\s\n]*/g, '');
					html = html.replace(/[\s\n]*$/g, '');
					html = html.replace( />\s{2,}</g, '><');
					html = html.replace(/\n\n/g, "\n");
					html = html.replace(/\u200B/g, '');

					return html;
				},
				normalizeCurrentHeading: function()
				{
					var heading = this.selection.block();
					if (this.utils.isCurrentOrParentHeader() && heading)
					{
						heading.normalize();
					}
				}
			};
		},

		// =code
		code: function()
		{
			return {
				syncFire: true,
				html: false,
				start: function(html)
				{
					html = $.trim(html);
					html = html.replace(/^(<span id="selection-marker-1" class="redactor-selection-marker">​<\/span>)/, '');

					// clean
					if (this.opts.type === 'textarea')
					{
						html = this.clean.onSet(html);
					}
					else if (this.opts.type === 'div' && html === '')
					{
						html = this.opts.emptyHtml;
					}

					html = html.replace(/<p><span id="selection-marker-1" class="redactor-selection-marker">​<\/span><\/p>/, '');

					this.events.stopDetectChanges();
					this.core.editor().html(html);
					this.observe.load();
					this.events.startDetectChanges();
				},
				set: function(html, options)
				{
					html = $.trim(html);

                    options = options || {};

                    // start
                    if (options.start)
                    {
                        this.start = options.start;
                    }

					// clean
					if (this.opts.type === 'textarea')
					{
						html = this.clean.onSet(html);
					}
					else if (this.opts.type === 'div' && html === '')
					{
						html = this.opts.emptyHtml;
					}

					this.core.editor().html(html);

					if (this.opts.type === 'textarea')
					{
    					this.code.sync();
					}

					this.placeholder.enable();
				},
				get: function()
				{
					if (this.opts.type === 'textarea')
					{
						return this.core.textarea().val();
                    }
					else
					{
						var html = this.core.editor().html();

						// clean
						html = this.clean.onGet(html);

						return html;
					}
				},
				sync: function()
				{
					if (!this.code.syncFire)
					{
						return;
					}

					var html = this.core.editor().html();
					var htmlCleaned = this.code.cleaned(html);

					// is there a need to synchronize
					if (this.code.isSync(htmlCleaned))
					{
						// do not sync
						return;
					}

					// save code
					this.code.html = htmlCleaned;

					if (this.opts.type !== 'textarea')
					{
						this.core.callback('sync', html);
						this.core.callback('change', html);
						return;
					}

					if (this.opts.type === 'textarea')
					{
						setTimeout($.proxy(function()
						{
							this.code.startSync(html);

						}, this), 10);
					}
				},
				startSync: function(html)
				{
					// before clean callback
					html = this.core.callback('syncBefore', html);

					// clean
					html = this.clean.onSync(html);

					// set code
					this.core.textarea().val(html);

					// after sync callback
					this.core.callback('sync', html);

					// change callback
					if (this.start === false)
					{
						this.core.callback('change', html);
					}

					this.start = false;
				},
				isSync: function(htmlCleaned)
				{
					var html = (this.code.html !== false) ? this.code.html : false;

					return (html !== false && html === htmlCleaned);
				},
				cleaned: function(html)
				{
					html = html.replace(/\u200B/g, '');
					return this.clean.removeMarkers(html);
				}
			};
		},

		// =core
		core: function()
		{
			return {

				id: function()
				{
					return this.$editor.attr('id');
				},
				element: function()
				{
					return this.$element;
				},
				editor: function()
				{
					return (typeof this.$editor === 'undefined') ? $() : this.$editor;
				},
				textarea: function()
				{
					return this.$textarea;
				},
				box: function()
				{
					return (this.opts.type === 'textarea') ? this.$box : this.$element;
				},
				toolbar: function()
				{
					return (this.$toolbar) ? this.$toolbar : false;
				},
				air: function()
				{
					return (this.$air) ? this.$air : false;
				},
				object: function()
				{
					return $.extend({}, this);
				},
				structure: function()
				{
					this.core.editor().toggleClass('redactor-structure');
				},
				addEvent: function(name)
				{
					this.core.event = name;
				},
				getEvent: function()
				{
					return this.core.event;
				},
				callback: function(type, e, data)
				{
					var eventNamespace = 'redactor';
					var returnValue = false;
					var events = $._data(this.core.element()[0], 'events');

					// on callback
					if (typeof events !== 'undefined' && typeof events[type] !== 'undefined')
					{
						var len = events[type].length;
						for (var i = 0; i < len; i++)
						{
							var namespace = events[type][i].namespace;
							if (namespace === 'callback.' + eventNamespace)
							{
								var handler = events[type][i].handler;
								var args = (typeof data === 'undefined') ? [e] : [e, data];
								returnValue = (typeof args === 'undefined') ? handler.call(this, e) : handler.call(this, e, args);
							}
						}
					}

					if (returnValue)
					{
						return returnValue;
					}

					// no callback
					if (typeof this.opts.callbacks[type] === 'undefined')
					{
						return (typeof data === 'undefined') ? e : data;
					}

					// callback
					var callback = this.opts.callbacks[type];

					if ($.isFunction(callback))
					{
						return (typeof data === 'undefined') ? callback.call(this, e) : callback.call(this, e, data);
					}
					else
					{
						return (typeof data === 'undefined') ? e : data;
					}
				},
				destroy: function()
				{
					this.opts.destroyed = true;

					this.core.callback('destroy');

					// placeholder
					this.placeholder.destroy();

					// progress
					this.progress.destroy();

					// help label
					$('#redactor-voice-' + this.uuid).remove();

					this.core.editor().removeClass('redactor-in redactor-styles redactor-structure redactor-layer-img-edit');

					// caret service
					this.core.editor().off('keydown.redactor-remove-textnode');

					// observer
					this.core.editor().off('.redactor-observe.' + this.uuid);

					// off events and remove data
					this.$element.off('.redactor').removeData('redactor');
					this.core.editor().off('.redactor');

					$(document).off('.redactor-dropdown');
					$(document).off('.redactor-air.' + this.uuid);
					$(document).off('mousedown.redactor-blur.' + this.uuid);
					$(document).off('mousedown.redactor.' + this.uuid);
					$(document).off('touchstart.redactor.' + this.uuid + ' click.redactor.' + this.uuid);
					$(window).off('.redactor-toolbar.' + this.uuid);
					$(window).off('touchmove.redactor.' + this.uuid);
					$("body").off('scroll.redactor.' + this.uuid);

					$(this.opts.toolbarFixedTarget).off('scroll.redactor.' + this.uuid);

					// plugins events
					var self = this;
					if (this.opts.plugins !== false)
					{
						$.each(this.opts.plugins, function(i,s)
						{
							$(window).off('.redactor-plugin-' + s);
							$(document).off('.redactor-plugin-' + s);
							$("body").off('.redactor-plugin-' + s);
							self.core.editor().off('.redactor-plugin-' + s);
						});
					}

					// click to edit
					this.$element.off('click.redactor-click-to-edit');
					this.$element.removeClass('redactor-click-to-edit');

					// common
					this.core.editor().removeClass('redactor-layer');
					this.core.editor().removeAttr('contenteditable');

					var html = this.code.get();

					if (this.opts.toolbar && this.$toolbar)
					{
						// dropdowns off
						this.$toolbar.find('a').each(function()
						{
							var $el = $(this);
							if ($el.data('dropdown'))
							{
								$el.data('dropdown').remove();
								$el.data('dropdown', {});
							}
						});
					}

					if (this.opts.type === 'textarea')
					{
						this.$box.after(this.$element);
						this.$box.remove();
						this.$element.val(html).show();
					}

					// air
					if (this.opts.air)
					{
						this.$air.remove();
					}

					if (this.opts.toolbar && this.$toolbar)
					{
						this.$toolbar.remove();
					}

					// modal
					if (this.$modalBox)
					{
						this.$modalBox.remove();
					}

					if (this.$modalOverlay)
					{
						this.$modalOverlay.remove();
					}

					// hide link's tooltip
					$('.redactor-link-tooltip').remove();

					// autosave
					clearInterval(this.autosaveTimeout);
				}
			};
		},

		// =detect
		detect: function()
		{
			return {

				// public
				isWebkit: function()
				{
					return /webkit/.test(this.opts.userAgent);
				},
				isFirefox: function()
				{
					return this.opts.userAgent.indexOf('firefox') > -1;
				},
				isIe: function(v)
				{
                    if (document.documentMode || /Edge/.test(navigator.userAgent))
                    {
                        return 'edge';
                    }

					var ie;
					ie = RegExp('msie' + (!isNaN(v)?('\\s'+v):''), 'i').test(navigator.userAgent);

					if (!ie)
					{
						ie = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
					}

					return ie;
				},
				isMobile: function()
				{
					return /(iPhone|iPod|BlackBerry|Android)/.test(navigator.userAgent);
				},
				isDesktop: function()
				{
					return !/(iPhone|iPod|iPad|BlackBerry|Android)/.test(navigator.userAgent);
				},
				isIpad: function()
				{
					return /iPad/.test(navigator.userAgent);
				}

			};
		},

		// =dropdown
		dropdown: function()
		{
			return {
				active: false,
				button: false,
				key: false,
				position: [],
				getDropdown: function()
				{
					return this.dropdown.active;
				},
				build: function(name, $dropdown, dropdownObject)
				{
					dropdownObject = this.dropdown.buildFormatting(name, dropdownObject);

					$.each(dropdownObject, $.proxy(function(btnName, btnObject)
					{
						var $item = this.dropdown.buildItem(btnName, btnObject);

						this.observe.addDropdown($item, btnName, btnObject);
						$dropdown.attr('rel', name).append($item);

					}, this));
				},
				buildFormatting: function(name, dropdownObject)
				{
					if (name !== 'format' || this.opts.formattingAdd === false)
					{
						return dropdownObject;
					}

					$.each(this.opts.formattingAdd, $.proxy(function(i,s)
					{
						var type = (this.utils.isBlockTag(s.args[0])) ? 'block' : 'inline';

						dropdownObject[i] = {
							func: (type === 'block') ? 'block.format' : 'inline.format',
							args: s.args,
							title: s.title
						};

					}, this));

					return dropdownObject;
				},
				buildItem: function(btnName, btnObject)
				{
					var $itemContainer = $('<li />');
					if (typeof btnObject.classname !== 'undefined')
					{
    					$itemContainer.addClass(btnObject.classname);
					}

					if (btnName.search(/^divider/i) !== -1)
					{
    					$itemContainer.addClass('redactor-dropdown-divider');

    					return $itemContainer;
					}

					var $item = $('<a href="#" class="redactor-dropdown-' + btnName + '" role="button" />');
					var $itemSpan = $('<span />').html(btnObject.title);

					$item.append($itemSpan);
					$item.on('mousedown', $.proxy(function(e)
					{
						e.preventDefault();

						this.dropdown.buildClick(e, btnName, btnObject);

					}, this));

					$itemContainer.append($item);

					return $itemContainer;

				},
				buildClick: function(e, btnName, btnObject)
				{
					if ($(e.target).hasClass('redactor-dropdown-link-inactive'))
					{
						return;
					}

					var command = this.dropdown.buildCommand(btnObject);

					if (typeof btnObject.args !== ' undefined')
					{
						this.button.toggle(e, btnName, command.type, command.callback, btnObject.args);
					}
					else
					{
						this.button.toggle(e, btnName, command.type, command.callback);
					}
				},
				buildCommand: function(btnObject)
				{
					var command = {};
					command.type = 'func';
					command.callback = btnObject.func;

					if (btnObject.command)
					{
						command.type = 'command';
						command.callback = btnObject.command;
					}
					else if (btnObject.dropdown)
					{
						command.type = 'dropdown';
						command.callback = btnObject.dropdown;
					}

					return command;
				},
				show: function(e, key)
				{
					if (this.detect.isDesktop())
					{
						this.core.editor().focus();
					}

					this.dropdown.hideAll(false, key);

					this.dropdown.key = key;
					this.dropdown.button = this.button.get(this.dropdown.key);

					if (this.dropdown.button.hasClass('dropact'))
					{
						this.dropdown.hide();
						return;
					}

					// re append
					this.dropdown.active = this.dropdown.button.data('dropdown').appendTo(document.body);

					// callback
					this.core.callback('dropdownShow', { dropdown: this.dropdown.active, key: this.dropdown.key, button: this.dropdown.button });

					// set button
					this.button.setActive(this.dropdown.key);
					this.dropdown.button.addClass('dropact');

					// position
					this.dropdown.getButtonPosition();

					// show
					if (this.button.toolbar().hasClass('toolbar-fixed-box') && this.detect.isDesktop())
					{
						this.dropdown.showIsFixedToolbar();
					}
					else
					{
						this.dropdown.showIsUnFixedToolbar();
					}

					// disable scroll whan dropdown scroll
					if (this.detect.isDesktop() && !this.detect.isFirefox())
					{
						this.dropdown.active.on('mouseover.redactor-dropdown', $.proxy(this.utils.disableBodyScroll, this));
						this.dropdown.active.on('mouseout.redactor-dropdown mousedown.redactor-dropdown', $.proxy(this.utils.enableBodyScroll, this));
					}

					e.stopPropagation();

				},
				showIsFixedToolbar: function()
				{
					var top = this.dropdown.button.position().top + this.dropdown.button.innerHeight() + this.opts.toolbarFixedTopOffset;

					var position = 'fixed';
					if (this.opts.toolbarFixedTarget !== document)
					{
						top = (this.dropdown.button.innerHeight() + this.$toolbar.offset().top) + this.opts.toolbarFixedTopOffset;
						position = 'absolute';
					}

					this.dropdown.active.css({

						position: position,
						left: this.dropdown.position.left + 'px',
						top: top + 'px'

					}).show();

					// animate
					this.dropdown.active.redactorAnimation('slideDown', { duration: 0.2 }, $.proxy(function()
					{
						this.dropdown.enableCallback();
						this.dropdown.enableEvents();

					}, this));
				},
				showIsUnFixedToolbar: function()
				{
					this.dropdown.active.css({

						position: 'absolute',
						left: this.dropdown.position.left + 'px',
						top: (this.dropdown.button.innerHeight() + this.dropdown.position.top) + 'px'

					}).show();

					// animate
					this.dropdown.active.redactorAnimation(((this.opts.animation) ? 'slideDown' : 'show'), { duration: 0.2 }, $.proxy(function()
					{
						this.dropdown.enableCallback();
						this.dropdown.enableEvents();

					}, this));
				},
				enableEvents: function()
				{
					$(document).on('mousedown.redactor-dropdown', $.proxy(this.dropdown.hideAll, this));
					this.core.editor().on('touchstart.redactor-dropdown', $.proxy(this.dropdown.hideAll, this));
					$(document).on('keyup.redactor-dropdown', $.proxy(this.dropdown.closeHandler, this));
				},
				enableCallback: function()
				{
					this.core.callback('dropdownShown', { dropdown: this.dropdown.active, key: this.dropdown.key, button: this.dropdown.button });
				},
				getButtonPosition: function()
				{
					this.dropdown.position = this.dropdown.button.offset();

					// fix right placement
					var dropdownWidth = this.dropdown.active.width();
					if ((this.dropdown.position.left + dropdownWidth) > $(document).width())
					{
						this.dropdown.position.left = Math.max(0, this.dropdown.position.left - dropdownWidth + parseInt(this.dropdown.button.innerWidth()));
					}

				},
				closeHandler: function(e)
				{
					if (e.which !== this.keyCode.ESC)
					{
						return;
					}

					this.dropdown.hideAll(e);
					this.core.editor().focus();
				},
				hideAll: function(e, key)
				{
					if (this.detect.isDesktop())
					{
						this.utils.enableBodyScroll();
					}

					if (e !== false && $(e.target).closest('.redactor-dropdown').length !== 0)
					{
						return;
					}

					var $buttons = (typeof key === 'undefined') ? this.button.toolbar().find('a.dropact') : this.button.toolbar().find('a.dropact').not('.re-' + key);
					var $elements = (typeof key === 'undefined') ? $('.redactor-dropdown-' + this.uuid) : $('.redactor-dropdown-' + this.uuid).not('.redactor-dropdown-box-' + key);

					if ($elements.length !== 0)
					{
						$(document).off('.redactor-dropdown');
						this.core.editor().off('.redactor-dropdown');

						$.each($elements, $.proxy(function(i,s)
						{
							var $el = $(s);

							this.core.callback('dropdownHide', $el);

							$el.hide();
							$el.off('mouseover mouseout').off('.redactor-dropdown');

						}, this));

						$buttons .removeClass('redactor-act dropact');
					}

				},
				hide: function ()
				{
					if (this.dropdown.active === false)
					{
						return;
					}

					if (this.detect.isDesktop())
					{
						this.utils.enableBodyScroll();
					}

					this.dropdown.active.redactorAnimation(((this.opts.animation) ? 'slideUp' : 'hide'), { duration: 0.2 }, $.proxy(function()
					{
						$(document).off('.redactor-dropdown');
						this.core.editor().off('.redactor-dropdown');

						this.dropdown.hideOut();


					}, this));
				},
				hideOut: function()
				{
					this.core.callback('dropdownHide', this.dropdown.active);

					this.dropdown.button.removeClass('redactor-act dropact');
					this.dropdown.active.off('mouseover mouseout').off('.redactor-dropdown');
					this.dropdown.button = false;
					this.dropdown.key = false;
					this.dropdown.active = false;
				}
			};
		},

		// =events
		events: function()
		{
			return {
				focused: false,
				blured: true,
				dropImage: false,
				stopChanges: false,
				stopDetectChanges: function()
				{
					this.events.stopChanges = true;
				},
				startDetectChanges: function()
				{
					var self = this;
					setTimeout(function()
					{
						self.events.stopChanges = false;
					}, 1);
				},
				dragover: function(e)
				{
					e.preventDefault();
					e.stopPropagation();

					if (e.target.tagName === 'IMG')
					{
						$(e.target).addClass('redactor-image-dragover');
					}

				},
				dragleave: function(e)
				{
					// remove image dragover
					this.core.editor().find('img').removeClass('redactor-image-dragover');
				},
				drop: function(e)
				{
					e = e.originalEvent || e;

					// remove image dragover
					this.core.editor().find('img').removeClass('redactor-image-dragover');

					if (this.opts.type === 'inline' || this.opts.type === 'pre')
					{
						e.preventDefault();
						return false;
					}

					if (window.FormData === undefined || !e.dataTransfer)
					{
						return true;
					}

					if (e.dataTransfer.files.length === 0)
					{
						return this.events.onDrop(e);
					}
					else
					{
						this.events.onDropUpload(e);
					}

					this.core.callback('drop', e);

				},
				click: function(e)
				{
					var event = this.core.getEvent();
					var type = (event === 'click' || event === 'arrow') ? false : 'click';

                    this.core.addEvent(type);
					this.utils.disableSelectAll();
					this.core.callback('click', e);
				},
				focus: function(e)
				{
					if (this.rtePaste)
					{
						return;
					}

					if (this.events.isCallback('focus'))
					{
						this.core.callback('focus', e);
					}

					this.events.focused = true;
					this.events.blured = false;

					// tab
					if (this.selection.current() === false)
					{
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						range.setStart(this.core.editor()[0], 0);
						range.setEnd(this.core.editor()[0], 0);
						this.selection.update(sel, range);
					}

				},
				blur: function(e)
				{
					if (this.start || this.rtePaste)
					{
						return;
					}

					if ($(e.target).closest('#' + this.core.id() + ', .redactor-toolbar, .redactor-dropdown, #redactor-modal-box').length !== 0)
					{
						return;
					}

					if (!this.events.blured && this.events.isCallback('blur'))
					{
						this.core.callback('blur', e);
					}

					this.events.focused = false;
					this.events.blured = true;
				},
				touchImageEditing: function()
				{
					var scrollTimer = -1;
					this.events.imageEditing = false;
					$(window).on('touchmove.redactor.' + this.uuid, $.proxy(function()
					{
						this.events.imageEditing = true;
						if (scrollTimer !== -1)
						{
							clearTimeout(scrollTimer);
						}

						scrollTimer = setTimeout($.proxy(function()
						{
							this.events.imageEditing = false;

						}, this), 500);

					}, this));
				},
				init: function()
				{
					this.core.editor().on('dragover.redactor dragenter.redactor', $.proxy(this.events.dragover, this));
					this.core.editor().on('dragleave.redactor', $.proxy(this.events.dragleave, this));
					this.core.editor().on('drop.redactor', $.proxy(this.events.drop, this));
					this.core.editor().on('click.redactor', $.proxy(this.events.click, this));
					this.core.editor().on('paste.redactor', $.proxy(this.paste.init, this));
					this.core.editor().on('keydown.redactor', $.proxy(this.keydown.init, this));
					this.core.editor().on('keyup.redactor', $.proxy(this.keyup.init, this));
					this.core.editor().on('focus.redactor', $.proxy(this.events.focus, this));

					$(document).on('mousedown.redactor-blur.' + this.uuid, $.proxy(this.events.blur, this));

					this.events.touchImageEditing();

					this.events.createObserver();
					this.events.setupObserver();

				},
				createObserver: function()
				{
					var self = this;
					this.events.observer = new MutationObserver(function(mutations)
					{
						mutations.forEach($.proxy(self.events.iterateObserver, self));
					});

				},
				iterateObserver: function(mutation)
				{

					var stop = false;

					// target
					if (((this.opts.type === 'textarea' || this.opts.type === 'div')
					    && (!this.detect.isFirefox() && mutation.target === this.core.editor()[0]))
					    || (mutation.attributeName === 'class' && mutation.target === this.core.editor()[0])
                    )
					{
						stop = true;
					}

					if (!stop)
					{
    					this.observe.load();
						this.events.changeHandler();
					}
				},
				setupObserver: function()
				{
					this.events.observer.observe(this.core.editor()[0], {
						 attributes: true,
						 subtree: true,
						 childList: true,
						 characterData: true,
						 characterDataOldValue: true
					});
				},
				changeHandler: function()
				{
					if (this.events.stopChanges)
					{
						return;
					}

					this.code.sync();

					// autosave
					if (this.autosave.is())
					{
						clearTimeout(this.autosaveTimeout);
						this.autosaveTimeout = setTimeout($.proxy(this.autosave.send, this), 300);
					}

				},
				onDropUpload: function(e)
				{
					e.preventDefault();
					e.stopPropagation();

					if ((!this.opts.dragImageUpload && !this.opts.dragFileUpload) || (this.opts.imageUpload === null && this.opts.fileUpload === null))
					{
						return;
					}

					if (e.target.tagName === 'IMG')
					{
						this.events.dropImage = e.target;
					}

					var files = e.dataTransfer.files;
                    var len = files.length;
					for (var i = 0; i < len; i++)
					{
    					this.upload.directUpload(files[i], e);
    				}
				},
				onDrop: function(e)
				{
					this.core.callback('drop', e);
				},
				isCallback: function(name)
				{
					return (typeof this.opts.callbacks[name] !== 'undefined' && $.isFunction(this.opts.callbacks[name]));
				},

				// #backward
				stopDetect: function()
				{
					this.events.stopDetectChanges();
				},
				startDetect: function()
				{
					this.events.startDetectChanges();
				}

			};
		},

		// =file
		file: function()
		{
			return {
				is: function()
				{
					return !(!this.opts.fileUpload || !this.opts.fileUpload && !this.opts.s3);
				},
				show: function()
				{
					// build modal
					this.modal.load('file', this.lang.get('file'), 700);

					// build upload
					this.upload.init('#redactor-modal-file-upload', this.opts.fileUpload, this.file.insert);

					// set selected text
					$('#redactor-filename').val(this.selection.get().toString());

					// show
					this.modal.show();
				},
				insert: function(json, direct, e)
				{
					// error callback
					if (typeof json.error !== 'undefined')
					{
						this.modal.close();
						this.core.callback('fileUploadError', json);
						return;
					}

					this.file.release(e, direct);

					// prepare
					this.buffer.set();
					this.air.collapsed();

					// get
					var text = this.file.text(json);
					var $link = $('<a />').attr('href', json.url).text(text);
					var id = (typeof json.id === 'undefined') ? '' : json.id;
					var type = (typeof json.s3 === 'undefined') ? 'file' : 's3';

					// set id
					$link.attr('data-' + type, id);

					// insert
					$link = $(this.insert.node($link));

					// focus
					this.caret.after($link);

					// callback
					this.storage.add({ type: type, node: $link[0], url: $link[0].href, id: id });

					if (direct !== null)
					{
						this.core.callback('fileUpload', $link, json);
					}

				},
				release: function(e, direct)
				{
					if (direct)
					{
						// drag and drop upload
						this.marker.remove();
						this.insert.nodeToPoint(e, this.marker.get());
						this.selection.restore();
					}
					else
					{
						// upload from modal
						this.modal.close();
					}
				},
				text: function(json)
				{
					var text = $('#redactor-filename').val();

					return (typeof text === 'undefined' || text === '') ? json.name : text;
				}
			};
		},

		// =focus
		focus: function()
		{
			return {
				start: function()
				{
					this.core.editor().focus();

					if (this.opts.type === 'inline')
					{
						return;
					}

					var $first = this.focus.first();
					if ($first !== false)
					{
						this.caret.start($first);
					}
				},
				end: function()
				{
					this.core.editor().focus();

					var last = (this.opts.inline) ? this.core.editor() : this.focus.last();
					if (last.length === 0)
					{
						return;
					}

					// get inline last node
					var lastNode = this.focus.lastChild(last);
					if (!this.detect.isWebkit() && lastNode !== false)
					{
						this.caret.end(lastNode);
					}
					else
					{
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						if (range !== null)
						{
							range.selectNodeContents(last[0]);
							range.collapse(false);

							this.selection.update(sel, range);
						}
						else
						{
							this.caret.end(last);
						}
					}

				},
				first: function()
				{
					var $first = this.core.editor().children().first();
					if ($first.length === 0 && ($first[0].length === 0 || $first[0].tagName === 'BR' || $first[0].tagName === 'HR' || $first[0].nodeType === 3))
					{
						return false;
					}

					if ($first[0].tagName === 'UL' || $first[0].tagName === 'OL')
					{
						return $first.find('li').first();
					}

					return $first;

				},
				last: function()
				{
					return this.core.editor().children().last();
				},
				lastChild: function(last)
				{
					var lastNode = last[0].lastChild;

					return (lastNode !== null && this.utils.isInlineTag(lastNode.tagName)) ? lastNode : false;
				},
				is: function()
				{
					return (this.core.editor()[0] === document.activeElement);
				}
			};
		},

		// =image
		image: function()
		{
			return {
				is: function()
				{
					return !(!this.opts.imageUpload || !this.opts.imageUpload && !this.opts.s3);
				},
				show: function()
				{
					// build modal
					this.modal.load('image', this.lang.get('image'), 700);

					// build upload
					this.upload.init('#redactor-modal-image-droparea', this.opts.imageUpload, this.image.insert);
					this.modal.show();

				},
				insert: function(json, direct, e)
				{
					var $img;

					// error callback
					if (typeof json.error !== 'undefined')
					{
						this.modal.close();
						this.events.dropImage = false;
						this.core.callback('imageUploadError', json, e);
						return;
					}

					// change image
					if (this.events.dropImage !== false)
					{
						$img = $(this.events.dropImage);

						this.core.callback('imageDelete', $img[0].src, $img);

						$img.attr('src', json.url);

						this.events.dropImage = false;
						this.core.callback('imageUpload', $img, json);
						return;
					}

					this.placeholder.hide();
					var $figure = $('<' + this.opts.imageTag + '>');

					$img = $('<img>');
					$img.attr('src', json.url);

					// set id
					var id = (typeof json.id === 'undefined') ? '' : json.id;
					var type = (typeof json.s3 === 'undefined') ? 'image' : 's3';
					$img.attr('data-' + type, id);

					$figure.append($img);

					var pre = this.utils.isTag(this.selection.current(), 'pre');

					if (direct)
					{
						this.air.collapsed();
						this.marker.remove();

						var node = this.insert.nodeToPoint(e, this.marker.get());
						var $next = $(node).next();

						this.selection.restore();

						// buffer
						this.buffer.set();

						// insert
						if (typeof $next !== 'undefined' && $next.length !== 0 && $next[0].tagName === 'IMG')
						{
							// delete callback
							this.core.callback('imageDelete', $next[0].src, $next);

							// replace
							$next.closest('figure, p', this.core.editor()[0]).replaceWith($figure);
							this.caret.after($figure);
						}
						else
						{
							if (pre)
							{
								$(pre).after($figure);
							}
							else
							{
								this.insert.node($figure);
							}

							this.caret.after($figure);
						}

					}
					else
					{
						this.modal.close();

						// buffer
						this.buffer.set();

						// insert
						this.air.collapsed();

						if (pre)
						{
							$(pre).after($figure);
						}
						else
						{
							this.insert.node($figure);
						}

						this.caret.after($figure);
					}

					this.events.dropImage = false;

					this.storage.add({ type: type, node: $img[0], url: $img[0].src, id: id });

					if (direct !== null)
					{
						this.core.callback('imageUpload', $img, json);
					}
					else
					{
    					this.core.callback('imageInserted', $img, json);
					}
				},
				setEditable: function($image)
				{
					$image.on('dragstart', function(e)
					{
						e.preventDefault();
					});

                    if (this.opts.imageResizable)
                    {
    					var handler = $.proxy(function(e)
    					{
    						this.observe.image = $image;
    						this.image.resizer = this.image.loadEditableControls($image);

    						$(document).on('mousedown.redactor-image-resize-hide.' + this.uuid, $.proxy(this.image.hideResize, this));

    						if (this.image.resizer)
    						{
                                this.image.resizer.on('mousedown.redactor touchstart.redactor', $.proxy(function(e)
        						{
        							this.image.setResizable(e, $image);
        						}, this));
    						}

    					}, this);

    					$image.off('mousedown.redactor').on('mousedown.redactor', $.proxy(this.image.hideResize, this));
    					$image.off('click.redactor touchstart.redactor').on('click.redactor touchstart.redactor', handler);
                    }
                    else
                    {
    					$image.off('click.redactor touchstart.redactor').on('click.redactor touchstart.redactor', $.proxy(function(e)
    					{
    						setTimeout($.proxy(function()
    						{
    							this.image.showEdit($image);

    						}, this), 200);

    					}, this));
                    }

				},
				setResizable: function(e, $image)
				{
					e.preventDefault();

				    this.image.resizeHandle = {
				        x : e.pageX,
				        y : e.pageY,
				        el : $image,
				        ratio: $image.width() / $image.height(),
				        h: $image.height()
				    };

				    e = e.originalEvent || e;

				    if (e.targetTouches)
				    {
				         this.image.resizeHandle.x = e.targetTouches[0].pageX;
				         this.image.resizeHandle.y = e.targetTouches[0].pageY;
				    }

					this.image.startResize();


				},
				startResize: function()
				{
					$(document).on('mousemove.redactor-image-resize touchmove.redactor-image-resize', $.proxy(this.image.moveResize, this));
					$(document).on('mouseup.redactor-image-resize touchend.redactor-image-resize', $.proxy(this.image.stopResize, this));
				},
				moveResize: function(e)
				{
					e.preventDefault();

					e = e.originalEvent || e;

					var height = this.image.resizeHandle.h;

		            if (e.targetTouches) height += (e.targetTouches[0].pageY -  this.image.resizeHandle.y);
		            else height += (e.pageY -  this.image.resizeHandle.y);

					var width = Math.round(height * this.image.resizeHandle.ratio);

					if (height < 50 || width < 100) return;

					var height = Math.round(this.image.resizeHandle.el.width() / this.image.resizeHandle.ratio);

					this.image.resizeHandle.el.attr({width: width, height: height});
		            this.image.resizeHandle.el.width(width);
		            this.image.resizeHandle.el.height(height);

		            this.code.sync();
				},
				stopResize: function()
				{
					this.handle = false;
					$(document).off('.redactor-image-resize');

					this.image.hideResize();
				},
                hideResize: function(e)
				{
					if (e && $(e.target).closest('#redactor-image-box', this.$editor[0]).length !== 0) return;
					if (e && e.target.tagName == 'IMG')
					{
						var $image = $(e.target);
					}

					var imageBox = this.$editor.find('#redactor-image-box');
					if (imageBox.length === 0) return;

					$('#redactor-image-editter').remove();
					$('#redactor-image-resizer').remove();

					imageBox.find('img').css({
						marginTop: imageBox[0].style.marginTop,
						marginBottom: imageBox[0].style.marginBottom,
						marginLeft: imageBox[0].style.marginLeft,
						marginRight: imageBox[0].style.marginRight
					});

					imageBox.css('margin', '');
					imageBox.find('img').css('opacity', '');
					imageBox.replaceWith(function()
					{
						return $(this).contents();
					});

					$(document).off('mousedown.redactor-image-resize-hide.' + this.uuid);

					if (typeof this.image.resizeHandle !== 'undefined')
					{
						this.image.resizeHandle.el.attr('rel', this.image.resizeHandle.el.attr('style'));
					}
				},
				loadResizableControls: function($image, imageBox)
				{
					if (this.opts.imageResizable && !this.detect.isMobile())
					{
						var imageResizer = $('<span id="redactor-image-resizer" data-redactor="verified"></span>');

						if (!this.detect.isDesktop())
						{
							imageResizer.css({ width: '15px', height: '15px' });
						}

						imageResizer.attr('contenteditable', false);
						imageBox.append(imageResizer);
						imageBox.append($image);

						return imageResizer;
					}
					else
					{
						imageBox.append($image);
						return false;
					}
				},
				loadEditableControls: function($image)
				{
					var imageBox = $('<span id="redactor-image-box" data-redactor="verified">');
					imageBox.css('float', $image.css('float')).attr('contenteditable', false);

					if ($image[0].style.margin != 'auto')
					{
						imageBox.css({
							marginTop: $image[0].style.marginTop,
							marginBottom: $image[0].style.marginBottom,
							marginLeft: $image[0].style.marginLeft,
							marginRight: $image[0].style.marginRight
						});

						$image.css('margin', '');
					}
					else
					{
						imageBox.css({ 'display': 'block', 'margin': 'auto' });
					}

					$image.css('opacity', '.5').after(imageBox);


					if (this.opts.imageEditable)
					{
						// editter
						this.image.editter = $('<span id="redactor-image-editter" data-redactor="verified">' + this.lang.get('edit') + '</span>');
						this.image.editter.attr('contenteditable', false);
						this.image.editter.on('click', $.proxy(function()
						{
							this.image.showEdit($image);
						}, this));

						imageBox.append(this.image.editter);

						// position correction
						var editerWidth = this.image.editter.innerWidth();
						this.image.editter.css('margin-left', '-' + editerWidth/2 + 'px');
					}

					return this.image.loadResizableControls($image, imageBox);

				},
				showEdit: function($image)
				{
					if (this.events.imageEditing)
					{
						return;
					}

					this.observe.image = $image;

					var $link = $image.closest('a', this.$editor[0]);
    				var $figure = $image.closest('figure', this.$editor[0]);
    				var $container = ($figure.length !== 0) ? $figure : $image;

					this.modal.load('image-edit', this.lang.get('edit'), 705);

					this.image.buttonDelete = this.modal.getDeleteButton().text(this.lang.get('delete'));
					this.image.buttonSave = this.modal.getActionButton().text(this.lang.get('save'));

					this.image.buttonDelete.on('click', $.proxy(this.image.remove, this));
					this.image.buttonSave.on('click', $.proxy(this.image.update, this));

					if (this.opts.imageCaption === false)
					{
						$('#redactor-image-caption').val('').hide().prev().hide();
					}
					else
					{
						var $parent = $image.closest(this.opts.imageTag, this.$editor[0]);
						var $ficaption = $parent.find('figcaption');
						if ($ficaption !== 0)
						{

							$('#redactor-image-caption').val($ficaption.text()).show();
						}
					}

					if (!this.opts.imagePosition)
					{
    					$('.redactor-image-position-option').hide();
    				}
					else
					{
    					var isCentered = ($figure.length !== 0) ? ($container.css('text-align') === 'center') : ($container.css('display') == 'block' && $container.css('float') == 'none');
						var floatValue = (isCentered) ? 'center' : $container.css('float');
						$('#redactor-image-align').val(floatValue);
					}

					$('#redactor-image-preview').html($('<img src="' + $image.attr('src') + '" style="max-width: 100%;">'));
					$('#redactor-image-title').val($image.attr('alt'));

					var $redactorImageLink = $('#redactor-image-link');
					$redactorImageLink.attr('href', $image.attr('src'));
					if ($link.length !== 0)
					{
						$redactorImageLink.val($link.attr('href'));
						if ($link.attr('target') === '_blank')
						{
							$('#redactor-image-link-blank').prop('checked', true);
						}
					}

					// hide link's tooltip
					$('.redactor-link-tooltip').remove();

					this.modal.show();

					// focus
					if (this.detect.isDesktop())
					{
						$('#redactor-image-title').focus();
					}

				},
				update: function()
				{
					var $image = this.observe.image;
					var $link = $image.closest('a', this.core.editor()[0]);

					var title = $('#redactor-image-title').val().replace(/(<([^>]+)>)/ig,"");
					$image.attr('alt', title).attr('title', title);

                    this.image.setFloating($image);

					// as link
					var link = $.trim($('#redactor-image-link').val()).replace(/(<([^>]+)>)/ig,"");
					if (link !== '')
					{
						// test url (add protocol)
						var pattern = '((xn--)?[a-z0-9]+(-[a-z0-9]+)*\\.)+[a-z]{2,}';
						var re = new RegExp('^(http|ftp|https)://' + pattern, 'i');
						var re2 = new RegExp('^' + pattern, 'i');

						if (link.search(re) === -1 && link.search(re2) === 0 && this.opts.linkProtocol)
						{
							link = this.opts.linkProtocol + '://' + link;
						}

						var target = ($('#redactor-image-link-blank').prop('checked')) ? true : false;

						if ($link.length === 0)
						{
							var a = $('<a href="' + link + '" id="redactor-img-tmp">' + this.utils.getOuterHtml($image) + '</a>');
							if (target)
							{
								a.attr('target', '_blank');
							}

							$image = $image.replaceWith(a);
							$link = this.core.editor().find('#redactor-img-tmp');
							$link.removeAttr('id');
						}
						else
						{
							$link.attr('href', link);
							if (target)
							{
								$link.attr('target', '_blank');
							}
							else
							{
								$link.removeAttr('target');
							}
						}
					}
					else if ($link.length !== 0)
					{
						$link.replaceWith(this.utils.getOuterHtml($image));
					}

                    this.image.addCaption($image, $link);
					this.modal.close();

					// buffer
					this.buffer.set();

				},
				setFloating: function($image)
				{
    				var $figure = $image.closest('figure', this.$editor[0]);
    				var $container = ($figure.length !== 0) ? $figure : $image;
					var floating = $('#redactor-image-align').val();

					var imageFloat = '';
					var imageDisplay = '';
					var imageMargin = '';
					var textAlign = '';

					switch (floating)
					{
						case 'left':
							imageFloat = 'left';
							imageMargin = '0 ' + this.opts.imageFloatMargin + ' ' + this.opts.imageFloatMargin + ' 0';
						break;
						case 'right':
							imageFloat = 'right';
							imageMargin = '0 0 ' + this.opts.imageFloatMargin + ' ' + this.opts.imageFloatMargin;
						break;
						case 'center':

                            if ($figure.length !== 0)
                            {
                                textAlign = 'center';
                            }
                            else
                            {
	    						imageDisplay = 'block';
    							imageMargin = 'auto';
							}

						break;
					}

					$container.css({ 'float': imageFloat, 'display': imageDisplay, 'margin': imageMargin, 'text-align': textAlign });
					$container.attr('rel', $image.attr('style'));
				},
				addCaption: function($image, $link)
				{
                    var caption = $('#redactor-image-caption').val();

                    var $target = ($link.length !== 0) ? $link : $image;
					var $figcaption = $target.next();

					if ($figcaption.length === 0 || $figcaption[0].tagName !== 'FIGCAPTION')
					{
						$figcaption = false;
					}

					if (caption !== '')
					{
						if ($figcaption === false)
						{
							$figcaption = $('<figcaption />').text(caption);
							$target.after($figcaption);
						}
						else
						{
							$figcaption.text(caption);
						}
					}
					else if ($figcaption !== false)
					{
						$figcaption.remove();
					}
				},
				remove: function(e, $image, index)
				{
					$image = (typeof $image === 'undefined') ? $(this.observe.image) : $image;

					// delete from modal
					if (typeof e !== 'boolean')
					{
						this.buffer.set();
					}

					this.events.stopDetectChanges();

					var $link = $image.closest('a', this.core.editor()[0]);
					var $figure = $image.closest(this.opts.imageTag, this.core.editor()[0]);
					var $parent = $image.parent();

					// callback
                    var imageDeleteStop = this.core.callback('imageDelete', e, $image[0]);
					if (imageDeleteStop === false)
					{
						e.preventDefault();
						return false;
					}

					if ($('#redactor-image-box').length !== 0)
					{
						$parent = $('#redactor-image-box').parent();
					}

					var $next, $prev;
					if ($figure.length !== 0)
					{
						$prev = $figure.prev();
						$next = $figure.next();
						$figure.remove();
					}
					else if ($link.length !== 0)
					{
						$parent = $link.parent();
						$link.remove();
					}
					else
					{
						$image.remove();
					}

					$('#redactor-image-box').remove();

					if (e !== false)
					{
						if ($next && $next.length !== 0)
						{
							this.caret.start($next);
						}
						else if ($prev && $prev.length !== 0)
						{
                            this.caret.end($prev);
						}
					}

					if (typeof e !== 'boolean')
					{
						this.modal.close();
					}

					this.utils.restoreScroll();
					this.observe.image = false;
					this.events.startDetectChanges();
					this.placeholder.enable();
					this.code.sync();

				}
			};
		},

		// =indent
		indent: function()
		{
			return {
				increase: function()
				{
					if (!this.list.get())
					{
						return;
					}

					var $current = $(this.selection.current()).closest('li');
					var $list = $current.closest('ul, ol', this.core.editor()[0]);

					var $li = $current.closest('li');
					var $prev = $li.prev();
					if ($prev.length === 0 || $prev[0].tagName !== 'LI')
					{
						return;
					}

					this.buffer.set();


					if (this.utils.isCollapsed())
					{
						var listTag = $list[0].tagName;
						var $newList = $('<' + listTag + ' />');

						this.selection.save();

                        var $ol = $prev.find('ol').first();
                        if ($ol.length === 1)
                        {
                            $ol.append($current);
                        }
                        else
                        {
                            var listTag = $list[0].tagName;
                            var $newList = $('<' + listTag + ' />');
                            $newList.append($current);
                            $prev.append($newList);
                        }

						this.selection.restore();
					}
					else
					{
						document.execCommand('indent');

						// normalize
						this.selection.save();
						this.indent.removeEmpty();
						this.indent.normalize();
						this.selection.restore();
					}
				},
				decrease: function()
				{
					if (!this.list.get())
					{
						return;
					}

					var $current = $(this.selection.current()).closest('li');
					var $list = $current.closest('ul, ol', this.core.editor()[0]);

					this.buffer.set();

					document.execCommand('outdent');

					var $item = $(this.selection.current()).closest('li', this.core.editor()[0]);

					if (this.utils.isCollapsed())
					{
						this.indent.repositionItem($item);
					}

					if ($item.length === 0)
					{
						document.execCommand('formatblock', false, 'p');
						$item = $(this.selection.current());
						var $next = $item.next();
						if ($next.length !== 0 && $next[0].tagName === 'BR')
						{
							$next.remove();
						}
					}

					// normalize
					this.selection.save();
					this.indent.removeEmpty();
					this.indent.normalize();
					this.selection.restore();

				},
				repositionItem: function($item)
				{
    				var $next = $item.next();
    				if ($next.length !== 0 && ($next[0].tagName !== 'UL' || $next[0].tagName !== 'OL'))
    				{
        				$item.append($next);
    				}

					var $prev = $item.prev();
					if ($prev.length !== 0 && $prev[0].tagName !== 'LI')
					{
						this.selection.save();
						var $li = $item.parents('li', this.core.editor()[0]);
						$li.after($item);
						this.selection.restore();
					}
				},
				normalize: function()
				{
					this.core.editor().find('li').each($.proxy(function(i,s)
					{
						var $el = $(s);

						// remove style
						$el.find(this.opts.inlineTags.join(',')).each(function()
						{
							$(this).removeAttr('style');
						});

						var $parent = $el.parent();
						if ($parent.length !== 0 && $parent[0].tagName === 'LI')
						{
							$parent.after($el);
							return;
						}

						var $next = $el.next();
						if ($next.length !== 0 && ($next[0].tagName === 'UL' || $next[0].tagName === 'OL'))
						{
							$el.append($next);
						}

					}, this));

				},
				removeEmpty: function($list)
				{
					var $lists = this.core.editor().find('ul, ol');
					var $items = this.core.editor().find('li');

					$items.each($.proxy(function(i, s)
					{
						this.indent.removeItemEmpty(s);

					}, this));

					$lists.each($.proxy(function(i, s)
					{
						this.indent.removeItemEmpty(s);

					}, this));

					$items.each($.proxy(function(i, s)
					{
						this.indent.removeItemEmpty(s);

					}, this));
				},
				removeItemEmpty: function(s)
				{
					var html = s.innerHTML.replace(/[\t\s\n]/g, '');
					html = html.replace(/<span><\/span>/g, '');

					if (html === '')
					{
						$(s).remove();
					}
				}
			};
		},

		// =inline
		inline: function()
		{
			return {
    			getClearedNodes: function()
    			{
                    var nodes = this.selection.nodes();
        			var newNodes = [];
        			var len = nodes.length;
                    var started = 0;

                    // find array slice
                    for (var i = 0; i < len; i++)
					{
						if ($(nodes[i]).hasClass('redactor-selection-marker'))
						{
    						started = i + 2;
    						break;
						}
					}

                    // find selected inline & text nodes
                    for (var i = 0; i < len; i++)
					{
						if (i >= started && !this.utils.isBlockTag(nodes[i].tagName))
						{
                            newNodes.push(nodes[i]);
						}
					}

					return newNodes;
    			},
                isConvertableAttr: function(node, attr, value)
                {
                    var nodeAttrValue = $(node).attr(attr);
                    if (nodeAttrValue)
                    {
                        if (attr === 'style')
                        {

                            value = $.trim(value).replace(/;$/, '')

                            var rules = value.split(';');
                            var count = 0;
                            for (var i = 0; i < rules.length; i++)
                            {
                                var arr = rules[i].split(':');
                                var ruleName = $.trim(arr[0]);
                                var ruleValue = $.trim(arr[1]);

                                if (ruleName.search(/color/) !== -1)
                                {
                                    var val = $(node).css(ruleName);
                                    if (val && (val === ruleValue || this.utils.rgb2hex(val) === ruleValue))
                                    {
                                        count++;
                                    }
                                }
                                else if ($(node).css(ruleName) === ruleValue)
                                {
                                    count++;
                                }
                            }

                            if (count === rules.length)
                            {
                                return 1;
                            }
                        }
                        else if (nodeAttrValue === value)
                        {
                            return 1;
                        }
                    }

                    return 0;

                },
    			isConvertable: function(node, nodeTag, tag, attr)
    			{
                    if (nodeTag === tag)
                    {
                        if (attr)
                        {
                            var count = 0;
                            for (var key in attr)
                            {
                                count += this.inline.isConvertableAttr(node, key, attr[key]);
                            }

                            if (count === Object.keys(attr).length)
                            {
                                return true;
                            }
                        }
                        else
                        {
                            return true;
                        }
                    }

                    return false;
    			},
    			setNodesStriked: function(nodes, tag, attr)
    			{
                    for (var i = 0; i < nodes.length; i++)
					{
                        var nodeTag = (nodes[i].tagName) ? nodes[i].tagName.toLowerCase() : undefined;

                        var parent = nodes[i].parentNode;
                        var parentTag = (parent && parent.tagName) ? parent.tagName.toLowerCase() : undefined;

                        var convertable = this.inline.isConvertable(parent, parentTag, tag, attr);
                        if (convertable)
                        {
                            var $el = $(parent).replaceWith(function()
                            {
                                return $('<strike>').append($(this).contents());
                            });

                            $el.attr('data-redactor-inline-converted');
                        }

                        var convertable = this.inline.isConvertable(nodes[i], nodeTag, tag, attr);
                        if (convertable)
                        {
                            var $el = $(nodes[i]).replaceWith(function()
                            {
                                return $('<strike>').append($(this).contents());
                            });
                        }
    				}
    			},
				format: function(tag, attr, value, type)
				{
    				if (typeof attr !== 'undefined' && typeof attr !== 'object')
    				{
        				var obj = {};
        				obj[attr] = value;
        				attr = obj;
    				}

                    tag = tag.toLowerCase();

					// Stop formatting pre/code
					if (this.utils.isCurrentOrParent(['PRE', 'CODE']))
					{
						return;
					}

					var tags = ['b', 'bold', 'i', 'italic', 'underline', 'strikethrough', 'deleted', 'superscript', 'subscript'];
					var replaced = ['strong', 'strong', 'em', 'em', 'u', 'del', 'del', 'sup', 'sub'];

					for (var i = 0; i < tags.length; i++)
					{
						if (tag === tags[i])
						{
							tag = replaced[i];
						}
					}

                    this.placeholder.hide();
					this.buffer.set();

					if (this.utils.isCollapsed())
					{
    					this.inline.formatCollapsed(tag, attr, value, type);
    				}
    				else
    				{
        				this.inline.formatUncollapsed(tag, attr, value, type);
    				}
				},
				formatUncollapsed: function(tag, attr, value, type)
				{
    				this.selection.save();

                    var nodes = this.inline.getClearedNodes();
                    this.inline.setNodesStriked(nodes, tag, attr);

                    this.selection.restore();

                    document.execCommand('strikethrough');

                    this.selection.saveInstant();

                    var self = this;
                    this.core.editor().find('strike').each(function()
    				{
                        var $el = self.utils.replaceToTag(this, tag);
        				for (var key in attr)
                        {
        				    self.inline.setAttr($el, key, attr[key], type);
        				}

        				// remove inside
        				var $inside = $el.find(tag);
        				if ($inside.length !== 0)
        				{
            				for (var key in attr)
                            {
            				    self.inline.removeSpecificAttr($inside, key, attr[key]);
            				}
        				}

                        // same parent
                        var $parent = $el.parent();
                        if ($parent.html() == $el[0].outerHTML)
                        {
                            for (var key in attr)
                            {
            				    self.inline.removeSpecificAttr($parent, key, attr[key]);
            				}
                        }

                        // cache style
                        $el.attr('data-redactor-style-cache', $el.attr('style'));

    				});

    				this.selection.restoreInstant();
				},
				formatCollapsed: function(tag, attr, value, type)
				{
    				var inline = this.selection.inline();
    				if (inline)
					{
                        var currentTag = inline.tagName.toLowerCase();
                        if (currentTag === tag)
						{
							// empty = remove
							if (this.utils.isEmpty(inline.innerHTML))
							{
								this.caret.after(inline);
								$(inline).remove();
							}
							// not empty = break
							else
							{
								var $first = this.inline.insertBreakpoint(inline, currentTag);
								this.caret.after($first);
							}
						}
                        else if ($(inline).closest(tag).length === 0)
                        {
							this.inline.insertInline(tag, attr, value, type);
						}
						else
						{
    						this.caret.start(inline);
						}
    				}
    				else
    				{
                        this.inline.insertInline(tag, attr, value, type);
    				}
				},
                insertBreakpoint: function(inline, currentTag)
				{
					var breakpoint = document.createElement('span');
					breakpoint.id = 'redactor-inline-breakpoint';
					breakpoint = this.insert.node(breakpoint);

					var end = this.utils.isEndOfElement(inline);
					var code = this.utils.getOuterHtml(inline);
					var endTag = (end) ? '' : '<' + currentTag + '>';

					code = code.replace(/<span\sid="redactor-inline-breakpoint">​<\/span>/i, '</' + currentTag + '>' + endTag);
					var $code = $(code);
					$(inline).replaceWith($code);

					if (endTag !== '')
					{
    					this.utils.cloneAttributes(inline, $code.last());
					}

					return $code.first();
				},
				insertInline: function(tag, attr, value, type)
				{
					var node = document.createElement(tag);
					node = this.inline.setAttr(node, attr, value, type);

					this.insert.node(node);
					this.caret.start(node);
				},
                setAttr: function(inline, attr, value, type)
				{
					if (typeof attr === 'undefined')
					{
						return inline;
					}

					var func = (typeof type === 'undefined') ? 'toggle' : type;

					if (attr === 'class')
					{
						inline = this.inline[func + 'Class'](value, inline);
					}
					else
					{
						if (func === 'remove')
						{
							inline = this.inline[func + 'Attr'](attr, inline);
						}
						else if (func === 'removeAll')
						{
							inline = this.inline[func + 'Attr'](inline);
						}
						else
						{
							inline = this.inline[func + 'Attr'](attr, value, inline);

							if (attr === 'style' && inline[0].tagName === 'SPAN')
							{
							    $(inline).attr('data-redactor-span', true);
							}
						}
					}

					return inline;
				},
                getInlines: function(inline)
				{
					return (typeof inline === 'undefined') ? this.selection.inlines() : inline;
				},
				update: function(tag, attr, value, type)
				{
					var inlines = this.selection.inlines();
					var result = [];
					var self = this;

					$.each(inlines, function(i,s)
					{
						if ($.isArray(tag))
						{
							if ($.inArray(s.tagName.toLowerCase(), tag) === -1)
							{
								return;
							}
						}
						else
						{
							if (tag !== '*' && s.tagName.toLowerCase() !== tag)
							{
								return;
							}
						}

						result.push(self.inline.setAttr(s, attr, value, type));

					});

					return result;

				},
				replaceClass: function(value, inline)
				{
					return $(this.inline.getInlines(inline)).removeAttr('class').addClass(value)[0];
				},
				toggleClass: function(value, inline)
				{
					return $(this.inline.getInlines(inline)).toggleClass(value)[0];
				},
				addClass: function(value, inline)
				{
					return $(this.inline.getInlines(inline)).addClass(value)[0];
				},
				removeClass: function(value, inline)
				{
					return $(this.inline.getInlines(inline)).removeClass(value)[0];
				},
				removeAllClass: function(inline)
				{
					return $(this.inline.getInlines(inline)).removeAttr('class')[0];
				},
				replaceAttr: function(inline, attr, value)
				{
					inline = this.inline.removeAttr(attr, this.inline.getInlines(inline));

					return $(inline).attr(attr, value)[0];
				},
				toggleAttr: function(attr, value, inline)
				{
					inline = this.inline.getInlines(inline);

					var self = this;
					var returned = [];
					$.each(inline, function(i,s)
					{
						var $el = $(s);
						if ($el.attr(attr))
						{
							returned.push(self.inline.removeAttr(attr, s));
						}
						else
						{
							returned.push(self.inline.addAttr(attr, value, s));
						}
					});

					return returned;

				},
				addAttr: function(attr, value, inline)
				{
					return $(this.inline.getInlines(inline)).attr(attr, value)[0];
				},
				removeSpecificAttr: function(inline, key, value)
				{
    				if (key === 'style')
    				{
        				var arr = value.split(':');
        				var name = arr[0].trim();
                        $(inline).css(name, '');
                        this.utils.removeEmptyAttr(inline, 'style');
    				}
    				else
    				{
        				$(inline).removeAttr(key)[0];
    				}
				},
				removeAttr: function(attr, inline)
				{
					return $(this.inline.getInlines(inline)).removeAttr(attr)[0];
				},
				removeAllAttr: function(inline)
				{
					inline = this.inline.getInlines(inline);

					var returned = [];
					$.each(inline, function(i, s)
					{
						if (typeof s.attributes === 'undefined')
						{
							returned.push(s);
						}

						var $el = $(s);
						var len = s.attributes.length;
						for (var z = 0; z < len; z++)
						{
							$el.removeAttr(s.attributes[z].name);
						}

						returned.push($el[0]);
					});

					return returned;
				},
				removeFormat: function()
				{
					document.execCommand('removeFormat');
				},
				removeStyleRule: function(name)
				{
					this.buffer.set();
					var parent = this.selection.parent();
					var nodes = this.selection.inlines();

					this.selection.save();

					if (parent && parent.tagName === 'SPAN')
					{
						var $s = $(parent);

						$s.css(name, '');
						$s.removeAttr('data-redactor-span');
						this.utils.removeEmptyAttr($s, 'style');
						if ($s[0].attributes.length === 0)
						{
							$s.replaceWith($s.contents());
						}
					}

					$.each(nodes, $.proxy(function(i,s)
					{
						var $s = $(s);
						if ($.inArray(s.tagName.toLowerCase(), this.opts.inlineTags) != -1 && !$s.hasClass('redactor-selection-marker'))
						{
							$s.css(name, '');
							this.utils.removeEmptyAttr($s, 'style');
							if ($s[0].attributes.length === 0)
							{
								$s.replaceWith($s.contents());
							}
						}
					}, this));

					this.selection.restore();
				}

			};
		},

		// =insert
		insert: function()
		{
			return {
				set: function(html)
				{
					this.placeholder.hide();

					this.code.set(html);
					this.focus.end();

					this.placeholder.enable();
				},
				html: function(html, data)
				{
					this.placeholder.hide();
					this.core.editor().focus();

					var block = this.selection.block();
					var inline = this.selection.inline();

					// clean
					if (typeof data === 'undefined')
					{
						data = this.clean.getCurrentType(html, true);
						html = this.clean.onPaste(html, data, true);
					}

					html = $.parseHTML(html);

					// delete selected content
					var sel = this.selection.get();
					var range = this.selection.range(sel);
					range.deleteContents();

					this.selection.update(sel, range);

					// insert list in list
					if (data.lists)
					{
						var $list = $(html);
						if ($list.length !== 0 && ($list[0].tagName === 'UL' || $list[0].tagName === 'OL'))
						{

							this.insert.appendLists(block, $list);
							return;
						}
					}

					if (data.blocks && block)
					{
						if (this.utils.isSelectAll())
						{
							this.core.editor().html(html);
							this.focus.end();
						}
						else
						{
							var breaked = this.utils.breakBlockTag();
							if (breaked === false)
							{
								this.insert.placeHtml(html);
							}
							else
							{
    							var $last = $(html).children().last();
								$last.append(this.marker.get());

								if (breaked.type === 'start')
								{
									breaked.$block.before(html);
								}
								else
								{
									breaked.$block.after(html);
								}

								this.selection.restore();
								this.core.editor().find('p').each(function()
								{
									if ($.trim(this.innerHTML) === '')
									{
										$(this).remove();
									}
								});
							}
						}
					}
					else
					{
						if (inline)
						{
							// remove same tag inside
							var $div = $("<div/>").html(html);
							$div.find(inline.tagName.toLowerCase()).each(function()
							{
								$(this).contents().unwrap();
							});

							html = $div.html();

						}

						if (this.utils.isSelectAll())
						{
							var $node = $(this.opts.emptyHtml);
							this.core.editor().html('').append($node);
							$node.html(html);
							this.caret.end($node);
						}
						else
						{
							this.insert.placeHtml(html);
						}
					}


					this.utils.disableSelectAll();
					this.linkify.format();

					if (data.pre)
					{
						this.clean.cleanPre();
					}

				},
				text: function(text)
				{
					text = text.toString();
					text = $.trim(text);

					var tmp = document.createElement('div');
					tmp.innerHTML = text;
					text = tmp.textContent || tmp.innerText;

					if (typeof text === 'undefined')
					{
						return;
					}

					this.placeholder.hide();
					this.core.editor().focus();

					// blocks
					var blocks = this.selection.blocks();

					// nl to spaces
					text = text.replace(/\n/g, ' ');

					// select all
					if (this.utils.isSelectAll())
					{
						var $node = $(this.opts.emptyHtml);
						this.core.editor().html('').append($node);
						$node.html(text);
						this.caret.end($node);
					}
					else
					{
						// insert
						var sel = this.selection.get();
						var node = document.createTextNode(text);

						if (sel.getRangeAt && sel.rangeCount)
						{
							var range = sel.getRangeAt(0);
							range.deleteContents();
							range.insertNode(node);
							range.setStartAfter(node);
							range.collapse(true);

							this.selection.update(sel, range);
						}

						// wrap node if selected two or more block tags
						if (blocks.length > 1)
						{
							$(node).wrap('<p>');
							this.caret.after(node);
						}
					}

					this.utils.disableSelectAll();
					this.linkify.format();
					this.clean.normalizeCurrentHeading();

				},
				raw: function(html)
				{
					this.placeholder.hide();
					this.core.editor().focus();

					var sel = this.selection.get();

					var range = this.selection.range(sel);
					range.deleteContents();

		            var el = document.createElement("div");
		            el.innerHTML = html;

		            var frag = document.createDocumentFragment(), node, lastNode;
		            while ((node = el.firstChild))
		            {
		                lastNode = frag.appendChild(node);
		            }

		            range.insertNode(frag);

					if (lastNode)
					{
						range = range.cloneRange();
						range.setStartAfter(lastNode);
						range.collapse(true);
						sel.removeAllRanges();
						sel.addRange(range);
					}
				},
				node: function(node, deleteContent)
				{
					this.placeholder.hide();

					if (typeof this.start !== 'undefined')
					{
						this.core.editor().focus();
					}

					node = node[0] || node;

					var block = this.selection.block();
					var gap = this.utils.isBlockTag(node.tagName);
					var result = true;

					if (this.utils.isSelectAll())
					{
						if (gap)
						{
							this.core.editor().html(node);
						}
						else
						{
							this.core.editor().html($('<p>').html(node));
						}

						this.code.sync();
					}
					else if (gap && block)
					{
						var breaked = this.utils.breakBlockTag();
						if (breaked === false)
						{
							this.insert.placeNode(node, deleteContent);
						}
						else
						{
							if (breaked.type === 'start')
							{
								breaked.$block.before(node);
							}
							else
							{
								breaked.$block.after(node);
							}

							this.core.editor().find('p:empty').remove();
						}
					}
					else
					{
						result = this.insert.placeNode(node, deleteContent);
					}

					this.utils.disableSelectAll();

					if (result)
					{
					    this.caret.end(node);
					}

					return node;

				},
				appendLists: function(block, $list)
				{
					var $block = $(block);
					var last;
					var isEmpty = this.utils.isEmpty(block.innerHTML);

					if (isEmpty || this.utils.isEndOfElement(block))
					{
						last = $block;
						$list.find('li').each(function()
						{
							last.after(this);
							last = $(this);
						});

						if (isEmpty)
						{
							$block.remove();
						}
					}
					else if (this.utils.isStartOfElement(block))
					{
						$list.find('li').each(function()
						{
							$block.before(this);
							last = $(this);
						});
					}
					else
					{
				        var endOfNode = this.selection.extractEndOfNode(block);

				        $block.after($('<li>').append(endOfNode));
				        $block.append($list);
						last = $list;
					}

					this.marker.remove();

					if (last)
					{
						this.caret.end(last);
					}

					this.linkify.format();
				},
				placeHtml: function(html)
				{
					var marker = document.createElement('span');
					marker.id = 'redactor-insert-marker';
					marker = this.insert.node(marker);

					$(marker).before(html);
					this.selection.restore();
					this.caret.after(marker);
					$(marker).remove();
				},
				placeNode: function(node, deleteContent)
				{
					var sel = this.selection.get();
					var range = this.selection.range(sel);
					if (range == null)
					{
    					return false;
					}

					if (deleteContent !== false)
					{
						range.deleteContents();
					}

					range.insertNode(node);
					range.collapse(false);

					this.selection.update(sel, range);
				},
				nodeToPoint: function(e, node)
				{
					this.placeholder.hide();

					node = node[0] || node;

					if (this.utils.isEmpty())
					{
						node = (this.utils.isBlock(node)) ? node : $('<p />').append(node);

						this.core.editor().html(node);

						return node;
					}

					var range;
					var x = e.clientX, y = e.clientY;
					if (document.caretPositionFromPoint)
					{
					    var pos = document.caretPositionFromPoint(x, y);
					    var sel = document.getSelection();
					    range = sel.getRangeAt(0);
					    range.setStart(pos.offsetNode, pos.offset);
					    range.collapse(true);
					    range.insertNode(node);
					}
					else if (document.caretRangeFromPoint)
					{
					    range = document.caretRangeFromPoint(x, y);
					    range.insertNode(node);
					}
					else if (typeof document.body.createTextRange !== "undefined")
					{
				        range = document.body.createTextRange();
				        range.moveToPoint(x, y);
				        var endRange = range.duplicate();
				        endRange.moveToPoint(x, y);
				        range.setEndPoint("EndToEnd", endRange);
				        range.select();
					}

					return node;

				},

				// #backward
				nodeToCaretPositionFromPoint: function(e, node)
				{
					this.insert.nodeToPoint(e, node);
				},
				marker: function()
				{
					this.marker.insert();
				}
			};
		},

		// =keydown
		keydown: function()
		{
			return {
				init: function(e)
				{
					if (this.rtePaste)
					{
						return;
					}

					var key = e.which;
					var arrow = (key >= 37 && key <= 40);

					this.keydown.ctrl = e.ctrlKey || e.metaKey;
					this.keydown.parent = this.selection.parent();
					this.keydown.current = this.selection.current();
					this.keydown.block = this.selection.block();

			        // detect tags
					this.keydown.pre = this.utils.isTag(this.keydown.current, 'pre');
					this.keydown.blockquote = this.utils.isTag(this.keydown.current, 'blockquote');
					this.keydown.figcaption = this.utils.isTag(this.keydown.current, 'figcaption');
					this.keydown.figure = this.utils.isTag(this.keydown.current, 'figure');

					// callback
					var keydownStop = this.core.callback('keydown', e);
					if (keydownStop === false)
					{
						e.preventDefault();
						return false;
					}

					// shortcuts setup
					this.shortcuts.init(e, key);

					// buffer
					this.keydown.checkEvents(arrow, key);
                    this.keydown.setupBuffer(e, key);

					if (this.utils.isSelectAll() && ( key === this.keyCode.ENTER || key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE))
					{
						e.preventDefault();

						this.code.set(this.opts.emptyHtml);

						return;
					}

					this.keydown.addArrowsEvent(arrow);
					this.keydown.setupSelectAll(e, key);

					// turn off enter key
					if (!this.opts.enterKey && key === this.keyCode.ENTER)
					{
						e.preventDefault();

						// remove selected
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						if (!range.collapsed)
						{
							range.deleteContents();
						}

						return;
					}

					// down
					if (this.opts.enterKey && key === this.keyCode.DOWN)
					{
						this.keydown.onArrowDown();
					}

					// up
					if (this.opts.enterKey && key === this.keyCode.UP)
					{
						this.keydown.onArrowUp();
					}


					// replace to p before / after the table or into body
					if ((this.opts.type === 'textarea' || this.opts.type === 'div') && this.keydown.current && this.keydown.current.nodeType === 3 && $(this.keydown.parent).hasClass('redactor-in'))
					{
						this.keydown.wrapToParagraph();
					}

					// on Shift+Space or Ctrl+Space
					if (!this.keyup.lastShiftKey && key === this.keyCode.SPACE && (e.ctrlKey || e.shiftKey))
					{
						e.preventDefault();

						return this.keydown.onShiftSpace();
					}

					// on Shift+Enter or Ctrl+Enter
					if (key === this.keyCode.ENTER && (e.ctrlKey || e.shiftKey))
					{
						e.preventDefault();

						return this.keydown.onShiftEnter(e);
					}

					// on enter
					if (key === this.keyCode.ENTER && !e.shiftKey && !e.ctrlKey && !e.metaKey)
					{
						return this.keydown.onEnter(e);
					}

					// tab or cmd + [
					if (key === this.keyCode.TAB || e.metaKey && key === 221 || e.metaKey && key === 219)
					{
						return this.keydown.onTab(e, key);
					}

                    // firefox bugfix
					if (this.detect.isFirefox() && key === this.keyCode.BACKSPACE && this.keydown.block && this.keydown.block.tagName === 'P' && this.utils.isStartOfElement(this.keydown.block))
					{
    					var $prev = $(this.keydown.block).prev();
    					if ($prev.length !== 0)
    					{
        					e.preventDefault();

        					$prev.append(this.marker.get());
        					$prev.append($(this.keydown.block).html());
        					$(this.keydown.block).remove();

                            this.selection.restore();

        					return;
    					}
					}

					// backspace & delete
					if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
					{
    					if (this.observe.image && typeof this.observe.image !== 'undefined' && $('#redactor-image-box').length !== 0)
    					{
        					e.preventDefault();

        					var $prev = this.observe.image.closest('figure, p').prev()
        					this.image.remove(false);
                            this.observe.image = false;

        					if ($prev && $prev.length !== 0)
        					{
            					this.caret.end($prev);
        					}
        					else
        					{
            					this.core.editor().focus();
        					}

        					return;
    					}

						this.keydown.onBackspaceAndDeleteBefore();
					}

					if (key === this.keyCode.DELETE)
					{
						var $next = $(this.keydown.block).next();

						// delete figure
						if (this.utils.isEndOfElement(this.keydown.block) && $next.length !== 0 && $next[0].tagName === 'FIGURE')
						{
							$next.remove();
							return false;
						}

						// append list (safari bug)
						var tagLi = (this.keydown.block && this.keydown.block.tagName === 'LI') ? this.keydown.block : false;
						if (tagLi)
						{
							var $list = $(this.keydown.block).parents('ul, ol').last();
							var $nextList = $list.next();

							if (this.utils.isRedactorParent($list) && this.utils.isEndOfElement($list) && $nextList.length !== 0
								&& ($nextList[0].tagName === 'UL' || $nextList[0].tagName === 'OL'))
							{
								e.preventDefault();

								$list.append($nextList.contents());
								$nextList.remove();

								return false;
							}
						}

						// append pre
						if (this.utils.isEndOfElement(this.keydown.block) && $next.length !== 0 && $next[0].tagName === 'PRE')
						{
							$(this.keydown.block).append($next.text());
							$next.remove();
							return false;
						}

					}

					// image delete
					if (key === this.keyCode.DELETE && $('#redactor-image-box').length !== 0)
					{
						this.image.remove();
					}

					// backspace
					if (key === this.keyCode.BACKSPACE)
					{
						if (this.detect.isFirefox())
						{
							this.line.removeOnBackspace(e);
						}

                        // combine list after and before if paragraph is empty
                        if (this.list.combineAfterAndBefore(this.keydown.block))
                        {
                            e.preventDefault();
                            return;
                        }

						// backspace as outdent
						var block = this.selection.block();
						if (block && block.tagName === 'LI' && this.utils.isCollapsed() && this.utils.isStartOfElement())
						{
							this.indent.decrease();
							e.preventDefault();
							return;
						}

						this.keydown.removeInvisibleSpace();
						this.keydown.removeEmptyListInTable(e);

					}

					if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
					{
						this.keydown.onBackspaceAndDeleteAfter(e);
					}

				},
				onShiftSpace: function()
				{
					this.buffer.set();
					this.insert.raw('&nbsp;');

					return false;
				},
				onShiftEnter: function(e)
				{
					this.buffer.set();

					return (this.keydown.pre) ? this.keydown.insertNewLine(e) : this.insert.raw('<br>');
				},
				onBackspaceAndDeleteBefore: function()
				{
					this.utils.saveScroll();
				},
				onBackspaceAndDeleteAfter: function(e)
				{
					// remove style tag
					setTimeout($.proxy(function()
					{
						this.code.syncFire = false;
						this.keydown.removeEmptyLists();

						this.core.editor().find('*[style]').not('img, figure, #redactor-image-box, #redactor-image-editter, [data-redactor-span]').removeAttr('style');

						this.keydown.formatEmpty(e);
						this.code.syncFire = true;

					}, this), 1);
				},
				onEnter: function(e)
				{
					var stop = this.core.callback('enter', e);
					if (stop === false)
					{
						e.preventDefault();
						return false;
					}

					// blockquote exit
					if (this.keydown.blockquote && this.keydown.exitFromBlockquote(e) === true)
					{
						return false;
					}

					// pre
					if (this.keydown.pre)
					{
						return this.keydown.insertNewLine(e);
					}
					// blockquote & figcaption
					else if (this.keydown.blockquote || this.keydown.figcaption)
					{
						return this.keydown.insertBreakLine(e);
					}
					// figure
					else if (this.keydown.figure)
					{
						setTimeout($.proxy(function()
						{
							this.keydown.replaceToParagraph('FIGURE');

						}, this), 1);
					}
					// paragraphs
					else if (this.keydown.block)
					{
						setTimeout($.proxy(function()
						{
							this.keydown.replaceToParagraph('DIV');

						}, this), 1);

						// empty list exit
						if (this.keydown.block.tagName === 'LI')
						{
							var current = this.selection.current();
							var $parent = $(current).closest('li', this.$editor[0]);
							var $list = $parent.parents('ul,ol', this.$editor[0]).last();

							if ($parent.length !== 0 && this.utils.isEmpty($parent.html()) && $list.next().length === 0 && this.utils.isEmpty($list.find("li").last().html()))
							{
								$list.find("li").last().remove();

								var node = $(this.opts.emptyHtml);
								$list.after(node);
								this.caret.start(node);

								return false;
							}
						}

					}
					// outside
					else if (!this.keydown.block)
					{
						return this.keydown.insertParagraph(e);
					}

                    // firefox enter into inline element
					if (this.detect.isFirefox() && this.utils.isInline(this.keydown.parent))
					{
                        this.keydown.insertBreakLine(e);
                        return;
                    }


					// remove inline tags in new-empty paragraph
					setTimeout($.proxy(function()
					{
						var inline = this.selection.inline();
						if (inline && this.utils.isEmpty(inline.innerHTML))
						{
							var parent = this.selection.block();
							$(inline).remove();
							//this.caret.start(parent);

                            var range = document.createRange();
                            range.setStart(parent, 0);

                            var textNode = document.createTextNode('\u200B');

                            range.insertNode(textNode);
                            range.setStartAfter(textNode);
                            range.collapse(true);

                            var sel = window.getSelection();
            				sel.removeAllRanges();
            				sel.addRange(range);
						}


					}, this), 1);
				},
				checkEvents: function(arrow, key)
				{
					if (!arrow && (this.core.getEvent() === 'click' || this.core.getEvent() === 'arrow'))
					{
						this.core.addEvent(false);

						if (this.keydown.checkKeyEvents(key))
						{
							this.buffer.set();
						}
					}
				},
				checkKeyEvents: function(key)
				{
					var k = this.keyCode;
					var keys = [k.BACKSPACE, k.DELETE, k.ENTER, k.ESC, k.TAB, k.CTRL, k.META, k.ALT, k.SHIFT];

					return ($.inArray(key, keys) === -1) ? true : false;

				},
				addArrowsEvent: function(arrow)
				{
					if (!arrow)
					{
						return;
					}

					if ((this.core.getEvent() === 'click' || this.core.getEvent() === 'arrow'))
					{
						this.core.addEvent(false);
						return;
					}

				    this.core.addEvent('arrow');
				},
				setupBuffer: function(e, key)
				{
					if (this.keydown.ctrl && key === 90 && !e.shiftKey && !e.altKey && this.opts.buffer.length) // z key
					{
						e.preventDefault();
						this.buffer.undo();
						return;
					}
					// redo
					else if (this.keydown.ctrl && key === 90 && e.shiftKey && !e.altKey && this.opts.rebuffer.length !== 0)
					{
						e.preventDefault();
						this.buffer.redo();
						return;
					}
					else if (!this.keydown.ctrl)
					{
						if (key === this.keyCode.SPACE || key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE || (key === this.keyCode.ENTER && !e.ctrlKey && !e.shiftKey))
						{
							this.buffer.set();
						}
					}
				},
				exitFromBlockquote: function(e)
				{

					if (!this.utils.isEndOfElement(this.keydown.blockquote))
					{
						return;
					}

					var tmp = this.clean.removeSpacesHard($(this.keydown.blockquote).html());
					if (tmp.search(/(<br\s?\/?>){3}$/i) !== -1)
					{
						e.preventDefault();

						var $last = $(this.keydown.blockquote).children().last().prev();

						$last.prev().filter('br').remove();
						$last.filter('br').remove();
						$(this.keydown.blockquote).children().last().filter('br').remove();
						$(this.keydown.blockquote).children().last().filter('span').remove();

						var node = $(this.opts.emptyHtml);
						$(this.keydown.blockquote).after(node);
						this.caret.start(node);

						return true;

					}

					return;

				},
				onArrowDown: function()
				{
					var tags = [this.keydown.blockquote, this.keydown.pre, this.keydown.figcaption];

					for (var i = 0; i < tags.length; i++)
					{
						if (tags[i])
						{
							this.keydown.insertAfterLastElement(tags[i]);
							return false;
						}
					}
				},
				onArrowUp: function()
				{
					var tags = [this.keydown.blockquote, this.keydown.pre, this.keydown.figcaption];

					for (var i = 0; i < tags.length; i++)
					{
						if (tags[i])
						{
							this.keydown.insertBeforeFirstElement(tags[i]);
							return false;
						}
					}
				},
				insertAfterLastElement: function(element)
				{
					if (!this.utils.isEndOfElement(element))
					{
						return;
					}

					var last = this.core.editor().contents().last();
					var $next = (element.tagName === 'FIGCAPTION') ? $(this.keydown.block).parent().next() : $(this.keydown.block).next();

					if ($next.length !== 0)
					{
						return;
					}
					else if (last.length === 0 && last[0] !== element)
					{
						this.caret.start(last);
						return;
					}
					else
					{
						var node = $(this.opts.emptyHtml);

						if (element.tagName === 'FIGCAPTION')
						{
						    $(element).parent().after(node);
						}
						else
						{
    						$(element).after(node);
						}

						this.caret.start(node);
					}

				},
				insertBeforeFirstElement: function(element)
				{
					if (!this.utils.isStartOfElement())
					{
						return;
					}

					if (this.core.editor().contents().length > 1 && this.core.editor().contents().first()[0] !== element)
					{
						return;
					}

					var node = $(this.opts.emptyHtml);
					$(element).before(node);
					this.caret.start(node);

				},
				onTab: function(e, key)
				{
					if (!this.opts.tabKey)
					{
						return true;
					}

					var isList = (this.keydown.block && this.keydown.block.tagName === 'LI')
					if (this.utils.isEmpty(this.code.get()) || (!isList && !this.keydown.pre && this.opts.tabAsSpaces === false))
					{
						return true;
					}

					e.preventDefault();
					this.buffer.set();

                    var isListStart = (isList && this.utils.isStartOfElement(this.keydown.block));
					var node;

					if (this.keydown.pre && !e.shiftKey)
					{
						node = (this.opts.preSpaces) ? document.createTextNode(Array(this.opts.preSpaces + 1).join('\u00a0')) : document.createTextNode('\t');
						this.insert.node(node);
					}
					else if (this.opts.tabAsSpaces !== false && !isListStart)
					{
						node = document.createTextNode(Array(this.opts.tabAsSpaces + 1).join('\u00a0'));
						this.insert.node(node);
					}
					else
					{
						if (e.metaKey && key === 219)
						{
							this.indent.decrease();
						}
						else if (e.metaKey && key === 221)
						{
							this.indent.increase();
						}
						else if (!e.shiftKey)
						{
							this.indent.increase();
						}
						else
						{
							this.indent.decrease();
						}
					}

					return false;
				},
				setupSelectAll: function(e, key)
				{
					if (this.keydown.ctrl && key === 65)
					{
						this.utils.enableSelectAll();
					}
					else if (key !== this.keyCode.LEFT_WIN && !this.keydown.ctrl)
					{
						this.utils.disableSelectAll();
					}
				},
				insertNewLine: function(e)
				{
					e.preventDefault();

					var node = document.createTextNode('\n');

					var sel = this.selection.get();
					var range = this.selection.range(sel);

					range.deleteContents();
					range.insertNode(node);

					this.caret.after(node);

					return false;
				},
				insertParagraph: function(e)
				{
					e.preventDefault();

					var p = document.createElement('p');
					p.innerHTML = this.opts.invisibleSpace;

					var sel = this.selection.get();
					var range = this.selection.range(sel);

					range.deleteContents();
					range.insertNode(p);

					this.caret.start(p);

					return false;
				},
				insertBreakLine: function(e)
				{
					return this.keydown.insertBreakLineProcessing(e);
				},
				insertDblBreakLine: function(e)
				{
					return this.keydown.insertBreakLineProcessing(e, true);
				},
				insertBreakLineProcessing: function(e, dbl)
				{
					e.stopPropagation();

					var br1 = document.createElement('br');
					this.insert.node(br1);

					if (dbl === true)
					{
						var br2 = document.createElement('br');
						this.insert.node(br2);
					}

					return false;

				},
				wrapToParagraph: function()
				{
					var $current = $(this.keydown.current);
					var	node = $('<p>').append($current.clone());
					$current.replaceWith(node);


					var next = $(node).next();
					if (typeof(next[0]) !== 'undefined' && next[0].tagName === 'BR')
					{
						next.remove();
					}

					this.caret.end(node);

				},
				replaceToParagraph: function(tag)
				{
					var blockElem = this.selection.block();
					var $prev = $(blockElem).prev();

					var blockHtml = blockElem.innerHTML.replace(/<br\s?\/?>/gi, '');
					if (blockElem.tagName === tag && this.utils.isEmpty(blockHtml) && !$(blockElem).hasClass('redactor-in'))
					{
						var p = document.createElement('p');
						$(blockElem).replaceWith(p);

                        this.keydown.setCaretToParagraph(p);

						return false;
					}
					else if (blockElem.tagName === 'P')
					{
						$(blockElem).removeAttr('class').removeAttr('style');

						// fix #227
						if (this.detect.isIe() && this.utils.isEmpty(blockHtml) && this.utils.isInline(this.keydown.parent))
                        {
                            $(blockElem).on('input', $.proxy(function()
                            {
                                var parent = this.selection.parent();
                                if (this.utils.isInline(parent))
                                {
                                    var html = $(parent).html();
                                    $(blockElem).html(html);
                                    this.caret.end(blockElem);
                                }

                                $(blockElem).off('keyup');

                            }, this));
						}

						return false;
					}
					else if ($prev.hasClass(this.opts.videoContainerClass))
					{
    					$prev.removeAttr('class');

    					var p = document.createElement('p');
						$prev.replaceWith(p);

						this.keydown.setCaretToParagraph(p);

						return false;
					}
				},
				setCaretToParagraph: function(p)
				{
                    var range = document.createRange();
                    range.setStart(p, 0);

                    var textNode = document.createTextNode('\u200B');

                    range.insertNode(textNode);
                    range.setStartAfter(textNode);
                    range.collapse(true);

                    var sel = window.getSelection();
    				sel.removeAllRanges();
    				sel.addRange(range);
				},
				removeInvisibleSpace: function()
				{
					var $current = $(this.keydown.current);
					if ($current.text().search(/^\u200B$/g) === 0)
					{
						$current.remove();
					}
				},
				removeEmptyListInTable: function(e)
				{
					var $current = $(this.keydown.current);
					var $parent = $(this.keydown.parent);
					var td = $current.closest('td', this.$editor[0]);

					if (td.length !== 0 && $current.closest('li', this.$editor[0]) && $parent.children('li').length === 1)
					{
						if (!this.utils.isEmpty($current.text()))
						{
							return;
						}

						e.preventDefault();

						$current.remove();
						$parent.remove();

						this.caret.start(td);
					}
				},
				removeEmptyLists: function()
				{
					var removeIt = function()
					{
						var html = $.trim(this.innerHTML).replace(/\/t\/n/g, '');
						if (html === '')
						{
							$(this).remove();
						}
					};

					this.core.editor().find('li').each(removeIt);
					this.core.editor().find('ul, ol').each(removeIt);
				},
				formatEmpty: function(e)
				{
					var html = $.trim(this.core.editor().html());

					if (!this.utils.isEmpty(html))
					{
						return;
					}

					e.preventDefault();

					if (this.opts.type === 'inline' || this.opts.type === 'pre')
					{
						this.core.editor().html(this.marker.html());
						this.selection.restore();
					}
					else
					{
						this.core.editor().html(this.opts.emptyHtml);
						this.focus.start();
					}

					return false;

				}
			};
		},

		// =keyup
		keyup: function()
		{
			return {
				init: function(e)
				{
					if (this.rtePaste)
					{
						return;
					}

					var key = e.which;
					this.keyup.block = this.selection.block();
					this.keyup.current = this.selection.current();
					this.keyup.parent = this.selection.parent();
					this.keyup.lastShiftKey = e.shiftKey;


					// callback
					var stop = this.core.callback('keyup', e);
					if (stop === false)
					{
						e.preventDefault();
						return false;
					}

                    // replace a prev figure to paragraph if caret is before image
                    if (key === this.keyCode.ENTER)
                    {
                        if (this.keyup.block && this.keyup.block.tagName === 'FIGURE')
                        {
                            var $prev = $(this.keyup.block).prev();
                            if ($prev.length !== 0 && $prev[0].tagName === 'FIGURE')
                            {
                                var $newTag = this.utils.replaceToTag($prev, 'p');
                                this.caret.start($newTag);
                                return;
                            }
                        }
                    }

					// replace figure to paragraph
					if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
					{
						if (this.utils.isSelectAll())
						{
							this.focus.start();

							return;
						}


						// if caret before figure - delete image
						if (this.keyup.block && this.keydown.block && this.keyup.block.tagName === 'FIGURE' && this.utils.isStartOfElement(this.keydown.block))
						{
    						e.preventDefault();

                            this.selection.save();
                            $(this.keyup.block).find('figcaption').remove();
    						$(this.keyup.block).find('img').first().remove();
    						this.utils.replaceToTag(this.keyup.block, 'p');

    						var $marker = this.marker.find();
    						$('html, body').animate({ scrollTop: $marker.position().top + 20 }, 500);

    						this.selection.restore();
    						return;
						}


						// if paragraph does contain only image replace to figure
						if (this.keyup.block && this.keyup.block.tagName === 'P')
						{
							var isContainImage = $(this.keyup.block).find('img').length;
							var text = $(this.keyup.block).text().replace(/\u200B/g, '');
							if (text === '' && isContainImage !== 0)
							{
								this.utils.replaceToTag(this.keyup.block, 'figure');
							}
						}

						// if figure does not contain image - replace to paragraph
						if (this.keyup.block && this.keyup.block.tagName === 'FIGURE' && $(this.keyup.block).find('img').length === 0)
						{
							this.selection.save();
							this.utils.replaceToTag(this.keyup.block, 'p');
							this.selection.restore();
						}
					}

					// linkify
					if (this.linkify.isKey(key))
					{
						this.linkify.format();
					}

				}

			};
		},

		// =lang
		lang: function()
		{
			return {
				load: function()
				{
					this.opts.curLang = this.opts.langs[this.opts.lang];
				},
				get: function(name)
				{
					return (typeof this.opts.curLang[name] !== 'undefined') ? this.opts.curLang[name] : '';
				}
			};
		},

		// =line
		line: function()
		{
			return {
				insert: function()
				{
					this.buffer.set();

					// insert
					this.insert.html(this.line.getLineHtml());

					// find
					var $hr = this.core.editor().find('#redactor-hr-tmp-id');
					$hr.removeAttr('id');

					this.core.callback('insertedLine', $hr);

					return $hr;
				},
				getLineHtml: function()
				{
					var html = '<hr id="redactor-hr-tmp-id" />';
					if (!this.detect.isFirefox() && this.utils.isEmpty())
					{
						html += '<p>' + this.opts.emptyHtml + '</p>';
					}

					return html;
				},
				// ff only
				removeOnBackspace: function(e)
				{
					if (!this.utils.isCollapsed())
					{
						return;
					}

					var $block = $(this.selection.block());
					if ($block.length === 0 || !this.utils.isStartOfElement($block))
					{
						return;
					}

					// if hr is previous element
					var $prev = $block.prev();
					if ($prev && $prev.length !== 0 && $prev[0].tagName === 'HR')
					{
						e.preventDefault();
						$prev.remove();
					}
				}
			};
		},

		// =link
		link: function()
		{
			return {

				// public
				get: function()
				{
					return $(this.selection.inlines('a'));
				},
				is: function()
				{
					var nodes = this.selection.nodes() ;
					var $link = $(this.selection.current()).closest('a', this.core.editor()[0]);

					return ($link.length === 0 || nodes.length > 1) ? false : $link;
				},
				unlink: function(e)
				{
					// if call from clickable element
					if (typeof e !== 'undefined' && e.preventDefault)
					{
						e.preventDefault();
					}

					// buffer
					this.buffer.set();

					var links = this.selection.inlines('a');
					if (links.length === 0)
					{
						return;
					}

					var $links = this.link.replaceLinksToText(links);

					this.observe.closeAllTooltip();
					this.core.callback('deletedLink', $links);

				},
				insert: function(link, cleaned)
				{
					var $el = this.link.is();

					if (cleaned !== true)
					{
						link = this.link.buildLinkFromObject($el, link);
						if (link === false)
						{
							return false;
						}
					}

					// buffer
					this.buffer.set();

					// callback
					link = this.core.callback('beforeInsertingLink', link);

					if ($el === false)
					{
						// insert
						$el = $('<a />');
						$el = this.link.update($el, link);
						$el = $(this.insert.node($el));

						var $parent = $el.parent();
						if (this.utils.isRedactorParent($parent) === false)
						{
							$el.wrap('<p>');
						}

						// remove unlink wrapper
						if ($parent.hasClass('redactor-unlink'))
						{
							$parent.replaceWith(function(){
								return $(this).contents();
							});
						}

						this.caret.after($el);
						this.core.callback('insertedLink', $el);
					}
					else
					{
						// update
						$el = this.link.update($el, link);
						this.caret.after($el);
					}

				},
				update: function($el, link)
				{
					$el.text(link.text);
					$el.attr('href', link.url);

					this.link.target($el, link.target);

					return $el;

				},
				target: function($el, target)
				{
					return (target) ? $el.attr('target', '_blank') : $el.removeAttr('target');
				},
				show: function(e)
				{
					// if call from clickable element
					if (typeof e !== 'undefined' && e.preventDefault)
					{
						e.preventDefault();
					}

					// close tooltip
					this.observe.closeAllTooltip();

					// is link
					var $el = this.link.is();

					// build modal
					this.link.buildModal($el);

					// build link
					var link = this.link.buildLinkFromElement($el);

					// if link cut & paste inside editor browser added self host to a link
					link.url = this.link.removeSelfHostFromUrl(link.url);

                    // new tab target
					if (this.opts.linkNewTab && !$el)
					{
    					link.target = true;
					}

					// set modal values
					this.link.setModalValues(link);

					// show modal
					this.modal.show();

					// focus
					if (this.detect.isDesktop())
					{
						$('#redactor-link-url').focus();
					}
				},

				// private
				setModalValues: function(link)
				{
					$('#redactor-link-blank').prop('checked', link.target);
					$('#redactor-link-url').val(link.url);
					$('#redactor-link-url-text').val(link.text);
				},
				buildModal: function($el)
				{
					this.modal.load('link', this.lang.get(($el === false) ? 'link-insert' : 'link-edit'), 600);

					// button insert
					var $btn = this.modal.getActionButton();
					$btn.text(this.lang.get(($el === false) ? 'insert' : 'save')).on('click', $.proxy(this.link.callback, this));

				},
				callback: function()
				{
					// build link
					var link = this.link.buildLinkFromModal();
					if (link === false)
					{
						return false;
					}

					// close
					this.modal.close();

					// insert or update
					this.link.insert(link, true);
				},
				cleanUrl: function(url)
				{
					return (typeof url === 'undefined') ? '' : $.trim(url.replace(/[^\W\w\D\d+&\'@#/%?=~_|!:,.;\(\)]/gi, ''));
				},
				cleanText: function(text)
				{
					return (typeof text === 'undefined') ? '' :$.trim(text.replace(/(<([^>]+)>)/gi, ''));
				},
				getText: function(link)
				{
					return (link.text === '' && link.url !== '') ? this.link.truncateUrl(link.url.replace(/<|>/g, '')) : link.text;
				},
				isUrl: function(url)
				{
					var pattern = '((xn--)?[\\W\\w\\D\\d]+(-[\\W\\w\\D\\d]+)*\\.)+[\\W\\w]{2,}';

					var re1 = new RegExp('^(http|ftp|https)://' + pattern, 'i');
					var re2 = new RegExp('^' + pattern, 'i');
					var re3 = new RegExp('\.(html|php)$', 'i');
					var re4 = new RegExp('^/', 'i');
					var re5 = new RegExp('^tel:(.*?)', 'i');

					// add protocol
					if (url.search(re1) === -1 && url.search(re2) !== -1 && url.search(re3) === -1 && url.substring(0, 1) !== '/')
					{
						url = 'http://' + url;
					}

					if (url.search(re1) !== -1 || url.search(re3) !== -1 || url.search(re4) !== -1 || url.search(re5) !== -1)
					{
						return url;
					}

					return false;
				},
				isMailto: function(url)
				{
					return (url.search('@') !== -1 && /(http|ftp|https):\/\//i.test(url) === false);
				},
				isEmpty: function(link)
				{
					return (link.url === '' || (link.text === '' && link.url === ''));
				},
				truncateUrl: function(url)
				{
					return (url.length > this.opts.linkSize) ? url.substring(0, this.opts.linkSize) + '...' : url;
				},
				parse: function(link)
				{
					// mailto
					if (this.link.isMailto(link.url))
					{
						link.url = 'mailto:' + link.url.replace('mailto:', '');
					}
					// url
					else if (link.url.search('#') !== 0)
					{
						link.url = this.link.isUrl(link.url);
					}

					// empty url or text or isn't url
					return (this.link.isEmpty(link) || link.url === false) ? false : link;

				},
				buildLinkFromModal: function()
				{
					var link = {};

					// url
					link.url = this.link.cleanUrl($('#redactor-link-url').val());

					// text
					link.text = this.link.cleanText($('#redactor-link-url-text').val());
					link.text = this.link.getText(link);

					// target
					link.target = ($('#redactor-link-blank').prop('checked')) ? true : false;

					// parse
					return this.link.parse(link);

				},
				buildLinkFromObject: function($el, link)
				{
					// url
					link.url = this.link.cleanUrl(link.url);

					// text
					link.text = (typeof link.text === 'undefined' && this.selection.is()) ? this.selection.text() : this.link.cleanText(link.text);
					link.text = this.link.getText(link);

					// target
					link.target = ($el === false) ? link.target : this.link.buildTarget($el);

					// parse
					return this.link.parse(link);

				},
				buildLinkFromElement: function($el)
				{
					var link = {
						url: '',
						text: (this.selection.is()) ? this.selection.text() : '',
						target: false
					};

					if ($el !== false)
					{
						link.url = $el.attr('href');
						link.text = $el.text();
						link.target = this.link.buildTarget($el);
					}

					return link;
				},
				buildTarget: function($el)
				{
					return (typeof $el.attr('target') !== 'undefined' && $el.attr('target') === '_blank') ? true : false;
				},
				removeSelfHostFromUrl: function(url)
				{
					var href = self.location.href.replace('#', '').replace(/\/$/i, '');
					return url.replace(/^\/\#/, '#').replace(href, '').replace('mailto:', '');
				},
				replaceLinksToText: function(links)
				{
					var $first;
					var $links = $.each(links, function(i,s)
					{
						var $el = $(s);
						var $unlinked = $('<span class="redactor-unlink" />').append($el.contents());
						$el.replaceWith($unlinked);

						if (i === 0)
						{
							$first = $unlinked;
						}

						return $el;
					});

					// set caret after unlinked node
					if (links.length === 1 && this.selection.isCollapsed())
					{
						this.caret.after($first);
					}

					return $links;
				}
			};
		},

		// =linkify
		linkify: function()
		{
			return {
				isKey: function(key)
				{
					return key === this.keyCode.ENTER || key === this.keyCode.SPACE;
				},
				isLink: function(node)
				{
					return (node.nodeValue.match(this.opts.regexps.linkyoutube) || node.nodeValue.match(this.opts.regexps.linkvimeo) || node.nodeValue.match(this.opts.regexps.linkimage) || node.nodeValue.match(this.opts.regexps.url));
				},
				isFiltered: function(i, node)
				{
					return node.nodeType === 3 && $.trim(node.nodeValue) !== "" && !$(node).parent().is("pre") && (this.linkify.isLink(node));
				},
				handler: function(i, node)
				{
					var $el = $(node);
					var text = $el.text();
					var html = text;

					if (html.match(this.opts.regexps.linkyoutube) || html.match(this.opts.regexps.linkvimeo))
					{
						html = this.linkify.convertVideoLinks(html);
					}
					else if (html.match(this.opts.regexps.linkimage))
					{
						html = this.linkify.convertImages(html);
					}
					else
					{
						html = this.linkify.convertLinks(html);
					}

					$el.before(text.replace(text, html)).remove();
				},
				format: function()
				{
					if (!this.opts.linkify || this.utils.isCurrentOrParent('pre'))
					{
						return;
					}


					this.core.editor().find(":not(iframe,img,a,pre,code,.redactor-unlink)").addBack().contents().filter($.proxy(this.linkify.isFiltered, this)).each($.proxy(this.linkify.handler, this));

					// collect
					var $objects = this.core.editor().find('.redactor-linkify-object').each($.proxy(function(i,s)
					{
						var $el = $(s);
						$el.removeClass('redactor-linkify-object');
						if ($el.attr('class') === '')
						{
							$el.removeAttr('class');
						}

						if (s.tagName === 'DIV') // video container
						{
							this.linkify.breakBlockTag($el, 'video');
						}
						else if (s.tagName === 'IMG') // image
						{
							this.linkify.breakBlockTag($el, 'image');
						}
						else if (s.tagName === 'A')
						{
							this.core.callback('insertedLink', $el);
						}

						return $el;

					}, this));

					// callback
					setTimeout($.proxy(function()
					{
						this.code.sync();
						this.core.callback('linkify', $objects);

					}, this), 100);

				},
				breakBlockTag: function($el, type)
				{
					var breaked = this.utils.breakBlockTag();
					if (breaked === false)
					{
						return;
					}

					var $newBlock = $el;
					if (type === 'image')
					{
						$newBlock = $('<figure />').append($el);
					}

					if (breaked.type === 'start')
					{
						breaked.$block.before($newBlock);
					}
					else
					{
						breaked.$block.after($newBlock);
					}


					if (type === 'image')
					{
						this.caret.after($newBlock);
					}

				},
				convertVideoLinks: function(html)
				{
					var iframeStart = '<div class="' + this.opts.videoContainerClass + ' redactor-linkify-object"><iframe class="redactor-linkify-object" width="500" height="281" src="';
					var iframeEnd = '" frameborder="0" allowfullscreen></iframe></div>';

					if (html.match(this.opts.regexps.linkyoutube))
					{
						html = html.replace(this.opts.regexps.linkyoutube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
					}

					if (html.match(this.opts.regexps.linkvimeo))
					{
						html = html.replace(this.opts.regexps.linkvimeo, iframeStart + '//player.vimeo.com/video/$2' + iframeEnd);
					}

					return html;
				},
				convertImages: function(html)
				{
					var matches = html.match(this.opts.regexps.linkimage);
					if (!matches)
					{
						return html;
					}

					return html.replace(html, '<img src="' + matches + '" class="redactor-linkify-object" />');
				},
				convertLinks: function(html)
				{
					var matches = html.match(this.opts.regexps.url);
					if (!matches)
					{
						return html;
					}

					matches = $.grep(matches, function(v, k) { return $.inArray(v, matches) === k; });

					var length = matches.length;

					for (var i = 0; i < length; i++)
					{
						var href = matches[i], text = href;
						var linkProtocol = (href.match(/(https?|ftp):\/\//i) !== null) ? '' : 'http://';

						if (text.length > this.opts.linkSize)
						{
							text = text.substring(0, this.opts.linkSize) + '...';
						}

						if (text.search('%') === -1)
						{
							text = decodeURIComponent(text);
						}

						var regexB = "\\b";

						if ($.inArray(href.slice(-1), ["/", "&", "="]) !== -1)
						{
							regexB = "";
						}

						// escaping url
						var regexp = new RegExp('(' + href.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + regexB + ')', 'g');

						html = html.replace(regexp, '<a href="' + linkProtocol + $.trim(href) + '" class="redactor-linkify-object">' + $.trim(text) + '</a>');
					}

					return html;
				}
			};
		},

		// =list
		list: function()
		{
			return {
				toggle: function(cmd)
				{
					if (this.utils.inBlocks(['table', 'td', 'th', 'tr']))
					{
						return;
					}

					var tag = (cmd === 'orderedlist' || cmd === 'ol') ? 'OL' : 'UL';
					cmd = (tag === 'OL') ? 'orderedlist' : 'unorderedlist'

					var $list = $(this.selection.current()).parentsUntil('.redactor-in', 'ul, ol').first();

					this.placeholder.hide();
					this.buffer.set();


					if ($list.length !== 0 && $list[0].tagName === tag && this.utils.isRedactorParent($list))
					{
						this.selection.save();

						// remove list
						$list.find('ul, ol').each(function()
						{
							var parent = $(this).closest('li');
							$(this).find('li').each(function()
							{
								$(parent).after(this);
							});
						});

						$list.find('ul, ol').remove();
						$list.find('li').each(function()
						{
							return $(this).replaceWith(function()
							{
								return $('<p />').append($(this).contents());
							});
						});


						$list.replaceWith(function()
						{
							return $(this).contents();
						});

						this.selection.restore();
						return;
					}


					this.selection.save();

					if ($list.length !== 0 && $list[0].tagName !== tag)
					{
                        $list.each($.proxy(function(i,s)
                        {
                            this.utils.replaceToTag(s, tag);

                        }, this));
					}
					else
					{
					    document.execCommand('insert' + cmd);
					}

					this.selection.restore();

					var $insertedList = this.list.get();
					if (!$insertedList)
					{
						if (!this.selection.block())
						{
							document.execCommand('formatblock', false, 'p');
						}

						return;
					}

					// clear span
					$insertedList.find('span').replaceWith(function()
					{
						return $(this).contents();
					});

					// remove style
					$insertedList.find(this.opts.inlineTags.join(',')).each(function()
					{
						$(this).removeAttr('style');
					});

					// remove block-element list wrapper
					var $listParent = $insertedList.parent();
					if (this.utils.isRedactorParent($listParent) && $listParent[0].tagName !== 'LI' && this.utils.isBlock($listParent))
					{
						this.selection.save();

						$listParent.replaceWith($listParent.contents());

						this.selection.restore();
					}

				},
				get: function()
				{
					var current = this.selection.current();
					var $list = $(current).closest('ul, ol', this.core.editor()[0]);

					return ($list.length === 0) ? false : $list;
				},
				combineAfterAndBefore: function(block)
				{
    				var $prev = $(block).prev();
    				var $next = $(block).next();
                    var isEmptyBlock = (block && block.tagName === 'P' && (block.innerHTML === '<br>' || block.innerHTML === ''));
                    var isBlockWrapped = ($prev.closest('ol, ul', this.core.editor()[0]).length === 1 && $next.closest('ol, ul', this.core.editor()[0]).length === 1);

                    if (isEmptyBlock && isBlockWrapped)
                    {
                        $prev.children('li').last().append(this.marker.get());
                        $prev.append($next.contents());
                        this.selection.restore();

                        return true;
                    }

                    return false;

				}
			};
		},

		// =marker
		marker: function()
		{
			return {

				// public
				get: function(num)
				{
					num = (typeof num === 'undefined') ? 1 : num;

					var marker = document.createElement('span');

					marker.id = 'selection-marker-' + num;
					marker.className = 'redactor-selection-marker';
					marker.innerHTML = this.opts.invisibleSpace;

					return marker;
				},
				html: function(num)
				{
					return this.utils.getOuterHtml(this.marker.get(num));
				},
				find: function(num)
				{
					num = (typeof num === 'undefined') ? 1 : num;

					return this.core.editor().find('span#selection-marker-' + num);
				},
				insert: function()
				{
					var sel = this.selection.get();
					var range = this.selection.range(sel);

					this.marker.insertNode(range, this.marker.get(1), true);
					if (range && range.collapsed === false)
					{
						this.marker.insertNode(range, this.marker.get(2), false);
					}

				},
				remove: function()
				{
					this.core.editor().find('.redactor-selection-marker').each(this.marker.iterateRemove);
				},

				// private
				insertNode: function(range, node, collapse)
				{
					var parent = this.selection.parent();
					if (range === null || $(parent).closest('.redactor-in').length === 0)
					{
						return;
					}

					range = range.cloneRange();

					try {
						range.collapse(collapse);
						range.insertNode(node);
					}
					catch (e)
					{
						this.focus.start();
					}
				},
				iterateRemove: function(i, el)
				{
					var $el = $(el);
					var text = $el.text().replace(/\u200B/g, '');

					return (text === '') ? $el.remove() : $el.replaceWith(function() { return $(this).contents(); });
				}
			};
		},

		// =modal
		modal: function()
		{
			return {
				callbacks: {},
				templates: function()
				{
					this.opts.modal = {
						'image-edit': String()
						+ '<div class="redactor-modal-tab redactor-group" data-title="General">'
							+ '<div id="redactor-image-preview" class="redactor-modal-tab-side">'
							+ '</div>'
							+ '<div class="redactor-modal-tab-area">'
								+ '<section>'
									+ '<label>' + this.lang.get('title') + '</label>'
									+ '<input type="text" id="redactor-image-title" />'
								+ '</section>'
								+ '<section>'
									+ '<label>' + this.lang.get('caption') + '</label>'
									+ '<input type="text" id="redactor-image-caption" aria-label="' + this.lang.get('caption') + '" />'
								+ '</section>'
								+ '<section>'
									+ '<label>' + this.lang.get('link') + '</label>'
									+ '<input type="text" id="redactor-image-link" aria-label="' + this.lang.get('link') + '" />'
								+ '</section>'
								+ '<section>'
        							+ '<label class="redactor-image-position-option">' + this.lang.get('image-position') + '</label>'
        							+ '<select class="redactor-image-position-option" id="redactor-image-align" aria-label="' + this.lang.get('image-position') + '">'
        								+ '<option value="none">' + this.lang.get('none') + '</option>'
        								+ '<option value="left">' + this.lang.get('left') + '</option>'
        								+ '<option value="center">' + this.lang.get('center') + '</option>'
        								+ '<option value="right">' + this.lang.get('right') + '</option>'
        							+ '</select>'
								+ '</section>'
								+ '<section>'
									+ '<label class="checkbox"><input type="checkbox" id="redactor-image-link-blank" aria-label="' + this.lang.get('link-in-new-tab') + '"> ' + this.lang.get('link-in-new-tab') + '</label>'
								+ '</section>'
								+ '<section>'
									+ '<button id="redactor-modal-button-action">' + this.lang.get('insert') + '</button>'
									+ '<button id="redactor-modal-button-cancel">' + this.lang.get('cancel') + '</button>'
									+ '<button id="redactor-modal-button-delete" class="redactor-modal-button-offset">' + this.lang.get('delete') + '</button>'
								+ '</section>'
							+ '</div>'
						+ '</div>',

						'image': String()
						+ '<div class="redactor-modal-tab" data-title="Upload">'
							+ '<section>'
								+ '<div id="redactor-modal-image-droparea"></div>'
	 						+ '</section>'
 						+ '</div>',

						'file': String()
						+ '<div class="redactor-modal-tab" data-title="Upload">'
							+ '<section>'
								+ '<label>' + this.lang.get('filename') + ' <span class="desc">(' + this.lang.get('optional') + ')</span></label>'
								+ '<input type="text" id="redactor-filename" aria-label="' + this.lang.get('filename') + '" /><br><br>'
							+ '</section>'
							+ '<section>'
								+ '<div id="redactor-modal-file-upload"></div>'
							+ '</section>'
						+ '</div>',

						'link': String()
						+ '<div class="redactor-modal-tab" data-title="General">'
							+ '<section>'
								+ '<label>URL</label>'
								+ '<input type="url" id="redactor-link-url" aria-label="URL" />'
							+ '</section>'
							+ '<section>'
								+ '<label>' + this.lang.get('text') + '</label>'
								+ '<input type="text" id="redactor-link-url-text" aria-label="' + this.lang.get('text') + '" />'
							+ '</section>'
							+ '<section>'
								+ '<label class="checkbox"><input type="checkbox" id="redactor-link-blank"> ' + this.lang.get('link-in-new-tab') + '</label>'
							+ '</section>'
							+ '<section>'
								+ '<button id="redactor-modal-button-action">' + this.lang.get('insert') + '</button>'
								+ '<button id="redactor-modal-button-cancel">' + this.lang.get('cancel') + '</button>'
							+ '</section>'
						+ '</div>'
					};

					$.extend(this.opts, this.opts.modal);

				},
				addCallback: function(name, callback)
				{
					this.modal.callbacks[name] = callback;
				},
				addTemplate: function(name, template)
				{
					this.opts.modal[name] = template;
				},
				getTemplate: function(name)
				{
					return this.opts.modal[name];
				},
				getModal: function()
				{
					return this.$modalBody;
				},
				getActionButton: function()
				{
					return this.$modalBody.find('#redactor-modal-button-action');
				},
				getCancelButton: function()
				{
					return this.$modalBody.find('#redactor-modal-button-cancel');
				},
				getDeleteButton: function()
				{
					return this.$modalBody.find('#redactor-modal-button-delete');
				},
				load: function(templateName, title, width)
				{
					if (typeof this.$modalBox !== 'undefined' && this.$modalBox.hasClass('open'))
					{
						return;
					}

					this.modal.templateName = templateName;
					this.modal.width = width;

					this.modal.build();
					this.modal.enableEvents();
					this.modal.setTitle(title);
					this.modal.setDraggable();
					this.modal.setContent();

					// callbacks
					if (typeof this.modal.callbacks[templateName] !== 'undefined')
					{
						this.modal.callbacks[templateName].call(this);
					}

				},
				show: function()
				{

					if (!this.detect.isDesktop())
					{
						document.activeElement.blur();
					}

					this.selection.save();
					this.modal.buildTabber();

					if (this.detect.isMobile())
					{
						this.modal.width = '96%';
					}

					// resize
					setTimeout($.proxy(this.modal.buildWidth, this), 0);
					$(window).on('resize.redactor-modal', $.proxy(this.modal.buildWidth, this));


					this.$modalOverlay.redactorAnimation('fadeIn', {
						duration: 0.25
					});

					this.$modalBox.addClass('open').show();
					this.$modal.redactorAnimation('fadeIn', {
							timing: 'cubic-bezier(0.175, 0.885, 0.320, 1.105)'
						},
						$.proxy(function()
						{

							this.utils.saveScroll();
							this.utils.disableBodyScroll();

							// modal shown callback
							this.core.callback('modalOpened', this.modal.templateName, this.$modal);

							// fix bootstrap modal focus
							$(document).off('focusin.modal');

							// enter
							var $elements = this.$modal.find('input[type=text],input[type=url],input[type=email]');
							$elements.on('keydown.redactor-modal', $.proxy(this.modal.setEnter, this));

						}, this)
					);

				},
				buildWidth: function()
				{
					var windowHeight = $(window).height();
					var windowWidth = $(window).width();

					var number = (typeof this.modal.width === 'number');

					if (!number && this.modal.width.match(/%$/))
					{
						this.$modal.css({ 'width': this.modal.width, 'margin-bottom': '16px' });
					}
					else if (parseInt(this.modal.width) > windowWidth)
					{
						this.$modal.css({ 'width': '96%', 'margin-bottom': '2%' });
					}
					else
					{
						if (number)
						{
							this.modal.width += 'px';
						}

						this.$modal.css({ 'width': this.modal.width, 'margin-bottom': '16px' });
					}

					// margin top
					var height = this.$modal.outerHeight();
					var top = (windowHeight/2 - height/2) + 'px';

					if (this.detect.isMobile())
					{
						top = '2%';
					}
					else if (height > windowHeight)
					{
						top = '16px';

					}

					this.$modal.css('margin-top', top);
				},
				buildTabber: function()
				{
					this.modal.tabs = this.$modal.find('.redactor-modal-tab');

					if (this.modal.tabs.length < 2)
					{
						return;
					}

					this.modal.$tabsBox = $('<div id="redactor-modal-tabber" />');
					$.each(this.modal.tabs, $.proxy(function(i,s)
					{
						var a = $('<a href="#" rel="' + i + '" />').text($(s).attr('data-title'));

						a.on('click', $.proxy(this.modal.showTab, this));

						if (i === 0)
						{
							a.addClass('active');
						}

						this.modal.$tabsBox.append(a);

					}, this));

					this.$modalBody.prepend(this.modal.$tabsBox);

				},
				showTab: function(e)
				{
					e.preventDefault();

					var $el = $(e.target);
					var index = $el.attr('rel');

					this.modal.tabs.hide();
					this.modal.tabs.eq(index).show();

					$('#redactor-modal-tabber').find('a').removeClass('active');
					$el.addClass('active');

					return false;

				},
				setTitle: function(title)
				{
					this.$modalHeader.html(title);
				},
				setContent: function()
				{
					this.$modalBody.html(this.modal.getTemplate(this.modal.templateName));

					this.modal.getCancelButton().on('mousedown', $.proxy(this.modal.close, this));
				},
				setDraggable: function()
				{
					if (typeof $.fn.draggable === 'undefined')
					{
						return;
					}

					this.$modal.draggable({ handle: this.$modalHeader });
					this.$modalHeader.css('cursor', 'move');
				},
				setEnter: function(e)
				{
					if (e.which !== 13)
					{
						return;
					}

					e.preventDefault();
					this.modal.getActionButton().click();
				},
				build: function()
				{
					this.modal.buildOverlay();

					this.$modalBox = $('<div id="redactor-modal-box"/>').hide();
					this.$modal = $('<div id="redactor-modal" role="dialog" />');
					this.$modalHeader = $('<div id="redactor-modal-header" />');
					this.$modalClose = $('<button type="button" id="redactor-modal-close" aria-label="' + this.lang.get('close') + '" />').html('&times;');
					this.$modalBody = $('<div id="redactor-modal-body" />');

					this.$modal.append(this.$modalHeader);
					this.$modal.append(this.$modalBody);
					this.$modal.append(this.$modalClose);
					this.$modalBox.append(this.$modal);
					this.$modalBox.appendTo(document.body);

				},
				buildOverlay: function()
				{
					this.$modalOverlay = $('<div id="redactor-modal-overlay">').hide();
					$('body').prepend(this.$modalOverlay);
				},
				enableEvents: function()
				{
					this.$modalClose.on('mousedown.redactor-modal', $.proxy(this.modal.close, this));
					$(document).on('keyup.redactor-modal', $.proxy(this.modal.closeHandler, this));
					this.core.editor().on('keyup.redactor-modal', $.proxy(this.modal.closeHandler, this));
					this.$modalBox.on('click.redactor-modal', $.proxy(this.modal.close, this));
				},
				disableEvents: function()
				{
					this.$modalClose.off('mousedown.redactor-modal');
					$(document).off('keyup.redactor-modal');
					this.core.editor().off('keyup.redactor-modal');
					this.$modalBox.off('click§.redactor-modal');
					$(window).off('resize.redactor-modal');
				},
				closeHandler: function(e)
				{
					if (e.which !== this.keyCode.ESC)
					{
						return;
					}

					this.modal.close(false);
				},
				close: function(e)
				{
					if (e)
					{
						if ($(e.target).attr('id') !== 'redactor-modal-button-cancel' && e.target !== this.$modalClose[0] && e.target !== this.$modalBox[0])
						{
							return;
						}

						e.preventDefault();
					}

					if (!this.$modalBox)
					{
						return;
					}

					// restore selection
					this.selection.restore();

					this.modal.disableEvents();
					this.utils.enableBodyScroll();
					this.utils.restoreScroll();

					this.$modalOverlay.redactorAnimation('fadeOut', { duration: 0.4 }, $.proxy(function()
					{
						this.$modalOverlay.remove();

					}, this));

					this.$modal.redactorAnimation('fadeOut', {

						duration: 0.3,
						timing: 'cubic-bezier(0.175, 0.885, 0.320, 1.175)'

					}, $.proxy(function()
					{
						if (typeof this.$modalBox !== 'undefined')
						{
							this.$modalBox.remove();
							this.$modalBox = undefined;
						}

						$(document.body).css('overflow', this.modal.bodyOveflow);
						this.core.callback('modalClosed', this.modal.templateName);

					}, this));

				}
			};
		},

		// =observe
		observe: function()
		{
			return {
				load: function()
				{
					if (typeof this.opts.destroyed !== 'undefined')
					{
						return;
					}

					this.observe.links();
					this.observe.images();

				},
				isCurrent: function($el, $current)
				{
					if (typeof $current === 'undefined')
					{
						$current = $(this.selection.current());
					}

					return $current.is($el) || $current.parents($el).length > 0;
				},
				toolbar: function()
				{
					this.observe.buttons();
					this.observe.dropdowns();
				},
				buttons: function(e, btnName)
				{
					var current = this.selection.current();
					var parent = this.selection.parent();

					if (e !== false)
					{
						this.button.setInactiveAll();
					}
					else
					{
						this.button.setInactiveAll(btnName);
					}

					if (e === false && btnName !== 'html')
					{
						if ($.inArray(btnName, this.opts.activeButtons) !== -1)
						{
							this.button.toggleActive(btnName);
						}

						return;
					}

					if (!this.utils.isRedactorParent(current))
					{
						return;
					}

					// disable line
					if (this.utils.isCurrentOrParentHeader() || this.utils.isCurrentOrParent(['table', 'pre', 'blockquote', 'li']))
					{
						this.button.disable('horizontalrule');
					}
					else
					{
						this.button.enable('horizontalrule');
					}


					$.each(this.opts.activeButtonsStates, $.proxy(function(key, value)
					{
						var parentEl = $(parent).closest(key, this.$editor[0]);
						var currentEl = $(current).closest(key, this.$editor[0]);

						if (parentEl.length !== 0 && !this.utils.isRedactorParent(parentEl))
						{
							return;
						}

						if (!this.utils.isRedactorParent(currentEl))
						{
							return;
						}

						if (parentEl.length !== 0 || currentEl.closest(key, this.$editor[0]).length !== 0)
						{
							this.button.setActive(value);
						}

					}, this));

				},
				dropdowns: function()
				{
    				var finded = $('<div />').html(this.selection.html()).find('a').length;
					var $current = $(this.selection.current());
					var isRedactor = this.utils.isRedactorParent($current);

					$.each(this.opts.observe.dropdowns, $.proxy(function(key, value)
					{
						var observe = value.observe,
							element = observe.element,
							$item   = value.item,
							inValues = typeof observe['in'] !== 'undefined' ? observe['in'] : false,
							outValues = typeof observe.out !== 'undefined' ? observe.out : false;

						if (($current.closest(element).length > 0 && isRedactor) || (element === 'a' && finded !== 0))
						{
							this.observe.setDropdownProperties($item, inValues, outValues);
						}
						else
						{
							this.observe.setDropdownProperties($item, outValues, inValues);
						}

					}, this));
				},
				setDropdownProperties: function($item, addProperties, deleteProperties)
				{
					if (deleteProperties && typeof deleteProperties.attr !== 'undefined')
					{
						this.observe.setDropdownAttr($item, deleteProperties.attr, true);
					}

					if (typeof addProperties.attr !== 'undefined')
					{
						this.observe.setDropdownAttr($item, addProperties.attr);
					}

					if (typeof addProperties.title !== 'undefined')
					{
						$item.find('span').text(addProperties.title);
					}
				},
				setDropdownAttr: function($item, properties, isDelete)
				{
					$.each(properties, function(key, value)
					{
						if (key === 'class')
						{
							if (!isDelete)
							{
								$item.addClass(value);
							}
							else
							{
								$item.removeClass(value);
							}
						}
						else
						{
							if (!isDelete)
							{
								$item.attr(key, value);
							}
							else
							{
								$item.removeAttr(key);
							}
						}
					});
				},
				addDropdown: function($item, btnName, btnObject)
				{
					if (typeof btnObject.observe === "undefined")
					{
						return;
					}

					btnObject.item = $item;

					this.opts.observe.dropdowns.push(btnObject);
				},
				images: function()
				{
                    if (this.opts.imageEditable)
                    {
                        this.core.editor().addClass('redactor-layer-img-edit');
    					this.core.editor().find('img').each($.proxy(function(i, img)
    					{
    						var $img = $(img);

    						// IE fix (when we clicked on an image and then press backspace IE does goes to image's url)
    						$img.closest('a', this.$editor[0]).on('click', function(e) { e.preventDefault(); });

    						this.image.setEditable($img);


    					}, this));
                    }
				},
				links: function()
				{
					if (this.opts.linkTooltip)
					{
    					this.core.editor().find('a').each($.proxy(function(i, s)
    					{
        					var $link = $(s);
        					if ($link.data('cached') !== true)
        					{
            					$link.data('cached', true);
            					$link.on('touchstart.redactor.' + this.uuid + ' click.redactor.' + this.uuid, $.proxy(this.observe.showTooltip, this));
        					}

    					}, this));
					}
				},
				getTooltipPosition: function($link)
				{
					return $link.offset();
				},
				showTooltip: function(e)
				{
					var $el = $(e.target);

					if ($el[0].tagName === 'IMG')
					{
						return;
					}

					if ($el[0].tagName !== 'A')
					{
						$el = $el.closest('a', this.$editor[0]);
					}

					if ($el[0].tagName !== 'A')
					{
						return;
					}

					var $link = $el;

					var pos = this.observe.getTooltipPosition($link);
					var tooltip = $('<span class="redactor-link-tooltip"></span>');

					var href = $link.attr('href');
					if (href === undefined)
					{
						href = '';
					}

					if (href.length > 24)
					{
						href = href.substring(0, 24) + '...';
					}

					var aLink = $('<a href="' + $link.attr('href') + '" target="_blank" />').html(href).addClass('redactor-link-tooltip-action');
					var aEdit = $('<a href="#" />').html(this.lang.get('edit')).on('click', $.proxy(this.link.show, this)).addClass('redactor-link-tooltip-action');
					var aUnlink = $('<a href="#" />').html(this.lang.get('unlink')).on('click', $.proxy(this.link.unlink, this)).addClass('redactor-link-tooltip-action');

					tooltip.append(aLink).append(' | ').append(aEdit).append(' | ').append(aUnlink);

					var lineHeight = parseInt($link.css('line-height'), 10);
                    var lineClicked = Math.ceil((e.pageY - pos.top)/lineHeight);
                    var top = pos.top + lineClicked * lineHeight;

					tooltip.css({
						top: top + 'px',
						left: pos.left + 'px'
					});

					$('.redactor-link-tooltip').remove();
					$('body').append(tooltip);

					this.core.editor().on('touchstart.redactor.' + this.uuid + ' click.redactor.' + this.uuid, $.proxy(this.observe.closeTooltip, this));
					$(document).on('touchstart.redactor.' + this.uuid + ' click.redactor.' + this.uuid, $.proxy(this.observe.closeTooltip, this));
				},
				closeAllTooltip: function()
				{
					$('.redactor-link-tooltip').remove();
				},
				closeTooltip: function(e)
				{
					e = e.originalEvent || e;

					var target = e.target;
					var $parent = $(target).closest('a', this.$editor[0]);
					if ($parent.length !== 0 && $parent[0].tagName === 'A' && target.tagName !== 'A')
					{
						return;
					}
					else if ((target.tagName === 'A' && this.utils.isRedactorParent(target)) || $(target).hasClass('redactor-link-tooltip-action'))
					{
						return;
					}

					this.observe.closeAllTooltip();

					this.core.editor().off('touchstart.redactor.' + this.uuid + ' click.redactor.' + this.uuid, $.proxy(this.observe.closeTooltip, this));
					$(document).off('touchstart.redactor.' + this.uuid + ' click.redactor.' + this.uuid, $.proxy(this.observe.closeTooltip, this));
				}

			};
		},

		// =offset
		offset: function()
		{
			return {
				get: function(node)
				{
					var cloned = this.offset.clone(node);
					if (cloned === false)
					{
						return 0;
					}

					var div = document.createElement('div');
					div.appendChild(cloned.cloneContents());
					div.innerHTML = div.innerHTML.replace(/<img(.*?[^>])>$/gi, 'i');

			        var text = $.trim($(div).text()).replace(/[\t\n\r\n]/g, '').replace(/\u200B/g, '');

					return text.length;

				},
				clone: function(node)
				{
					var sel = this.selection.get();
					var range = this.selection.range(sel);

					if (range === null && typeof node === 'undefined')
					{
						return false;
					}

					node = (typeof node === 'undefined') ? this.$editor : node;
					if (node === false)
					{
						return false;
					}

					node = node[0] || node;

					var cloned = range.cloneRange();
					cloned.selectNodeContents(node);
					cloned.setEnd(range.endContainer, range.endOffset);

					return cloned;
				},
				set: function(start, end)
				{
					end = (typeof end === 'undefined') ? start : end;

					if (!this.focus.is())
					{
						this.focus.start();
					}

					var sel = this.selection.get();
					var range = this.selection.range(sel);
					var node, offset = 0;
					var walker = document.createTreeWalker(this.$editor[0], NodeFilter.SHOW_TEXT, null, null);

					while ((node = walker.nextNode()) !== null)
					{
						offset += node.nodeValue.length;
						if (offset > start)
						{
							range.setStart(node, node.nodeValue.length + start - offset);
							start = Infinity;
						}

						if (offset >= end)
						{
							range.setEnd(node, node.nodeValue.length + end - offset);
							break;
						}
					}

					range.collapse(false);
					this.selection.update(sel, range);
				}
			};
		},

		// =paragraphize
		paragraphize: function()
		{
			return {
				load: function(html)
				{
					if (this.opts.paragraphize === false || this.opts.type === 'inline' || this.opts.type === 'pre')
					{
						return html;
					}

					if (html === '' || html === '<p></p>')
					{
						return this.opts.emptyHtml;
					}

					html = html + "\n";

					this.paragraphize.safes = [];
					this.paragraphize.z = 0;

					// before
					html = html.replace(/(<br\s?\/?>){1,}\n?<\/blockquote>/gi, '</blockquote>');
					html = html.replace(/<\/pre>/gi, "</pre>\n\n");
					html = html.replace(/<p>\s<br><\/p>/gi, '<p></p>');

					html = this.paragraphize.getSafes(html);

					html = html.replace('<br>', "\n");
					html = this.paragraphize.convert(html);

					html = this.paragraphize.clear(html);
					html = this.paragraphize.restoreSafes(html);

					// after
					html = html.replace(new RegExp('<br\\s?/?>\n?<(' + this.opts.paragraphizeBlocks.join('|') + ')(.*?[^>])>', 'gi'), '<p><br /></p>\n<$1$2>');

					return $.trim(html);
				},
				getSafes: function(html)
				{
					var $div = $('<div />').append(html);

					// remove paragraphs in blockquotes
					$div.find('blockquote p').replaceWith(function()
					{
						return $(this).append('<br />').contents();
					});

                    $div.find(this.opts.paragraphizeBlocks.join(', ')).each($.proxy(function(i,s)
					{
						this.paragraphize.z++;
						this.paragraphize.safes[this.paragraphize.z] = s.outerHTML;

						return $(s).replaceWith("\n#####replace" + this.paragraphize.z + "#####\n\n");


					}, this));

                    // deal with redactor selection markers
                    $div.find('span.redactor-selection-marker').each($.proxy(function(i,s)
                    {
                        this.paragraphize.z++;
                        this.paragraphize.safes[this.paragraphize.z] = s.outerHTML;

                        return $(s).replaceWith("\n#####replace" + this.paragraphize.z + "#####\n\n");
                    }, this));

					return $div.html();
				},
				restoreSafes: function(html)
				{
					$.each(this.paragraphize.safes, function(i,s)
					{
						s = (typeof s !== 'undefined') ? s.replace(/\$/g, '&#36;') : s;
						html = html.replace('#####replace' + i + '#####', s);

					});

					return html;
				},
				convert: function(html)
				{
					html = html.replace(/\r\n/g, "xparagraphmarkerz");
					html = html.replace(/\n/g, "xparagraphmarkerz");
					html = html.replace(/\r/g, "xparagraphmarkerz");

					var re1 = /\s+/g;
					html = html.replace(re1, " ");
					html = $.trim(html);

					var re2 = /xparagraphmarkerzxparagraphmarkerz/gi;
					html = html.replace(re2, "</p><p>");

					var re3 = /xparagraphmarkerz/gi;
					html = html.replace(re3, "<br>");

					html = '<p>' + html + '</p>';

					html = html.replace("<p></p>", "");
					html = html.replace("\r\n\r\n", "");
					html = html.replace(/<\/p><p>/g, "</p>\r\n\r\n<p>");
					html = html.replace(new RegExp("<br\\s?/?></p>", "g"), "</p>");
					html = html.replace(new RegExp("<p><br\\s?/?>", "g"), "<p>");
					html = html.replace(new RegExp("<p><br\\s?/?>", "g"), "<p>");
					html = html.replace(new RegExp("<br\\s?/?></p>", "g"), "</p>");
					html = html.replace(/<p>&nbsp;<\/p>/gi, "");
					html = html.replace(/<p>\s?<br>&nbsp;<\/p>/gi, '');
					html = html.replace(/<p>\s?<br>/gi, '<p>');

					return html;
				},
				clear: function(html)
				{

					html = html.replace(/<p>(.*?)#####replace(.*?)#####\s?<\/p>/gi, '<p>$1</p>#####replace$2#####');
					html = html.replace(/(<br\s?\/?>){2,}<\/p>/gi, '</p>');

					html = html.replace(new RegExp('</blockquote></p>', 'gi'), '</blockquote>');
					html = html.replace(new RegExp('<p></blockquote>', 'gi'), '</blockquote>');
					html = html.replace(new RegExp('<p><blockquote>', 'gi'), '<blockquote>');
					html = html.replace(new RegExp('<blockquote></p>', 'gi'), '<blockquote>');

					html = html.replace(new RegExp('<p><p ', 'gi'), '<p ');
					html = html.replace(new RegExp('<p><p>', 'gi'), '<p>');
					html = html.replace(new RegExp('</p></p>', 'gi'), '</p>');
					html = html.replace(new RegExp('<p>\\s?</p>', 'gi'), '');
					html = html.replace(new RegExp("\n</p>", 'gi'), '</p>');
					html = html.replace(new RegExp('<p>\t?\t?\n?<p>', 'gi'), '<p>');
					html = html.replace(new RegExp('<p>\t*</p>', 'gi'), '');

					return html;
				}
			};
		},

		// =paste
		paste: function()
		{
			return {
				init: function(e)
				{
					this.rtePaste = true;
					var pre = (this.opts.type === 'pre' || this.utils.isCurrentOrParent('pre')) ? true : false;

					// clipboard event
					if (this.detect.isDesktop())
					{
    					if (!this.paste.pre && this.opts.clipboardImageUpload && this.opts.imageUpload && this.paste.detectClipboardUpload(e))
    					{
    						if (this.detect.isIe())
    						{
    							setTimeout($.proxy(this.paste.clipboardUpload, this), 100);
    						}

    						return;
    					}
					}

					this.utils.saveScroll();
					this.selection.save();
					this.paste.createPasteBox(pre);

					$(window).on('scroll.redactor-freeze', $.proxy(function()
					{
						$(window).scrollTop(this.saveBodyScroll);

					}, this));

					setTimeout($.proxy(function()
					{
						var html = this.paste.getPasteBoxCode(pre);

						// buffer
						this.buffer.set();
						this.selection.restore();

						this.utils.restoreScroll();

						// paste info
						var data = this.clean.getCurrentType(html);

						// clean
						html = this.clean.onPaste(html, data);

						// callback
						var returned = this.core.callback('paste', html);
						html = (typeof returned === 'undefined') ? html : returned;

						this.paste.insert(html, data);
						this.rtePaste = false;

						// clean pre breaklines
						if (pre)
						{
							this.clean.cleanPre();
						}

						$(window).off('scroll.redactor-freeze');

					}, this), 1);

				},
				getPasteBoxCode: function(pre)
				{
					var html = (pre) ? this.$pasteBox.val() : this.$pasteBox.html();
					this.$pasteBox.remove();

					return html;
				},
				createPasteBox: function(pre)
				{
					var css = { position: 'fixed', width: '1px', top: 0, left: '-9999px' };

					this.$pasteBox = (pre) ? $('<textarea>').css(css) : $('<div>').attr('contenteditable', 'true').css(css);
					this.paste.appendPasteBox();
					this.$pasteBox.focus();
				},
				appendPasteBox: function()
				{
					if (this.detect.isIe())
					{
						this.core.box().append(this.$pasteBox);
					}
					else
					{
						// bootstrap modal
						var $visibleModals = $('.modal-body:visible');
						if ($visibleModals.length > 0)
						{
							$visibleModals.append(this.$pasteBox);
						}
						else
						{
							$('body').prepend(this.$pasteBox);
						}
					}
				},
				detectClipboardUpload: function(e)
				{
					e = e.originalEvent || e;

					var clipboard = e.clipboardData;

					if (this.detect.isIe())
					{
						return true;
					}

					if (this.detect.isFirefox())
					{
						return false;
					}

					// prevent safari fake url
					var types = clipboard.types;
					if (types.indexOf('public.tiff') !== -1)
					{
						e.preventDefault();
						return false;
					}


					if (!clipboard.items || !clipboard.items.length)
					{
						return;
					}

					var file = clipboard.items[0].getAsFile();
					if (file === null)
					{
						return false;
					}

					var reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = $.proxy(this.paste.insertFromClipboard, this);

					return true;
				},
				clipboardUpload: function()
				{
					var imgs = this.$editor.find('img');
					$.each(imgs, $.proxy(function(i,s)
					{
						if (s.src.search(/^data\:image/i) === -1)
						{
							return;
						}

						var formData = !!window.FormData ? new FormData() : null;
						if (!window.FormData)
						{
							return;
						}

						this.buffer.set();

						this.upload.direct = true;
						this.upload.type = 'image';
						this.upload.url = this.opts.imageUpload;
						this.upload.callback = $.proxy(function(data)
						{
							if (this.detect.isIe())
							{
								$(s).wrap($('<figure />'));
							}

							else
							{
								var $parent = $(s).parent();
								this.utils.replaceToTag($parent, 'figure');
							}

							s.src = data.url;
							this.core.callback('imageUpload', $(s), data);

						}, this);

						var blob = this.utils.dataURItoBlob(s.src);

						formData.append('clipboard', 1);
						formData.append(this.opts.imageUploadParam, blob);

						this.progress.show();
						this.upload.send(formData, false);
						this.code.sync();

					}, this));
				},
				insertFromClipboard: function(e)
				{
					var formData = !!window.FormData ? new FormData() : null;
					if (!window.FormData)
					{
						return;
					}

					this.buffer.set();

					this.upload.direct = true;
					this.upload.type = 'image';
					this.upload.url = this.opts.imageUpload;
					this.upload.callback = this.image.insert;

					var blob = this.utils.dataURItoBlob(e.target.result);

					formData.append('clipboard', 1);
					formData.append(this.opts.imageUploadParam, blob);

					this.progress.show();
					this.upload.send(formData, e);
				},
				insert: function(html, data)
				{
					if (data.pre)
					{
						this.insert.raw(html);
					}
					else if (data.text)
					{
						this.insert.text(html);
					}
					else
					{
						this.insert.html(html, data);
					}

					// Firefox Clipboard Observe
					if (this.detect.isFirefox() && this.opts.clipboardImageUpload)
					{
						setTimeout($.proxy(this.paste.clipboardUpload, this), 100);
					}

				}
			};
		},

		// =placeholder
		placeholder: function()
		{
			return {

				// public
				enable: function()
				{
					setTimeout($.proxy(function()
					{
						return (this.placeholder.isEditorEmpty()) ? this.placeholder.show() : this.placeholder.hide();

					}, this), 5);
				},
				show: function()
				{
					this.core.editor().addClass('redactor-placeholder');
				},
				update: function(text)
				{
					this.opts.placeholder = text;
					this.core.editor().attr('placeholder', text);
				},
				hide: function()
				{
					this.core.editor().removeClass('redactor-placeholder');
				},
				is: function()
				{
					return this.core.editor().hasClass('redactor-placeholder');
				},


				// private
				init: function()
				{
					if (!this.placeholder.enabled())
					{
						return;
					}

					if (!this.utils.isEditorRelative())
					{
						this.utils.setEditorRelative();
					}

					this.placeholder.build();
					this.placeholder.buildPosition();
					this.placeholder.enable();
					this.placeholder.enableEvents();

				},
				enabled: function()
				{
					return (this.opts.placeholder) ? this.core.element().attr('placeholder', this.opts.placeholder) : this.placeholder.isAttr();
				},
				enableEvents: function()
				{
					this.core.editor().on('keydown.redactor-placeholder.' + this.uuid, $.proxy(this.placeholder.enable, this));
				},
				disableEvents: function()
				{
					this.core.editor().off('.redactor-placeholder.' + this.uuid);
				},
				build: function()
				{
					this.core.editor().attr('placeholder', this.core.element().attr('placeholder'));
				},
				buildPosition: function()
				{
					var $style = $('<style />');
					$style.addClass('redactor-placeholder-style-tag');
					$style.html('#' + this.core.id() + '.redactor-placeholder::after ' + this.placeholder.getPosition());

					$('head').append($style);
				},
				getPosition: function()
				{
					return '{ top: ' + this.core.editor().css('padding-top') + '; left: ' + this.core.editor().css('padding-left') + '; }';
				},
				isEditorEmpty: function()
				{
					var html = $.trim(this.core.editor().html()).replace(/[\t\n]/g, '');
					var states = ['', '<p>​</p>', '<p>​<br></p>'];

					return ($.inArray(html, states) !== -1);
				},
				isAttr: function()
				{
					return (typeof this.core.element().attr('placeholder') !== 'undefined' && this.core.element().attr('placeholder') !== '');
				},
				destroy: function()
				{
					this.core.editor().removeAttr('placeholder');

					this.placeholder.hide();
					this.placeholder.disableEvents();

					$('.redactor-placeholder-style-tag').remove();
				}
			};
		},

		// =progress
		progress: function()
		{
			return {
				$box: null,
				$bar: null,
				target: document.body,  // or id selector

				// public
				show: function()
				{
					if (!this.progress.is())
					{
						this.progress.build();
						this.progress.$box.redactorAnimation('fadeIn');
					}
					else
					{
						this.progress.$box.show();
					}
				},
				hide: function()
				{
					if (this.progress.is())
					{
						this.progress.$box.redactorAnimation('fadeOut', { duration: 0.35 }, $.proxy(this.progress.destroy, this));
					}
				},
				update: function(value)
				{
					this.progress.show();
					this.progress.$bar.css('width', value + '%');
				},
				is: function()
				{
					return (this.progress.$box === null) ? false : true;
				},

				// private
				build: function()
				{
					this.progress.$bar = $('<span />');
					this.progress.$box = $('<div id="redactor-progress" />');

					this.progress.$box.append(this.progress.$bar);
					$(this.progress.target).append(this.progress.$box);
				},
				destroy: function()
				{
					if (this.progress.is())
					{
						this.progress.$box.remove();
					}

					this.progress.$box = null;
					this.progress.$bar = null;
				}
			};
		},

		// =selection
		selection: function()
		{
			return {
				get: function()
				{
					if (window.getSelection)
					{
						return window.getSelection();
					}
					else if (document.selection && document.selection.type !== "Control")
					{
						return document.selection;
					}

					return null;
				},
				range: function(sel)
				{
					if (typeof sel === 'undefined')
					{
						sel = this.selection.get();
					}

					if (sel.getRangeAt && sel.rangeCount)
					{
						return sel.getRangeAt(0);
					}

					return null;
				},
				is: function()
				{
					return (this.selection.isCollapsed()) ? false : true;
				},
				isRedactor: function()
				{
					var range = this.selection.range();

					if (range !== null)
					{
						var el = range.startContainer.parentNode;

						if ($(el).hasClass('redactor-in') || $(el).parents('.redactor-in').length !== 0)
						{
							return true;
						}
					}

					return false;
				},
				isCollapsed: function()
				{
					var sel = this.selection.get();

					return (sel === null) ? false : sel.isCollapsed;
				},
				update: function(sel, range)
				{
					if (range === null)
					{
						return;
					}

					sel.removeAllRanges();
					sel.addRange(range);
				},
				current: function()
				{
					var sel = this.selection.get();

					return (sel === null) ? false : sel.anchorNode;
				},
				parent: function()
				{
					var current = this.selection.current();

					return (current === null) ? false : current.parentNode;
				},
				block: function(node)
				{
					node = node || this.selection.current();

					while (node)
					{
						if (this.utils.isBlockTag(node.tagName))
						{
							return ($(node).hasClass('redactor-in')) ? false : node;
						}

						node = node.parentNode;
					}

					return false;
				},
				inline: function(node)
				{
					node = node || this.selection.current();

					while (node)
					{
						if (this.utils.isInlineTag(node.tagName))
						{
							return ($(node).hasClass('redactor-in')) ? false : node;
						}

						node = node.parentNode;
					}

					return false;
				},
				element: function(node)
				{
					if (!node)
					{
						node = this.selection.current();
					}

					while (node)
					{
						if (node.nodeType === 1)
						{
							if ($(node).hasClass('redactor-in'))
							{
								return false;
							}

							return node;
						}

						node = node.parentNode;
					}

					return false;
				},
				prev: function()
				{
					var current = this.selection.current();

					return (current === null) ? false : this.selection.current().previousSibling;
				},
				next: function()
				{
					var current = this.selection.current();

					return (current === null) ? false : this.selection.current().nextSibling;
				},
				blocks: function(tag)
				{
					var blocks = [];
					var nodes = this.selection.nodes(tag);

					$.each(nodes, $.proxy(function(i,node)
					{
						if (this.utils.isBlock(node))
						{
							blocks.push(node);
						}

					}, this));

					var block = this.selection.block();
					if (blocks.length === 0 && block === false)
					{
						return [];
					}
					else if (blocks.length === 0 && block !== false)
					{
						return [block];
					}
					else
					{
						return blocks;
					}

				},
				inlines: function(tag)
				{
					var inlines = [];
					var nodes = this.selection.nodes(tag);

					$.each(nodes, $.proxy(function(i,node)
					{
						if (this.utils.isInline(node))
						{
							inlines.push(node);
						}

					}, this));

					var inline = this.selection.inline();
					if (inlines.length === 0 && inline === false)
					{
						return [];
					}
					else if (inlines.length === 0 && inline !== false)
					{
						return [inline];
					}
					else
					{
						return inlines;
					}
				},
				nodes: function(tag)
				{
					var filter = (typeof tag === 'undefined') ? [] : (($.isArray(tag)) ? tag : [tag]);

					var sel = this.selection.get();
					var range = this.selection.range(sel);

					if (this.utils.isCollapsed())
					{
						return [this.selection.current()];
					}
					else
					{
						var node = range.startContainer;
						var endNode = range.endContainer;

						// single node
						if (node === endNode)
						{
							return [this.selection.parent()];
						}

						// iterate
						var nodes = [];
						while (node && node !== endNode)
						{
							nodes.push(node = this.selection.nextNode(node));
						}

						// partially selected nodes
						node = range.startContainer;
						while (node && node !== range.commonAncestorContainer)
						{
							nodes.unshift(node);
							node = node.parentNode;
						}

						// remove service nodes
						var resultNodes = [];
						$.each(nodes, function(i,s)
						{
    						if (s)
    						{
    							var tagName = (s.nodeType !== 1) ? false : s.tagName.toLowerCase();

    							if ($(s).hasClass('redactor-script-tag, redactor-selection-marker'))
    							{
    								return;
    							}
    							else if (tagName && filter.length !== 0 && $.inArray(tagName, filter) === -1)
    							{
    								return;
    							}
    							else
    							{
    								resultNodes.push(s);
    							}
							}
						});

						return (resultNodes.length === 0) ? [] : resultNodes;
					}

				},
				nextNode: function(node)
				{
					if (node.hasChildNodes())
					{
						return node.firstChild;
					}
					else
					{
						while (node && !node.nextSibling)
						{
							node = node.parentNode;
						}

						if (!node)
						{
							return null;
						}

						return node.nextSibling;
					}
				},
				save: function()
				{
 					this.marker.insert();
					this.savedSel = this.core.editor().html();
				},
				restore: function(removeMarkers)
				{
                    var node1 = this.marker.find(1);
					var node2 = this.marker.find(2);

					if (this.detect.isFirefox())
					{
						this.core.editor().focus();
					}

					if (node1.length !== 0 && node2.length !== 0)
					{
						this.caret.set(node1, node2);
					}
					else if (node1.length !== 0)
					{
						this.caret.start(node1);
					}
					else
					{
						this.core.editor().focus();
					}

					if (removeMarkers !== false)
					{
						this.marker.remove();
						this.savedSel = false;
					}
				},
                saveInstant: function()
                {
                    var el = this.core.editor()[0];
                    var doc = el.ownerDocument, win = doc.defaultView;
                    var sel = win.getSelection();

                    if (!sel.getRangeAt || !sel.rangeCount)
                    {
                        return;
                    }

                    var range = sel.getRangeAt(0);
                    var selectionRange = range.cloneRange();

                    selectionRange.selectNodeContents(el);
                    selectionRange.setEnd(range.startContainer, range.startOffset);

                    var start = selectionRange.toString().length;

                    this.saved = {
                        start: start,
                        end: start + range.toString().length,
                        node: range.startContainer
                    };

                    return this.saved;
                },
                restoreInstant: function(saved)
                {
                    if (typeof saved === 'undefined' && !this.saved)
                    {
                        return;
                    }

                    this.saved = (typeof saved !== 'undefined') ? saved : this.saved;

                    var $node = this.core.editor().find(this.saved.node);
                    if ($node.length !== 0 && $node.text().trim().replace(/\u200B/g, '').length === 0)
                    {
                       try {
                            var range = document.createRange();
                            range.setStart($node[0], 0);

                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                        catch(e) {}

                        return;
                    }

                    var el = this.core.editor()[0];
                    var doc = el.ownerDocument, win = doc.defaultView;
                    var charIndex = 0, range = doc.createRange();

                    range.setStart(el, 0);
                    range.collapse(true);

                    var nodeStack = [el], node, foundStart = false, stop = false;
                    while (!stop && (node = nodeStack.pop()))
                    {
                        if (node.nodeType == 3)
                        {
                            var nextCharIndex = charIndex + node.length;
                            if (!foundStart && this.saved.start >= charIndex && this.saved.start <= nextCharIndex)
                            {
                                range.setStart(node, this.saved.start - charIndex);
                                foundStart = true;
                            }

                            if (foundStart && this.saved.end >= charIndex && this.saved.end <= nextCharIndex)
                            {
                                range.setEnd(node, this.saved.end - charIndex);
                                stop = true;
                            }
                            charIndex = nextCharIndex;
                        }
                        else
                        {
                            var i = node.childNodes.length;
                            while (i--)
                            {
                                nodeStack.push(node.childNodes[i]);
                            }
                        }
                    }

                    var sel = win.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                },
				node: function(node)
				{
					$(node).prepend(this.marker.get(1));
					$(node).append(this.marker.get(2));

					this.selection.restore();
				},
				all: function()
				{
					this.core.editor().focus();

					var sel = this.selection.get();
					var range = this.selection.range(sel);

					range.selectNodeContents(this.core.editor()[0]);

					this.selection.update(sel, range);
				},
				remove: function()
				{
					this.selection.get().removeAllRanges();
				},
				replace: function(html)
				{
					this.insert.html(html);
				},
				text: function()
				{
					return this.selection.get().toString();
				},
				html: function()
				{
					var html = '';
					var sel = this.selection.get();

					if (sel.rangeCount)
					{
						var container = document.createElement('div');
						var len = sel.rangeCount;
						for (var i = 0; i < len; ++i)
						{
							container.appendChild(sel.getRangeAt(i).cloneContents());
						}

						html = this.clean.onGet(container.innerHTML);
					}

					return html;
				},
				extractEndOfNode: function(node)
				{
					var sel = this.selection.get();
					var range = this.selection.range(sel);

			        var clonedRange = range.cloneRange();
			        clonedRange.selectNodeContents(node);
			        clonedRange.setStart(range.endContainer, range.endOffset);

			        return clonedRange.extractContents();
				},

				// #backward
				removeMarkers: function()
				{
					this.marker.remove();
				},
				marker: function(num)
				{
					return this.marker.get(num);
				},
				markerHtml: function(num)
				{
					return this.marker.html(num);
				}

			};
		},

		// =shortcuts
		shortcuts: function()
		{
			return {
				// based on https://github.com/jeresig/jquery.hotkeys
				hotkeysSpecialKeys: {
					8: "backspace", 9: "tab", 10: "return", 13: "return", 16: "shift", 17: "ctrl", 18: "alt", 19: "pause",
					20: "capslock", 27: "esc", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home",
					37: "left", 38: "up", 39: "right", 40: "down", 45: "insert", 46: "del", 59: ";", 61: "=",
					96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7",
					104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111 : "/",
					112: "f1", 113: "f2", 114: "f3", 115: "f4", 116: "f5", 117: "f6", 118: "f7", 119: "f8",
					120: "f9", 121: "f10", 122: "f11", 123: "f12", 144: "numlock", 145: "scroll", 173: "-", 186: ";", 187: "=",
					188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
				},
				hotkeysShiftNums: {
					"`": "~", "1": "!", "2": "@", "3": "#", "4": "$", "5": "%", "6": "^", "7": "&",
					"8": "*", "9": "(", "0": ")", "-": "_", "=": "+", ";": ": ", "'": "\"", ",": "<",
					".": ">",  "/": "?",  "\\": "|"
				},
				init: function(e, key)
				{
					// disable browser's hot keys for bold and italic if shortcuts off
					if (this.opts.shortcuts === false)
					{
						if ((e.ctrlKey || e.metaKey) && (key === 66 || key === 73))
						{
							e.preventDefault();
						}

						return false;
					}
					else
					{
						// build
						$.each(this.opts.shortcuts, $.proxy(function(str, command)
						{
							this.shortcuts.build(e, str, command);

						}, this));
					}
				},
				build: function(e, str, command)
				{
					var handler = $.proxy(function()
					{
						this.shortcuts.buildHandler(command);

					}, this);

					var keys = str.split(',');
					var len = keys.length;
					for (var i = 0; i < len; i++)
					{
						if (typeof keys[i] === 'string')
						{
							this.shortcuts.handler(e, $.trim(keys[i]), handler);
						}
					}

				},
				buildHandler: function(command)
				{
					var func;
					if (command.func.search(/\./) !== '-1')
					{
						func = command.func.split('.');
						if (typeof this[func[0]] !== 'undefined')
						{
							this[func[0]][func[1]].apply(this, command.params);
						}
					}
					else
					{
						this[command.func].apply(this, command.params);
					}
				},
				handler: function(e, keys, origHandler)
				{
					keys = keys.toLowerCase().split(" ");

					var special = this.shortcuts.hotkeysSpecialKeys[e.keyCode];
					var character = String.fromCharCode(e.which).toLowerCase();
					var modif = "", possible = {};

					$.each([ "alt", "ctrl", "meta", "shift"], function(index, specialKey)
					{
						if (e[specialKey + 'Key'] && special !== specialKey)
						{
							modif += specialKey + '+';
						}
					});


					if (special)
					{
						possible[modif + special] = true;
					}

					if (character)
					{
						possible[modif + character] = true;
						possible[modif + this.shortcuts.hotkeysShiftNums[character]] = true;

						// "$" can be triggered as "Shift+4" or "Shift+$" or just "$"
						if (modif === "shift+")
						{
							possible[this.shortcuts.hotkeysShiftNums[character]] = true;
						}
					}

					var len = keys.length;
					for (var i = 0; i < len; i++)
					{
						if (possible[keys[i]])
						{
							e.preventDefault();
							return origHandler.apply(this, arguments);
						}
					}
				}
			};
		},

		// =storage
		storage: function()
		{
			return {
				data: [],
				add: function(data)
				{
					// type, node, url, id
					data.status = true;
					data.url = decodeURI(this.link.removeSelfHostFromUrl(data.url));

					this.storage.data[data.url] = data;
				},
				status: function(url, status)
				{
					this.storage.data[decodeURI(url)].status = status;
				},
				observe: function()
				{
					var _this = this;

					var $images = this.core.editor().find('[data-image]');
					$images.each(function(i, s)
					{
						_this.storage.add({ type: 'image', node: s, url: s.src, id: $(s).attr('data-image') });
					});

					var $files = this.core.editor().find('[data-file]');
					$files.each(function(i, s)
					{
						_this.storage.add({ type: 'file', node: s, url: s.href, id: $(s).attr('data-file') });
					});

					var $s3 = this.core.editor().find('[data-s3]');
					$s3.each(function(i, s)
					{
						var url = (s.tagName === 'IMG') ? s.src : s.href;
						_this.storage.add({ type: 's3', node: s, url: url, id: $(s).attr('data-s3') });
					});

				},
				changes: function()
				{
					for (var key in this.storage.data)
					{
						var data = this.storage.data[key];
						var attr = (data.node.tagName === 'IMG') ? 'src' : 'href';
						var $el = this.core.editor().find('[data-' + data.type + '][' + attr + '="' + data.url + '"]');

						if ($el.length === 0)
						{
							this.storage.status(data.url, false);
						}
						else
						{
							this.storage.status(data.url, true);
						}
					}


					return this.storage.data;
				}

			};
		},

		// =toolbar
		toolbar: function()
		{
			return {
				build: function()
				{
					this.button.hideButtons();
					this.button.hideButtonsOnMobile();

					this.$toolbar = this.toolbar.createContainer();

					this.toolbar.append();
					this.button.$toolbar = this.$toolbar;
					this.button.setFormatting();
					this.button.load(this.$toolbar);
					this.toolbar.setFixed();

				},
				createContainer: function()
				{
					return $('<ul>').addClass('redactor-toolbar').attr({ 'id': 'redactor-toolbar-' + this.uuid, 'role': 'toolbar' });
				},
				append: function()
				{
					if (this.opts.toolbarExternal)
					{
						this.$toolbar.addClass('redactor-toolbar-external');
						$(this.opts.toolbarExternal).html(this.$toolbar);
					}
					else
					{
						if (this.opts.type === 'textarea')
						{
							this.$box.prepend(this.$toolbar);
						}
						else
						{
							this.$element.before(this.$toolbar);
						}

					}
				},
				setFixed: function()
				{
					if (!this.opts.toolbarFixed || this.opts.toolbarExternal)
					{
						return;
					}

					if (this.opts.toolbarFixedTarget !== document)
					{
						var $el = $(this.opts.toolbarFixedTarget);
						this.toolbarOffsetTop = ($el.length === 0) ? 0 : this.core.box().offset().top - $el.offset().top;
					}

					// bootstrap modal fix
					var late = (this.core.box().closest('.modal-body').length !== 0) ? 1000 : 0;

					setTimeout($.proxy(function()
					{
    					var self = this;
						this.toolbar.observeScroll(false);
						if (this.detect.isDesktop())
						{
							$(this.opts.toolbarFixedTarget).on('scroll.redactor.' + this.uuid, function()
							{
                                if (self.core.editor().height() < 100 || self.placeholder.isEditorEmpty())
            					{
                					return;
            					}

    							self.toolbar.observeScroll();
                            });
						}
						else
						{
							$(this.opts.toolbarFixedTarget).on('scroll.redactor.' + this.uuid, function()
							{
                                if (self.core.editor().height() < 100 || self.placeholder.isEditorEmpty())
            					{
                					return;
            					}

								self.core.toolbar().hide();
								clearTimeout($.data(this, "scrollCheck"));
								$.data(this, "scrollCheck", setTimeout(function()
								{
									self.core.toolbar().show();
									self.toolbar.observeScroll();
								}, 250) );

							});
						}

					}, this), late);

				},
				getBoxTop: function()
				{
					return (this.opts.toolbarFixedTarget === document) ? this.core.box().offset().top : this.toolbar.toolbarOffsetTop;
				},
				observeScroll: function(start)
				{
					// tolerance 0 if redactor in the hidden layer
					var tolerance = 0;

					if (start !== false)
					{
						tolerance = (this.opts.toolbarFixedTarget === document) ? 20 : 0;
					}

					var scrollTop = $(this.opts.toolbarFixedTarget).scrollTop();
					var boxTop = this.toolbar.getBoxTop();

                    if (scrollTop === boxTop)
                    {
                        return;
                    }

					if ((scrollTop + this.opts.toolbarFixedTopOffset + tolerance) > boxTop)
					{
						this.toolbar.observeScrollEnable(scrollTop, boxTop);
					}
					else
					{
						this.toolbar.observeScrollDisable();
					}
				},
				observeScrollResize: function()
				{
					this.$toolbar.css({

						width: this.core.box().innerWidth(),
						left: this.core.box().offset().left

					});
				},
				observeScrollEnable: function(scrollTop, boxTop)
				{
					if (typeof this.fullscreen !== 'undefined' && this.fullscreen.isOpened === false)
					{
						this.toolbar.observeScrollDisable();
						return;
					}

					var end = boxTop + this.core.box().outerHeight() - 32;
					var width = this.core.box().innerWidth();

					var position = (this.detect.isDesktop()) ? 'fixed' : 'absolute';
					var top = (this.detect.isDesktop()) ? this.opts.toolbarFixedTopOffset : ($(this.opts.toolbarFixedTarget).scrollTop() - boxTop + this.opts.toolbarFixedTopOffset);
					var left = (this.detect.isDesktop()) ? this.core.box().offset().left : 0;

					if (this.opts.toolbarFixedTarget !== document)
					{
						 position = 'absolute';
						 top = this.opts.toolbarFixedTopOffset + $(this.opts.toolbarFixedTarget).scrollTop() - boxTop;
						 left = 0;
					}

					this.$toolbar.addClass('toolbar-fixed-box');

					this.$toolbar.css({
						position: position,
						width: width,
						top: top,
						left: left
					});


					if (scrollTop > end)
					{
						$('.redactor-dropdown-' + this.uuid + ':visible').hide();
					}

					this.toolbar.setDropdownsFixed();

					this.$toolbar.css('visibility', (scrollTop < end) ? 'visible' : 'hidden');
					$(window).on('resize.redactor-toolbar.' + this.uuid, $.proxy(this.toolbar.observeScrollResize, this));
				},
				observeScrollDisable: function()
				{
					this.$toolbar.css({
						position: 'relative',
						width: 'auto',
						top: 0,
						left: 0,
						visibility: 'visible'
					});

					this.toolbar.unsetDropdownsFixed();
					this.$toolbar.removeClass('toolbar-fixed-box');
					$(window).off('resize.redactor-toolbar.' + this.uuid);
				},
				setDropdownsFixed: function()
				{
					var position = (this.opts.toolbarFixedTarget === document && this.detect.isDesktop()) ? 'fixed' : 'absolute';
					this.toolbar.setDropdownPosition(position);
				},
				unsetDropdownsFixed: function()
				{
					this.toolbar.setDropdownPosition('absolute');
				},
				setDropdownPosition: function(position)
				{
					var self = this;
					$('.redactor-dropdown-' + this.uuid).each(function()
					{
						var $el = $(this);
						var $button = self.button.get($el.attr('rel'));
						var top = (position === 'fixed') ? self.opts.toolbarFixedTopOffset : $button.offset().top;

						$el.css({ position: position, top: ($button.innerHeight() + top) + 'px' });
					});
				}
			};
		},

		// =upload
		upload: function()
		{
			return {
				init: function(id, url, callback)
				{
					this.upload.direct = false;
					this.upload.callback = callback;
					this.upload.url = url;
					this.upload.$el = $(id);
					this.upload.$droparea = $('<div id="redactor-droparea" />');

					this.upload.$placeholdler = $('<div id="redactor-droparea-placeholder" />').text(this.lang.get('upload-label'));
					this.upload.$input = $('<input type="file" name="file" />');

					this.upload.$placeholdler.append(this.upload.$input);
					this.upload.$droparea.append(this.upload.$placeholdler);
					this.upload.$el.append(this.upload.$droparea);

					this.upload.$droparea.off('redactor.upload');
					this.upload.$input.off('redactor.upload');

					this.upload.$droparea.on('dragover.redactor.upload', $.proxy(this.upload.onDrag, this));
					this.upload.$droparea.on('dragleave.redactor.upload', $.proxy(this.upload.onDragLeave, this));

					// change
					this.upload.$input.on('change.redactor.upload', $.proxy(function(e)
					{
						e = e.originalEvent || e;
						this.upload.traverseFile(this.upload.$input[0].files[0], e);
					}, this));

					// drop
					this.upload.$droparea.on('drop.redactor.upload', $.proxy(function(e)
					{
						e.preventDefault();

						this.upload.$droparea.removeClass('drag-hover').addClass('drag-drop');
						this.upload.onDrop(e);

					}, this));
				},
				directUpload: function(file, e)
				{
					this.upload.direct = true;
					this.upload.traverseFile(file, e);
				},
				onDrop: function(e)
				{
					e = e.originalEvent || e;
					var files = e.dataTransfer.files;

					if (this.opts.multipleImageUpload)
					{
						var len = files.length;
						for (var i = 0; i < len; i++)
						{
							this.upload.traverseFile(files[i], e);
						}
					}
					else
					{
						this.upload.traverseFile(files[0], e);
					}
				},
				traverseFile: function(file, e)
				{
					if (this.opts.s3)
					{
						this.upload.setConfig(file);
						this.uploads3.send(file, e);
						return;
					}

					var formData = !!window.FormData ? new FormData() : null;
					if (window.FormData)
					{
						this.upload.setConfig(file);

						var name = (this.upload.type === 'image') ? this.opts.imageUploadParam : this.opts.fileUploadParam;
						formData.append(name, file);
					}

					this.progress.show();
					this.core.callback('uploadStart', e, formData);
					this.upload.send(formData, e);
				},
				setConfig: function(file)
				{
					this.upload.getType(file);

					if (this.upload.direct)
					{
						this.upload.url = (this.upload.type === 'image') ? this.opts.imageUpload : this.opts.fileUpload;
						this.upload.callback = (this.upload.type === 'image') ? this.image.insert : this.file.insert;
					}
				},
				getType: function(file)
				{
					this.upload.type = (this.opts.imageTypes.indexOf(file.type) === -1) ? 'file' : 'image';

					if (this.opts.imageUpload === null && this.opts.fileUpload !== null)
					{
						this.upload.type = 'file';
					}
				},
				getHiddenFields: function(obj, fd)
				{
					if (obj === false || typeof obj !== 'object')
					{
						return fd;
					}

					$.each(obj, $.proxy(function(k, v)
					{
						if (v !== null && v.toString().indexOf('#') === 0)
						{
							v = $(v).val();
						}

						fd.append(k, v);

					}, this));

					return fd;

				},
				send: function(formData, e)
				{
					// append hidden fields
					if (this.upload.type === 'image')
					{
						formData = this.utils.appendFields(this.opts.imageUploadFields, formData);
						formData = this.utils.appendForms(this.opts.imageUploadForms, formData);
						formData = this.upload.getHiddenFields(this.upload.imageFields, formData);
					}
					else
					{
						formData = this.utils.appendFields(this.opts.fileUploadFields, formData);
						formData = this.utils.appendForms(this.opts.fileUploadForms, formData);
						formData = this.upload.getHiddenFields(this.upload.fileFields, formData);
					}

					var xhr = new XMLHttpRequest();
					xhr.open('POST', this.upload.url);
					xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

					// complete
					xhr.onreadystatechange = $.proxy(function()
					{
					    if (xhr.readyState === 4)
					    {
					        var data = xhr.responseText;

							data = data.replace(/^\[/, '');
							data = data.replace(/\]$/, '');

							var json;
							try
							{
								json = (typeof data === 'string' ? JSON.parse(data) : data);
							}
							catch(err)
							{
								json = { error: true };
							}


							this.progress.hide();

							if (!this.upload.direct)
							{
								this.upload.$droparea.removeClass('drag-drop');
							}

							this.upload.callback(json, this.upload.direct, e);
					    }
					}, this);

					xhr.send(formData);
				},
				onDrag: function(e)
				{
					e.preventDefault();
					this.upload.$droparea.addClass('drag-hover');
				},
				onDragLeave: function(e)
				{
					e.preventDefault();
					this.upload.$droparea.removeClass('drag-hover');
				},
				clearImageFields: function()
				{
					this.upload.imageFields = {};
				},
				addImageFields: function(name, value)
				{
					this.upload.imageFields[name] = value;
				},
				removeImageFields: function(name)
				{
					delete this.upload.imageFields[name];
				},
				clearFileFields: function()
				{
					this.upload.fileFields = {};
				},
				addFileFields: function(name, value)
				{
					this.upload.fileFields[name] = value;
				},
				removeFileFields: function(name)
				{
					delete this.upload.fileFields[name];
				}
			};
		},

		// =s3
		uploads3: function()
		{
			return {
				send: function(file, e)
				{
					this.uploads3.executeOnSignedUrl(file, $.proxy(function(signedURL)
					{
						this.uploads3.sendToS3(file, signedURL, e);
					}, this));
				},
				executeOnSignedUrl: function(file, callback)
				{
					var xhr = new XMLHttpRequest();
					var mark = (this.opts.s3.search(/\?/) === -1) ? '?' : '&';

					xhr.open('GET', this.opts.s3 + mark + 'name=' + file.name + '&type=' + file.type, true);

					// hack to pass bytes through unprocessed.
					if (xhr.overrideMimeType)
					{
						xhr.overrideMimeType('text/plain; charset=x-user-defined');
					}

					var that = this;
					xhr.onreadystatechange = function(e)
					{
						if (this.readyState === 4 && this.status === 200)
						{
							that.progress.show();
							callback(decodeURIComponent(this.responseText));
						}
					};

					xhr.send();
				},
				createCORSRequest: function(method, url)
				{
					var xhr = new XMLHttpRequest();
					if ("withCredentials" in xhr)
					{
						xhr.open(method, url, true);
					}
					else if (typeof XDomainRequest !== "undefined")
					{
						xhr = new XDomainRequest();
						xhr.open(method, url);
					}
					else
					{
						xhr = null;
					}

					return xhr;
				},
				sendToS3: function(file, url, e)
				{
					var xhr = this.uploads3.createCORSRequest('PUT', url);
					if (!xhr)
					{
						return;
					}

					xhr.onload = $.proxy(function()
					{
						var json;

						this.progress.hide();

						if (xhr.status !== 200)
						{
							// error
							json = { error: true };
							this.upload.callback(json, this.upload.direct, xhr);

							return;
						}

						var s3file = url.split('?');

						if (!s3file[0])
						{
							 // url parsing is fail
							 return false;
						}


						if (!this.upload.direct)
						{
							this.upload.$droparea.removeClass('drag-drop');
						}

						json = { url: s3file[0], id: s3file[0], s3: true };
						if (this.upload.type === 'file')
						{
							var arr = s3file[0].split('/');
							json.name = arr[arr.length-1];
						}

						this.upload.callback(json, this.upload.direct, e);


					}, this);

					xhr.onerror = function() {};
					xhr.upload.onprogress = function(e) {};

					xhr.setRequestHeader('Content-Type', file.type);
					xhr.setRequestHeader('x-amz-acl', 'public-read');

					xhr.send(file);

				}
			};
		},

		// =utils
		utils: function()
		{
			return {
				isEmpty: function(html)
				{
					html = (typeof html === 'undefined') ? this.core.editor().html() : html;

					html = html.replace(/[\u200B-\u200D\uFEFF]/g, '');
					html = html.replace(/&nbsp;/gi, '');
					html = html.replace(/<\/?br\s?\/?>/g, '');
					html = html.replace(/\s/g, '');
					html = html.replace(/^<p>[^\W\w\D\d]*?<\/p>$/i, '');
					html = html.replace(/<iframe(.*?[^>])>$/i, 'iframe');
					html = html.replace(/<source(.*?[^>])>$/i, 'source');

					// remove empty tags
					html = html.replace(/<[^\/>][^>]*><\/[^>]+>/gi, '');
					html = html.replace(/<[^\/>][^>]*><\/[^>]+>/gi, '');

					html = $.trim(html);

					return html === '';
				},
				isElement: function(obj)
				{
					try {
						// Using W3 DOM2 (works for FF, Opera and Chrome)
						return obj instanceof HTMLElement;
					}
					catch(e)
					{
						return (typeof obj === "object") && (obj.nodeType === 1) && (typeof obj.style === "object") && (typeof obj.ownerDocument === "object");
					}
				},
				strpos: function(haystack, needle, offset)
				{
					var i = haystack.indexOf(needle, offset);
					return i >= 0 ? i : false;
				},
				dataURItoBlob: function(dataURI)
				{
					var byteString;
					if (dataURI.split(',')[0].indexOf('base64') >= 0)
					{
						byteString = atob(dataURI.split(',')[1]);
					}
					else
					{
						byteString = unescape(dataURI.split(',')[1]);
					}

					var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

					var ia = new Uint8Array(byteString.length);
					for (var i = 0; i < byteString.length; i++)
					{
						ia[i] = byteString.charCodeAt(i);
					}

					return new Blob([ia], { type:mimeString });
				},
				getOuterHtml: function(el)
				{
					return $('<div>').append($(el).eq(0).clone()).html();
				},
				cloneAttributes: function(from, to)
				{
					from = from[0] || from;
					to = $(to);

					var attrs = from.attributes;
					var len = attrs.length;
					while (len--)
					{
					    var attr = attrs[len];
					    to.attr(attr.name, attr.value);
					}

					return to;
				},
				breakBlockTag: function()
				{
					var block = this.selection.block();
					if (!block)
					{
    					return false;
					}

					var isEmpty = this.utils.isEmpty(block.innerHTML);

					var tag = block.tagName.toLowerCase();
					if (tag === 'pre' || tag === 'li' || tag === 'td' || tag === 'th')
					{
						return false;
					}


					if (!isEmpty && this.utils.isStartOfElement(block))
					{
						return { $block: $(block), $next: $(block).next(), type: 'start' };
					}
					else if (!isEmpty && this.utils.isEndOfElement(block))
					{
						return { $block: $(block), $next: $(block).next(), type: 'end' };
					}
					else
					{
						var endOfNode = this.selection.extractEndOfNode(block);
						var $nextPart = $('<' + tag + ' />').append(endOfNode);

						$nextPart = this.utils.cloneAttributes(block, $nextPart);
						$(block).after($nextPart);

						return { $block: $(block), $next: $nextPart, type: 'break' };
					}
				},
				// tag detection
				inBlocks: function(tags)
				{
					tags = ($.isArray(tags)) ? tags : [tags];

					var blocks = this.selection.blocks();
					var len = blocks.length;
					var contains = false;
					for (var i = 0; i < len; i++)
					{
						if (blocks[i] !== false)
						{
							var tag = blocks[i].tagName.toLowerCase();

							if ($.inArray(tag, tags) !== -1)
							{
								contains = true;
							}
						}
					}

					return contains;

				},
				inInlines: function(tags)
				{
					tags = ($.isArray(tags)) ? tags : [tags];

					var inlines = this.selection.inlines();
					var len = inlines.length;
					var contains = false;
					for (var i = 0; i < len; i++)
					{
						var tag = inlines[i].tagName.toLowerCase();

						if ($.inArray(tag, tags) !== -1)
						{
							contains = true;
						}
					}

					return contains;

				},
				isTag: function(current, tag)
				{
					var element = $(current).closest(tag, this.core.editor()[0]);
					if (element.length === 1)
					{
						return element[0];
					}

					return false;
				},
				isBlock: function(block)
				{
					if (block === null)
					{
						return false;
					}

					block = block[0] || block;

					return block && this.utils.isBlockTag(block.tagName);
				},
				isBlockTag: function(tag)
				{
					return (typeof tag === 'undefined') ? false : this.reIsBlock.test(tag);
				},
				isInline: function(inline)
				{
					inline = inline[0] || inline;

					return inline && this.utils.isInlineTag(inline.tagName);
				},
				isInlineTag: function(tag)
				{
					return (typeof tag === 'undefined') ? false : this.reIsInline.test(tag);
				},
				// parents detection
				isRedactorParent: function(el)
				{
					if (!el)
					{
						return false;
					}

					if ($(el).parents('.redactor-in').length === 0 || $(el).hasClass('redactor-in'))
					{
						return false;
					}

					return el;
				},
				isCurrentOrParentHeader: function()
				{
					return this.utils.isCurrentOrParent(['H1', 'H2', 'H3', 'H4', 'H5', 'H6']);
				},
				isCurrentOrParent: function(tagName)
				{
					var parent = this.selection.parent();
					var current = this.selection.current();

					if ($.isArray(tagName))
					{
						var matched = 0;
						$.each(tagName, $.proxy(function(i, s)
						{
							if (this.utils.isCurrentOrParentOne(current, parent, s))
							{
								matched++;
							}
						}, this));

						return (matched === 0) ? false : true;
					}
					else
					{
						return this.utils.isCurrentOrParentOne(current, parent, tagName);
					}
				},
				isCurrentOrParentOne: function(current, parent, tagName)
				{
					tagName = tagName.toUpperCase();

					return parent && parent.tagName === tagName ? parent : current && current.tagName === tagName ? current : false;
				},
				isEditorRelative: function()
				{
					var position = this.core.editor().css('position');
					var arr = ['absolute', 'fixed', 'relative'];

					return ($.inArray(arr, position) !== -1);
				},
				setEditorRelative: function()
				{
					this.core.editor().addClass('redactor-relative');
				},
				// scroll
				getScrollTarget: function()
				{
    				var $scrollTarget = $(this.opts.scrollTarget);

    				return ($scrollTarget.length !== 0) ? $scrollTarget : $(document);
				},
				freezeScroll: function()
				{
					this.freezeScrollTop = this.utils.getScrollTarget().scrollTop();
					this.utils.getScrollTarget().scrollTop(this.freezeScrollTop);
				},
				unfreezeScroll: function()
				{
					if (typeof this.freezeScrollTop === 'undefined')
					{
						return;
					}

					this.utils.getScrollTarget().scrollTop(this.freezeScrollTop);
				},
				saveScroll: function()
				{
					this.tmpScrollTop = this.utils.getScrollTarget().scrollTop();
				},
				restoreScroll: function()
				{
					if (typeof this.tmpScrollTop === 'undefined')
					{
						return;
					}

					this.utils.getScrollTarget().scrollTop(this.tmpScrollTop);
				},
				isStartOfElement: function(element)
				{
					if (typeof element === 'undefined')
					{
						element = this.selection.block();
						if (!element)
						{
							return false;
						}
					}

					return (this.offset.get(element) === 0) ? true : false;
				},
				isEndOfElement: function(element)
				{
					if (typeof element === 'undefined')
					{
						element = this.selection.block();
						if (!element)
						{
							return false;
						}
					}

					var text = $.trim($(element).text()).replace(/[\t\n\r\n]/g, '').replace(/\u200B/g, '');
					var offset = this.offset.get(element);

					return (offset === text.length) ? true : false;
				},
				removeEmptyAttr: function(el, attr)
				{
					var $el = $(el);
					if (typeof $el.attr(attr) === 'undefined')
					{
						return true;
					}

					if ($el.attr(attr) === '')
					{
						$el.removeAttr(attr);
						return true;
					}

					return false;
				},
				replaceToTag: function(node, tag)
				{
					var replacement;
					$(node).replaceWith(function()
					{
						replacement = $('<' + tag + ' />').append($(this).contents());

						for (var i = 0; i < this.attributes.length; i++)
						{
							replacement.attr(this.attributes[i].name, this.attributes[i].value);
						}

						return replacement;
					});

					return replacement;
				},
				// select all
				isSelectAll: function()
				{
					return this.selectAll;
				},
				enableSelectAll: function()
				{
					this.selectAll = true;
				},
				disableSelectAll: function()
				{
					this.selectAll = false;
				},
				disableBodyScroll: function()
				{
					var $body = $('html');
					var windowWidth = window.innerWidth;
					if (!windowWidth)
					{
						var documentElementRect = document.documentElement.getBoundingClientRect();
						windowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
					}

					var isOverflowing = document.body.clientWidth < windowWidth;
					var scrollbarWidth = this.utils.measureScrollbar();

					$body.css('overflow', 'hidden');
					if (isOverflowing)
					{
						$body.css('padding-right', scrollbarWidth);
					}
				},
				measureScrollbar: function()
				{
					var $body = $('body');
					var scrollDiv = document.createElement('div');
					scrollDiv.className = 'redactor-scrollbar-measure';

					$body.append(scrollDiv);
					var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
					$body[0].removeChild(scrollDiv);
					return scrollbarWidth;
				},
				enableBodyScroll: function()
				{
					$('html').css({ 'overflow': '', 'padding-right': '' });
					$('body').remove('redactor-scrollbar-measure');
				},
				appendFields: function(appendFields, data)
				{
					if (!appendFields)
					{
						return data;
					}
					else if (typeof appendFields === 'object')
					{
    					$.each(appendFields, function(k, v)
    					{
    						if (v !== null && v.toString().indexOf('#') === 0)
    						{
        						v = $(v).val();
                            }

    						data.append(k, v);

    					});

    					return data;
					}

					var $fields = $(appendFields);
					if ($fields.length === 0)
					{
						return data;
					}
					else
					{
						var str = '';
						$fields.each(function()
						{
							data.append($(this).attr('name'), $(this).val());
						});

						return data;
					}
				},
				appendForms: function(appendForms, data)
				{
					if (!appendForms)
					{
						return data;
					}

					var $forms = $(appendForms);
					if ($forms.length === 0)
					{
						return data;
					}
					else
					{
						var formData = $forms.serializeArray();

						$.each(formData, function(z,f)
						{
							data.append(f.name, f.value);
						});

						return data;
					}
				},
				isRgb: function(str)
				{
                    return (str.search(/^rgb/i) === 0);
				},
				rgb2hex: function(rgb)
				{
                    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

                    return (rgb && rgb.length === 4) ? "#" +
                    ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
                    ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
                    ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
                },

				// #backward
				isCollapsed: function()
				{
					return this.selection.isCollapsed();
				},
				isMobile: function()
				{
					return this.detect.isMobile();
				},
				isDesktop: function()
				{
					return this.detect.isDesktop();
				},
				isPad: function()
				{
					return this.detect.isIpad();
				}

			};
		},

		// #backward
		browser: function()
		{
			return {
				webkit: function()
				{
					return this.detect.isWebkit();
				},
				ff: function()
				{
					return this.detect.isFirefox();
				},
				ie: function()
				{
					return this.detect.isIe();
				}
			};
		}
	};

	$(window).on('load.tools.redactor', function()
	{
		$('[data-tools="redactor"]').redactor();
	});

	// constructor
	Redactor.prototype.init.prototype = Redactor.prototype;

})(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);

(function($)
{
	$.fn.redactorAnimation = function(animation, options, callback)
	{
		return this.each(function()
		{
			new redactorAnimation(this, animation, options, callback);
		});
	};

	function redactorAnimation(element, animation, options, callback)
	{
		// default
		var opts = {
			duration: 0.5,
			iterate: 1,
			delay: 0,
			prefix: 'redactor-',
			timing: 'linear'
		};

		this.animation = animation;
		this.slide = (this.animation === 'slideDown' || this.animation === 'slideUp');
		this.$element = $(element);
		this.prefixes = ['', '-moz-', '-o-animation-', '-webkit-'];
		this.queue = [];

		// options or callback
		if (typeof options === 'function')
		{
			callback = options;
			this.opts = opts;
		}
		else
		{
			this.opts = $.extend(opts, options);
		}

		// slide
		if (this.slide)
		{
			this.$element.height(this.$element.height());
		}

		// init
		this.init(callback);

	}

	redactorAnimation.prototype = {

		init: function(callback)
		{
			this.queue.push(this.animation);

			this.clean();

			if (this.animation === 'show')
			{
				this.opts.timing = 'linear';
				this.$element.removeClass('hide').show();

				if (typeof callback === 'function')
				{
					callback(this);
				}
			}
			else if (this.animation === 'hide')
			{
				this.opts.timing = 'linear';
				this.$element.hide();

				if (typeof callback === 'function')
				{
					callback(this);
				}
			}
			else
			{
				this.animate(callback);
			}

		},
		animate: function(callback)
		{
			this.$element.addClass('redactor-animated').css('display', '').removeClass('hide');
			this.$element.addClass(this.opts.prefix + this.queue[0]);

			this.set(this.opts.duration + 's', this.opts.delay + 's', this.opts.iterate, this.opts.timing);

			var _callback = (this.queue.length > 1) ? null : callback;
			this.complete('AnimationEnd', $.proxy(function()
			{
				if (this.$element.hasClass(this.opts.prefix + this.queue[0]))
				{
					this.clean();
					this.queue.shift();

					if (this.queue.length)
					{
						this.animate(callback);
					}
				}

			}, this), _callback);
		},
		set: function(duration, delay, iterate, timing)
		{
			var len = this.prefixes.length;

			while (len--)
			{
				this.$element.css(this.prefixes[len] + 'animation-duration', duration);
				this.$element.css(this.prefixes[len] + 'animation-delay', delay);
				this.$element.css(this.prefixes[len] + 'animation-iteration-count', iterate);
				this.$element.css(this.prefixes[len] + 'animation-timing-function', timing);
			}

		},
		clean: function()
		{
			this.$element.removeClass('redactor-animated');
			this.$element.removeClass(this.opts.prefix + this.queue[0]);

			this.set('', '', '', '');

		},
		complete: function(type, make, callback)
		{
			this.$element.one(type.toLowerCase() + ' webkit' + type + ' o' + type + ' MS' + type, $.proxy(function()
			{
				if (typeof make === 'function')
				{
					make();
				}

				if (typeof callback === 'function')
				{
					callback(this);
				}

				// hide
				var effects = ['fadeOut', 'slideUp', 'zoomOut', 'slideOutUp', 'slideOutRight', 'slideOutLeft'];
				if ($.inArray(this.animation, effects) !== -1)
				{
					this.$element.css('display', 'none');
				}

				// slide
				if (this.slide)
				{
					this.$element.css('height', '');
				}

			}, this));

		}
	};

})(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);


// Make redactor work with webpack...
/* harmony default export */ __webpack_exports__["default"] = ($.fn.redactor);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "L161":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'Comprehension',
  props: {
    models: {
      type: Array,
      required: true
    },
    respondable: {
      type: Boolean
    }
  },
  methods: {
    save: function save(model) {
      model.DSSave();
    }
  }
};

/***/ }),

/***/ "LR4t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LdAm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LeFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VisualVocab/selector.vue
var selector = __webpack_require__("GX+T");
var selector_default = /*#__PURE__*/__webpack_require__.n(selector);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2396b925","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VisualVocab/selector.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector"},[_c('div',{staticClass:"label",on:{"click":_vm.toggleDrop}},[(_vm.selected)?_c('span',[_vm._v(_vm._s(_vm.selected.label))]):_c('span',{staticClass:"placeholder"},[_vm._v("Choose definition")]),_vm._v(" "),_c('div',{staticClass:"right-side-icon"},[_c('sprite',{attrs:{"name":"iconDownDir"}})],1)]),_vm._v(" "),(_vm.dropActive)?_c('ul',{staticClass:"drop"},[_vm._l((_vm.options),function(option){return _c('li',{key:option.id,on:{"click":function($event){_vm.select(option, $event)}}},[_vm._v("\n      "+_vm._s(option.label)+"\n    ")])}),_vm._v(" "),(_vm.selected)?_c('li',{staticClass:"clear",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.clear($event)}}},[_vm._v("Clear Definition")]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var VisualVocab_selector = (esExports);
// CONCATENATED MODULE: ./src/components/VisualVocab/selector.vue
function injectStyle (ssrContext) {
  __webpack_require__("DXb6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2396b925"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selector_default.a,
  VisualVocab_selector,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_VisualVocab_selector = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M+lj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bigben.15e0de5.jpg";

/***/ }),

/***/ "M0Gz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'page-not-found',
  routeConfig: {
    path: '*'
  },
  metaInfo: {
    title: "Page not Found"
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.$router.push({ name: 'assignments' });
    }, 3000);
  }
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
var App = __webpack_require__("xJD8");
var App_default = /*#__PURE__*/__webpack_require__.n(App);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56625ff0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"external-link-warning",rawName:"v-external-link-warning"}],attrs:{"id":"app"}},[(!_vm.$route.meta.public && (_vm.bypass || _vm.session.user))?_c('div',[(!_vm.$classicParams.embedMode)?_c('app-header',{attrs:{"trans":_vm.$route.meta.transHeader}}):_vm._e(),_vm._v(" "),_c('main',{class:{full: _vm.$route.meta.fullMainContainer}},[_c('router-view')],1)],1):(_vm.$route.meta.public)?_c('main',[_c('router-view')],1):_c('main'),_vm._v(" "),(_vm.session.user)?_c('session-warning',{attrs:{"session":_vm.session}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("f2BJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56625ff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App_default.a,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MDMS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MGhq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MODg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MXnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/comprehension.vue
var comprehension = __webpack_require__("L161");
var comprehension_default = /*#__PURE__*/__webpack_require__.n(comprehension);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ee5d49","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/comprehension.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ul',_vm._l((_vm.models),function(model,index){return _c('li',[_c('h4',[_vm._v("Question "+_vm._s(index+1)+" of "+_vm._s(_vm.models.length))]),_vm._v(" "),_c('p',{staticClass:"question",domProps:{"innerHTML":_vm._s(model.question.question)}}),_vm._v(" "),_c('radio-group',{attrs:{"options":model.question.options,"name":'comp'+index,"disabled":!_vm.respondable},on:{"input":function($event){_vm.save(model)}},model:{value:(model.response),callback:function ($$v) {_vm.$set(model, "response", $$v)},expression:"model.response"}},[_vm._l((model.question.options),function(option,index){return (!_vm.respondable && (option.correct || option.response==model.response))?_c('span',{class:['bullet', {correct: option.correct, incorrect: !option.correct}],attrs:{"slot":'bullet-'+index},slot:'bullet-'+index},[((option.correct))?_c('sprite',{attrs:{"name":"iconCheck"}}):_c('sprite',{attrs:{"name":"iconClose"}})],1):_vm._e()}),_vm._v(" "),_vm._l((model.question.options),function(option,index){return (!_vm.respondable)?_c('div',{staticClass:"explanation",attrs:{"slot":'lower-'+index},slot:'lower-'+index},[_vm._v("\n          "+_vm._s(option.explanation)+"\n        ")]):_vm._e()})],2)],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_comprehension = (esExports);
// CONCATENATED MODULE: ./src/components/_global/comprehension.vue
function injectStyle (ssrContext) {
  __webpack_require__("AT2c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30ee5d49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  comprehension_default.a,
  _global_comprehension,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_comprehension = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Mm8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-hourglass",
  "use": "icon-hourglass-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-hourglass\">\n    <!-- Generator: Sketch 49.2 (51160) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-hourglass</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-hourglass_icon-hourglass\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <path d=\"M17.1428571,1.42857143 C17.1428571,3.37054542 16.7466557,5.08741814 15.9542411,6.57924107 C15.1618264,8.07106401 14.1703929,9.21130558 12.9799107,10 C14.1703929,10.7886944 15.1618264,11.928936 15.9542411,13.4207589 C16.7466557,14.9125819 17.1428571,16.6294546 17.1428571,18.5714286 L18.2142857,18.5714286 C18.3184529,18.5714286 18.4040175,18.6049104 18.4709821,18.671875 C18.5379468,18.7388396 18.5714286,18.8244042 18.5714286,18.9285714 L18.5714286,19.6428571 C18.5714286,19.7470243 18.5379468,19.832589 18.4709821,19.8995536 C18.4040175,19.9665182 18.3184529,20 18.2142857,20 L1.78571429,20 C1.6815471,20 1.59598248,19.9665182 1.52901786,19.8995536 C1.46205324,19.832589 1.42857143,19.7470243 1.42857143,19.6428571 L1.42857143,18.9285714 C1.42857143,18.8244042 1.46205324,18.7388396 1.52901786,18.671875 C1.59598248,18.6049104 1.6815471,18.5714286 1.78571429,18.5714286 L2.85714286,18.5714286 C2.85714286,16.6294546 3.25334425,14.9125819 4.04575893,13.4207589 C4.8381736,11.928936 5.82960714,10.7886944 7.02008929,10 C5.82960714,9.21130558 4.8381736,8.07106401 4.04575893,6.57924107 C3.25334425,5.08741814 2.85714286,3.37054542 2.85714286,1.42857143 L1.78571429,1.42857143 C1.6815471,1.42857143 1.59598248,1.39508962 1.52901786,1.328125 C1.46205324,1.26116038 1.42857143,1.17559576 1.42857143,1.07142857 L1.42857143,0.357142857 C1.42857143,0.25297567 1.46205324,0.167411049 1.52901786,0.100446429 C1.59598248,0.033481808 1.6815471,3.55271368e-15 1.78571429,3.55271368e-15 L18.2142857,3.55271368e-15 C18.3184529,3.55271368e-15 18.4040175,0.033481808 18.4709821,0.100446429 C18.5379468,0.167411049 18.5714286,0.25297567 18.5714286,0.357142857 L18.5714286,1.07142857 C18.5714286,1.17559576 18.5379468,1.26116038 18.4709821,1.328125 C18.4040175,1.39508962 18.3184529,1.42857143 18.2142857,1.42857143 L17.1428571,1.42857143 Z M15.7142857,1.42857143 L4.28571429,1.42857143 C4.28571429,2.96131719 4.60193136,4.38987433 5.234375,5.71428571 L14.765625,5.71428571 C15.3980686,4.38987433 15.7142857,2.96131719 15.7142857,1.42857143 Z M15.078125,15 C14.6763373,13.9508876 14.135048,13.0524591 13.4542411,12.3046875 C12.7734341,11.5569159 12.049855,11.0267873 11.2834821,10.7142857 L8.71651786,10.7142857 C7.95014498,11.0267873 7.2265659,11.5569159 6.54575893,12.3046875 C5.86495195,13.0524591 5.32366272,13.9508876 4.921875,15 L15.078125,15 Z\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "N9x1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _2 = __webpack_require__("IcnI");

var _3 = _interopRequireDefault(_2);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _3.default.defineResource({
  name: "syncblastAsset",
  relations: {
    hasMany: {
      questions: [{
        localField: "questions",
        localKeys: "questionIds"
      }, {
        localField: "blastQuestionId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _lodash2.default.chain(instance.questions).find({ key: "syncblast" }).get("id").value();
        }
      }, {
        localField: "blastQuikPollId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _lodash2.default.chain(instance.questions).find({ key: "syncblast-poll" }).get("id").value();
        }
      }],
      media: [{
        localField: "media",
        localKeys: "mediaIds"
      }],
      blastBackgrounds: [{
        localField: "backgrounds",
        localKeys: "backgroundIds"
      }]
    },
    hasOne: {
      questions: [{
        localField: "blastQuestion",
        localKey: "blastQuestionId"
      }, {
        localField: "blastQuikPoll",
        localKey: "blastQuikPollId"
      }],
      media: [{
        localField: "backdropVideoId",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _lodash2.default.chain(instance.media).find({ key: "backdrop", type: "video" }).get("id").value();
        }
      }, {
        localField: "backdropVideo",
        localKey: "backdropVideoId"
      }]
    }
  },
  afterInject: function afterInject(resource, data) {
    // Give Vue's v-for something to use as a key.
    var id = 1;
    _lodash2.default.each(_lodash2.default.get(data, 'background.contentModules') || [], function (x) {
      return x.id = id++;
    });
  }
});

exports.default = resource;

/***/ }),

/***/ "ND/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppHeader/NavToggle.vue
var NavToggle = __webpack_require__("xfS/");
var NavToggle_default = /*#__PURE__*/__webpack_require__.n(NavToggle);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a834402","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/NavToggle.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li'),_c('li'),_c('li')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var AppHeader_NavToggle = (esExports);
// CONCATENATED MODULE: ./src/components/AppHeader/NavToggle.vue
function injectStyle (ssrContext) {
  __webpack_require__("uWGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a834402"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NavToggle_default.a,
  AppHeader_NavToggle,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_AppHeader_NavToggle = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NFsx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _freeze = __webpack_require__("u2KI");

var _freeze2 = _interopRequireDefault(_freeze);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _autoload = __webpack_require__("VONp");

var _autoload2 = _interopRequireDefault(_autoload);

var _bus = __webpack_require__("2zug");

var _bus2 = _interopRequireDefault(_bus);

var _classicParams = __webpack_require__("789/");

var _classicParams2 = _interopRequireDefault(_classicParams);

var _jqueryEasing = __webpack_require__("u2nA");

var _jqueryEasing2 = _interopRequireDefault(_jqueryEasing);

var _jqueryUi = __webpack_require__("rCzz");

var _jqueryUi2 = _interopRequireDefault(_jqueryUi);

var _lodash = __webpack_require__("HqjJ");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("5YSM");

var _moment2 = _interopRequireDefault(_moment);

var _router = __webpack_require__("hooP");

var _router2 = _interopRequireDefault(_router);

var _session = __webpack_require__("PDtk");

var _session2 = _interopRequireDefault(_session);

var _store3 = __webpack_require__("ov2f");

var _store4 = _interopRequireDefault(_store3);

var _styles = __webpack_require__("/pYs");

var _styles2 = _interopRequireDefault(_styles);

var _vueCountdown = __webpack_require__("6JIv");

var _vueCountdown2 = _interopRequireDefault(_vueCountdown);

var _vueFilters = __webpack_require__("6MUw");

var _vueFilters2 = _interopRequireDefault(_vueFilters);

var _vueMeta = __webpack_require__("3vri");

var _vueMeta2 = _interopRequireDefault(_vueMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initializers = {
  autoload: _autoload2.default,
  bus: _bus2.default,
  classicParams: _classicParams2.default,
  jqueryEasing: _jqueryEasing2.default,
  jqueryUi: _jqueryUi2.default,
  lodash: _lodash2.default,
  moment: _moment2.default,
  router: _router2.default,
  session: _session2.default,
  store: _store4.default,
  styles: _styles2.default,
  vueCountdown: _vueCountdown2.default,
  vueFilters: _vueFilters2.default,
  vueMeta: _vueMeta2.default
}; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

(0, _freeze2.default)(initializers);


_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: initializers.router,
  template: '<App v-if="appReady"/>',
  components: { App: _App2.default },
  data: function data() {
    return {
      appReady: false
    };
  },
  created: function created() {
    var _this = this;

    var required = _.chain(initializers).filter({ required: true }).map("onReady").value();
    _promise2.default.all(required).then(function () {
      _this.appReady = true;
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "NrOt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O0LQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OW3S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _2 = __webpack_require__("IcnI");

var _3 = _interopRequireDefault(_2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _3.default.defineResource({
  name: "assignments",
  relations: {
    belongsTo: {
      syncblastAsset: {
        localKey: "syncblastAssetId",
        localField: "syncblastAsset"
      }
    },
    hasOne: {
      rubrics: {
        localKey: "rubricsId",
        localField: "rubrics"
      },
      blastBackgrounds: {
        localKey: "blastBackgroundId",
        localField: "blastBackground"
      }
    },
    hasMany: {
      userAssignments: {
        localField: "userAssignments",
        foreignKey: "assignmentId"
      },
      questions: [{
        localField: "questions",
        localKeys: "questionIds"
      }, {
        localField: "compQuestionIds",
        get: function get(Resource, relationDef, instance, origGetter) {
          return _.chain(instance.questions).filter({ key: "sb-background" }).map("id").value();
        }
      }, {
        localField: "compQuestions",
        localKeys: "compQuestionIds"
      }]
    }
  }
});

exports.default = resource;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "Oi1/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AssignmentList = __webpack_require__("9/aY");

var _AssignmentList2 = _interopRequireDefault(_AssignmentList);

var _GeographyMasthead = __webpack_require__("tN/O");

var _GeographyMasthead2 = _interopRequireDefault(_GeographyMasthead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'Assignments',
  routeConfig: {
    name: "assignments", path: "/assignments", meta: { transHeader: true }
  },
  components: { AssignmentList: _AssignmentList2.default, GeographyMasthead: _GeographyMasthead2.default },
  metaInfo: {
    title: "Assignments"
  },
  data: function data() {
    return {
      ready: false,
      assignments: this.$store.filter('userAssignments'),
      // this app does not have infinite scrolling implemented
      // in future, if you get a bug report that says "student did not see given assignment",
      // see if they have exactly 100 assignments in the list and then increase this number.
      // alternatively, implement infinite scrolling
      assignmentsPromise: this.$store.findAll('userAssignments', { limit: 100 })
    };
  },
  created: function created() {
    var _this = this;

    this.assignmentsPromise.then(function (assignments) {
      _this.ready = true;
      _this.assignments = assignments;
    });
  }
};

/***/ }),

/***/ "OlF2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'rate',
  mixins: [_sidebar2.default]
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "P+2j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/romanforum.089f022.jpg";

/***/ }),

/***/ "P+uw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/peer-reviews.vue
var peer_reviews = __webpack_require__("Vobj");
var peer_reviews_default = /*#__PURE__*/__webpack_require__.n(peer_reviews);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45199f3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/peer-reviews.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.reviews),function(review){return _c('li',[_c('peer-review',{attrs:{"review":review,"display":_vm.display}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_peer_reviews = (esExports);
// CONCATENATED MODULE: ./src/components/_global/peer-reviews.vue
function injectStyle (ssrContext) {
  __webpack_require__("XhZW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45199f3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  peer_reviews_default.a,
  _global_peer_reviews,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_peer_reviews = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PD4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "logo-blasts",
  "use": "logo-blasts-usage",
  "viewBox": "0 0 220 33",
  "content": "<symbol viewBox=\"0 0 220 33\" id=\"logo-blasts\">\n    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->\n    <title>logo-blasts</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"logo-blasts_baasp-logo\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"logo-blasts_logo-blasts\">\n            <path d=\"M178.088387,26.1868051 C174.482822,26.1868051 171.873916,24.8970092 170.115104,23.0795697 L172.049798,20.4120374 C173.368907,21.8484009 175.508796,23.1381967 178.234955,23.1381967 C181.049055,23.1381967 182.133656,21.7604603 182.133656,20.4413509 C182.133656,16.3374551 170.760002,18.8877332 170.760002,11.7059155 C170.760002,8.45211236 173.574102,5.96046132 177.883192,5.96046132 C180.902487,5.96046132 183.394138,6.95712174 185.182264,8.71593424 L183.247571,11.2662124 C181.693953,9.71259465 179.612691,9.00906965 177.560744,9.00906965 C175.567423,9.00906965 174.277627,10.0057301 174.277627,11.4420936 C174.277627,15.1062863 185.651281,12.8491436 185.651281,20.1189019 C185.651281,23.3727051 183.335511,26.1868051 178.088387,26.1868051 Z\" id=\"logo-blasts_S\" fill=\"#4B4A4B\" />\n            <polygon id=\"logo-blasts_T\" fill=\"#4B4A4B\" points=\"197.171503 25.8350426 193.741819 25.8350426 193.741819 9.30220507 187.820483 9.30220507 187.820483 6.28291028 203.092838 6.28291028 203.092838 9.30220507 197.171503 9.30220507\" />\n            <path d=\"M211.974841,26.1868051 C208.369276,26.1868051 205.760371,24.8970092 204.001558,23.0795697 L205.936252,20.4120374 C207.255361,21.8484009 209.39525,23.1381967 212.121409,23.1381967 C214.935509,23.1381967 216.02011,21.7604603 216.02011,20.4413509 C216.02011,16.3374551 204.646456,18.8877332 204.646456,11.7059155 C204.646456,8.45211236 207.460556,5.96046132 211.769647,5.96046132 C214.788941,5.96046132 217.280592,6.95712174 219.068719,8.71593424 L217.134025,11.2662124 C215.580407,9.71259465 213.499146,9.00906965 211.447198,9.00906965 C209.453877,9.00906965 208.164081,10.0057301 208.164081,11.4420936 C208.164081,15.1062863 219.537735,12.8491436 219.537735,20.1189019 C219.537735,23.3727051 217.221965,26.1868051 211.974841,26.1868051 Z\" id=\"logo-blasts_S\" fill=\"#4B4A4B\" />\n            <path d=\"M168.971876,25.8350426 L165.073175,25.8350426 L163.636811,22.0535957 L154.666867,22.0535957 L153.230504,25.8350426 L149.331803,25.8350426 L157.011951,6.28291028 L161.291728,6.28291028 L168.971876,25.8350426 Z M162.669464,19.0343009 L159.151839,9.71259465 L155.634214,19.0343009 L162.669464,19.0343009 Z\" id=\"logo-blasts_A\" fill=\"#4B4A4B\" />\n            <polygon id=\"logo-blasts_L\" fill=\"#4B4A4B\" points=\"146.57633 25.8350426 134.528464 25.8350426 134.528464 6.28291028 137.958149 6.28291028 137.958149 22.8157478 146.57633 22.8157478\" />\n            <path d=\"M126.203419,25.8350426 L116.324755,25.8350426 L116.324755,6.28291028 L125.939597,6.28291028 C129.545162,6.28291028 131.50917,8.51073944 131.50917,11.2662124 C131.50917,13.6992363 129.926238,15.3701082 128.108799,15.7511842 C130.219374,16.0736332 131.890246,18.1548947 131.890246,20.5292915 C131.890246,23.5778999 129.896925,25.8350426 126.203419,25.8350426 Z M125.265385,14.3441342 C126.994884,14.3441342 127.991545,13.3181603 127.991545,11.8231697 C127.991545,10.3868061 126.994884,9.30220507 125.265385,9.30220507 L119.754439,9.30220507 L119.754439,14.3441342 L125.265385,14.3441342 Z M125.411953,22.8157478 C127.258706,22.8157478 128.372621,21.7897738 128.372621,20.0895884 C128.372621,18.6239113 127.346647,17.363429 125.411953,17.363429 L119.754439,17.363429 L119.754439,22.8157478 L125.411953,22.8157478 Z\" id=\"logo-blasts_B\" fill=\"#4B4A4B\" />\n            <path d=\"M103.941982,17.8911753 L111.15958,16.0504573 L103.926032,14.2739705 C103.441928,14.154992 103.276823,13.5506157 103.633328,13.2023019 L108.96365,7.99914822 L101.811146,10.0778232 C101.332215,10.2166314 100.887339,9.77563506 101.022267,9.29584136 L103.036711,2.12436961 L97.8814074,7.50081801 C97.5369733,7.86033998 96.9304416,7.70127091 96.8075834,7.21802855 L94.9668654,-1.42108547e-14 L93.1908096,7.23397857 C93.0714001,7.71808309 92.4670238,7.8831873 92.11871,7.52625182 L86.9159874,2.19549805 L88.9942313,9.34886438 C89.1334706,9.82736484 88.6924742,10.272672 88.2126805,10.1377435 L81.0416399,8.12243753 L86.4180883,13.2781722 C86.7780413,13.6234685 86.6181101,14.229138 86.1348677,14.3524273 L78.9172703,16.1931453 L86.1512488,17.9696321 C86.6357844,18.0886106 86.8000265,18.6929869 86.4435221,19.0413007 L81.1131994,24.2440233 L88.2661346,22.1657794 C88.7446351,22.0269712 89.1895112,22.4679675 89.0550138,22.9477612 L87.0401389,30.119233 L92.1954425,24.7427846 C92.5403077,24.3828315 93.1464082,24.5423317 93.2692665,25.025143 L95.1104155,32.2431715 L96.8869024,25.009624 C97.0054498,24.5255195 97.6102571,24.3604153 97.9581399,24.7169197 L103.160862,30.0481045 L101.082619,22.8947382 C100.94381,22.4162377 101.384376,21.9709306 101.8646,22.1058591 L109.03521,24.1211651 L103.659193,18.9654304 C103.299671,18.6201341 103.45874,18.0144646 103.941982,17.8911753\" id=\"logo-blasts_Blast\" fill=\"#0461A8\" />\n            <path d=\"M67.9574112,26.1868051 C62.1826435,26.1868051 57.6976716,22.0829092 57.6976716,16.0736332 C57.6976716,10.0350436 62.1826435,5.96046132 67.9574112,5.96046132 C71.8854258,5.96046132 74.3477633,7.98309569 75.7841268,10.328179 L72.8820862,11.8524832 C71.9440529,10.2109249 70.0386727,9.00906965 67.9574112,9.00906965 C64.0880237,9.00906965 61.2152966,11.9404238 61.2152966,16.0736332 C61.2152966,20.1482155 64.0880237,23.1381967 67.9574112,23.1381967 C70.0386727,23.1381967 71.9440529,21.907028 72.8820862,20.2947832 L75.8134404,21.7604603 C74.3184498,24.1055436 71.8854258,26.1868051 67.9574112,26.1868051 Z\" id=\"logo-blasts_C\" fill=\"#0461A8\" />\n            <polygon id=\"logo-blasts_N\" fill=\"#0461A8\" points=\"54.9715123 25.8350426 51.659082 25.8350426 41.4579695 11.8524832 41.4579695 25.8350426 38.0282852 25.8350426 38.0282852 6.28291028 41.5459102 6.28291028 51.5418279 19.8257665 51.5418279 6.28291028 54.9715123 6.28291028\" />\n            <polygon id=\"logo-blasts_Y\" fill=\"#0461A8\" points=\"28.3548164 25.8350426 24.925132 25.8350426 24.925132 17.7151915 17.3329248 6.28291028 21.2609393 6.28291028 26.6253175 14.6372697 31.9896956 6.28291028 35.9177102 6.28291028 28.3548164 17.7151915\" />\n            <path d=\"M8.362981,26.1868051 C4.75741538,26.1868051 2.14851017,24.8970092 0.389697672,23.0795697 L2.32439142,20.4120374 C3.6435008,21.8484009 5.78338934,23.1381967 8.50954871,23.1381967 C11.3236487,23.1381967 12.4082498,21.7604603 12.4082498,20.4413509 C12.4082498,16.3374551 1.03459559,18.8877332 1.03459559,11.7059155 C1.03459559,8.45211236 3.84869559,5.96046132 8.15778621,5.96046132 C11.177081,5.96046132 13.668732,6.95712174 15.4568581,8.71593424 L13.5221643,11.2662124 C11.9685466,9.71259465 9.88728517,9.00906965 7.83533725,9.00906965 C5.84201642,9.00906965 4.55222059,10.0057301 4.55222059,11.4420936 C4.55222059,15.1062863 15.9258748,12.8491436 15.9258748,20.1189019 C15.9258748,23.3727051 13.610105,26.1868051 8.362981,26.1868051 Z\" id=\"logo-blasts_S\" fill=\"#0461A8\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PDQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-numbers",
  "use": "icon-numbers-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-numbers\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-numbers</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-numbers_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-numbers_icon-numbers\">\n            <path d=\"M8.65,0.88 C8.65,0.6399988 8.5633342,0.4333342 8.39,0.26 C8.2166658,0.0866658 8.0033346,0 7.75,0 L5.05,0 C4.7966654,0 4.5833342,0.0866658 4.41,0.26 C4.2366658,0.4333342 4.15,0.6399988 4.15,0.88 L4.15,14.22 L0.55,14.22 L6.41,20 L12.25,14.22 L8.65,14.22 L8.65,0.88 Z M16.11,5.56 L17.23,5.56 L17.23,1.12 L15.01,1.12 L15.01,2.22 L16.11,2.22 L16.11,5.56 Z M18.33,10 L19.45,8.88 L19.45,7.78 L18.51,6.66 L13.87,6.66 L13.87,7.78 L18.33,7.78 L18.33,8.9 L14.95,8.88 L13.89,10 L13.89,11.12 L15.01,12.22 L19.45,12.22 L19.45,11.12 L15.01,11.12 L15.01,10 L18.33,10 Z M13.89,13.34 L13.89,14.44 L18.33,14.44 L18.33,15.56 L15.01,15.56 L15.01,16.68 L18.33,16.68 L18.33,17.78 L13.89,17.78 L13.89,18.9 L18.33,18.9 L19.45,17.78 L19.45,16.68 L18.33,15.56 L19.45,15.12 L19.45,14.22 L18.55,13.34 L13.89,13.34 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PDtk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__("hooP");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _http = __webpack_require__("087f");

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Session = {
  install: function install(Vue, options) {

    Vue.prototype.$session = {

      session: null,
      user: null,
      authorize: function authorize(loginToken) {
        var _this = this;

        return _store2.default.create('sessions', { applicationId: 3, loginToken: loginToken }).then(function (response) {
          if (response.token) {
            sessionStorage.setItem('token', response.token);
            _http2.default.defaults.httpConfig.headers.common.token = response.token;
          }
          _this.session = response;
          _this.user = response.user;
          _http2.default.http.interceptors.response.use(function (response) {
            return response;
          }, function (error) {
            if (error.status === 401) {
              _.defer(function () {
                _router2.default.push({ name: "logout" });
              });
            }
            return _promise2.default.reject(error);
          });
          return _promise2.default.resolve(response);
        }).catch(function (error) {
          sessionStorage.removeItem('token');
          return _promise2.default.reject(error);
        });
      },
      destroy: function destroy() {
        if (this.session) {
          return this.session.DSDestroy().then(function () {
            sessionStorage.removeItem('token');
          });
        } else {
          sessionStorage.removeItem('token');
          return _promise2.default.resolve();
        }
      }
    };
  }
};

_vue2.default.use(Session);

// router.beforeEach((to, from, next) => {
//   console.log(Vue.$session)
//   console.log('global', to, from, next)
// })

exports.default = Session;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "PG7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/container.vue
var container = __webpack_require__("QoHx");
var container_default = /*#__PURE__*/__webpack_require__.n(container);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f91707","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/container.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_container = (esExports);
// CONCATENATED MODULE: ./src/components/_global/container.vue
function injectStyle (ssrContext) {
  __webpack_require__("VGUU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51f91707"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  container_default.a,
  _global_container,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_container = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PU9P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bryce.e587ce9.jpg";

/***/ }),

/***/ "PUaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-write-chrome",
  "use": "icon-write-chrome-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-write-chrome\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <title>writing</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-write-chrome_Svgsprites\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-write-chrome_writing\">\n            <path d=\"M8.01338704,15.9789225 C12.4122187,15.9789225 15.9789225,12.4122187 15.9789225,8.01338704 C15.9789225,3.61455541 12.4122187,0.0478515625 8.01338704,0.0478515625 C3.61455541,0.0478515625 0.0478515625,3.61455541 0.0478515625,8.01338704 C0.0478515625,12.4122187 3.61455541,15.9789225 8.01338704,15.9789225\" id=\"icon-write-chrome_Fill-1\" fill=\"#0361A8\" />\n            <path d=\"M12.759887,5.66538704 L10.361887,3.26738704 C10.329887,3.23538704 10.286887,3.21738704 10.239887,3.21738704 C10.193887,3.21738704 10.150887,3.23538704 10.118887,3.26738704 L8.95488704,4.43138704 L11.595887,7.07038704 L12.759887,5.90638704 C12.790887,5.87638704 12.809887,5.83338704 12.809887,5.78538704 C12.809887,5.73838704 12.790887,5.69538704 12.759887,5.66538704 L12.759887,5.66538704 Z M3.95288704,9.43338704 L3.95488704,9.43638704 C3.93488704,9.45938704 3.91788704,9.48538704 3.90988704,9.51838704 L3.90588704,9.51738704 L3.22088704,12.600387 L3.22488704,12.601387 C3.22088704,12.612387 3.21688704,12.625387 3.21688704,12.637387 C3.21688704,12.731387 3.29488704,12.809387 3.38888704,12.809387 C3.40188704,12.809387 3.41388704,12.804387 3.42588704,12.801387 L3.42588704,12.805387 L6.50988704,12.119387 L6.50788704,12.115387 C6.54088704,12.108387 6.57088704,12.096387 6.59388704,12.072387 L11.353887,7.31238704 L8.71288704,4.67338704 L3.95288704,9.43338704 Z M6.30088704,11.814387 L3.61388704,12.411387 L4.21088704,9.72638704 L5.27388704,9.72638704 L5.27388704,10.582387 C5.27388704,10.677387 5.34988704,10.753387 5.44488704,10.753387 L6.30088704,10.753387 L6.30088704,11.814387 Z\" id=\"icon-write-chrome_Fill-4\" fill=\"#FFFFFF\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PgOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/Assignments/index.vue
var Assignments = __webpack_require__("Oi1/");
var Assignments_default = /*#__PURE__*/__webpack_require__.n(Assignments);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05833932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Assignments/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GeographyMasthead'),_vm._v(" "),(_vm.ready)?_c('section',[_c('assignment-list',{attrs:{"assignments":_vm.assignments}},[_c('div',{staticClass:"empty",attrs:{"slot":"empty"},slot:"empty"},[_c('h2',[_vm._v("There are currently no assignments due.")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var routes_Assignments = (esExports);
// CONCATENATED MODULE: ./src/routes/Assignments/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("XEWa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05833932"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Assignments_default.a,
  routes_Assignments,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_routes_Assignments = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PtPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/vocab.vue
var vocab = __webpack_require__("CBCv");
var vocab_default = /*#__PURE__*/__webpack_require__.n(vocab);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c71182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/vocab.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Vocab"}},[_c('visual-vocab',{attrs:{"model":_vm.blast.vocabQuestion,"respondable":_vm.blast.isOpen || _vm.blast.isPreview}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_vocab = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/vocab.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vocab_default.a,
  sidebar_vocab,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_vocab = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PvP2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cambodia.ab3c821.jpg";

/***/ }),

/***/ "QO//":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _Modal = __webpack_require__("AKuq");

var _Modal2 = _interopRequireDefault(_Modal);

var _http = __webpack_require__("087f");

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SESSION_LENGTH = 120 * 60 * 1000;
var SESSION_OFFSET = 60 * 1000;

exports.default = {
  name: 'SessionWarning',
  props: ['session'],
  components: { Modal: _Modal2.default },
  data: function data() {
    return {
      sessionExpires: null,
      sessionTimer: null,
      showModal: false,
      loggedOut: false
    };
  },
  created: function created() {
    var _this = this;

    _http2.default.http.interceptors.response.use(function (response) {
      if (_.get(response, "headers['ss-authenticated']")) {
        _this.initTimer();
      }
      return response;
    }, function (error) {
      return _promise2.default.reject(error);
    });
  },

  methods: {
    initTimer: function initTimer() {
      var _this2 = this;

      if (this.sessionTimer) {
        clearTimeout(this.sessionTimer);
      }
      this.sessionTimer = setTimeout(function () {
        _this2.sessionExpires = 59000;
        _this2.showModal = true;
      }, SESSION_LENGTH - SESSION_OFFSET);
    },
    logout: function logout() {
      this.$router.push({ name: "logout" });
      this.showModal = false;
      this.loggedOut = true;
    },
    extend: function extend() {
      this.$store.find('ping', 'auth');
      this.showModal = false;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "QT3A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QVMN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'BlastResponse',
  props: {
    model: {
      type: Object,
      required: true
    },
    maxchars: {
      type: Number,
      default: 140
    },
    respondable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: this.model.response || ""
    };
  },

  computed: {
    charsLeft: function charsLeft() {
      return this.maxchars - this.innerValue.length;
    }
  },
  methods: {
    save: _.debounce(function (model) {
      model.DSSave();
    }, 500),
    updateValue: function updateValue() {
      var value = this.innerValue.length < 5 ? null : this.innerValue;
      this.$emit("input", value);
      if (value) {
        this.save(this.model);
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "QgTD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

var colors = ['#0361A8', '#8e6fbc', '#79ac6a', '#808080', '#e5d94f']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'QuikPoll',
  props: {
    model: {
      type: Object,
      required: true
    },
    respondable: {
      type: Boolean
    }
  },
  data: function data() {
    var _this = this;

    var data = [];
    var labels = [];
    _.each(this.model.question.options, function (option) {
      data.push(option.votes);
      labels.push(option.value);
    });
    return {
      colors: colors,
      data: data,
      labels: labels,
      options: function () {
        return _this.model.question.options.map(function (option, index) {
          return _.assign(option, {
            color: colors[index],
            percent: (option.votes / _.sum(data) * 100).toFixed(1)
          });
        });
      }()
    };
  },

  methods: {
    save: function save(model) {
      this.model.DSSave();
    }
  },
  components: {
    chart: {
      extends: _vueChartjs.Pie,
      props: ['data', 'labels'],
      mounted: function mounted() {

        this.renderChart({
          datasets: [{
            data: this.data,
            backgroundColor: colors
          }],
          labels: this.labels
        }, {
          tooltips: { enabled: false },
          hover: false,
          legend: false,
          responsive: true
        });
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "QjqZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "annotations",
  relations: {
    belongsTo: {
      userAssignments: {
        parent: true,
        localKey: "userAssignmentId",
        localField: "userAssignment"
      },
      annotationColors: {
        localKey: "colorId",
        localField: "color"
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "QmQ/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryNavigation = __webpack_require__("q97C");

var _PrimaryNavigation2 = _interopRequireDefault(_PrimaryNavigation);

var _SecondaryNavigation = __webpack_require__("fi5N");

var _SecondaryNavigation2 = _interopRequireDefault(_SecondaryNavigation);

var _NavToggle = __webpack_require__("ND/Y");

var _NavToggle2 = _interopRequireDefault(_NavToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AppHeader',
  components: { PrimaryNavigation: _PrimaryNavigation2.default, SecondaryNavigation: _SecondaryNavigation2.default, NavToggle: _NavToggle2.default },
  props: {
    trans: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isSecondaryNavActive: false
    };
  },
  created: function created() {
    var _this = this;

    this.$router.afterEach(function () {
      _this.isSecondaryNavActive = false;
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "QoHx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//


exports.default = {
  name: 'Container'
};

/***/ }),

/***/ "RvPL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/machu.9f95f16.jpg";

/***/ }),

/***/ "SDXc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SELg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/Assignments/Detail.vue
var Detail = __webpack_require__("59tT");
var Detail_default = /*#__PURE__*/__webpack_require__.n(Detail);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99e43840","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Assignments/Detail.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assignment)?_c('blast-student',{attrs:{"blast":_vm.assignment}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Assignments_Detail = (esExports);
// CONCATENATED MODULE: ./src/routes/Assignments/Detail.vue
function injectStyle (ssrContext) {
  __webpack_require__("sw1O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99e43840"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Detail_default.a,
  Assignments_Detail,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_Assignments_Detail = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SiIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/video.vue
var video = __webpack_require__("z2t3");
var video_default = /*#__PURE__*/__webpack_require__.n(video);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cef81e5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/video.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-js',{attrs:{"media":_vm.data}}),_vm._v(" "),(_vm.data.caption)?_c('div',{staticClass:"caption",domProps:{"innerHTML":_vm._s(_vm.data.caption)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var content_module_video = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/video.vue
function injectStyle (ssrContext) {
  __webpack_require__("SDXc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cef81e5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  video_default.a,
  content_module_video,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _global_content_module_video = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "T/X7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shanghai.d51ec47.jpg";

/***/ }),

/***/ "TAwG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'annotatorColorSwatch',
  props: {
    value: {}
  },
  data: function data() {
    return {
      colors: this.$store.getAll('annotationColors'),
      innerValue: this.value
    };
  },

  methods: {
    updateValue: function updateValue(val) {
      this.$emit('input', val);
    }
  }
};

/***/ }),

/***/ "TNX8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item = __webpack_require__("ybNA");

var _item2 = _interopRequireDefault(_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'assignmentList',
  components: { AssignmentItem: _item2.default },
  props: {
    assignments: {
      type: Array,
      required: true
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "TYut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-blast-chrome",
  "use": "icon-blast-chrome-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-blast-chrome\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <title>blast</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-blast-chrome_Svgsprites\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-blast-chrome_blast\">\n            <path d=\"M8.01338704,15.9789225 C12.4122187,15.9789225 15.9789225,12.4122187 15.9789225,8.01338704 C15.9789225,3.61455541 12.4122187,0.0478515625 8.01338704,0.0478515625 C3.61455541,0.0478515625 0.0478515625,3.61455541 0.0478515625,8.01338704 C0.0478515625,12.4122187 3.61455541,15.9789225 8.01338704,15.9789225\" id=\"icon-blast-chrome_Fill-1\" fill=\"#0361A8\" />\n            <polygon id=\"icon-blast-chrome_Fill-2\" fill=\"#FEFEFE\" points=\"8.37032784 5.04046363 10.2585978 2.41283055 9.80755358 5.6160092 12.7584532 4.28581091 10.76534 6.8359037 13.9881768 7.15589393 10.9859476 8.36923572 13.6146728 10.2564136 10.40931 9.80646146 11.7416925 12.756269 9.19159969 10.7642479 8.86942523 13.9849004 7.65717555 10.9837634 5.76781344 13.6135807 6.21776557 10.4071257 3.27014226 11.7406004 5.26216335 9.18832334 2.0393266 8.86833311 5.04046363 7.65608343 2.41392267 5.76672132 5.61710132 6.21667346 4.28690302 3.26686591 6.83699581 5.25997912 7.15807816 2.0393266\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "TaB5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tx8I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/blast-top-10.vue
var blast_top_10 = __webpack_require__("x+Mw");
var blast_top_10_default = /*#__PURE__*/__webpack_require__.n(blast_top_10);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-401d2e24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/blast-top-10.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0,false,false),_vm._v(" "),_c('ol',_vm._l((_vm.top10),function(blast,index){return _c('li',{class:{active: blast.isOpen}},[_c('div',{staticClass:"upper"},[_c('div',[_c('span',{staticClass:"rank"},[_vm._v(_vm._s(blast.rank)+".")]),_vm._v(" "),_c('button',{staticClass:"nickname",on:{"click":function($event){$event.preventDefault();blast.isOpen = !blast.isOpen}}},[_vm._v("\n            "+_vm._s(blast.name || "Anonymous")+"\n            "),_c('sprite',{staticClass:"down-arrow",attrs:{"name":"iconDownDir"}})],1)]),_vm._v(" "),_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm._f("blastScore")(blast.score)))])]),_vm._v(" "),(blast.isOpen)?_c('blockquote',[_vm._v(_vm._s(blast.post))]):_vm._e()])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Rated by "),_c('strong',[_vm._v("peers")]),_vm._v(". How do you compare?")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_blast_top_10 = (esExports);
// CONCATENATED MODULE: ./src/components/_global/blast-top-10.vue
function injectStyle (ssrContext) {
  __webpack_require__("flQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-401d2e24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  blast_top_10_default.a,
  _global_blast_top_10,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_blast_top_10 = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ty3F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V59Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/textarea-autogrow.vue
var textarea_autogrow = __webpack_require__("/qKa");
var textarea_autogrow_default = /*#__PURE__*/__webpack_require__.n(textarea_autogrow);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a23773","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/textarea-autogrow.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.innerValue),expression:"innerValue"}],attrs:{"maxlength":_vm.max >= 0 ? _vm.max : false},domProps:{"value":(_vm.innerValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.innerValue=$event.target.value},_vm.updateValue],"blur":_vm.updateValue,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.metaKey){ return null; }_vm.onKeyup($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_textarea_autogrow = (esExports);
// CONCATENATED MODULE: ./src/components/_global/textarea-autogrow.vue
function injectStyle (ssrContext) {
  __webpack_require__("o5UV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05a23773"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  textarea_autogrow_default.a,
  _global_textarea_autogrow,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_textarea_autogrow = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VGUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VHPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-blast",
  "use": "icon-blast-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-blast\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-blast</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-blast_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-blast_icon-blast\">\n            <polygon points=\"6.33 19.14 7.05 13.9 2.25 16.08 5.51 11.92 0.25 11.4 5.13 9.42 0.85 6.34 6.09 7.06 3.91 2.26 8.07 5.5 8.59 0.26 10.57 5.14 13.65 0.86 12.91 6.08 17.73 3.92 14.49 8.08 19.75 8.6 14.85 10.58 19.13 13.66 13.89 12.92 16.07 17.74 11.91 14.5 11.39 19.74 9.41 14.84\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "VONp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _freeze = __webpack_require__("u2KI");

var _freeze2 = _interopRequireDefault(_freeze);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _assignmentCompletionSummary = __webpack_require__("j328");

var _assignmentCompletionSummary2 = _interopRequireDefault(_assignmentCompletionSummary);

var _audioButton = __webpack_require__("1M2u");

var _audioButton2 = _interopRequireDefault(_audioButton);

var _blastLabels = __webpack_require__("BmKQ");

var _blastLabels2 = _interopRequireDefault(_blastLabels);

var _blastResponse = __webpack_require__("8SLU");

var _blastResponse2 = _interopRequireDefault(_blastResponse);

var _blastReviewsGiven = __webpack_require__("+Xi7");

var _blastReviewsGiven2 = _interopRequireDefault(_blastReviewsGiven);

var _blastReviewsReceived = __webpack_require__("f+QQ");

var _blastReviewsReceived2 = _interopRequireDefault(_blastReviewsReceived);

var _blastTop = __webpack_require__("Tx8I");

var _blastTop2 = _interopRequireDefault(_blastTop);

var _btn = __webpack_require__("qOgP");

var _btn2 = _interopRequireDefault(_btn);

var _clipboard = __webpack_require__("Hyns");

var _clipboard2 = _interopRequireDefault(_clipboard);

var _comprehension = __webpack_require__("MXnZ");

var _comprehension2 = _interopRequireDefault(_comprehension);

var _container = __webpack_require__("PG7S");

var _container2 = _interopRequireDefault(_container);

var _contentModule = __webpack_require__("mcHD");

var _contentModule2 = _interopRequireDefault(_contentModule);

var _expander = __webpack_require__("3h6O");

var _expander2 = _interopRequireDefault(_expander);

var _inView = __webpack_require__("t9kw");

var _inView2 = _interopRequireDefault(_inView);

var _interactiveText = __webpack_require__("rson");

var _interactiveText2 = _interopRequireDefault(_interactiveText);

var _peerReviews = __webpack_require__("P+uw");

var _peerReviews2 = _interopRequireDefault(_peerReviews);

var _posterImage = __webpack_require__("EJGL");

var _posterImage2 = _interopRequireDefault(_posterImage);

var _questionGroup = __webpack_require__("pbZg");

var _questionGroup2 = _interopRequireDefault(_questionGroup);

var _quikPoll = __webpack_require__("Euco");

var _quikPoll2 = _interopRequireDefault(_quikPoll);

var _radioGroup = __webpack_require__("o7gd");

var _radioGroup2 = _interopRequireDefault(_radioGroup);

var _ratePeer = __webpack_require__("B3WU");

var _ratePeer2 = _interopRequireDefault(_ratePeer);

var _ratings = __webpack_require__("D9hc");

var _ratings2 = _interopRequireDefault(_ratings);

var _redactor = __webpack_require__("sKqS");

var _redactor2 = _interopRequireDefault(_redactor);

var _rubricCriteria = __webpack_require__("gdcu");

var _rubricCriteria2 = _interopRequireDefault(_rubricCriteria);

var _sprite = __webpack_require__("FdUn");

var _sprite2 = _interopRequireDefault(_sprite);

var _sticky = __webpack_require__("B0+f");

var _sticky2 = _interopRequireDefault(_sticky);

var _textareaAutogrow = __webpack_require__("V59Y");

var _textareaAutogrow2 = _interopRequireDefault(_textareaAutogrow);

var _videoJs = __webpack_require__("vNLa");

var _videoJs2 = _interopRequireDefault(_videoJs);

var _vue3 = __webpack_require__("uKTz");

var _vue4 = _interopRequireDefault(_vue3);

var _writeResponse = __webpack_require__("dp1W");

var _writeResponse2 = _interopRequireDefault(_writeResponse);

var _autoFocus = __webpack_require__("Ct8I");

var _autoFocus2 = _interopRequireDefault(_autoFocus);

var _externalLinkWarning = __webpack_require__("rNxO");

var _externalLinkWarning2 = _interopRequireDefault(_externalLinkWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  assignmentCompletionSummary: _assignmentCompletionSummary2.default,
  audioButton: _audioButton2.default,
  blastLabels: _blastLabels2.default,
  blastResponse: _blastResponse2.default,
  blastReviewsGiven: _blastReviewsGiven2.default,
  blastReviewsReceived: _blastReviewsReceived2.default,
  blastTop10: _blastTop2.default,
  btn: _btn2.default,
  clipboard: _clipboard2.default,
  comprehension: _comprehension2.default,
  container: _container2.default,
  contentModule: _contentModule2.default,
  expander: _expander2.default,
  inView: _inView2.default,
  interactiveText: _interactiveText2.default,
  peerReviews: _peerReviews2.default,
  posterImage: _posterImage2.default,
  questionGroup: _questionGroup2.default,
  quikPoll: _quikPoll2.default,
  radioGroup: _radioGroup2.default,
  ratePeer: _ratePeer2.default,
  ratings: _ratings2.default,
  redactor: _redactor2.default,
  rubricCriteria: _rubricCriteria2.default,
  sprite: _sprite2.default,
  sticky: _sticky2.default,
  textareaAutogrow: _textareaAutogrow2.default,
  videoJs: _videoJs2.default,
  vue: _vue4.default,
  writeResponse: _writeResponse2.default
};
(0, _freeze2.default)(components);
var directives = {
  autoFocus: _autoFocus2.default,
  externalLinkWarning: _externalLinkWarning2.default
};
(0, _freeze2.default)(directives);


_lodash2.default.map(components, function (component) {
  _vue2.default.component(component.name, component);
});

_lodash2.default.map(directives, function (directive) {
  _vue2.default.directive(directive.name, directive);
});

/***/ }),

/***/ "Vobj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _peerReview = __webpack_require__("nAdW");

var _peerReview2 = _interopRequireDefault(_peerReview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PeerReviews',
  components: { PeerReview: _peerReview2.default },
  props: {
    reviews: {
      type: Array,
      required: true
    },
    display: {
      type: String,
      default: "received"
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),

/***/ "VqW9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PrimaryNavigation'
};

/***/ }),

/***/ "Vqap":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tigers.99ad4ac.jpg";

/***/ }),

/***/ "Vxcp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//


exports.default = {
  name: 'ContentModuleImage',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "W8Ih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/quikpoll.vue
var quikpoll = __webpack_require__("+LEf");
var quikpoll_default = /*#__PURE__*/__webpack_require__.n(quikpoll);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c7ade3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/quikpoll.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"QuikPoll"}},[_c('quik-poll',{attrs:{"model":_vm.blast.quikPoll,"respondable":_vm.blast.isOpen}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_quikpoll = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/quikpoll.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  quikpoll_default.a,
  sidebar_quikpoll,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_quikpoll = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WdoC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wem0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eiffel.cbfaf5f.jpg";

/***/ }),

/***/ "WhBN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'Profile',
  routeConfig: {
    name: "profile", path: "/profile"
  },
  metaInfo: {
    title: "Profile"
  }
};

/***/ }),

/***/ "WuPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-review",
  "use": "icon-review-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-review\">\n    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-review</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-review_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-review_icon-review\">\n            <path d=\"M9.91071429,14.1046143 L11.2053571,12.8099714 L9.50892857,11.1135428 L8.21428571,12.4081857 L8.21428571,13.0331857 L9.28571429,13.0331857 L9.28571429,14.1046143 L9.91071429,14.1046143 Z M14.8102679,6.43720354 C14.9367566,6.31071482 14.9404768,6.18794819 14.8214286,6.06889997 C14.7023804,5.94985176 14.5796137,5.95357196 14.453125,6.08006069 L10.546875,9.98631069 C10.4203863,10.1127994 10.4166661,10.235566 10.5357143,10.3546143 C10.6547625,10.4736625 10.7775291,10.4699423 10.9040179,10.3434535 L14.8102679,6.43720354 Z M15.7142857,12.6983643 L15.7142857,14.8189 C15.7142857,15.7043211 15.3999287,16.4613819 14.7712054,17.0901053 C14.142482,17.7188287 13.3854211,18.0331857 12.5,18.0331857 L3.21428571,18.0331857 C2.32886462,18.0331857 1.57180374,17.7188287 0.943080357,17.0901053 C0.314356975,16.4613819 0,15.7043211 0,14.8189 L0,5.53318569 C0,4.64776459 0.314356975,3.89070371 0.943080357,3.26198033 C1.57180374,2.63325695 2.32886462,2.31889997 3.21428571,2.31889997 L12.5,2.31889997 C12.9687523,2.31889997 13.4040158,2.41190499 13.8058036,2.59791783 C13.9174113,2.65000142 13.9843749,2.73556604 14.0066964,2.85461426 C14.029018,2.98110299 13.9955362,3.08898881 13.90625,3.17827497 L13.359375,3.72514997 C13.2552078,3.82931716 13.1361614,3.85907877 13.0022321,3.81443569 C12.8311003,3.76979261 12.6636913,3.7474714 12.5,3.7474714 L3.21428571,3.7474714 C2.72321183,3.7474714 2.30282913,3.92232084 1.953125,4.27202497 C1.60342087,4.6217291 1.42857143,5.0421118 1.42857143,5.53318569 L1.42857143,14.8189 C1.42857143,15.3099739 1.60342087,15.7303566 1.953125,16.0800607 C2.30282913,16.4297648 2.72321183,16.6046143 3.21428571,16.6046143 L12.5,16.6046143 C12.9910739,16.6046143 13.4114566,16.4297648 13.7611607,16.0800607 C14.1108648,15.7303566 14.2857143,15.3099739 14.2857143,14.8189 L14.2857143,13.41265 C14.2857143,13.3159233 14.3191961,13.2340789 14.3861607,13.1671143 L15.1004464,12.4528285 C15.2120541,12.3412208 15.3422612,12.3151794 15.4910714,12.3747035 C15.6398817,12.4342277 15.7142857,12.5421135 15.7142857,12.6983643 Z M14.6428571,4.46175711 L17.8571429,7.67604283 L10.3571429,15.1760428 L7.14285714,15.1760428 L7.14285714,11.9617571 L14.6428571,4.46175711 Z M19.5982143,5.9349714 L18.5714286,6.96175711 L15.3571429,3.7474714 L16.3839286,2.72068569 C16.5922629,2.51235131 16.8452366,2.40818569 17.1428571,2.40818569 C17.4404777,2.40818569 17.6934513,2.51235131 17.9017857,2.72068569 L19.5982143,4.41711426 C19.8065487,4.62544863 19.9107143,4.87842229 19.9107143,5.17604283 C19.9107143,5.47366336 19.8065487,5.72663703 19.5982143,5.9349714 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "XAIW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noframeworkWaypoints = __webpack_require__("HIb3");

var _noframeworkWaypoints2 = _interopRequireDefault(_noframeworkWaypoints);

__webpack_require__("THrZ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//


exports.default = {
  name: 'inView',
  props: {
    el: {
      type: String,
      default: "div"
    }
  },
  data: function data() {
    return {
      inview: null
    };
  },
  mounted: function mounted() {
    this.init();
    $(window).on("resize", this.refresh);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.inview = new Waypoint.Inview({
        element: this.$el,
        enter: function enter(direction) {
          _this.$emit('enter', direction);
        },
        entered: function entered(direction) {
          _this.$emit('entered', direction);
        },
        exit: function exit(direction) {
          _this.$emit('exit', direction);
        },
        exited: function exited(direction) {
          _this.$emit('exited', direction);
        }
      });
    },
    refresh: function refresh() {
      if (this.inview) {
        this.inview.destroy();
        this.init();
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "XEWa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XhZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XzEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/number-crunch.vue
var number_crunch = __webpack_require__("g1ph");
var number_crunch_default = /*#__PURE__*/__webpack_require__.n(number_crunch);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e3b0d2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/number-crunch.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crunch"},[_c('h3',[_vm._v(_vm._s(_vm.data.number))]),_vm._v(" "),_c('div',{class:['answer', {active: _vm.active}]},[_c('p',[_vm._v(_vm._s(_vm.data.answer))]),_vm._v(" "),(!_vm.active)?_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.reveal()}}},[_c('sprite',{attrs:{"name":"iconHelpCircled"}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var content_module_number_crunch = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/number-crunch.vue
function injectStyle (ssrContext) {
  __webpack_require__("mv0P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e3b0d2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  number_crunch_default.a,
  content_module_number_crunch,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _global_content_module_number_crunch = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Y+DG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stonehenge.81d0753.jpg";

/***/ }),

/***/ "YaZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-help-circled",
  "use": "icon-help-circled-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-help-circled\">\n    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-help-circled</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-help-circled_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-help-circled_icon-help-circled\">\n            <path d=\"M0.0499515999,9.99489197 C0.0499515999,8.64980577 0.311885509,7.36137411 0.835761185,6.12955833 C1.35963686,4.89774255 2.06756635,3.84292762 2.95957088,2.96508189 C3.85157541,2.08723617 4.90639034,1.37930668 6.12404731,0.841272203 C7.34170429,0.303237725 8.63721525,0.0413038155 10.010619,0.0554626175 C11.3557052,0.0554626175 12.6441369,0.317396527 13.8759527,0.841272203 C15.1077685,1.36514788 16.1625834,2.07307736 17.0404291,2.96508189 C17.9182749,3.85708642 18.6262043,4.91190135 19.1642388,6.12955833 C19.7022733,7.34721531 19.9642072,8.63564697 19.9500484,9.99489197 C19.9358896,11.354137 19.6739557,12.6425686 19.1642388,13.8602256 C18.6545219,15.0778826 17.9465925,16.1397768 17.0404291,17.0459401 C16.1342658,17.9521035 15.0794509,18.660033 13.8759527,19.1697498 C12.6724545,19.6794667 11.3875625,19.937861 10.0212381,19.9449404 C8.6549137,19.9520198 7.35586309,19.6936255 6.12404731,19.1697498 C4.89223154,18.6458742 3.8374166,17.9379447 2.95957088,17.0459401 C2.08172515,16.1539356 1.37379566,15.0920414 0.835761185,13.8602256 C0.297726707,12.6284098 0.0357927978,11.3399782 0.0499515999,9.99489197 Z M8.14166652,13.3505113 C8.15582532,12.9115884 8.30449051,12.564703 8.58766656,12.3098445 C8.8708426,12.0549861 9.26020381,11.9310984 9.75576189,11.9381778 C10.25132,11.9452572 10.6336019,12.0691449 10.9026191,12.3098445 C11.1716364,12.5505442 11.3132223,12.8974296 11.3273811,13.3505113 C11.3415399,13.8035929 11.199954,14.1504784 10.9026191,14.391178 C10.6052843,14.6318777 10.2194627,14.7522257 9.74514284,14.7522257 C9.27082297,14.7522257 8.8850014,14.6318777 8.58766656,14.391178 C8.29033171,14.1504784 8.14166652,13.8035929 8.14166652,13.3505113 Z M7.12223787,6.27822501 C8.0142424,5.74019053 9.06197804,5.47117733 10.2654762,5.47117733 C11.1716395,5.47117733 11.9220448,5.71187335 12.5167145,6.19327262 C13.1113842,6.67467189 13.4087146,7.26225337 13.4087146,7.95603467 C13.3945558,8.46575154 13.3166835,8.86219205 13.1750955,9.14536809 C13.0335075,9.42854413 12.8282079,9.68339875 12.5591907,9.90993958 C12.2320715,10.1461477 11.8497858,10.3797667 11.4123334,10.6107968 C11.1291588,10.7350931 10.9875715,10.9029999 10.9875715,11.1145172 L10.9875715,11.5027968 L8.50271417,11.5027968 L8.50271417,10.6957492 C8.50271417,10.3559379 8.54518994,10.094004 8.63014275,9.90993958 C8.71509556,9.72587515 8.91331582,9.54889278 9.22480946,9.37898716 L10.0941925,8.97833252 C10.5623499,8.7625529 10.7964286,8.52797743 10.7964286,8.27460612 C10.7964286,7.96311247 10.4424639,7.80736799 9.73452379,7.80736799 C9.08321889,7.80736799 8.43192377,8.01266754 7.78061887,8.4232728 L7.12223787,6.27822501 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Yb5C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/la.c7a77b6.jpg";

/***/ }),

/***/ "ZwO8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aCyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/Profile/index.vue
var Profile = __webpack_require__("WhBN");
var Profile_default = /*#__PURE__*/__webpack_require__.n(Profile);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3f9f88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Profile/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("profile page will go here")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var routes_Profile = (esExports);
// CONCATENATED MODULE: ./src/routes/Profile/index.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Profile_default.a,
  routes_Profile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_routes_Profile = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aUzv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'BlastReviewsGiven',
  props: {
    blast: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "aXN+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/Channels/detail.vue
var detail = __webpack_require__("w2WD");
var detail_default = /*#__PURE__*/__webpack_require__.n(detail);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc05a5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Channels/detail.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  channel: "+_vm._s(_vm.$_.get(_vm.channel, 'name'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Channels_detail = (esExports);
// CONCATENATED MODULE: ./src/routes/Channels/detail.vue
function injectStyle (ssrContext) {
  __webpack_require__("zlUU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc05a5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  detail_default.a,
  Channels_detail,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_Channels_detail = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bJz5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uluru.7e4ad3b.jpg";

/***/ }),

/***/ "bRJQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bTCR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rio.0dc40fa.jpg";

/***/ }),

/***/ "bVQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "buV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Annotator/controls.vue
var controls = __webpack_require__("coLc");
var controls_default = /*#__PURE__*/__webpack_require__.n(controls);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a12c535","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Annotator/controls.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.annotation)?_c('div',{class:['controls', {editing: _vm.editing, viewing: !_vm.editing}],staticStyle:{"position":"absolute"}},[_c('div',{staticClass:"upper"},[_c('div',{staticClass:"upper__left"},[(!_vm.annotation.overlap)?_c('h2',[(_vm.annotation.note)?_c('span',[_vm._v(_vm._s(_vm.editing ? ( (_vm.annotation.note && _vm.annotation.id) ? 'Edit' : 'Add') : '')+" Note")]):_vm._e(),_vm._v(" "),(!_vm.annotation.note)?_c('span',[_vm._v("Highlight")]):_vm._e()]):_c('h2',[_vm._v("Annotations cannot overlap")]),_vm._v(" "),(!_vm.annotation.overlap)?_c('div',{class:['color-swatch', {active: _vm.swatchOpen}]},[_c('button',{on:{"click":function($event){_vm.swatchOpen = !_vm.swatchOpen}}},[_c('i',{class:['color-swatch-item', 'color-'+_vm.annotation.colorId],attrs:{"title":(_vm.annotation.color) ? _vm.annotation.color.name : '',"tooltip":""}}),_vm._v(" "),(_vm.editing)?_c('sprite',{attrs:{"name":"iconDownDir"}}):_vm._e()],1),_vm._v(" "),(_vm.swatchOpen)?_c('annotation-swatch',{on:{"input":function($event){_vm.swatchOpen = false}},model:{value:(_vm.annotation.colorId),callback:function ($$v) {_vm.$set(_vm.annotation, "colorId", $$v)},expression:"annotation.colorId"}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"upper__right"},[_c('ul',[(_vm.on && _vm.annotation.id && !_vm.editing)?_c('li',[_c('button',{on:{"click":function($event){_vm.editing = true}}},[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.on && _vm.annotation.id)?_c('li',[_c('button',{on:{"click":function($event){_vm.remove()}}},[_vm._v("Remove")])]):_vm._e(),_vm._v(" "),_c('li',[_c('clipboard',{attrs:{"text":_vm.annotation.text},on:{"copied":function($event){_vm.emit('close')}}},[_vm._v("Copy")])],1),_vm._v(" "),_c('li',[_c('button',{staticClass:"icon-cancel",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.emit('close')}}},[_c('sprite',{attrs:{"name":"iconClose"}})],1)])])])]),_vm._v(" "),(_vm.editing || _vm.annotation.note)?_c('div',{staticClass:"note"},[(_vm.annotation.note && !_vm.editing)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.annotation.note)}}):_vm._e(),_vm._v(" "),(_vm.editing)?_c('textarea-autogrow',{directives:[{name:"auto-focus",rawName:"v-auto-focus"}],attrs:{"placeholder":"Type to add a note..."},on:{"metaEnter":function($event){_vm.save()}},model:{value:(_vm.annotation.note),callback:function ($$v) {_vm.$set(_vm.annotation, "note", $$v)},expression:"annotation.note"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.editing)?_c('button',{staticClass:"save",on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s((_vm.annotation.id) ? 'Save' : 'Create')+" "+_vm._s((_vm.annotation.note) ? "Note" : "Highlight"))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Annotator_controls = (esExports);
// CONCATENATED MODULE: ./src/components/Annotator/controls.vue
function injectStyle (ssrContext) {
  __webpack_require__("TaB5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a12c535"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  controls_default.a,
  Annotator_controls,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_Annotator_controls = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "c0Yp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/navajo.1c5f58b.jpg";

/***/ }),

/***/ "cA3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/blast.vue
var blast = __webpack_require__("2Yv2");
var blast_default = /*#__PURE__*/__webpack_require__.n(blast);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089db63c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/blast.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Blast"}},[_c('blast-response',{attrs:{"model":_vm.blast.blastPrompt,"maxchars":_vm.blast.assignment.shortFormLength,"respondable":_vm.blast.isOpen},model:{value:(_vm.blast.blastPrompt.response),callback:function ($$v) {_vm.$set(_vm.blast.blastPrompt, "response", $$v)},expression:"blast.blastPrompt.response"}}),_vm._v(" "),_c('review-display',{attrs:{"blast":_vm.blast}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_blast = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/blast.vue
function injectStyle (ssrContext) {
  __webpack_require__("DBiS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-089db63c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  blast_default.a,
  sidebar_blast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_blast = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cCGf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _2 = __webpack_require__("IcnI");

var _3 = _interopRequireDefault(_2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _3.default.defineResource({
  name: "reviews",
  relations: {
    belongsTo: {
      userAssignments: [{
        localKey: 'reviewerUserAssignmentId',
        localField: 'reviewerUserAssignment',
        parent: true
      }, {
        localKey: 'revieweeUserAssignmentId',
        localField: 'revieweeUserAssignment'
      }]
    },
    hasOne: {
      users: [{
        localKey: 'revieweeUserId',
        localField: 'revieweeUser'
      }, {
        localKey: 'reviewerUserId',
        localField: 'reviewerUser'
      }],
      rubrics: {
        localKey: "rubricsId",
        localField: "rubrics"
      }
    }
  },
  computed: {
    totalScore: {
      get: function get() {
        if (this.ratings) {
          return _.sum(this.ratings);
        }
      }
    },
    averageScore: {
      get: function get() {
        if (this.ratings) {
          return this.totalScore / this.rubrics.criteria.length;
        }
      }
    },
    reviewBy: {
      get: function get() {
        return _.get(this, "reviewerUser.nickname") || "Anonymous";
      }
    },
    reviewOf: {
      get: function get() {
        return _.get(this, "revieweeUser.nickname") || "Anonymous";
      }
    }
  }
});

exports.default = resource;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "cDJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-profile",
  "use": "icon-profile-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-profile\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-profile</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-profile_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-profile_icon-profile\">\n            <path d=\"M10,20 C8.1866576,20 6.5066744,19.5466712 4.96,18.64 C3.4533258,17.7466622 2.2533378,16.5466742 1.36,15.04 C0.4533288,13.4933256 0,11.8133424 0,10 C0,8.1866576 0.4533288,6.5066744 1.36,4.96 C2.2533378,3.4533258 3.4533258,2.2533378 4.96,1.36 C6.5066744,0.4533288 8.1866576,0 10,0 C11.8133424,0 13.4933256,0.4533288 15.04,1.36 C16.5466742,2.2533378 17.7466622,3.4533258 18.64,4.96 C19.5466712,6.5066744 20,8.1866576 20,10 C20,11.8133424 19.5466712,13.4933256 18.64,15.04 C17.7466622,16.5466742 16.5466742,17.7466622 15.04,18.64 C13.4933256,19.5466712 11.8133424,20 10,20 Z M15,13.24 C15,12.173328 14.8533348,11.2933368 14.56,10.6 C14.1333312,9.6399952 13.4600046,9.16 12.54,9.16 C12.4999998,9.16 12.380001,9.226666 12.18,9.36 C11.846665,9.5866678 11.5533346,9.7533328 11.3,9.86 C10.8733312,10.060001 10.4400022,10.16 10,10.16 C9.5599978,10.16 9.1266688,10.060001 8.7,9.86 C8.4466654,9.7533328 8.153335,9.5866678 7.82,9.36 C7.619999,9.226666 7.5000002,9.16 7.46,9.16 C6.5399954,9.16 5.8733354,9.6399952 5.46,10.6 C5.1533318,11.2933368 5,12.173328 5,13.24 C5,13.8000028 5.1733316,14.246665 5.52,14.58 C5.8666684,14.913335 6.3266638,15.08 6.9,15.08 L13.1,15.08 C13.6733362,15.08 14.1333316,14.913335 14.48,14.58 C14.8266684,14.246665 15,13.8000028 15,13.24 Z M12.72,6.9 C12.72,6.4066642 12.5966679,5.9500021 12.35,5.53 C12.1033321,5.1099979 11.7733354,4.7766679 11.36,4.53 C10.9466646,4.2833321 10.4933358,4.16 10,4.16 C9.5066642,4.16 9.0533354,4.2833321 8.64,4.53 C8.2266646,4.7766679 7.8966679,5.1099979 7.65,5.53 C7.4033321,5.9500021 7.28,6.4066642 7.28,6.9 C7.28,7.3933358 7.4033321,7.8466646 7.65,8.26 C7.8966679,8.6733354 8.2266646,9.0033321 8.64,9.25 C9.0533354,9.4966679 9.5066642,9.62 10,9.62 C10.4933358,9.62 10.9466646,9.4966679 11.36,9.25 C11.7733354,9.0033321 12.1033321,8.6733354 12.35,8.26 C12.5966679,7.8466646 12.72,7.3933358 12.72,6.9 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "cF0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cY5d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mastheads = [{
  image: 'brixby.jpg',
  text: 'Brixby Bridge, California'
}, {
  image: 'chicago.jpg',
  text: 'Chicago, Illinois'
}, {
  image: 'dolomite.jpg',
  text: 'Dolomites, Alps, Italy'
}, {
  image: 'montecarlo.jpg',
  text: 'Monte Carlo, Monaco'
}, {
  image: 'dorset.jpg',
  text: 'Durdle Door, Dorset, England'
}, {
  image: 'monument.jpg',
  text: 'Monument Valley, Arizona'
}, {
  image: 'sidney.jpg',
  text: 'Sydney, Australia'
}, {
  image: 'rome.jpg',
  text: 'Colosseum, Rome, Italy'
}, {
  image: 'vietnam.jpg',
  text: 'Mu Cang Chai, YenBai, Vietnam'
}, {
  image: 'rio.jpg',
  text: 'Sugarloaf Mountain, Rio de Janeiro, Brazil'
}, {
  image: 'machu.jpg',
  text: 'Machu Picchu, Peru'
}, {
  image: 'japan.jpg',
  text: 'Fujiyoshida, Japan'
}, {
  image: 'himalayas.jpg',
  text: 'Himalaya Mountains, Nepal'
}, {
  image: 'dubai.jpg',
  text: 'Burj Khalifa, Dubai'
}, {
  image: 'halfdome.jpg',
  text: 'Half Dome, Yosemite, California'
}, {
  image: 'agua.jpg',
  text: 'Agua Azul Waterfalls, Chiapas, Mexico'
}, {
  image: 'greatwall.jpg',
  text: 'Great Wall of China'
}, {
  image: 'guellpark.jpg',
  text: 'Guell Park, Barcelona, Spain'
}, {
  image: 'shanghai.jpg',
  text: 'Shanghai, China'
}, {
  image: 'danakil.jpg',
  text: 'Danakil Desert, Ethiopia'
}, {
  image: 'giantscausway.jpg',
  text: 'Giant\'s Causeway, Northern Ireland'
}, {
  image: 'pyramids.jpg',
  text: 'The Great Pyramid of Giza, Egypt'
}, {
  image: 'horseshoefalls.jpg',
  text: 'Horseshoe Falls, Niagara Falls, Ontario'
}, {
  image: 'badlands.jpg',
  text: 'Badlands National Park, South Dakota'
}, {
  image: 'liriver.jpg',
  text: 'Li Jiang, China'
}, {
  image: 'chocolatethills.jpg',
  text: 'Chocolate Hills in Bohol, Philippines'
}, {
  image: 'lotus.jpg',
  text: 'Lotus Temple, New Delhi'
}, {
  image: 'spaceneedle.jpg',
  text: 'Space Needle, Seattle'
}, {
  image: 'haydar.jpg',
  text: 'Haydar Aliyev Centre, Azerbaijan'
}, {
  image: 'louvre.jpg',
  text: 'Louvre Museum, Paris, France'
}, {
  image: 'stonehenge.jpg',
  text: 'Stonehenge, England'
}, {
  image: 'tajmahal.jpg',
  text: 'Taj Mahal, India'
}, {
  image: 'halong.jpg',
  text: 'Halong Bay, Vietnam'
}, {
  image: 'easter.jpg',
  text: 'Moai Statues, Easter Island'
}, {
  image: 'uluru.jpg',
  text: 'Uluru, Northern Territory, Australia'
}, {
  image: 'romanforum.jpg',
  text: 'Roman Forum, Rome, Italy'
}, {
  image: 'heceta.jpg',
  text: 'Heceta Head Lighthouse, Oregon'
}, {
  image: 'kilamajaro.jpg',
  text: 'Mount Kilimanjaro, Tanzania'
}, {
  image: 'varanasi.jpg',
  text: 'Varanasi, India'
}, {
  image: 'faeroe.jpg',
  text: 'Faroe Islands'
}, {
  image: 'stupa.jpg',
  text: 'Boudhanath stupa, Kathmandu, Nepal'
}, {
  image: 'fitzroy.jpg',
  text: 'Monte Fitz Roy, Patagonia'
}, {
  image: 'bryce.jpg',
  text: 'Bryce Canyon National Park, Utah'
}, {
  image: 'cambodia.jpg',
  text: 'The Bayon, Cambodia'
}, {
  image: 'goldengate.jpg',
  text: 'Golden Gate Bridge, San Francisco'
}, {
  image: 'bigben.jpg',
  text: 'Big Ben, London'
}, {
  image: 'newyork.jpg',
  text: 'New York City'
}, {
  image: 'monolake.jpg',
  text: 'Mono Lake, California'
}, {
  image: 'mahal.jpg',
  text: 'Hawa Mahal, Jaipur, India'
}, {
  image: 'tajmahal.jpg',
  text: 'Taj Mahal, India'
}, {
  image: 'acropolis.jpg',
  text: 'The Acropolis, Athens, Greece'
}, {
  image: 'la.jpg',
  text: 'Los Angeles, California'
}, {
  image: 'denali.jpg',
  text: 'Mount Denali, Alaska'
}, {
  image: 'tahoe.jpg',
  text: 'Lake Tahoe, Nevada'
}, {
  image: 'navajo.jpg',
  text: 'Monument Valley Navajo Tribal Park, Arizona'
}, {
  image: 'morainta.jpg',
  text: 'Moraine Lake, Alberta, Canada'
}, {
  image: 'tigers.jpg',
  text: 'Tiger\'s Nest, Bhutan'
}, {
  image: 'basil.jpg',
  text: 'St. Basil\'s Cathedral, Moscow, Russia'
}, {
  image: 'eiffel.jpg',
  text: 'Eiffel Tower, Paris, France'
}]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var masthead = _lodash2.default.sample(mastheads);

exports.default = {
  static: {
    masthead: (0, _assign2.default)(masthead, {
      image: __webpack_require__("so8r")("./" + masthead.image)
    })
  },
  data: function data() {
    return {
      active: false,
      displayBg: false
    };
  },
  mounted: function mounted() {
    this.displayBg = true;
  }
};

/***/ }),

/***/ "coLc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swatch = __webpack_require__("di2f");

var _swatch2 = _interopRequireDefault(_swatch);

var _clipboard = __webpack_require__("Hyns");

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'annotatorControls',
  props: {
    selection: Object,
    annotation: Object,
    on: Boolean
  },
  components: { AnnotationSwatch: _swatch2.default, Clipboard: _clipboard2.default },
  data: function data() {
    return {
      editing: !_.get(this.annotation, "id") && !_.get(this.annotation, "overlap"),
      quickResponse: false,
      swatchOpen: false
    };
  },
  mounted: function mounted() {
    this.$emit('controlsMounted');
    $(this.$el).on("click", function (e) {
      e.stopPropagation();
    });
  },

  methods: {
    emit: function emit(event) {
      this.$emit(event);
    },
    save: function save() {
      var method = this.annotation.id ? "DSSave" : "DSCreate";
      this.annotation[method]();
      this.$emit("close");
    },
    remove: function remove() {
      this.annotation.DSDestroy();
      this.$emit("close");
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF"), __webpack_require__("7t+N")))

/***/ }),

/***/ "cxtI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dRl+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "annotationFavorites",
  endpoint: "annotation-favorites",
  relations: {
    belongsTo: {
      users: {
        parent: true,
        localKey: "userId",
        localField: "user"
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "dRwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-star\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-star</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-star_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-star_icon-star\">\n            <path d=\"M19.29,8 C19.29,8.1600008 19.190001,8.339999 18.99,8.54 L14.95,12.48 L15.91,18.06 L15.91,18.3 C15.91,18.4466674 15.8700004,18.5733328 15.79,18.68 C15.7099996,18.7866672 15.6000007,18.8433333 15.46,18.85 C15.3199993,18.8566667 15.1700008,18.8133338 15.01,18.72 L9.99,16.08 L4.99,18.72 C4.8299992,18.8133338 4.6766674,18.86 4.53,18.86 C4.3833326,18.86 4.2700004,18.8000006 4.19,18.68 C4.1099996,18.5599994 4.07,18.433334 4.07,18.3 C4.07,18.2466664 4.0766666,18.1666672 4.09,18.06 L5.05,12.48 L0.99,8.54 C0.8033324,8.339999 0.71,8.1600008 0.71,8 C0.71,7.7199986 0.9166646,7.546667 1.33,7.48 L6.93,6.68 L9.45,1.6 C9.5966674,1.2933318 9.7766656,1.14 9.99,1.14 C10.2033344,1.14 10.3899992,1.2933318 10.55,1.6 L13.05,6.68 L18.65,7.48 C19.0766688,7.546667 19.29,7.7199986 19.29,8 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "dVC9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "di2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Annotator/swatch.vue
var swatch = __webpack_require__("TAwG");
var swatch_default = /*#__PURE__*/__webpack_require__.n(swatch);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60595e90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Annotator/swatch.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"swatch",staticStyle:{"position":"absolute"}},[_c('ul',_vm._l((_vm.colors),function(color){return _c('li',[_c('button',{on:{"click":function($event){_vm.updateValue(color.id)}}},[_c('i',{class:['color-swatch-item', 'color-'+color.id]}),_vm._v(" "+_vm._s(color.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Annotator_swatch = (esExports);
// CONCATENATED MODULE: ./src/components/Annotator/swatch.vue
function injectStyle (ssrContext) {
  __webpack_require__("4xQm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60595e90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  swatch_default.a,
  Annotator_swatch,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_Annotator_swatch = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dp1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/write-response.vue
var write_response = __webpack_require__("ezjI");
var write_response_default = /*#__PURE__*/__webpack_require__.n(write_response);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0cc51f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/write-response.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.model.question.promptHtml)}}),_vm._v(" "),(_vm.respondable)?[_c('redactor',{staticClass:"redactor--expand",attrs:{"placeholder":"Begin typing...","value":_vm.model.response},on:{"input":_vm.updateValue}}),_vm._v(" "),_c('p',{staticClass:"status"},[_vm._v(_vm._s(_vm.status))])]:[_c('div',{staticClass:"response"},[_c('annotator',{attrs:{"config":{},"inject":_vm.userAssignment.teacherAnnotations,"on":false}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.model.annotatedResponse)}})])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_write_response = (esExports);
// CONCATENATED MODULE: ./src/components/_global/write-response.vue
function injectStyle (ssrContext) {
  __webpack_require__("2Kh8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b0cc51f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  write_response_default.a,
  _global_write_response,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_write_response = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dtjf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'Channels',
  routeConfig: {
    name: "channels", path: "/channels"
  },
  metaInfo: {
    title: "Channels"
  }
};

/***/ }),

/***/ "e1+q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _text = __webpack_require__("fnYC");

var _text2 = _interopRequireDefault(_text);

var _image = __webpack_require__("oFOu");

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__("SiIu");

var _video2 = _interopRequireDefault(_video);

var _audio = __webpack_require__("vyiQ");

var _audio2 = _interopRequireDefault(_audio);

var _numberCrunch = __webpack_require__("XzEq");

var _numberCrunch2 = _interopRequireDefault(_numberCrunch);

var _researchLinks = __webpack_require__("6eYy");

var _researchLinks2 = _interopRequireDefault(_researchLinks);

var _discuss = __webpack_require__("f6qw");

var _discuss2 = _interopRequireDefault(_discuss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ContentModule',
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    align: {
      type: String
    }
  },
  data: function data() {
    return {
      headline: {
        audio: "Listen",
        crunch: "Number Crunch",
        research: "Research Links",
        discuss: "Discuss"
      }
    };
  },

  components: { cmtext: _text2.default, cmimage: _image2.default, cmvideo: _video2.default, cmaudio: _audio2.default, cmcrunch: _numberCrunch2.default, cmresearch: _researchLinks2.default, cmdiscuss: _discuss2.default },
  computed: {
    componentName: function componentName() {
      return 'cm' + this.type;
    }
  }
}; //
//
//
//
//
//
//

/***/ }),

/***/ "e2VZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-menu\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-menu</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-menu_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-menu_icon-menu\">\n            <path d=\"M0,5.00930132 C0,5.13977775 0.0462097109,5.24850648 0.138630519,5.33549077 C0.231051327,5.42247506 0.33706184,5.46596656 0.456665239,5.46596656 L19.4735105,5.46596656 C19.603987,5.46596656 19.7127157,5.42247506 19.7997,5.33549077 C19.8866843,5.24850648 19.9301758,5.13977775 19.9301758,5.00930132 L19.9301758,2.30192883 C19.9301758,2.1714524 19.8866843,2.06272366 19.7997,1.97573937 C19.7127157,1.88875508 19.603987,1.84526359 19.4735105,1.84526359 L0.456665239,1.84526359 C0.33706184,1.84526359 0.231051327,1.88875508 0.138630519,1.97573937 C0.0462097109,2.06272366 0,2.1714524 0,2.30192883 L0,5.00930132 Z M0,11.3536862 C0,11.4841627 0.0462097109,11.5928914 0.138630519,11.6798757 C0.231051327,11.76686 0.33706184,11.8103515 0.456665239,11.8103515 L19.4735105,11.8103515 C19.603987,11.8103515 19.7127157,11.76686 19.7997,11.6798757 C19.8866843,11.5928914 19.9301758,11.4841627 19.9301758,11.3536862 L19.9301758,8.64631376 C19.9301758,8.51583732 19.8866843,8.40710859 19.7997,8.3201243 C19.7127157,8.23314001 19.603987,8.18964852 19.4735105,8.18964852 L0.456665239,8.18964852 C0.33706184,8.18964852 0.231051327,8.23314001 0.138630519,8.3201243 C0.0462097109,8.40710859 0,8.51583732 0,8.64631376 L0,11.3536862 Z M0,17.6980712 C0,17.8285476 0.0462097109,17.9372763 0.138630519,18.0242606 C0.231051327,18.1112449 0.33706184,18.1547364 0.456665239,18.1547364 L19.4735105,18.1547364 C19.603987,18.1547364 19.7127157,18.1112449 19.7997,18.0242606 C19.8866843,17.9372763 19.9301758,17.8285476 19.9301758,17.6980712 L19.9301758,14.9906987 C19.9301758,14.8602222 19.8866843,14.7514935 19.7997,14.6645092 C19.7127157,14.5775249 19.603987,14.5340334 19.4735105,14.5340334 L0.456665239,14.5340334 C0.33706184,14.5340334 0.231051327,14.5775249 0.138630519,14.6645092 C0.0462097109,14.7514935 0,14.8602222 0,14.9906987 L0,17.6980712 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "ecni":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/acropolis.129795c.jpg";

/***/ }),

/***/ "ezjI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Annotator = __webpack_require__("Dzvx");

var _Annotator2 = _interopRequireDefault(_Annotator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusMessages = {
  idle: '',
  saving: 'Saving changes...',
  saved: 'Saved',
  error: 'Unable to save changes. Retrying...'
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var save = function save() {
  var vm = this;
  vm.model.DSSave().then(function () {
    return vm.status = statusMessages.saved;
  }).catch(function () {
    vm.status = statusMessages.error;
    _.delay(vm.startSaving, 5000);
  });
};

exports.default = {
  name: 'WriteResponse',
  props: {
    model: {
      type: Object,
      required: true
    },
    respondable: {
      type: Boolean,
      default: false
    }
  },
  components: { Annotator: _Annotator2.default },
  data: function data() {
    return {
      status: statusMessages.idle,
      debouncedSave: _.debounce(_.bind(save, this), 5000),
      userAssignment: this.$store.get('userAssignments', this.model.userAssignmentId)
    };
  },

  methods: {
    updateValue: function updateValue(newValue) {
      this.model.response = newValue;
      this.startSaving();
    },
    startSaving: function startSaving() {
      this.status = statusMessages.saving;
      this.debouncedSave();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "f+QQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/blast-reviews-received.vue
var blast_reviews_received = __webpack_require__("mjRF");
var blast_reviews_received_default = /*#__PURE__*/__webpack_require__.n(blast_reviews_received);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ecfd54a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/blast-reviews-received.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.blast.teacherReviewId)?_c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.blast.assignment.assignedBy)+"'s")]),_vm._v(" review:")]),_vm._v(" "),_c('div',{class:['rating', {single: _vm.single}]},[_c('p',[_vm._v("Teacher Rating")]),_vm._v(" "),_c('rubric-criteria',{attrs:{"rubric":_vm.blast.assignment.rubrics},model:{value:(_vm.blast.teacherReview.ratings),callback:function ($$v) {_vm.$set(_vm.blast.teacherReview, "ratings", $$v)},expression:"blast.teacherReview.ratings"}})],1),_vm._v(" "),_c('blockquote',{domProps:{"innerHTML":_vm._s(_vm.blast.teacherReview.review)}})]):_vm._e(),_vm._v(" "),(_vm.blast.peerReviewsReceived.length)?_c('div',[_c('div',{staticClass:"average"},[_c('p',[_vm._v("You've received "),_c('strong',[_vm._v(_vm._s(_vm.blast.peerReviewsReceived.length)+" peer")]),_vm._v(" reviews from others:")]),_vm._v(" "),_c('div',{class:['rating', {single: _vm.single}]},[_c('p',[_vm._v("Average Rating")]),_vm._v(" "),_c('rubric-criteria',{attrs:{"rubric":_vm.blast.assignment.rubrics},model:{value:(_vm.blast.reviewSummary),callback:function ($$v) {_vm.$set(_vm.blast, "reviewSummary", $$v)},expression:"blast.reviewSummary"}})],1)]),_vm._v(" "),_c('peer-reviews',{attrs:{"reviews":_vm.blast.peerReviewsReceived,"display":"received"}})],1):_c('div',[_vm._v("\n    You have not yet received any peer reviews. Check back later!\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_blast_reviews_received = (esExports);
// CONCATENATED MODULE: ./src/components/_global/blast-reviews-received.vue
function injectStyle (ssrContext) {
  __webpack_require__("2And")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ecfd54a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  blast_reviews_received_default.a,
  _global_blast_reviews_received,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_blast_reviews_received = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "f2BJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f4Eg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "users",
  computed: {
    fullName: {
      get: function get() {
        var fullName = this.fname;
        if (this.lname) {
          fullName = this.fname + " " + this.lname;
        }
        return fullName;
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "f6qw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/discuss.vue
var discuss = __webpack_require__("tGBv");
var discuss_default = /*#__PURE__*/__webpack_require__.n(discuss);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddeacb00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/discuss.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',_vm._l((_vm.data.questions),function(question){return _c('li',{domProps:{"innerHTML":_vm._s(question)}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var content_module_discuss = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/discuss.vue
function injectStyle (ssrContext) {
  __webpack_require__("HHDd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddeacb00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  discuss_default.a,
  content_module_discuss,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _global_content_module_discuss = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fBrG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fEC+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "blastBackgrounds"
});

exports.default = resource;

/***/ }),

/***/ "fHwL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chicago.eafe42d.jpg";

/***/ }),

/***/ "fi5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppHeader/SecondaryNavigation.vue
var SecondaryNavigation = __webpack_require__("HulK");
var SecondaryNavigation_default = /*#__PURE__*/__webpack_require__.n(SecondaryNavigation);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555fd27a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/SecondaryNavigation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{on:{"click":_vm.closeNav}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: 'assignments'}}},[_vm._v("Assignments")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'binder'}}},[_vm._v("Binder")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'logout'}}},[_vm._v(_vm._s(_vm.$session.session.isMimic ? 'Close' : 'Logout'))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var AppHeader_SecondaryNavigation = (esExports);
// CONCATENATED MODULE: ./src/components/AppHeader/SecondaryNavigation.vue
function injectStyle (ssrContext) {
  __webpack_require__("iOhP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-555fd27a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SecondaryNavigation_default.a,
  AppHeader_SecondaryNavigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_AppHeader_SecondaryNavigation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fklI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _controls = __webpack_require__("buV5");

var _controls2 = _interopRequireDefault(_controls);

var _swatch = __webpack_require__("di2f");

var _swatch2 = _interopRequireDefault(_swatch);

var _annotations = __webpack_require__("QjqZ");

var _annotations2 = _interopRequireDefault(_annotations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptySelection = function emptySelection() {
  return { start: null, end: null, highlighting: false, type: null };
}; //
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'annotator',
  props: {
    on: Boolean,
    readOnly: {
      type: Boolean,
      default: false
    },
    config: Object,
    inject: Array
  },
  components: { AnnotationControls: _controls2.default },
  data: function data() {
    return {
      selectionReady: true, //shitty
      selection: emptySelection(),
      showControls: true,
      tapper: false,
      controlsPositionTo: null,
      annotation: null,
      clearSelection: false,
      getWords: function getWords(start, end) {
        var _this = this;

        var _sort = [start, end].sort();

        var _sort2 = (0, _slicedToArray3.default)(_sort, 2);

        start = _sort2[0];
        end = _sort2[1];

        return $(_.map(_.range(start, end + 1), function (word) {
          return $('.word_' + word, _this.$el);
        }));
      }
    };
  },

  methods: {
    resetSelection: function resetSelection() {
      this.selection = emptySelection();
      this.selectionReady = false;
      this.showControls = false;
    },
    add: function add(annotations) {
      var _this2 = this;

      _.map(_.flatten([annotations]), function (annotation) {
        var isNew = !annotation.id;
        var words = _this2.getWords(annotation.startWord, annotation.endWord);
        words.each(function () {
          $(this).data("ssAnnotation", annotation.id).addClass("is-annotated").toggleClass("has-note", !!(annotation.note != null ? annotation.note.length : undefined));
          if (annotation.color) {
            return $(this).removeClass(function (index, css) {
              return (css.match(/(^|\s)color-\S+/g) || []).join(' ');
            }).addClass('color-' + annotation.color.id);
          }
        });
      });
    },
    remove: function remove(annotations) {
      var _this3 = this;

      _.map(_.flatten([annotations]), function (annotation) {
        var words = _this3.getWords(annotation.startWord, annotation.endWord);
        words.each(function (index, element) {
          $(element).data("ssAnnotation", null).removeClass('is-annotated has-note color-' + (annotation.color != null ? annotation.color.id : undefined));
        });
      });
    },
    injectFromStore: function injectFromStore() {
      this.add(this.inject);
    },
    controlSelection: function controlSelection(positionTo) {
      var _this4 = this;

      this.showControls = false;
      this.controlsPositionTo = null;
      this.$nextTick(function () {
        _this4.showControls = true;
        _this4.controlsPositionTo = positionTo;
      });
    },
    positionControls: function positionControls() {
      if (!this.controlsPositionTo) {
        return;
      }
      $(this.$refs.controls.$el).position({
        my: "center bottom",
        at: "center top",
        of: $('[data-word=' + this.controlsPositionTo + ']', this.$el),
        collision: "fit flip",
        within: this.$el,
        using: function using(coords, info) {
          if (info.vertical == 'top') {
            coords.top += 20;
          }
          $(info.element.element).css(coords).toggleClass("flipped", info.vertical == 'top');
        }
      });
    }
  },
  watch: {
    'selection': {
      handler: function handler(selection) {
        var start = selection.start;
        var end = selection.end || selection.start;
        $(".selected-word", this.$el).removeClass("selected-word");
        this.getWords(start, end).each(function () {
          return $(this).addClass("selected-word");
        });
      },

      deep: true
    },
    selectionReady: function selectionReady(ready) {
      if (ready) {
        this.selection.end = this.selection.end || this.selection.start;
        this.annotation = this.$store.createInstance('annotations', {
          startWord: this.selection.start,
          endWord: this.selection.end,
          text: _.map(this.getWords(this.selection.start, this.selection.end), function (word) {
            return $(word).text();
          }).join("").replace(/\s/g, " "),
          overlap: $(".is-annotated.selected-word", this.$el).length
        });
        _.assign(this.annotation, this.config);
        this.controlSelection(this.annotation.endWord);
      }
    },
    on: function on(_on) {
      if (document.selection) {
        document.selection.empty();
      } else if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
    }
  },
  created: function created() {
    var _this5 = this;

    _annotations2.default.on("DS.afterInject", function (store, annotations) {
      _this5.add(annotations);
    });
    _annotations2.default.on("DS.afterEject", function (store, annotations) {
      _this5.remove(annotations);
    });
  },
  destroyed: function destroyed() {
    _annotations2.default.off("DS.afterInject");
    _annotations2.default.off("DS.afterEject");
  },
  mounted: function mounted() {
    var _this6 = this;

    var $el = $(this.$el);
    var $words = $(".word", $el);
    var wordSelector = ".word:not(.is-annotated)";

    // Inject them
    this.injectFromStore();
    this.selectionReady = false;
    this.showControls = false;

    // Give all words a tabindex by default
    // a11y -- bring in later
    // $words.attr("tabindex", "0")

    // Setup event bindings
    $el
    // Allow text to be "selected"
    .on("mousedown", wordSelector, function (e) {
      if (!_this6.on) {
        return;
      }
      e.stopPropagation();
      var word = $(e.currentTarget).data("word");
      if (e.type == "mousedown") {
        _this6.resetSelection();
        _this6.selection.start = word;
        $el.on("mouseenter.annotationSelection", wordSelector, function (e) {
          _this6.selection.end = $(e.currentTarget).data("word");
        });
        $(document).one("mouseup", function (e) {
          _this6.selectionReady = true;
          $el.off("mouseenter.annotationSelection");
        });
      }
    })
    // Touch support
    .on("touchstart", wordSelector, function (e) {
      _this6.tapper = true;
      if (_this6.selectionReady) {
        _this6.resetSelection();
      }
    }).on("touchmove", wordSelector, function (e) {
      _this6.tapper = false;
    }).on("touchend", wordSelector, function (e) {
      e.preventDefault();
      if (!_this6.on || !_this6.tapper) {
        return;
      }
      var word = $(e.currentTarget).data("word");
      if (!_this6.selection.start) {
        _this6.resetSelection();
        _this6.selection.start = word;
      } else {
        _this6.selection.end = word;
        _this6.selectionReady = true;
      }
    })
    // Open control for annotation on click
    .on("click", ".is-annotated", function (e) {
      // if(!this.on) { return }
      var annotationId = $(e.currentTarget).data("ssAnnotation");
      _this6.annotation = _this6.$store.get('annotations', annotationId);
      _this6.controlSelection($(e.currentTarget).data("word"));
    })
    // Reset annotation when "esc" key is pressed
    .on("keyup", function (e) {
      if (e.keyCode === 27) {
        e.stopPropagation();
        _this6.resetSelection();
      }
    })
    // Give the annotations a "hover state"
    .on("mouseenter mouseleave", ".is-annotated", function (e) {
      if (!_this6.on) {
        return;
      }
      var annotation = _this6.$store.get('annotations', $(e.currentTarget).data("ssAnnotation"));
      if (annotation) {
        _this6.getWords(annotation.startWord, annotation.endWord).each(function () {
          $(this).toggleClass("hovered-word", e.type === "mouseenter");
        });
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("M4fF")))

/***/ }),

/***/ "flQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "flTr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fnYC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/text.vue
var content_module_text = __webpack_require__("leqZ");
var text_default = /*#__PURE__*/__webpack_require__.n(content_module_text);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d01e306","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/text.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",domProps:{"innerHTML":_vm._s(_vm.data.html)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_content_module_text = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/text.vue
function injectStyle (ssrContext) {
  __webpack_require__("LR4t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d01e306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  text_default.a,
  _global_content_module_text,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_content_module_text = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fqkn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/easter.28b95b3.jpg";

/***/ }),

/***/ "g1ph":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'ContentModuleAudio',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      active: false
    };
  },

  methods: {
    reveal: function reveal() {
      this.active = true;
    }
  }
};

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g68g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/logout/index.vue
var logout = __webpack_require__("lY6Q");
var logout_default = /*#__PURE__*/__webpack_require__.n(logout);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57603def","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/logout/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('container',[_c('div',{staticClass:"logo"},[_c('sprite',{attrs:{"name":"logoBlasts","width":"300"}})],1),_vm._v(" "),_c('div',{attrs:{"role":"alert"}},[_c('h1',[_vm._v("You have been logged off.")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":""},on:{"click":function($event){_vm.close()}}},[_vm._v("Please close this window or tab")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var routes_logout = (esExports);
// CONCATENATED MODULE: ./src/routes/logout/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("BuBz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57603def"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  logout_default.a,
  routes_logout,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_routes_logout = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gdcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/rubric-criteria.vue
var rubric_criteria = __webpack_require__("02K0");
var rubric_criteria_default = /*#__PURE__*/__webpack_require__.n(rubric_criteria);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1072d416","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/rubric-criteria.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.rubric.criteria),function(criteriaItem,criteriaIndex){return _c('li',[(_vm.rubric.criteria.length > 1)?_c('span',[_vm._v(_vm._s(criteriaItem.name))]):_vm._e(),_vm._v(" "),_c('ratings',{attrs:{"range":_vm.rubric.scoreRange,"read-only":true,"stars":_vm.rubric.criteria.length == 1},model:{value:(_vm.value[criteriaIndex]),callback:function ($$v) {_vm.$set(_vm.value, criteriaIndex, $$v)},expression:"value[criteriaIndex]"}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_rubric_criteria = (esExports);
// CONCATENATED MODULE: ./src/components/_global/rubric-criteria.vue
function injectStyle (ssrContext) {
  __webpack_require__("AxAM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1072d416"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  rubric_criteria_default.a,
  _global_rubric_criteria,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_rubric_criteria = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "h90m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-think",
  "use": "icon-think-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-think\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-think</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-think_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-think_icon-think\">\n            <path d=\"M20.0023419,10.4923626 C20.0023419,10.35207 19.9969462,10.2549457 19.9861544,10.200987 C19.9321957,9.240522 19.5922609,8.40957034 18.9663399,7.70810712 C18.545462,7.23327047 18.0328619,6.84477359 17.4285244,6.54260482 C16.9536877,5.77639115 16.3142866,5.1531774 15.5103018,4.67294488 C14.7063171,4.19271237 13.7998243,3.89864181 12.7907965,3.7907244 C11.7817686,3.68280698 10.7970369,3.76913962 9.83657191,4.04972491 C8.87610688,4.3303102 8.04515522,4.77816077 7.34369199,5.39329005 C6.10264167,5.10191302 4.91017208,5.12889197 3.76624744,5.47422771 C2.79499067,5.77639649 1.98022638,6.2566218 1.32193012,6.91491805 C0.836301738,7.3897547 0.482877492,7.93472949 0.261646784,8.54985878 C0.0404160747,9.16498806 -0.0405207755,9.80438918 0.0188338049,10.4680813 C0.0781883854,11.1317734 0.280530511,11.7657788 0.625866251,12.3701163 C0.895659799,12.844953 1.25717773,13.2820119 1.71043089,13.6813064 C2.42268585,14.2964357 3.27522068,14.7334947 4.26806093,14.9924965 C5.54148647,15.3270405 7.00374557,15.3432278 8.65488208,15.0410591 C9.32397008,15.5158957 10.0470059,15.8531326 10.8240114,16.0527798 C11.6010168,16.252427 12.3726147,16.303687 13.1388284,16.2065614 C13.7647494,16.1310192 14.3555885,15.9475623 14.9113632,15.6561853 C15.4671379,15.3648083 15.9608527,14.9924987 16.3925223,14.5392456 C17.450113,14.355786 18.2972521,13.9295186 18.9339648,13.2604306 C19.2793006,12.8827196 19.5436943,12.4591501 19.7271539,11.9897093 C19.9106135,11.5202685 20.0023419,11.021158 20.0023419,10.4923626 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "h96m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/louvre.0634f32.jpg";

/***/ }),

/***/ "hC4n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fitzroy.402cd1a.jpg";

/***/ }),

/***/ "hZfR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "annotationColors"
});

exports.default = resource;

/***/ }),

/***/ "hooP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__("u2KI");

var _freeze2 = _interopRequireDefault(_freeze);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _index = __webpack_require__("CDdB");

var _index2 = _interopRequireDefault(_index);

var _Detail = __webpack_require__("SELg");

var _Detail2 = _interopRequireDefault(_Detail);

var _index3 = __webpack_require__("PgOe");

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__("48cu");

var _index6 = _interopRequireDefault(_index5);

var _detail = __webpack_require__("aXN+");

var _detail2 = _interopRequireDefault(_detail);

var _index7 = __webpack_require__("sHVm");

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__("g68g");

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__("aCyy");

var _index12 = _interopRequireDefault(_index11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = {
  _404$index: _index2.default,
  Assignments$Detail: _Detail2.default,
  Assignments$index: _index4.default,
  Binder$index: _index6.default,
  Channels$detail: _detail2.default,
  Channels$index: _index8.default,
  logout$index: _index10.default,
  Profile$index: _index12.default
};
(0, _freeze2.default)(routes);


_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  base: '',
  routes: _lodash2.default.concat([
  // Defined Routes
  { path: '/', redirect: '/assignments' }],
  // Autoload from ./routes
  _lodash2.default.map(routes, function (route) {
    return _lodash2.default.assign({
      name: route.name.toLowerCase(),
      component: route
    }, route.routeConfig);
  })),

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/***/ }),

/***/ "i+2D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clipboard = __webpack_require__("V33R");

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Clipboard',
  props: ['text'],
  data: function data() {
    return {
      clipboard: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.clipboard = new _clipboard2.default(this.$el);
    this.clipboard.on('success', function (e) {
      e.clearSelection();
      _this.$emit('copied');
    });
  },
  destroyed: function destroyed() {
    this.clipboard.destroy();
  }
}; //
//
//
//

/***/ }),

/***/ "i1mO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/top10.vue
var top10 = __webpack_require__("qr+z");
var top10_default = /*#__PURE__*/__webpack_require__.n(top10);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b1cad9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/top10.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Top 10"}},[(!_vm.blast.blastPrompt.question.top || !_vm.blast.blastPrompt.question.top.length)?_c('div',[_c('p',[_vm._v("Check back soon and maybe you'll be in this list.")]),_vm._v(" "),_c('p',[_vm._v("You must rate at least "),_c('strong',[_vm._v("five")]),_vm._v(" peers and receive at least "),_c('strong',[_vm._v("five")]),_vm._v(" ratings to make the Top 10.")])]):_c('blast-top-10',{attrs:{"blast":_vm.blast}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_top10 = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/top10.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  top10_default.a,
  sidebar_top10,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_top10 = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iFUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-print\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-print</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-print_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-print_icon-print\">\n            <path d=\"M19.58,5.84 C19.7000006,5.84 19.7999996,5.8799996 19.88,5.96 C19.9600004,6.0400004 20,6.1333328 20,6.24 L20,17.9 C20,18.0200006 19.9600004,18.1233329 19.88,18.21 C19.7999996,18.2966671 19.7000006,18.34 19.58,18.34 L16.5,18.34 C16.3799994,18.34 16.2700005,18.3000004 16.17,18.22 C16.0699995,18.1399996 16.0066668,18.0400006 15.98,17.92 L15.66,16.24 C15.6333332,16.1333328 15.5700005,16.0400004 15.47,15.96 C15.3699995,15.8799996 15.2600006,15.84 15.14,15.84 L4.86,15.84 C4.7399994,15.84 4.6300005,15.8799996 4.53,15.96 C4.4299995,16.0400004 4.3666668,16.1333328 4.34,16.24 L4.02,17.92 C3.9933332,18.0400006 3.9300005,18.1399996 3.83,18.22 C3.7299995,18.3000004 3.6200006,18.34 3.5,18.34 L0.42,18.34 C0.2999994,18.34 0.2000004,18.2966671 0.12,18.21 C0.0399996,18.1233329 0,18.0200006 0,17.9 L0,6.24 C0,6.1333328 0.0399996,6.0400004 0.12,5.96 C0.2000004,5.8799996 0.2999994,5.84 0.42,5.84 L2.9,5.84 C3.0066672,5.84 3.1066662,5.8799996 3.2,5.96 C3.2933338,6.0400004 3.34,6.1333328 3.34,6.24 L3.34,8.74 C3.34,8.8600006 3.3766663,8.9599996 3.45,9.04 C3.5233337,9.1200004 3.6133328,9.16 3.72,9.16 L16.26,9.16 C16.3666672,9.16 16.4599996,9.1200004 16.54,9.04 C16.6200004,8.9599996 16.66,8.8600006 16.66,8.74 L16.66,6.24 C16.66,6.1333328 16.7033329,6.0400004 16.79,5.96 C16.8766671,5.8799996 16.9733328,5.84 17.08,5.84 L19.58,5.84 Z M1.66,8.36 C1.8866678,8.36 2.0833325,8.2766675 2.25,8.11 C2.4166675,7.9433325 2.5,7.7466678 2.5,7.52 C2.5,7.2933322 2.4166675,7.0966675 2.25,6.93 C2.0833325,6.7633325 1.8866678,6.68 1.66,6.68 C1.4333322,6.68 1.2400008,6.7633325 1.08,6.93 C0.9199992,7.0966675 0.84,7.2933322 0.84,7.52 C0.84,7.7466678 0.9199992,7.9433325 1.08,8.11 C1.2400008,8.2766675 1.4333322,8.36 1.66,8.36 Z M14.68,17.08 L15.32,19.6 C15.3466668,19.7066672 15.3300003,19.7999996 15.27,19.88 C15.2099997,19.9600004 15.1200006,20 15,20 L5,20 C4.8933328,20 4.806667,19.9600004 4.74,19.88 C4.673333,19.7999996 4.6533332,19.7066672 4.68,19.6 L5.32,17.08 C5.3466668,16.9599994 5.4099995,16.8600004 5.51,16.78 C5.6100005,16.6999996 5.7199994,16.66 5.84,16.66 L14.16,16.66 C14.2800006,16.66 14.3899995,16.6999996 14.49,16.78 C14.5900005,16.8600004 14.6533332,16.9599994 14.68,17.08 Z M4.58,8.28 C4.4733328,8.28 4.3833337,8.2400004 4.31,8.16 C4.2366663,8.0799996 4.2066666,7.9800006 4.22,7.86 L5.78,0.42 C5.8066668,0.2999994 5.8633329,0.2000004 5.95,0.12 C6.0366671,0.0399996 6.1399994,0 6.26,0 L13.76,0 C13.8666672,0 13.9666662,0.0399996 14.06,0.12 C14.1533338,0.2000004 14.2066666,0.2999994 14.22,0.42 L15.8,7.86 C15.8133334,7.9800006 15.7800004,8.0799996 15.7,8.16 C15.6199996,8.2400004 15.5266672,8.28 15.42,8.28 L4.58,8.28 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "iOhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ik46":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dubai.7aab216.jpg";

/***/ }),

/***/ "ikMx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ioLf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rome.51211f1.jpg";

/***/ }),

/***/ "izHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VisualVocab/definition.vue
var definition = __webpack_require__("nUEz");
var definition_default = /*#__PURE__*/__webpack_require__.n(definition);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a8b006c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VisualVocab/definition.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"definition",on:{"click":_vm.setAnswer}},[_c('div',{staticClass:"body"},[(_vm.definition.imageUrl)?_c('img',{staticClass:"image",attrs:{"src":_vm.definition.imageUrl}}):_vm._e(),_vm._v(" "),(_vm.definition.audioUrl)?_c('audio-button',{staticClass:"audio",attrs:{"src":_vm.definition.audioUrl}}):_vm._e(),_vm._v(" "),_c('h5',[_vm._v("\n      "+_vm._s(_vm.definition.term)+" "),(_vm.definition.altTerm)?_c('i',{staticClass:"alt-term"},[_vm._v("- "+_vm._s(_vm.definition.altTerm))]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"sample"},[_vm._v(_vm._s(_vm.definition.sample))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var VisualVocab_definition = (esExports);
// CONCATENATED MODULE: ./src/components/VisualVocab/definition.vue
function injectStyle (ssrContext) {
  __webpack_require__("MODg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a8b006c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  definition_default.a,
  VisualVocab_definition,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_VisualVocab_definition = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j328":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/assignment-completion-summary.vue
var assignment_completion_summary = __webpack_require__("wBG/");
var assignment_completion_summary_default = /*#__PURE__*/__webpack_require__.n(assignment_completion_summary);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a8cb76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/assignment-completion-summary.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.groups),function(group){return _c('li',[(group.complete)?_c('sprite',{staticClass:"icon-complete",attrs:{"name":"iconCheck"}}):_c('sprite',{staticClass:"icon-incomplete",attrs:{"name":"iconCheckOutline"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(group.title))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_assignment_completion_summary = (esExports);
// CONCATENATED MODULE: ./src/components/_global/assignment-completion-summary.vue
function injectStyle (ssrContext) {
  __webpack_require__("30+m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07a8cb76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  assignment_completion_summary_default.a,
  _global_assignment_completion_summary,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_assignment_completion_summary = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j707":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/Layout.vue
var Layout = __webpack_require__("pIzC");
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9c1bf4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/Layout.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{layout: true, active: _vm.expanded, closed: !_vm.expanded}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"scrollable"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar-nav"},[_vm._t("sidebarNav")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],staticClass:"sidebar-right"},[_c('div',{staticClass:"sidebar-content scrollable"},[_vm._t("questions")],2),_vm._v(" "),_c('transition',[_vm._t("bottom")],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var BlastStudent_Layout = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/Layout.vue
function injectStyle (ssrContext) {
  __webpack_require__("ikMx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a9c1bf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Layout_default.a,
  BlastStudent_Layout,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_BlastStudent_Layout = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j9od":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "khD7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__("Fi2f");

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_mixin2.default],
  props: {
    vm: {
      type: Object
    }
  }
};

/***/ }),

/***/ "kmoA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'RadioGroup',
  props: {
    value: {},
    name: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: this.value,
      settings: {
        labelProp: 'value',
        valueProp: 'response'
      },
      stamp: new Date().getTime()
    };
  },
  created: function created() {
    _.assign(this.settings, this.config);
  },

  methods: {
    intervalChar: function intervalChar(int) {
      return String.fromCharCode(64 + +int);
    },
    updateValue: function updateValue() {
      this.$emit('input', this.innerValue);
    }
  },
  watch: {
    value: function value(val) {
      this.innerValue = val;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "lMdH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin = __webpack_require__("Fi2f");

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ReviewDisplay',
  mixins: [_mixin2.default],
  data: function data() {
    return {
      activeTab: 'received',
      tabs: [{ key: 'received', label: 'Reviews Received (' + (this.blast.reviewsReceivedCount || 0) + ')' }, { key: 'given', label: 'Reviews Given (' + (this.blast.reviewsGivenCount || 0) + ')' }]
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "lY6Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Logout',
  routeConfig: {
    name: "logout", path: "/logout",
    meta: { public: true }
  },
  metaInfo: {
    title: "Logout"
  },
  data: function data() {
    return {
      showSignInLink: this.$classicParams.env == 'dev'
    };
  },
  created: function created() {
    var isMimic = _lodash2.default.get(this.$session, 'session.isMimic');
    this.$session.destroy();
    this.$classicParams.$destroy();
    if (isMimic) {
      this.close();
    }
  },

  methods: {
    close: function close() {
      window.close();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "lcqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppHeader/index.vue
var AppHeader = __webpack_require__("QmQ/");
var AppHeader_default = /*#__PURE__*/__webpack_require__.n(AppHeader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09960951","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{trans: _vm.trans}},[_c('primary-navigation'),_vm._v(" "),_c('div',{staticClass:"extras"},[_c('div',{staticClass:"user"},[_vm._v(_vm._s(_vm.$session.user.fullName))]),_vm._v(" "),_c('nav-toggle',{class:{active: _vm.isSecondaryNavActive},nativeOn:{"click":function($event){_vm.isSecondaryNavActive = !_vm.isSecondaryNavActive}}}),_vm._v(" "),_c('transition',[(_vm.isSecondaryNavActive)?_c('secondary-navigation',{on:{"close":function($event){_vm.isSecondaryNavActive = false}}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_AppHeader = (esExports);
// CONCATENATED MODULE: ./src/components/AppHeader/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("cxtI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09960951"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AppHeader_default.a,
  components_AppHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_AppHeader = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "leqZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//


exports.default = {
  name: 'ContentModuleText',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.0.2","/opt/atlassian/pipelines/agent/build/syncblasts-frontend"]],"_from":"vue-chartjs@3.0.2","_id":"vue-chartjs@3.0.2","_inBundle":false,"_integrity":"sha512-m6ItjL8o3ff4JpbF083RzZ4KPiNBFsqMKmWCcAtlisOdm1vvB/9mUDJePmxYKJkvl2AcpvLPiH1cUrhq46r8vA==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.0.2","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.0.2","saveSpec":null,"fetchSpec":"3.0.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.2.tgz","_spec":"3.0.2","_where":"/opt/atlassian/pipelines/agent/build/syncblasts-frontend","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.0.2"}

/***/ }),

/***/ "lts5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "responses",
  relations: {
    belongsTo: {
      questions: {
        localField: "question",
        localKey: "questionId"
      },
      userAssignments: {
        localField: "userAssigment",
        localKey: "userAssignmentId",
        parent: true
      }
    }
  }
});

exports.default = resource;

/***/ }),

/***/ "m110":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/goldengate.a3f417a.jpg";

/***/ }),

/***/ "m48A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m6Km":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'QuestionGroup',
  props: {
    headline: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ "mRjK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'Ratings',
  props: {
    value: {},
    range: {
      type: Array,
      required: true
    },
    name: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    stars: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: this.value,
      zeroBased: this.range[0] === 0,
      hovered: null
    };
  },

  methods: {
    updateValues: function updateValues() {
      this.$emit('input', this.innerValue);
    }
  }
};

/***/ }),

/***/ "mcHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module.vue
var content_module = __webpack_require__("e1+q");
var content_module_default = /*#__PURE__*/__webpack_require__.n(content_module);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ac1dd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['content', {wrapped: !!_vm.headline[_vm.type], left: _vm.align=='left', right: _vm.align=='right'}]},[(_vm.headline[_vm.type])?_c('h2',[_vm._v(_vm._s(_vm.headline[_vm.type]))]):_vm._e(),_vm._v(" "),_c(_vm.componentName,{tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_content_module = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module.vue
function injectStyle (ssrContext) {
  __webpack_require__("cF0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68ac1dd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  content_module_default.a,
  _global_content_module,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_content_module = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mj8Y":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "el6m",
	"./af.js": "el6m",
	"./ar": "k/LX",
	"./ar-dz": "8sQJ",
	"./ar-dz.js": "8sQJ",
	"./ar-kw": "Ypiv",
	"./ar-kw.js": "Ypiv",
	"./ar-ly": "vFBa",
	"./ar-ly.js": "vFBa",
	"./ar-ma": "5srG",
	"./ar-ma.js": "5srG",
	"./ar-sa": "OWdl",
	"./ar-sa.js": "OWdl",
	"./ar-tn": "zbnz",
	"./ar-tn.js": "zbnz",
	"./ar.js": "k/LX",
	"./az": "+TbT",
	"./az.js": "+TbT",
	"./be": "I3+K",
	"./be.js": "I3+K",
	"./bg": "6pzG",
	"./bg.js": "6pzG",
	"./bn": "BSxz",
	"./bn.js": "BSxz",
	"./bo": "xZM4",
	"./bo.js": "xZM4",
	"./br": "z7xq",
	"./br.js": "z7xq",
	"./bs": "CRbE",
	"./bs.js": "CRbE",
	"./ca": "vtJn",
	"./ca.js": "vtJn",
	"./cs": "50M2",
	"./cs.js": "50M2",
	"./cv": "imKR",
	"./cv.js": "imKR",
	"./cy": "0GzN",
	"./cy.js": "0GzN",
	"./da": "w5+c",
	"./da.js": "w5+c",
	"./de": "EVTu",
	"./de-at": "nG3g",
	"./de-at.js": "nG3g",
	"./de-ch": "Yt6q",
	"./de-ch.js": "Yt6q",
	"./de.js": "EVTu",
	"./dv": "qtbI",
	"./dv.js": "qtbI",
	"./el": "5alt",
	"./el.js": "5alt",
	"./en-au": "z0Rx",
	"./en-au.js": "z0Rx",
	"./en-ca": "3NXy",
	"./en-ca.js": "3NXy",
	"./en-gb": "+etJ",
	"./en-gb.js": "+etJ",
	"./en-ie": "9aRM",
	"./en-ie.js": "9aRM",
	"./en-nz": "nuu6",
	"./en-nz.js": "nuu6",
	"./eo": "ScLw",
	"./eo.js": "ScLw",
	"./es": "dvvA",
	"./es-do": "yg1m",
	"./es-do.js": "yg1m",
	"./es.js": "dvvA",
	"./et": "0unr",
	"./et.js": "0unr",
	"./eu": "RwsK",
	"./eu.js": "RwsK",
	"./fa": "0MmL",
	"./fa.js": "0MmL",
	"./fi": "3jre",
	"./fi.js": "3jre",
	"./fo": "wY+L",
	"./fo.js": "wY+L",
	"./fr": "khqN",
	"./fr-ca": "bEN0",
	"./fr-ca.js": "bEN0",
	"./fr-ch": "S4fe",
	"./fr-ch.js": "S4fe",
	"./fr.js": "khqN",
	"./fy": "1XdY",
	"./fy.js": "1XdY",
	"./gd": "Q4Vj",
	"./gd.js": "Q4Vj",
	"./gl": "ZUnQ",
	"./gl.js": "ZUnQ",
	"./gom-latn": "4dEw",
	"./gom-latn.js": "4dEw",
	"./he": "9PWd",
	"./he.js": "9PWd",
	"./hi": "d8Wo",
	"./hi.js": "d8Wo",
	"./hr": "YkY+",
	"./hr.js": "YkY+",
	"./hu": "79Lb",
	"./hu.js": "79Lb",
	"./hy-am": "DMpe",
	"./hy-am.js": "DMpe",
	"./id": "Ibyo",
	"./id.js": "Ibyo",
	"./is": "L3mU",
	"./is.js": "L3mU",
	"./it": "9XIi",
	"./it.js": "9XIi",
	"./ja": "x5kd",
	"./ja.js": "x5kd",
	"./jv": "30df",
	"./jv.js": "30df",
	"./ka": "JI1o",
	"./ka.js": "JI1o",
	"./kk": "HJwE",
	"./kk.js": "HJwE",
	"./km": "OTi2",
	"./km.js": "OTi2",
	"./kn": "2230",
	"./kn.js": "2230",
	"./ko": "dDkv",
	"./ko.js": "dDkv",
	"./ky": "PHd1",
	"./ky.js": "PHd1",
	"./lb": "vxmX",
	"./lb.js": "vxmX",
	"./lo": "K877",
	"./lo.js": "K877",
	"./lt": "Zk7u",
	"./lt.js": "Zk7u",
	"./lv": "JOTR",
	"./lv.js": "JOTR",
	"./me": "Ex1I",
	"./me.js": "Ex1I",
	"./mi": "jjiy",
	"./mi.js": "jjiy",
	"./mk": "gWcD",
	"./mk.js": "gWcD",
	"./ml": "kBLj",
	"./ml.js": "kBLj",
	"./mr": "V2NI",
	"./mr.js": "V2NI",
	"./ms": "KQOe",
	"./ms-my": "POgm",
	"./ms-my.js": "POgm",
	"./ms.js": "KQOe",
	"./my": "ZAKQ",
	"./my.js": "ZAKQ",
	"./nb": "MQ71",
	"./nb.js": "MQ71",
	"./ne": "PefK",
	"./ne.js": "PefK",
	"./nl": "aSId",
	"./nl-be": "Fpiv",
	"./nl-be.js": "Fpiv",
	"./nl.js": "aSId",
	"./nn": "YpEG",
	"./nn.js": "YpEG",
	"./pa-in": "r+L2",
	"./pa-in.js": "r+L2",
	"./pl": "eXAp",
	"./pl.js": "eXAp",
	"./pt": "I4bD",
	"./pt-br": "iAmb",
	"./pt-br.js": "iAmb",
	"./pt.js": "I4bD",
	"./ro": "tXyB",
	"./ro.js": "tXyB",
	"./ru": "ngkl",
	"./ru.js": "ngkl",
	"./sd": "OWeY",
	"./sd.js": "OWeY",
	"./se": "+EdD",
	"./se.js": "+EdD",
	"./si": "gaPs",
	"./si.js": "gaPs",
	"./sk": "jUKU",
	"./sk.js": "jUKU",
	"./sl": "DQFe",
	"./sl.js": "DQFe",
	"./sq": "M7V7",
	"./sq.js": "M7V7",
	"./sr": "bzhX",
	"./sr-cyrl": "33c5",
	"./sr-cyrl.js": "33c5",
	"./sr.js": "bzhX",
	"./ss": "NejB",
	"./ss.js": "NejB",
	"./sv": "w+2E",
	"./sv.js": "w+2E",
	"./sw": "Dll1",
	"./sw.js": "Dll1",
	"./ta": "jbxT",
	"./ta.js": "jbxT",
	"./te": "jB/5",
	"./te.js": "jB/5",
	"./tet": "VbPC",
	"./tet.js": "VbPC",
	"./th": "nLNk",
	"./th.js": "nLNk",
	"./tl-ph": "mfkQ",
	"./tl-ph.js": "mfkQ",
	"./tlh": "jXJl",
	"./tlh.js": "jXJl",
	"./tr": "92cT",
	"./tr.js": "92cT",
	"./tzl": "5MIk",
	"./tzl.js": "5MIk",
	"./tzm": "0vIq",
	"./tzm-latn": "3+Cq",
	"./tzm-latn.js": "3+Cq",
	"./tzm.js": "0vIq",
	"./uk": "Hd7b",
	"./uk.js": "Hd7b",
	"./ur": "XtGu",
	"./ur.js": "XtGu",
	"./uz": "uRCu",
	"./uz-latn": "1AHx",
	"./uz-latn.js": "1AHx",
	"./uz.js": "uRCu",
	"./vi": "FB03",
	"./vi.js": "FB03",
	"./x-pseudo": "APXS",
	"./x-pseudo.js": "APXS",
	"./yo": "/1ch",
	"./yo.js": "/1ch",
	"./zh-cn": "yEKL",
	"./zh-cn.js": "yEKL",
	"./zh-hk": "sjvb",
	"./zh-hk.js": "sjvb",
	"./zh-tw": "f55z",
	"./zh-tw.js": "f55z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mj8Y";

/***/ }),

/***/ "mjRF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'BlastReviewsReceived',
  props: {
    blast: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      single: this.blast.assignment.rubrics.criteria.length == 1
    };
  }
};

/***/ }),

/***/ "mv0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n0aw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/monolake.d9e3239.jpg";

/***/ }),

/***/ "nAdW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/peer-reviews/peer-review.vue
var peer_review = __webpack_require__("0AK1");
var peer_review_default = /*#__PURE__*/__webpack_require__.n(peer_review);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6b2fe4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/peer-reviews/peer-review.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{active: _vm.showResponse}},[_c('div',{staticClass:"upper"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.toggleResponse($event)}}},[_vm._v("\n      "+_vm._s(_vm.displayName)+"\n      "),_c('sprite',{staticClass:"down-arrow",attrs:{"name":"iconDownDir"}})],1),_vm._v(" "),_c('div',{staticClass:"ratings"},[_c('ratings',{attrs:{"range":_vm.review.rubrics.scoreRange,"read-only":true,"stars":_vm.review.rubrics.criteria.length == 1},model:{value:(_vm.review.averageScore),callback:function ($$v) {_vm.$set(_vm.review, "averageScore", $$v)},expression:"review.averageScore"}})],1)]),_vm._v(" "),_c('transition',[(_vm.showResponse)?_c('div',{staticClass:"response"},[(_vm.review.rubrics.criteria.length > 1)?_c('rubric-criteria',{attrs:{"rubric":_vm.review.rubrics},model:{value:(_vm.review.ratings),callback:function ($$v) {_vm.$set(_vm.review, "ratings", $$v)},expression:"review.ratings"}}):_vm._e(),_vm._v(" "),_c('blockquote',{domProps:{"innerHTML":_vm._s((_vm.display == 'given') ? _vm.review.revieweeUserAssignment.reviewQuestion.response : _vm.review.review)}}),_vm._v(" "),(_vm.display == 'given')?_c('p',{domProps:{"innerHTML":_vm._s(_vm.review.review)}}):_vm._e()],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var peer_reviews_peer_review = (esExports);
// CONCATENATED MODULE: ./src/components/_global/peer-reviews/peer-review.vue
function injectStyle (ssrContext) {
  __webpack_require__("IZGU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6b2fe4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  peer_review_default.a,
  peer_reviews_peer_review,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _global_peer_reviews_peer_review = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nUEz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _audioButton = __webpack_require__("1M2u");

var _audioButton2 = _interopRequireDefault(_audioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vocabDefinition',
  props: {
    value: Number,
    definition: Object
  },
  components: { AudioButton: _audioButton2.default },
  data: function data() {
    // To test image & alt term
    //
    // this.definition.imageUrl = 'http://95b2.http.cdn.softlayer.net/8095B2/content.studysync.com.s3-website-us-east-1.amazonaws.com/eld/06.01.10.RD.RR.05.Hatchet/positive.jpg'
    // this.definition.altTerm = 'En Espanish'
    // this.definition.audioUrl = 'https://www.sample-videos.com/audio/mp3/crowd-cheering.mp3'
    return {};
  },

  methods: {
    setAnswer: function setAnswer() {
      this.$emit("input", this.definition.id);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "nZ5y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/badlands.f7b52eb.jpg";

/***/ }),

/***/ "niYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/assignmentSubmitted.vue
var assignmentSubmitted = __webpack_require__("7qbW");
var assignmentSubmitted_default = /*#__PURE__*/__webpack_require__.n(assignmentSubmitted);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8ba6954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/assignmentSubmitted.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":'You have completed '+_vm.blast.assignment.name}},[(_vm.blast.assignment.features.reviews && !_vm.vm.peerReviewPending)?_c('div',[(_vm.vm.activeReview)?_c('div',[_c('p',[_vm._v("You have "+_vm._s(_vm.blast.reviewsAvailableCount)+" peer review(s) available.")]),_vm._v(" "),_c('btn',{on:{"click":function($event){$event.preventDefault();_vm.vm.setActiveTab('rate')}}},[_vm._v("Rate your peers")])],1):_c('p',[_vm._v(_vm._s(_vm.noReviewsAvailableMessage))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_assignmentSubmitted = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/assignmentSubmitted.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  assignmentSubmitted_default.a,
  sidebar_assignmentSubmitted,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_assignmentSubmitted = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o5UV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o7gd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/radio-group.vue
var radio_group = __webpack_require__("kmoA");
var radio_group_default = /*#__PURE__*/__webpack_require__.n(radio_group);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb70dfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/radio-group.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-group"},_vm._l((_vm.options),function(option,index){return _c('label',{class:{selected: _vm.innerValue==option[_vm.settings.valueProp], interactive: !_vm.disabled, disabled: _vm.disabled}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.innerValue),expression:"innerValue"}],attrs:{"type":"radio","name":_vm.name || 'radio'+_vm.stamp,"disabled":_vm.disabled},domProps:{"value":option[_vm.settings.valueProp],"checked":_vm._q(_vm.innerValue,option[_vm.settings.valueProp])},on:{"change":[function($event){_vm.innerValue=option[_vm.settings.valueProp]},_vm.updateValue]}}),_vm._v(" "),_vm._t('bullet-'+index,[_c('span',{staticClass:"bullet"},[_vm._v(_vm._s(_vm.intervalChar(index+1)))])]),_vm._v(" "),_c('div',{staticClass:"option-text"},[_vm._v("\n      "+_vm._s(option[_vm.settings.labelProp])+"\n      "),_vm._t('lower-'+index)],2)],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_radio_group = (esExports);
// CONCATENATED MODULE: ./src/components/_global/radio-group.vue
function injectStyle (ssrContext) {
  __webpack_require__("j9od")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6eb70dfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  radio_group_default.a,
  _global_radio_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_radio_group = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oFOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/image.vue
var content_module_image = __webpack_require__("Vxcp");
var image_default = /*#__PURE__*/__webpack_require__.n(content_module_image);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47374db2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{attrs:{"src":_vm.data.src,"alt":""}}),_vm._v(" "),_c('figcaption',{domProps:{"innerHTML":_vm._s(_vm.data.caption)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_content_module_image = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/image.vue
function injectStyle (ssrContext) {
  __webpack_require__("fBrG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47374db2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  image_default.a,
  _global_content_module_image,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_content_module_image = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oNG1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'comp',
  mixins: [_sidebar2.default]
}; //
//
//
//
//
//

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oULx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "ping"
});

exports.default = resource;

/***/ }),

/***/ "oeGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-check\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-check</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-check_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-check_icon-check\">\n            <path d=\"M18.66,5.91277344 C18.66,6.20610824 18.5533344,6.45943904 18.34,6.67277344 L8.74,16.2727734 C8.5266656,16.4727744 8.2733348,16.5727734 7.98,16.5727734 C7.6866652,16.5727734 7.4333344,16.4727744 7.22,16.2727734 L1.66,10.7127734 C1.459999,10.499439 1.36,10.2461082 1.36,9.95277344 C1.36,9.65943864 1.459999,9.40610784 1.66,9.19277344 L3.18,7.67277344 C3.3933344,7.45943904 3.6466652,7.35277344 3.94,7.35277344 C4.2333348,7.35277344 4.4866656,7.45943904 4.7,7.67277344 L7.98,10.9727734 L15.3,3.63277344 C15.5133344,3.41943904 15.7666652,3.31277344 16.06,3.31277344 C16.3533348,3.31277344 16.6066656,3.41943904 16.82,3.63277344 L18.34,5.15277344 C18.5533344,5.35277444 18.66,5.60610524 18.66,5.91277344 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "ov2f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__("u2KI");

var _freeze2 = _interopRequireDefault(_freeze);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _classicParams = __webpack_require__("789/");

var _classicParams2 = _interopRequireDefault(_classicParams);

var _annotationColors = __webpack_require__("hZfR");

var _annotationColors2 = _interopRequireDefault(_annotationColors);

var _annotationFavorites = __webpack_require__("dRl+");

var _annotationFavorites2 = _interopRequireDefault(_annotationFavorites);

var _annotations = __webpack_require__("QjqZ");

var _annotations2 = _interopRequireDefault(_annotations);

var _assignments = __webpack_require__("OW3S");

var _assignments2 = _interopRequireDefault(_assignments);

var _blastBackgrounds = __webpack_require__("fEC+");

var _blastBackgrounds2 = _interopRequireDefault(_blastBackgrounds);

var _channels = __webpack_require__("/wwO");

var _channels2 = _interopRequireDefault(_channels);

var _media = __webpack_require__("v62T");

var _media2 = _interopRequireDefault(_media);

var _ping = __webpack_require__("oULx");

var _ping2 = _interopRequireDefault(_ping);

var _questionGroups = __webpack_require__("FKUz");

var _questionGroups2 = _interopRequireDefault(_questionGroups);

var _questions = __webpack_require__("DkTw");

var _questions2 = _interopRequireDefault(_questions);

var _responses = __webpack_require__("lts5");

var _responses2 = _interopRequireDefault(_responses);

var _reviews = __webpack_require__("cCGf");

var _reviews2 = _interopRequireDefault(_reviews);

var _rubrics = __webpack_require__("/i4I");

var _rubrics2 = _interopRequireDefault(_rubrics);

var _sessions = __webpack_require__("KWO8");

var _sessions2 = _interopRequireDefault(_sessions);

var _syncblastAsset = __webpack_require__("N9x1");

var _syncblastAsset2 = _interopRequireDefault(_syncblastAsset);

var _user = __webpack_require__("f4Eg");

var _user2 = _interopRequireDefault(_user);

var _userAssignments = __webpack_require__("DxDC");

var _userAssignments2 = _interopRequireDefault(_userAssignments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var models = {
  annotationColors: _annotationColors2.default,
  annotationFavorites: _annotationFavorites2.default,
  annotations: _annotations2.default,
  assignments: _assignments2.default,
  blastBackgrounds: _blastBackgrounds2.default,
  channels: _channels2.default,
  media: _media2.default,
  ping: _ping2.default,
  questionGroups: _questionGroups2.default,
  questions: _questions2.default,
  responses: _responses2.default,
  reviews: _reviews2.default,
  rubrics: _rubrics2.default,
  sessions: _sessions2.default,
  syncblastAsset: _syncblastAsset2.default,
  user: _user2.default,
  userAssignments: _userAssignments2.default
};
(0, _freeze2.default)(models);


var Store = {

  required: true,

  onReady: null,

  install: function install(Vue, options) {
    Vue.prototype.$store = _store2.default;

    this.onReady = new _promise2.default(function (resolve, reject) {

      _classicParams2.default.onReady.then(function (params) {
        // Determine API Host URL
        var apiHost = function () {
          switch (params.env) {
            case "dev":
              return "http://localhost:9999";
            case "test":
              return "https://test-api.studysync.com";
            case "staging":
              return "https://staging-api.studysync.com";
            case "production":
              return "https://api.studysync.com";
            default:
              return "https://test-api.studysync.com/v2";
          }
        }();
        // Tell our DS adapter to use api host as basePath
        _.set(_store2.default.adapters.http.defaults, "basePath", apiHost + "/v2");
        _.set(_store2.default.adapters.http.defaults, "httpConfig.headers.common.token", sessionStorage.token);
        // Expose the store to window if we're in dev
        if (params.env == 'dev') {
          window.$store = _store2.default;
        }
        // Ready
        resolve();
      });
    });
  }
};

_vue2.default.use(Store);

exports.default = Store;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "p9D3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pIzC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'BlastStudentLayout',
  props: {
    expanded: {
      type: Boolean
    }
  }
};

/***/ }),

/***/ "pL8Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__("u2KI");

var _freeze2 = _interopRequireDefault(_freeze);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _mixin = __webpack_require__("Fi2f");

var _mixin2 = _interopRequireDefault(_mixin);

var _Masthead = __webpack_require__("1BCN");

var _Masthead2 = _interopRequireDefault(_Masthead);

var _Layout = __webpack_require__("j707");

var _Layout2 = _interopRequireDefault(_Layout);

var _Annotator = __webpack_require__("Dzvx");

var _Annotator2 = _interopRequireDefault(_Annotator);

var _assignmentSubmitted = __webpack_require__("niYG");

var _assignmentSubmitted2 = _interopRequireDefault(_assignmentSubmitted);

var _blast = __webpack_require__("cA3V");

var _blast2 = _interopRequireDefault(_blast);

var _comp = __webpack_require__("pXlB");

var _comp2 = _interopRequireDefault(_comp);

var _quikpoll = __webpack_require__("W8Ih");

var _quikpoll2 = _interopRequireDefault(_quikpoll);

var _rate = __webpack_require__("+ebk");

var _rate2 = _interopRequireDefault(_rate);

var _top = __webpack_require__("i1mO");

var _top2 = _interopRequireDefault(_top);

var _vocab = __webpack_require__("PtPl");

var _vocab2 = _interopRequireDefault(_vocab);

var _write = __webpack_require__("GoCM");

var _write2 = _interopRequireDefault(_write);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sidebarComponents = {
  assignmentSubmitted: _assignmentSubmitted2.default,
  blast: _blast2.default,
  comp: _comp2.default,
  quikpoll: _quikpoll2.default,
  rate: _rate2.default,
  top10: _top2.default,
  vocab: _vocab2.default,
  write: _write2.default
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


(0, _freeze2.default)(sidebarComponents);
exports.default = {
  name: 'BlastStudent',
  mixins: [_mixin2.default],
  components: _.assign({ Masthead: _Masthead2.default, Layout: _Layout2.default, Annotator: _Annotator2.default }, sidebarComponents),
  data: function data() {

    return {
      vm: this,
      sidebarComponents: sidebarComponents,
      layoutExpanded: false,
      activeTab: null,
      showPeerReviewConfirmation: false,
      peerReviewPending: false,
      activeReview: this.blast.getNextOpenReview(),
      showSubmitTooltip: false,
      sidebarNavData: [{
        key: "rate",
        title: "Review",
        icon: "iconStar",
        displayOrderOpen: 999,
        displayOrderClosed: 1
      }, {
        key: "top10",
        title: "Top 10",
        icon: "iconRibbon",
        displayOrderOpen: 999,
        displayOrderClosed: 2
      }, {
        key: "quikpoll",
        title: "QuikPoll",
        icon: "iconQuikpoll",
        questionGroupId: 11,
        displayOrderOpen: 1,
        displayOrderClosed: 7
      }, {
        key: "vocab",
        title: "Vocab",
        icon: "iconBlast",
        questionGroupId: 1,
        displayOrderOpen: 2,
        displayOrderClosed: 6
      }, {
        key: "comp",
        title: "Comp",
        icon: "iconThink",
        questionGroupId: 7,
        displayOrderOpen: 3,
        displayOrderClosed: 5
      }, {
        key: "blast",
        title: "Blast",
        icon: "iconBlast",
        questionGroupId: 10,
        displayOrderOpen: 4,
        displayOrderClosed: 3
      }, {
        key: "write",
        title: "Write",
        icon: "iconAnnotation",
        questionGroupId: 9,
        displayOrderOpen: 5,
        displayOrderClosed: 4
      }]
    };
  },

  computed: {
    prompt: function prompt() {
      var words = this.blast.assignment.syncblastAsset.prompt.split(' ');
      var lastWords = words.splice(-2, 2).join('&nbsp;');
      words.push(lastWords);
      return words.join(' ');
    },
    activeTabKey: function activeTabKey() {
      return this.activeTab ? this.activeTab.key : null;
    },
    nextTab: function nextTab() {
      var index = _.indexOf(this.sidebarModules, this.activeTab) + 1;
      return index == this.sidebarModules.length ? null : this.sidebarModules[index];
    },
    sidebarModules: function sidebarModules() {
      var _this = this;

      var navData = void 0;
      if (this.blast.isOpen) {
        // QUICK / VOCAB / COMP / BLAST / WRITE order of tabs before submission from top to bottom
        navData = _.orderBy(this.sidebarNavData, "displayOrderOpen");
      } else {
        // REVIEW / TOP 10 / BLAST / WRITE / COMP / VOCAB / QUICK after submission from top to bottom
        navData = _.orderBy(this.sidebarNavData, "displayOrderClosed");
      }
      var modules = _.filter(navData, function (module) {
        var allowed = function () {
          switch (module.key) {
            case "top10":
              return !_this.blast.isOpen && _this.blast.blastPrompt;
            case "submit":
              return _this.blast.isOpen;
            case "rate":
              return !_this.blast.isOpen && _this.blast.assignment.features.reviews;
            default:
              return _this.blast.questionGroupIds.includes(module.questionGroupId);
          }
        }();
        return allowed;
      });
      return modules;
    },
    backdropVideo: function backdropVideo() {
      var asset = this.blast.assignment.syncblastAsset;
      if (asset.bannerVideo) {
        return asset.backdropVideo;
      }
      return null;
    }
  },
  methods: {
    saveAssignment: function saveAssignment() {
      var responses = _.map(this.blast.responses, function (response) {
        if (response.response) {
          return response.DSSave();
        } else {
          return _promise2.default.resolve();
        }
      });
      return _promise2.default.all(responses);
    },
    submitAssignment: function submitAssignment() {
      var _this2 = this;

      this.saveAssignment().then(function () {
        _this2.peerReviewPending = true;
        _this2.setActiveTab({ key: "assignmentSubmitted" });
        _this2.blast.submitAssignment().then(function () {
          _this2.setActiveReview();
          _this2.peerReviewPending = false;
        });
      });
    },
    setActiveTab: function setActiveTab(tab) {
      this.layoutExpanded = true;
      this.activeTab = _.isString(tab) ? _.find(this.sidebarNavData, { key: tab }) : tab;
    },
    setActiveReview: function setActiveReview() {
      return this.activeReview = this.blast.getNextOpenReview();
    },
    savePeerReview: function savePeerReview() {
      var _this3 = this;

      this.peerReviewPending = true;
      this.activeReview.DSSave().then(function () {
        return _this3.blast.DSRefresh();
      }).then(function () {
        _this3.setActiveReview();
        _this3.peerReviewPending = false;
      });
    }
  },
  watch: {
    layoutExpanded: function layoutExpanded(expanded) {
      if (expanded && !this.activeTab) {
        this.setActiveTab(_.first(this.sidebarModules));
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "pXlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/sidebar/comp.vue
var comp = __webpack_require__("oNG1");
var comp_default = /*#__PURE__*/__webpack_require__.n(comp);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaaf9836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/sidebar/comp.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-group',{attrs:{"headline":"Comprehension"}},[_c('comprehension',{attrs:{"models":_vm.blast.compResponses,"respondable":_vm.blast.isOpen}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sidebar_comp = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/sidebar/comp.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  comp_default.a,
  sidebar_comp,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var BlastStudent_sidebar_comp = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pbZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/question-group.vue
var question_group = __webpack_require__("m6Km");
var question_group_default = /*#__PURE__*/__webpack_require__.n(question_group);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f48e6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/question-group.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['module']},[_c('div',{staticClass:"wrap"},[_c('h3',[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('form',[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_question_group = (esExports);
// CONCATENATED MODULE: ./src/components/_global/question-group.vue
function injectStyle (ssrContext) {
  __webpack_require__("LdAm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25f48e6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  question_group_default.a,
  _global_question_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_question_group = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pjET":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q3k8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SessionWarning/index.vue
var SessionWarning = __webpack_require__("QO//");
var SessionWarning_default = /*#__PURE__*/__webpack_require__.n(SessionWarning);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a998dd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionWarning/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal && !_vm.loggedOut)?_c('modal',{attrs:{"title":"Your session is about to expire."}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n      Time remaining:\n      "),_c('countdown',{attrs:{"time":_vm.sessionExpires},on:{"countdownend":function($event){_vm.logout()}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.seconds)+" seconds.")]}}])})],1),_vm._v(" "),_c('btn',{on:{"click":function($event){$event.preventDefault();_vm.extend()}}},[_vm._v("Keep Working")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_SessionWarning = (esExports);
// CONCATENATED MODULE: ./src/components/SessionWarning/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("zOnD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a998dd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SessionWarning_default.a,
  components_SessionWarning,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_SessionWarning = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q97C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppHeader/PrimaryNavigation.vue
var PrimaryNavigation = __webpack_require__("VqW9");
var PrimaryNavigation_default = /*#__PURE__*/__webpack_require__.n(PrimaryNavigation);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8e40ab4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/PrimaryNavigation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('router-link',{staticClass:"logo",attrs:{"to":{name: 'assignments'}}},[_c('sprite',{attrs:{"name":"logoBlasts"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var AppHeader_PrimaryNavigation = (esExports);
// CONCATENATED MODULE: ./src/components/AppHeader/PrimaryNavigation.vue
function injectStyle (ssrContext) {
  __webpack_require__("GX5x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8e40ab4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PrimaryNavigation_default.a,
  AppHeader_PrimaryNavigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_AppHeader_PrimaryNavigation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q9iy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHdV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/liriver.d8c8819.jpg";

/***/ }),

/***/ "qOgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/btn.vue
var btn = __webpack_require__("9hrF");
var btn_default = /*#__PURE__*/__webpack_require__.n(btn);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4563395c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/btn.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click', $event)},"mouseenter":function($event){_vm.$emit('mouseenter', $event)},"mouseleave":function($event){_vm.$emit('mouseleave', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_btn = (esExports);
// CONCATENATED MODULE: ./src/components/_global/btn.vue
function injectStyle (ssrContext) {
  __webpack_require__("/0Rk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4563395c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  btn_default.a,
  _global_btn,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_btn = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qr+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__("khD7");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'top10',
  mixins: [_sidebar2.default]
}; //
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "qw2f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rCzz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("taAx");

__webpack_require__("Up1f");

/***/ }),

/***/ "rNxO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WHITELIST = [_store2.default.adapters.http.defaults.basePath.replace(/https?:\/\//, ""), "studysync.com", "mackinvia.com", "mheducation.desire2learn.com", "95b2.http.cdn.softlayer.net", "95b2.https.cdn.softlayer.net"];

var openInWindow = function openInWindow(href) {
  var target = window.cordova ? "_system" : "_blank";
  window.open(href, target);
};

exports.default = {
  name: "externalLinkWarning",

  // When the bound element is inserted into the DOM...
  inserted: function inserted(el) {
    $(el).on("click", "a", function (e) {
      var hostName = e.currentTarget.hostname;
      var href = e.currentTarget.href;

      // only go further if they clicked a different host than the current host
      if (hostName && hostName != window.location.hostname) {
        // Prevent the link from taking over so we can force a new window
        e.preventDefault();

        // If we have the url whitelisted, let's open it in a new window
        if (_.some(WHITELIST, function (domain) {
          return _.includes(hostName, domain);
        })) {
          openInWindow(href);
        } else {
          // If we're not whitelisted, let's confirm with the user before opening the window, allowing them to cancel the action
          if (confirm("You are about to leave SyncBlasts and visit another website. Do you want to continue?")) {
            openInWindow(href);
          }
        }
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("M4fF")))

/***/ }),

/***/ "rYtj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/heceta.4356d8f.jpg";

/***/ }),

/***/ "rotc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rqdQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'ContentModuleAudio',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "rson":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/interactive-text.vue
var interactive_text = __webpack_require__("HckQ");
var interactive_text_default = /*#__PURE__*/__webpack_require__.n(interactive_text);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdd06bb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/interactive-text.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'interactive-text': true, annotationOn: _vm.annotationOn}},[_c('annotator',{attrs:{"config":_vm.annotationConfig,"on":_vm.annotationOn}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_interactive_text = (esExports);
// CONCATENATED MODULE: ./src/components/_global/interactive-text.vue
function injectStyle (ssrContext) {
  __webpack_require__("6S3C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  interactive_text_default.a,
  _global_interactive_text,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_interactive_text = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sHVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/Channels/index.vue
var Channels = __webpack_require__("dtjf");
var Channels_default = /*#__PURE__*/__webpack_require__.n(Channels);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431f00d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Channels/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  channels\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var routes_Channels = (esExports);
// CONCATENATED MODULE: ./src/routes/Channels/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("vDSc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-431f00d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Channels_default.a,
  routes_Channels,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_routes_Channels = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sKqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/redactor.vue
var redactor = __webpack_require__("3klC");
var redactor_default = /*#__PURE__*/__webpack_require__.n(redactor);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394b1c9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/redactor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.innerValue),expression:"innerValue"}],ref:"textarea",domProps:{"value":(_vm.innerValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.innerValue=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_redactor = (esExports);
// CONCATENATED MODULE: ./src/components/_global/redactor.vue
function injectStyle (ssrContext) {
  __webpack_require__("pjET")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-394b1c9d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  redactor_default.a,
  _global_redactor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_redactor = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sSYw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/denali.d4d5840.jpg";

/***/ }),

/***/ "sW16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-star-outline",
  "use": "icon-star-outline-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-star-outline\">\n    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-star-outline</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-star-outline_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-star-outline_icon-star-outline\" fill-rule=\"nonzero\">\n            <path d=\"M12.3858987,7.59528092 L12.1527647,7.12155279 L9.99875372,2.74405862 L7.59210004,7.59556682 L7.07142136,7.66994949 L2.24038361,8.35995587 L6.12495588,12.1297132 L6.03552124,12.649552 L5.20421743,17.4760599 L9.98906949,14.949658 L10.4554557,15.1949288 L14.7952001,17.4781198 L13.8753114,12.1312668 L14.251809,11.7640884 L17.7419508,8.36043123 L12.3858987,7.59528092 Z M14.91,18.06 L14.91,18.1453942 L14.9223121,18.2169583 C14.9350294,18.1713652 14.9575959,18.1232054 14.99,18.08 C14.9950936,18.0732085 15.0003534,18.0665405 15.0057692,18.06 L14.91,18.06 Z M19.29,8 C19.29,8.1600008 19.190001,8.339999 18.99,8.54 L14.95,12.48 L15.91,18.06 L15.91,18.3 C15.91,18.4466674 15.8700004,18.5733328 15.79,18.68 C15.7099996,18.7866672 15.6000007,18.8433333 15.46,18.85 C15.3199993,18.8566667 15.1700008,18.8133338 15.01,18.72 L9.99,16.08 L4.99,18.72 C4.8299992,18.8133338 4.6766674,18.86 4.53,18.86 C4.3833326,18.86 4.2700004,18.8000006 4.19,18.68 C4.1099996,18.5599994 4.07,18.433334 4.07,18.3 C4.07,18.2466664 4.0766666,18.1666672 4.09,18.06 L5.05,12.48 L0.99,8.54 C0.8033324,8.339999 0.71,8.1600008 0.71,8 C0.71,7.7199986 0.9166646,7.546667 1.33,7.48 L6.93,6.68 L9.45,1.6 C9.5966674,1.2933318 9.7766656,1.14 9.99,1.14 C10.2033344,1.14 10.3899992,1.2933318 10.55,1.6 L13.05,6.68 L18.65,7.48 C19.0766688,7.546667 19.29,7.7199986 19.29,8 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "scHf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/giantscausway.c12ea29.jpg";

/***/ }),

/***/ "so8r":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./acropolis.jpg": "ecni",
	"./agua.jpg": "CmTk",
	"./badlands.jpg": "nZ5y",
	"./basil.jpg": "B9Ve",
	"./bigben.jpg": "M+lj",
	"./brixby.jpg": "DRx7",
	"./bryce.jpg": "PU9P",
	"./cambodia.jpg": "PvP2",
	"./chicago.jpg": "fHwL",
	"./chocolatethills.jpg": "It2R",
	"./danakil.jpg": "tuKs",
	"./denali.jpg": "sSYw",
	"./dolomite.jpg": "IO2M",
	"./dorset.jpg": "HlYY",
	"./dubai.jpg": "ik46",
	"./easter.jpg": "fqkn",
	"./eiffel.jpg": "Wem0",
	"./faeroe.jpg": "4QZi",
	"./fitzroy.jpg": "hC4n",
	"./giantscausway.jpg": "scHf",
	"./goldengate.jpg": "m110",
	"./greatwall.jpg": "FHVA",
	"./guellpark.jpg": "vRJN",
	"./halfdome.jpg": "/gO/",
	"./halong.jpg": "CJs7",
	"./haydar.jpg": "BmRi",
	"./heceta.jpg": "rYtj",
	"./himalayas.jpg": "15Rg",
	"./horseshoefalls.jpg": "E2F4",
	"./japan.jpg": "1viU",
	"./kilamajaro.jpg": "yZmd",
	"./la.jpg": "Yb5C",
	"./liriver.jpg": "qHdV",
	"./lotus.jpg": "3qir",
	"./louvre.jpg": "h96m",
	"./machu.jpg": "RvPL",
	"./mahal.jpg": "/ZcK",
	"./monolake.jpg": "n0aw",
	"./montecarlo.jpg": "GeeW",
	"./monument.jpg": "AjKI",
	"./morainta.jpg": "DlbQ",
	"./navajo.jpg": "c0Yp",
	"./newyork.jpg": "Gcho",
	"./pyramids.jpg": "7+rr",
	"./rio.jpg": "bTCR",
	"./romanforum.jpg": "P+2j",
	"./rome.jpg": "ioLf",
	"./shanghai.jpg": "T/X7",
	"./sidney.jpg": "6W09",
	"./spaceneedle.jpg": "zdwg",
	"./stonehenge.jpg": "Y+DG",
	"./stupa.jpg": "IlYA",
	"./tahoe.jpg": "I7Ud",
	"./tajmahal.jpg": "6WdU",
	"./tigers.jpg": "Vqap",
	"./uluru.jpg": "bJz5",
	"./varanasi.jpg": "0ovn",
	"./vietnam.jpg": "0/tJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "so8r";

/***/ }),

/***/ "sw1O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t9kw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/in-view.vue
var in_view = __webpack_require__("XAIW");
var in_view_default = /*#__PURE__*/__webpack_require__.n(in_view);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dec03a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/in-view.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_in_view = (esExports);
// CONCATENATED MODULE: ./src/components/_global/in-view.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  in_view_default.a,
  _global_in_view,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_in_view = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tGBv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'ContentModuleDiscuss',
  props: ['data']
};

/***/ }),

/***/ "tN/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GeographyMasthead/index.vue
var GeographyMasthead = __webpack_require__("cY5d");
var GeographyMasthead_default = /*#__PURE__*/__webpack_require__.n(GeographyMasthead);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3e4df0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeographyMasthead/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geography-masthead"},[_c('transition',[(_vm.displayBg)?_c('div',{staticClass:"bg",style:(("background-image:url(" + (_vm.$options.static.masthead.image)))}):_vm._e()]),_vm._v(" "),_c('div',{class:['location', {active: _vm.active}]},[_c('h2',{on:{"click":function($event){_vm.active = true}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 491.582 491.582"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 491.582 491.582","xml:space":"preserve"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M245.791,0C153.799,0,78.957,74.841,78.957,166.833c0,36.967,21.764,93.187,68.493,176.926 c31.887,57.138,63.627,105.4,64.966,107.433l22.941,34.773c2.313,3.507,6.232,5.617,10.434,5.617s8.121-2.11,10.434-5.617 l22.94-34.771c1.326-2.01,32.835-49.855,64.967-107.435c46.729-83.735,68.493-139.955,68.493-176.926 C412.625,74.841,337.783,0,245.791,0z M322.302,331.576c-31.685,56.775-62.696,103.869-64.003,105.848l-12.508,18.959 l-12.504-18.954c-1.314-1.995-32.563-49.511-64.007-105.853c-43.345-77.676-65.323-133.104-65.323-164.743 C103.957,88.626,167.583,25,245.791,25s141.834,63.626,141.834,141.833C387.625,198.476,365.647,253.902,322.302,331.576z","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M245.791,73.291c-51.005,0-92.5,41.496-92.5,92.5s41.495,92.5,92.5,92.5s92.5-41.496,92.5-92.5 S296.796,73.291,245.791,73.291z M245.791,233.291c-37.22,0-67.5-30.28-67.5-67.5s30.28-67.5,67.5-67.5 c37.221,0,67.5,30.28,67.5,67.5S283.012,233.291,245.791,233.291z","fill":"#FFFFFF"}})])]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')]),_vm._v("\n      Where on earth is this?\n    ")]),_vm._v(" "),_c('div',{staticClass:"reveal"},[_vm._v(_vm._s(_vm.$options.static.masthead.text))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_GeographyMasthead = (esExports);
// CONCATENATED MODULE: ./src/components/GeographyMasthead/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("flTr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c3e4df0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  GeographyMasthead_default.a,
  components_GeographyMasthead,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_GeographyMasthead = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tNHr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//


exports.default = {
  name: 'ContentModuleAudio',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "tuKs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/danakil.efcf0a0.jpg";

/***/ }),

/***/ "u2nA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("Eg1c");

/***/ }),

/***/ "uKTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/vue.vue
var vue = __webpack_require__("8ndo");
var vue_default = /*#__PURE__*/__webpack_require__.n(vue);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c9d96d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/vue.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_vue = (esExports);
// CONCATENATED MODULE: ./src/components/_global/vue.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vue_default.a,
  _global_vue,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_vue = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "utZw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("g3Gj");

__webpack_require__("bVQ7");

var _video = __webpack_require__("63pp");

var _video2 = _interopRequireDefault(_video);

__webpack_require__("uPQo");

__webpack_require__("Jg0P");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Turn off console debugging
_video2.default.Html5DashJS.hook('beforeinitialize', function (player, mediaPlayer) {
  mediaPlayer.getDebug().setLogToBrowserConsole(false);
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'videoJs',
  props: {
    media: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: false
    },
    chromeless: {
      type: Boolean,
      default: false
    },
    banner: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      player: null,
      videoLoaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var videoLoaded = function videoLoaded() {
      if (!_this.videoLoaded) {
        _this.videoLoaded = true;
        _this.$emit("loadeddata");
      }
    };

    this.player = (0, _video2.default)(this.$refs.video, {
      fluid: true,
      muted: this.muted,
      inactivityTimeout: 750
    });

    $(this.$refs.video).one("loadeddata", videoLoaded);
    setTimeout(videoLoaded, 1000);
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "v62T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__("IcnI");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resource = _2.default.defineResource({
  name: "media"
});

exports.default = resource;

/***/ }),

/***/ "vDSc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/video-js.vue
var video_js = __webpack_require__("utZw");
var video_js_default = /*#__PURE__*/__webpack_require__.n(video_js);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3cda4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/video-js.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{banner: _vm.banner}},[_c('transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoLoaded),expression:"videoLoaded"}],staticClass:"video-wrapper"},[_c('video',{ref:"video",class:{'video-js': !_vm.chromeless},attrs:{"loop":_vm.loop,"autoplay":(_vm.autoplay) ? '' : null,"controls":(!_vm.chromeless) ? '' : null,"preload":"none","poster":(!_vm.chromeless) ? _vm.media.poster : null}},[(_vm.media.dash)?_c('source',{attrs:{"src":_vm.media.dash,"type":"application/dash+xml"}}):_vm._e(),_vm._v(" "),(_vm.media.hls)?_c('source',{attrs:{"src":_vm.media.hls,"type":"application/x-mpegurl"}}):_vm._e(),_vm._v(" "),(_vm.media.mp4)?_c('source',{attrs:{"src":_vm.media.mp4,"type":"video/mp4"}}):_vm._e(),_vm._v(" "),(_vm.media.cc)?_c('track',{attrs:{"kind":"captions","src":_vm.media.cc,"srclang":"en","label":"English"}}):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _global_video_js = (esExports);
// CONCATENATED MODULE: ./src/components/_global/video-js.vue
function injectStyle (ssrContext) {
  __webpack_require__("q9iy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c3cda4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  video_js_default.a,
  _global_video_js,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components__global_video_js = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vRJN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guellpark.8aaef3d.jpg";

/***/ }),

/***/ "vrLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlastStudent/ReviewDisplay.vue
var ReviewDisplay = __webpack_require__("lMdH");
var ReviewDisplay_default = /*#__PURE__*/__webpack_require__.n(ReviewDisplay);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0157d1d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlastStudent/ReviewDisplay.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.blast.isOpen && _vm.blast.assignment.features.reviews)?_c('div',{staticClass:"tabbed"},[_c('ul',{staticClass:"tabbed-nav"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.key,class:{active: _vm.activeTab==tab.key}},[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.activeTab = tab.key}}},[_vm._v(_vm._s(tab.label))])])})),_vm._v(" "),_c('div',{staticClass:"tabbed-content"},[(_vm.activeTab == 'received')?_c('blast-reviews-received',{attrs:{"blast":_vm.blast}}):_vm._e(),_vm._v(" "),(_vm.activeTab == 'given')?_c('blast-reviews-given',{attrs:{"blast":_vm.blast}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var BlastStudent_ReviewDisplay = (esExports);
// CONCATENATED MODULE: ./src/components/BlastStudent/ReviewDisplay.vue
function injectStyle (ssrContext) {
  __webpack_require__("3ej7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0157d1d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ReviewDisplay_default.a,
  BlastStudent_ReviewDisplay,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_BlastStudent_ReviewDisplay = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vyiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/_global/content-module/audio.vue
var audio = __webpack_require__("rqdQ");
var audio_default = /*#__PURE__*/__webpack_require__.n(audio);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52533d0b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/audio.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.data.src,"type":"audio/mpeg"}})]),_vm._v(" "),(_vm.data.caption)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.data.caption))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var content_module_audio = (esExports);
// CONCATENATED MODULE: ./src/components/_global/content-module/audio.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ty3F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52533d0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  audio_default.a,
  content_module_audio,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _global_content_module_audio = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "w2WD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'ChannelDetail',
  routeConfig: {
    name: "channelDetail", path: "/channels/:id"
  },
  metaInfo: function metaInfo() {
    return {
      // title: this.channelName
    };
  },
  data: function data() {
    return {
      channel: null
    };
  },
  created: function created() {
    var _this = this;

    this.$store.find('channels', this.$route.params.id).then(function (channel) {
      _this.channel = channel;
    }).catch(function (err) {
      // TODO: What to put here?
      // this.$router.push({name: "assignments"})
    });
  }
};

/***/ }),

/***/ "wBG/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'AssignmentCompletionSummary',
  props: {
    responses: {
      type: Array,
      required: true
    }
  },
  computed: {
    groups: function groups() {
      var groups = _.groupBy(this.responses, "question.groupId");
      var titles = {
        7: "Comprehension",
        10: "Blast Prompt",
        9: "Write Prompt",
        11: "QuikPoll"
      };
      return _.map(groups, function (responses, id) {
        return {
          title: titles[id],
          complete: _.every(responses, function (response) {
            return !!response.response;
          })
        };
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "x+Mw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'BlastTop10',
  props: {
    blast: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var top10 = this.blast.blastPrompt.question.top;
    var ranks = _.map(top10, "score");
    return {
      top10: _.map(top10, function (top, index) {
        return _.assign({}, top, { rank: _.indexOf(ranks, top.score) + 1, isOpen: index < 3 });
      })
    };
  },

  filters: {
    blastScore: function blastScore(value) {
      return value.toFixed(3);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "x5YY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__("u2KI");

var _freeze2 = _interopRequireDefault(_freeze);

var _iconAnnotation = __webpack_require__("5dOw");

var _iconAnnotation2 = _interopRequireDefault(_iconAnnotation);

var _iconBlastChrome = __webpack_require__("TYut");

var _iconBlastChrome2 = _interopRequireDefault(_iconBlastChrome);

var _iconBlast = __webpack_require__("VHPH");

var _iconBlast2 = _interopRequireDefault(_iconBlast);

var _iconCalendar = __webpack_require__("HTlV");

var _iconCalendar2 = _interopRequireDefault(_iconCalendar);

var _iconCheckOutline = __webpack_require__("5Ue1");

var _iconCheckOutline2 = _interopRequireDefault(_iconCheckOutline);

var _iconCheck = __webpack_require__("oeGR");

var _iconCheck2 = _interopRequireDefault(_iconCheck);

var _iconClock = __webpack_require__("HvI+");

var _iconClock2 = _interopRequireDefault(_iconClock);

var _iconClose = __webpack_require__("0pZc");

var _iconClose2 = _interopRequireDefault(_iconClose);

var _iconDownDir = __webpack_require__("ABrP");

var _iconDownDir2 = _interopRequireDefault(_iconDownDir);

var _iconHelpCircled = __webpack_require__("YaZh");

var _iconHelpCircled2 = _interopRequireDefault(_iconHelpCircled);

var _iconHourglass = __webpack_require__("Mm8U");

var _iconHourglass2 = _interopRequireDefault(_iconHourglass);

var _iconMenu = __webpack_require__("e2VZ");

var _iconMenu2 = _interopRequireDefault(_iconMenu);

var _iconNumbers = __webpack_require__("PDQp");

var _iconNumbers2 = _interopRequireDefault(_iconNumbers);

var _iconPause = __webpack_require__("I3gN");

var _iconPause2 = _interopRequireDefault(_iconPause);

var _iconPlay = __webpack_require__("y8aU");

var _iconPlay2 = _interopRequireDefault(_iconPlay);

var _iconPrint = __webpack_require__("iFUV");

var _iconPrint2 = _interopRequireDefault(_iconPrint);

var _iconProfile = __webpack_require__("cDJu");

var _iconProfile2 = _interopRequireDefault(_iconProfile);

var _iconPullout = __webpack_require__("Cpn3");

var _iconPullout2 = _interopRequireDefault(_iconPullout);

var _iconQuikpoll = __webpack_require__("2Ti/");

var _iconQuikpoll2 = _interopRequireDefault(_iconQuikpoll);

var _iconReadChrome = __webpack_require__("5RMJ");

var _iconReadChrome2 = _interopRequireDefault(_iconReadChrome);

var _iconReview = __webpack_require__("WuPQ");

var _iconReview2 = _interopRequireDefault(_iconReview);

var _iconRibbon = __webpack_require__("EHqG");

var _iconRibbon2 = _interopRequireDefault(_iconRibbon);

var _iconStarOutline = __webpack_require__("sW16");

var _iconStarOutline2 = _interopRequireDefault(_iconStarOutline);

var _iconStar = __webpack_require__("dRwk");

var _iconStar2 = _interopRequireDefault(_iconStar);

var _iconThink = __webpack_require__("h90m");

var _iconThink2 = _interopRequireDefault(_iconThink);

var _iconTv = __webpack_require__("JkCY");

var _iconTv2 = _interopRequireDefault(_iconTv);

var _iconWriteChrome = __webpack_require__("PUaY");

var _iconWriteChrome2 = _interopRequireDefault(_iconWriteChrome);

var _logoBlasts = __webpack_require__("PD4J");

var _logoBlasts2 = _interopRequireDefault(_logoBlasts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//


var sprites = {
  iconAnnotation: _iconAnnotation2.default,
  iconBlastChrome: _iconBlastChrome2.default,
  iconBlast: _iconBlast2.default,
  iconCalendar: _iconCalendar2.default,
  iconCheckOutline: _iconCheckOutline2.default,
  iconCheck: _iconCheck2.default,
  iconClock: _iconClock2.default,
  iconClose: _iconClose2.default,
  iconDownDir: _iconDownDir2.default,
  iconHelpCircled: _iconHelpCircled2.default,
  iconHourglass: _iconHourglass2.default,
  iconMenu: _iconMenu2.default,
  iconNumbers: _iconNumbers2.default,
  iconPause: _iconPause2.default,
  iconPlay: _iconPlay2.default,
  iconPrint: _iconPrint2.default,
  iconProfile: _iconProfile2.default,
  iconPullout: _iconPullout2.default,
  iconQuikpoll: _iconQuikpoll2.default,
  iconReadChrome: _iconReadChrome2.default,
  iconReview: _iconReview2.default,
  iconRibbon: _iconRibbon2.default,
  iconStarOutline: _iconStarOutline2.default,
  iconStar: _iconStar2.default,
  iconThink: _iconThink2.default,
  iconTv: _iconTv2.default,
  iconWriteChrome: _iconWriteChrome2.default,
  logoBlasts: _logoBlasts2.default
};
(0, _freeze2.default)(sprites);
exports.default = {
  name: 'sprite',
  props: {
    name: { type: String, required: true }
  },
  data: function data() {
    return {
      sprites: sprites
    };
  }
};

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppHeader = __webpack_require__("lcqv");

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SessionWarning = __webpack_require__("q3k8");

var _SessionWarning2 = _interopRequireDefault(_SessionWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  name: 'app',
  metaInfo: {
    title: "Loading...",
    titleTemplate: "%s | SyncBlasts"
  },
  components: { AppHeader: _AppHeader2.default, SessionWarning: _SessionWarning2.default },
  data: function data() {
    return {
      bypass: false,
      session: {}
    };
  },
  created: function created() {
    var _this = this;

    if (!this.bypass) {
      this.$session.authorize(this.$classicParams.loginToken).then(function (session) {
        // Set session
        _this.session = session;
        // Pre-pop with app meta data
        var metaConfig = _.assign({
          baseURL: _this.$store.adapters.http.defaults.basePath,
          url: '/metadata'
        }, _this.$store.adapters.http.defaults.httpConfig);
        _this.$store.adapters.http.http(metaConfig).then(function (response) {
          _.each(response.data, function (data, key) {
            if (_this.$store.definitions[key]) {
              _this.$store.inject(key, data);
            }
          });
        });
      }).catch(function (err) {
        _this.$router.push({ name: 'logout' });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("M4fF")))

/***/ }),

/***/ "xfS/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'NavToggle'
};

/***/ }),

/***/ "y8aU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-play\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-play</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-play_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-play_icon-play\">\n            <path d=\"M17.59,10.344881 L2.77,18.584881 C2.5966658,18.6782148 2.4500006,18.691548 2.33,18.624881 C2.2099994,18.558214 2.15,18.424882 2.15,18.224881 L2.15,1.78488098 C2.15,1.59821338 2.2099994,1.46488138 2.33,1.38488098 C2.4500006,1.30488058 2.5966658,1.31821378 2.77,1.42488098 L17.59,9.66488098 C17.7633342,9.75821478 17.85,9.87154698 17.85,10.004881 C17.85,10.138215 17.7633342,10.2515472 17.59,10.344881 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "yKHI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yThj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'posterImage',
  methods: {
    useFallback: function useFallback() {
      $(this.$el).attr("src", "/static/default-poster.jpg");
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "yZmd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kilamajaro.a68d3b7.jpg";

/***/ }),

/***/ "ybNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AssignmentList/item.vue
var item = __webpack_require__("C5MG");
var item_default = /*#__PURE__*/__webpack_require__.n(item);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55f1ca0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignmentList/item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{staticClass:"wrapper",attrs:{"to":{name: 'assignmentDetail', params: {id: _vm.blast.id}}}},[_c('div',{staticClass:"poster"},[_c('figure',[_c('poster-image',{attrs:{"src":_vm.blast.assignment.posterUrl}})],1),_vm._v(" "),_c('div',{staticClass:"poster-body"},[_c('div',{staticClass:"status"},[_c('sprite',{attrs:{"name":_vm.status.icon,"title":"Status"}}),_vm._v("\n          "+_vm._s(_vm.status.label)+"\n        ")],1),_vm._v(" "),(!_vm.blast.isClosed)?_c('div',{staticClass:"blast-due"},[_c('sprite',{attrs:{"name":"iconClock","title":"Due Date"}}),_vm._v("\n          "+_vm._s(_vm.dueDateStamp)+"\n        ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('h3',{staticClass:"blast-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('h4',{staticClass:"blast-prompt"},[_vm._v(_vm._s(_vm.blast.assignment.prompt))]),_vm._v(" "),_c('div',{staticClass:"excerpt"},[_c('p',[_vm._v(_vm._s(_vm.blast.assignment.blurb))])]),_vm._v(" "),_c('div',{staticClass:"blast-foot"},[_c('div',{staticClass:"blast-cta"},[_c('btn',[_vm._v("Continue Reading")])],1),_vm._v(" "),_c('div',{staticClass:"blast-type"},[_c('sprite',{attrs:{"name":'icon'+_vm.blast.assignmentType+'Chrome',"title":"Assignment Type: Blast"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var AssignmentList_item = (esExports);
// CONCATENATED MODULE: ./src/components/AssignmentList/item.vue
function injectStyle (ssrContext) {
  __webpack_require__("4q07")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55f1ca0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  item_default.a,
  AssignmentList_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_AssignmentList_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yjho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VisualVocab/index.vue
var VisualVocab = __webpack_require__("Bqf3");
var VisualVocab_default = /*#__PURE__*/__webpack_require__.n(VisualVocab);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a9439c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VisualVocab/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(true)?_c('div',{staticClass:"instruct"},[_c('h4',[_vm._v("Instructions")]),_vm._v(" "),_c('p',[_vm._v("You are given "),_c('strong',[_vm._v(_vm._s(_vm.model.response.length)+" definitions")]),_vm._v(" to choose from. Please use the definition selector to match a definition to the term.")])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list"},_vm._l((_vm.model.response),function(definition){return _c('li',{staticClass:"item"},[_c('definition',{attrs:{"definition":_vm.definitions[definition.definitionId]}}),_vm._v(" "),(_vm.respondable)?_c('selector',{attrs:{"available":_vm.availableDefinitions,"all":_vm.model.question.definitions},on:{"input":function($event){_vm.doit(definition)}},model:{value:(definition.answerDefinitionId),callback:function ($$v) {_vm.$set(definition, "answerDefinitionId", $$v)},expression:"definition.answerDefinitionId"}}):_c('div',{class:['answer', (definition.definitionId === definition.answerDefinitionId) ? 'correct' : 'incorrect']},[_c('h6',{staticClass:"answer__label"},[_vm._v("Your Response")]),_vm._v(" "),_c('div',{class:['answer', (definition.definitionId === definition.answerDefinitionId) ? 'selected' : '']},[_c('div',{staticClass:"answer__response"},[_c('span',{staticClass:"bullet",class:['answer', (definition.definitionId === definition.answerDefinitionId) ? 'correct' : 'incorrect']},[(definition.definitionId !== definition.answerDefinitionId)?_c('sprite',{attrs:{"name":"iconClose"}}):_vm._e(),_vm._v(" "),(definition.definitionId === definition.answerDefinitionId)?_c('sprite',{attrs:{"name":"iconCheck"}}):_vm._e()],1),_vm._v("\n            "+_vm._s(_vm.definitions[definition.answerDefinitionId] ? _vm.definitions[definition.answerDefinitionId].definition : '')+"\n          ")])]),_vm._v(" "),(definition.definitionId !== definition.answerDefinitionId)?_c('div',{staticClass:"answer__correct"},[_c('h6',{staticClass:"answer__label"},[_vm._v("Correct Response")]),_vm._v(" "),_c('div',{staticClass:"answer__response"},[_c('span',{staticClass:"bullet",class:['answer', (definition.definitionId !== definition.answerDefinitionId) ? 'correct' : 'incorrect']},[_c('sprite',{attrs:{"name":"iconCheck"}})],1),_vm._v("\n            "+_vm._s(_vm.definitions[definition.definitionId] ? _vm.definitions[definition.definitionId].definition : '')+"\n          ")])]):_vm._e()])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_VisualVocab = (esExports);
// CONCATENATED MODULE: ./src/components/VisualVocab/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("HS0v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20a9439c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  VisualVocab_default.a,
  components_VisualVocab,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_VisualVocab = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "z2t3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//


exports.default = {
  name: 'ContentModuleVideo',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "zOnD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zdwg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spaceneedle.295a0a0.jpg";

/***/ }),

/***/ "zlUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zmwA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AssignmentList = __webpack_require__("9/aY");

var _AssignmentList2 = _interopRequireDefault(_AssignmentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Binder',
  routeConfig: {
    name: "binder", path: "/binder", meta: { transHeader: true }
  },
  metaInfo: {
    title: "Binder"
  },
  components: { AssignmentList: _AssignmentList2.default },
  data: function data() {
    // see comment in routes/Assignments/index.vue
    var criteria = {
      limit: 100,
      where: {
        state: 'closed'
      }
    };
    return {
      ready: false,
      mastheadVideoLoaded: false,
      assignmentsCompleted: "",
      assignments: this.$store.filter('userAssignments', criteria),
      assignmentsPromise: this.$store.findAll('userAssignments', criteria)
    };
  },
  created: function created() {
    var _this = this;

    this.assignmentsPromise.then(function (assignments) {
      _this.ready = true;
      _this.assignments = assignments;
      if (!_this.assignments.length) {
        _this.assignmentsCompleted = "";
      } else if (_this.assignments.length == 1) {
        _this.assignmentsCompleted = "You've completed 1 assignment";
      } else {
        _this.assignmentsCompleted = "You've completed " + _this.assignments.length + " assignments";
      }
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.6dee4dce1f79e076c7db.js